import { jsx as y, jsxs as R, Fragment as Wr } from "react/jsx-runtime";
import * as S from "react";
import L, { createContext as gn, useContext as fn, useCallback as bn, useState as xe, useRef as Et, useEffect as Ie, useMemo as hn, createElement as Kr, forwardRef as kt, useImperativeHandle as qr } from "react";
import "react-dom";
import { D as oo, c as Hr, n as mn, s as Jr } from "./stay-request-B3qKR9d3.js";
import { f as YL, i as QL, h as XL, a as eE, g as tE, b as aE, j as oE, e as nE, d as rE, k as iE, l as lE, m as sE, p as cE, u as uE } from "./stay-request-B3qKR9d3.js";
var $t = (e) => e.type === "checkbox", Ue = (e) => e instanceof Date, de = (e) => e == null;
const pn = (e) => typeof e == "object";
var te = (e) => !de(e) && !Array.isArray(e) && pn(e) && !Ue(e), yn = (e) => te(e) && e.target ? $t(e.target) ? e.target.checked : e.target.value : e, Yr = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, vn = (e, t) => e.has(Yr(t)), Qr = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return te(t) && t.hasOwnProperty("isPrototypeOf");
}, Na = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function ie(e) {
  let t;
  const a = Array.isArray(e), o = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (!(Na && (e instanceof Blob || o)) && (a || te(e)))
    if (t = a ? [] : Object.create(Object.getPrototypeOf(e)), !a && !Qr(e))
      t = e;
    else
      for (const n in e)
        e.hasOwnProperty(n) && (t[n] = ie(e[n]));
  else
    return e;
  return t;
}
var Jt = (e) => /^\w*$/.test(e), ee = (e) => e === void 0, Oa = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Ia = (e) => Oa(e.replace(/["|']|\]/g, "").split(/\.|\[/)), C = (e, t, a) => {
  if (!t || !te(e))
    return a;
  const o = (Jt(t) ? [t] : Ia(t)).reduce((n, r) => de(n) ? n : n[r], e);
  return ee(o) || o === e ? ee(e[t]) ? a : e[t] : o;
}, he = (e) => typeof e == "boolean", G = (e, t, a) => {
  let o = -1;
  const n = Jt(t) ? [t] : Ia(t), r = n.length, i = r - 1;
  for (; ++o < r; ) {
    const l = n[o];
    let c = a;
    if (o !== i) {
      const s = e[l];
      c = te(s) || Array.isArray(s) ? s : isNaN(+n[o + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = c, e = e[l];
  }
};
const Bt = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, $e = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Pe = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, kn = L.createContext(null);
kn.displayName = "HookFormContext";
const ja = () => L.useContext(kn);
var $n = (e, t, a, o = !0) => {
  const n = {
    defaultValues: t._defaultValues
  };
  for (const r in e)
    Object.defineProperty(n, r, {
      get: () => {
        const i = r;
        return t._proxyFormState[i] !== $e.all && (t._proxyFormState[i] = !o || $e.all), a && (a[i] = !0), e[i];
      }
    });
  return n;
};
const La = typeof window < "u" ? L.useLayoutEffect : L.useEffect;
function Xr(e) {
  const t = ja(), { control: a = t.control, disabled: o, name: n, exact: r } = e || {}, [i, l] = L.useState(a._formState), c = L.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return La(() => a._subscribe({
    name: n,
    formState: c.current,
    exact: r,
    callback: (s) => {
      !o && l({
        ...a._formState,
        ...s
      });
    }
  }), [n, o, r]), L.useEffect(() => {
    c.current.isValid && a._setValid(!0);
  }, [a]), L.useMemo(() => $n(i, a, c.current, !1), [i, a]);
}
var Ce = (e) => typeof e == "string", wn = (e, t, a, o, n) => Ce(e) ? (o && t.watch.add(e), C(a, e, n)) : Array.isArray(e) ? e.map((r) => (o && t.watch.add(r), C(a, r))) : (o && (t.watchAll = !0), a), pa = (e) => de(e) || !pn(e);
function Oe(e, t, a = /* @__PURE__ */ new WeakSet()) {
  if (pa(e) || pa(t))
    return e === t;
  if (Ue(e) && Ue(t))
    return e.getTime() === t.getTime();
  const o = Object.keys(e), n = Object.keys(t);
  if (o.length !== n.length)
    return !1;
  if (a.has(e) || a.has(t))
    return !0;
  a.add(e), a.add(t);
  for (const r of o) {
    const i = e[r];
    if (!n.includes(r))
      return !1;
    if (r !== "ref") {
      const l = t[r];
      if (Ue(i) && Ue(l) || te(i) && te(l) || Array.isArray(i) && Array.isArray(l) ? !Oe(i, l, a) : i !== l)
        return !1;
    }
  }
  return !0;
}
function ei(e) {
  const t = ja(), { control: a = t.control, name: o, defaultValue: n, disabled: r, exact: i, compute: l } = e || {}, c = L.useRef(n), s = L.useRef(l), u = L.useRef(void 0);
  s.current = l;
  const d = L.useMemo(() => a._getWatch(o, c.current), [a, o]), [g, b] = L.useState(s.current ? s.current(d) : d);
  return La(() => a._subscribe({
    name: o,
    formState: {
      values: !0
    },
    exact: i,
    callback: (h) => {
      if (!r) {
        const p = wn(o, a._names, h.values || a._formValues, !1, c.current);
        if (s.current) {
          const $ = s.current(p);
          Oe($, u.current) || (b($), u.current = $);
        } else
          b(p);
      }
    }
  }), [a, r, o, i]), L.useEffect(() => a._removeUnmounted()), g;
}
function ti(e) {
  const t = ja(), { name: a, disabled: o, control: n = t.control, shouldUnregister: r, defaultValue: i } = e, l = vn(n._names.array, a), c = L.useMemo(() => C(n._formValues, a, C(n._defaultValues, a, i)), [n, a, i]), s = ei({
    control: n,
    name: a,
    defaultValue: c,
    exact: !0
  }), u = Xr({
    control: n,
    name: a,
    exact: !0
  }), d = L.useRef(e), g = L.useRef(n.register(a, {
    ...e.rules,
    value: s,
    ...he(e.disabled) ? { disabled: e.disabled } : {}
  }));
  d.current = e;
  const b = L.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!C(u.errors, a)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!C(u.dirtyFields, a)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!C(u.touchedFields, a)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!C(u.validatingFields, a)
    },
    error: {
      enumerable: !0,
      get: () => C(u.errors, a)
    }
  }), [u, a]), h = L.useCallback((k) => g.current.onChange({
    target: {
      value: yn(k),
      name: a
    },
    type: Bt.CHANGE
  }), [a]), p = L.useCallback(() => g.current.onBlur({
    target: {
      value: C(n._formValues, a),
      name: a
    },
    type: Bt.BLUR
  }), [a, n._formValues]), $ = L.useCallback((k) => {
    const P = C(n._fields, a);
    P && k && (P._f.ref = {
      focus: () => k.focus && k.focus(),
      select: () => k.select && k.select(),
      setCustomValidity: (A) => k.setCustomValidity(A),
      reportValidity: () => k.reportValidity()
    });
  }, [n._fields, a]), M = L.useMemo(() => ({
    name: a,
    value: s,
    ...he(o) || u.disabled ? { disabled: u.disabled || o } : {},
    onChange: h,
    onBlur: p,
    ref: $
  }), [a, o, u.disabled, h, p, $, s]);
  return L.useEffect(() => {
    const k = n._options.shouldUnregister || r;
    n.register(a, {
      ...d.current.rules,
      ...he(d.current.disabled) ? { disabled: d.current.disabled } : {}
    });
    const P = (A, N) => {
      const F = C(n._fields, A);
      F && F._f && (F._f.mount = N);
    };
    if (P(a, !0), k) {
      const A = ie(C(n._options.defaultValues, a));
      G(n._defaultValues, a, A), ee(C(n._formValues, a)) && G(n._formValues, a, A);
    }
    return !l && n.register(a), () => {
      (l ? k && !n._state.action : k) ? n.unregister(a) : P(a, !1);
    };
  }, [a, n, l, r]), L.useEffect(() => {
    n._setDisabledField({
      disabled: o,
      name: a
    });
  }, [o, a, n]), L.useMemo(() => ({
    field: M,
    formState: u,
    fieldState: b
  }), [M, u, b]);
}
const no = (e) => e.render(ti(e));
var Ea = (e, t, a, o, n) => t ? {
  ...a[e],
  types: {
    ...a[e] && a[e].types ? a[e].types : {},
    [o]: n || !0
  }
} : {}, dt = (e) => Array.isArray(e) ? e : [e], ro = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ge = (e) => te(e) && !Object.keys(e).length, Ba = (e) => e.type === "file", we = (e) => typeof e == "function", Tt = (e) => {
  if (!Na)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, xn = (e) => e.type === "select-multiple", Ta = (e) => e.type === "radio", ai = (e) => Ta(e) || $t(e), _a = (e) => Tt(e) && e.isConnected;
function oi(e, t) {
  const a = t.slice(0, -1).length;
  let o = 0;
  for (; o < a; )
    e = ee(e) ? o++ : e[t[o++]];
  return e;
}
function ni(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !ee(e[t]))
      return !1;
  return !0;
}
function re(e, t) {
  const a = Array.isArray(t) ? t : Jt(t) ? [t] : Ia(t), o = a.length === 1 ? e : oi(e, a), n = a.length - 1, r = a[n];
  return o && delete o[r], n !== 0 && (te(o) && ge(o) || Array.isArray(o) && ni(o)) && re(e, a.slice(0, -1)), e;
}
var Cn = (e) => {
  for (const t in e)
    if (we(e[t]))
      return !0;
  return !1;
};
function Rt(e, t = {}) {
  const a = Array.isArray(e);
  if (te(e) || a)
    for (const o in e)
      Array.isArray(e[o]) || te(e[o]) && !Cn(e[o]) ? (t[o] = Array.isArray(e[o]) ? [] : {}, Rt(e[o], t[o])) : de(e[o]) || (t[o] = !0);
  return t;
}
function Sn(e, t, a) {
  const o = Array.isArray(e);
  if (te(e) || o)
    for (const n in e)
      Array.isArray(e[n]) || te(e[n]) && !Cn(e[n]) ? ee(t) || pa(a[n]) ? a[n] = Array.isArray(e[n]) ? Rt(e[n], []) : { ...Rt(e[n]) } : Sn(e[n], de(t) ? {} : t[n], a[n]) : a[n] = !Oe(e[n], t[n]);
  return a;
}
var lt = (e, t) => Sn(e, t, Rt(t));
const io = {
  value: !1,
  isValid: !1
}, lo = { value: !0, isValid: !0 };
var zn = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((a) => a && a.checked && !a.disabled).map((a) => a.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ee(e[0].attributes.value) ? ee(e[0].value) || e[0].value === "" ? lo : { value: e[0].value, isValid: !0 } : lo
    ) : io;
  }
  return io;
}, An = (e, { valueAsNumber: t, valueAsDate: a, setValueAs: o }) => ee(e) ? e : t ? e === "" ? NaN : e && +e : a && Ce(e) ? new Date(e) : o ? o(e) : e;
const so = {
  isValid: !1,
  value: null
};
var Pn = (e) => Array.isArray(e) ? e.reduce((t, a) => a && a.checked && !a.disabled ? {
  isValid: !0,
  value: a.value
} : t, so) : so;
function co(e) {
  const t = e.ref;
  return Ba(t) ? t.files : Ta(t) ? Pn(e.refs).value : xn(t) ? [...t.selectedOptions].map(({ value: a }) => a) : $t(t) ? zn(e.refs).value : An(ee(t.value) ? e.ref.value : t.value, e);
}
var ri = (e, t, a, o) => {
  const n = {};
  for (const r of e) {
    const i = C(t, r);
    i && G(n, r, i._f);
  }
  return {
    criteriaMode: a,
    names: [...e],
    fields: n,
    shouldUseNativeValidation: o
  };
}, Ft = (e) => e instanceof RegExp, st = (e) => ee(e) ? e : Ft(e) ? e.source : te(e) ? Ft(e.value) ? e.value.source : e.value : e, uo = (e) => ({
  isOnSubmit: !e || e === $e.onSubmit,
  isOnBlur: e === $e.onBlur,
  isOnChange: e === $e.onChange,
  isOnAll: e === $e.all,
  isOnTouch: e === $e.onTouched
});
const _o = "AsyncFunction";
var ii = (e) => !!e && !!e.validate && !!(we(e.validate) && e.validate.constructor.name === _o || te(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === _o)), li = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), go = (e, t, a) => !a && (t.watchAll || t.watch.has(e) || [...t.watch].some((o) => e.startsWith(o) && /^\.\w+/.test(e.slice(o.length))));
const _t = (e, t, a, o) => {
  for (const n of a || Object.keys(e)) {
    const r = C(e, n);
    if (r) {
      const { _f: i, ...l } = r;
      if (i) {
        if (i.refs && i.refs[0] && t(i.refs[0], n) && !o)
          return !0;
        if (i.ref && t(i.ref, i.name) && !o)
          return !0;
        if (_t(l, t))
          break;
      } else if (te(l) && _t(l, t))
        break;
    }
  }
};
function fo(e, t, a) {
  const o = C(e, a);
  if (o || Jt(a))
    return {
      error: o,
      name: a
    };
  const n = a.split(".");
  for (; n.length; ) {
    const r = n.join("."), i = C(t, r), l = C(e, r);
    if (i && !Array.isArray(i) && a !== r)
      return { name: a };
    if (l && l.type)
      return {
        name: r,
        error: l
      };
    if (l && l.root && l.root.type)
      return {
        name: `${r}.root`,
        error: l.root
      };
    n.pop();
  }
  return {
    name: a
  };
}
var si = (e, t, a, o) => {
  a(e);
  const { name: n, ...r } = e;
  return ge(r) || Object.keys(r).length >= Object.keys(t).length || Object.keys(r).find((i) => t[i] === (!o || $e.all));
}, ci = (e, t, a) => !e || !t || e === t || dt(e).some((o) => o && (a ? o === t : o.startsWith(t) || t.startsWith(o))), ui = (e, t, a, o, n) => n.isOnAll ? !1 : !a && n.isOnTouch ? !(t || e) : (a ? o.isOnBlur : n.isOnBlur) ? !e : (a ? o.isOnChange : n.isOnChange) ? e : !0, di = (e, t) => !Oa(C(e, t)).length && re(e, t), _i = (e, t, a) => {
  const o = dt(C(e, a));
  return G(o, "root", t[a]), G(e, a, o), e;
}, jt = (e) => Ce(e);
function bo(e, t, a = "validate") {
  if (jt(e) || Array.isArray(e) && e.every(jt) || he(e) && !e)
    return {
      type: a,
      message: jt(e) ? e : "",
      ref: t
    };
}
var Je = (e) => te(e) && !Ft(e) ? e : {
  value: e,
  message: ""
}, ho = async (e, t, a, o, n, r) => {
  const { ref: i, refs: l, required: c, maxLength: s, minLength: u, min: d, max: g, pattern: b, validate: h, name: p, valueAsNumber: $, mount: M } = e._f, k = C(a, p);
  if (!M || t.has(p))
    return {};
  const P = l ? l[0] : i, A = (B) => {
    n && P.reportValidity && (P.setCustomValidity(he(B) ? "" : B || ""), P.reportValidity());
  }, N = {}, F = Ta(i), U = $t(i), ae = F || U, Q = ($ || Ba(i)) && ee(i.value) && ee(k) || Tt(i) && i.value === "" || k === "" || Array.isArray(k) && !k.length, X = Ea.bind(null, p, o, N), ce = (B, E, T, Z = Pe.maxLength, q = Pe.minLength) => {
    const oe = B ? E : T;
    N[p] = {
      type: B ? Z : q,
      message: oe,
      ref: i,
      ...X(B ? Z : q, oe)
    };
  };
  if (r ? !Array.isArray(k) || !k.length : c && (!ae && (Q || de(k)) || he(k) && !k || U && !zn(l).isValid || F && !Pn(l).isValid)) {
    const { value: B, message: E } = jt(c) ? { value: !!c, message: c } : Je(c);
    if (B && (N[p] = {
      type: Pe.required,
      message: E,
      ref: P,
      ...X(Pe.required, E)
    }, !o))
      return A(E), N;
  }
  if (!Q && (!de(d) || !de(g))) {
    let B, E;
    const T = Je(g), Z = Je(d);
    if (!de(k) && !isNaN(k)) {
      const q = i.valueAsNumber || k && +k;
      de(T.value) || (B = q > T.value), de(Z.value) || (E = q < Z.value);
    } else {
      const q = i.valueAsDate || new Date(k), oe = (Ve) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Ve), ve = i.type == "time", ke = i.type == "week";
      Ce(T.value) && k && (B = ve ? oe(k) > oe(T.value) : ke ? k > T.value : q > new Date(T.value)), Ce(Z.value) && k && (E = ve ? oe(k) < oe(Z.value) : ke ? k < Z.value : q < new Date(Z.value));
    }
    if ((B || E) && (ce(!!B, T.message, Z.message, Pe.max, Pe.min), !o))
      return A(N[p].message), N;
  }
  if ((s || u) && !Q && (Ce(k) || r && Array.isArray(k))) {
    const B = Je(s), E = Je(u), T = !de(B.value) && k.length > +B.value, Z = !de(E.value) && k.length < +E.value;
    if ((T || Z) && (ce(T, B.message, E.message), !o))
      return A(N[p].message), N;
  }
  if (b && !Q && Ce(k)) {
    const { value: B, message: E } = Je(b);
    if (Ft(B) && !k.match(B) && (N[p] = {
      type: Pe.pattern,
      message: E,
      ref: i,
      ...X(Pe.pattern, E)
    }, !o))
      return A(E), N;
  }
  if (h) {
    if (we(h)) {
      const B = await h(k, a), E = bo(B, P);
      if (E && (N[p] = {
        ...E,
        ...X(Pe.validate, E.message)
      }, !o))
        return A(E.message), N;
    } else if (te(h)) {
      let B = {};
      for (const E in h) {
        if (!ge(B) && !o)
          break;
        const T = bo(await h[E](k, a), P, E);
        T && (B = {
          ...T,
          ...X(E, T.message)
        }, A(T.message), o && (N[p] = B));
      }
      if (!ge(B) && (N[p] = {
        ref: P,
        ...B
      }, !o))
        return N;
    }
  }
  return A(!0), N;
};
const gi = {
  mode: $e.onSubmit,
  reValidateMode: $e.onChange,
  shouldFocusError: !0
};
function fi(e = {}) {
  let t = {
    ...gi,
    ...e
  }, a = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: we(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, o = {}, n = te(t.defaultValues) || te(t.values) ? ie(t.defaultValues || t.values) || {} : {}, r = t.shouldUnregister ? {} : ie(n), i = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, s = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let d = {
    ...u
  };
  const g = {
    array: ro(),
    state: ro()
  }, b = t.criteriaMode === $e.all, h = (_) => (f) => {
    clearTimeout(s), s = setTimeout(_, f);
  }, p = async (_) => {
    if (!t.disabled && (u.isValid || d.isValid || _)) {
      const f = t.resolver ? ge((await U()).errors) : await Q(o, !0);
      f !== a.isValid && g.state.next({
        isValid: f
      });
    }
  }, $ = (_, f) => {
    !t.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((_ || Array.from(l.mount)).forEach((m) => {
      m && (f ? G(a.validatingFields, m, f) : re(a.validatingFields, m));
    }), g.state.next({
      validatingFields: a.validatingFields,
      isValidating: !ge(a.validatingFields)
    }));
  }, M = (_, f = [], m, z, x = !0, w = !0) => {
    if (z && m && !t.disabled) {
      if (i.action = !0, w && Array.isArray(C(o, _))) {
        const D = m(C(o, _), z.argA, z.argB);
        x && G(o, _, D);
      }
      if (w && Array.isArray(C(a.errors, _))) {
        const D = m(C(a.errors, _), z.argA, z.argB);
        x && G(a.errors, _, D), di(a.errors, _);
      }
      if ((u.touchedFields || d.touchedFields) && w && Array.isArray(C(a.touchedFields, _))) {
        const D = m(C(a.touchedFields, _), z.argA, z.argB);
        x && G(a.touchedFields, _, D);
      }
      (u.dirtyFields || d.dirtyFields) && (a.dirtyFields = lt(n, r)), g.state.next({
        name: _,
        isDirty: ce(_, f),
        dirtyFields: a.dirtyFields,
        errors: a.errors,
        isValid: a.isValid
      });
    } else
      G(r, _, f);
  }, k = (_, f) => {
    G(a.errors, _, f), g.state.next({
      errors: a.errors
    });
  }, P = (_) => {
    a.errors = _, g.state.next({
      errors: a.errors,
      isValid: !1
    });
  }, A = (_, f, m, z) => {
    const x = C(o, _);
    if (x) {
      const w = C(r, _, ee(m) ? C(n, _) : m);
      ee(w) || z && z.defaultChecked || f ? G(r, _, f ? w : co(x._f)) : T(_, w), i.mount && p();
    }
  }, N = (_, f, m, z, x) => {
    let w = !1, D = !1;
    const V = {
      name: _
    };
    if (!t.disabled) {
      if (!m || z) {
        (u.isDirty || d.isDirty) && (D = a.isDirty, a.isDirty = V.isDirty = ce(), w = D !== V.isDirty);
        const W = Oe(C(n, _), f);
        D = !!C(a.dirtyFields, _), W ? re(a.dirtyFields, _) : G(a.dirtyFields, _, !0), V.dirtyFields = a.dirtyFields, w = w || (u.dirtyFields || d.dirtyFields) && D !== !W;
      }
      if (m) {
        const W = C(a.touchedFields, _);
        W || (G(a.touchedFields, _, m), V.touchedFields = a.touchedFields, w = w || (u.touchedFields || d.touchedFields) && W !== m);
      }
      w && x && g.state.next(V);
    }
    return w ? V : {};
  }, F = (_, f, m, z) => {
    const x = C(a.errors, _), w = (u.isValid || d.isValid) && he(f) && a.isValid !== f;
    if (t.delayError && m ? (c = h(() => k(_, m)), c(t.delayError)) : (clearTimeout(s), c = null, m ? G(a.errors, _, m) : re(a.errors, _)), (m ? !Oe(x, m) : x) || !ge(z) || w) {
      const D = {
        ...z,
        ...w && he(f) ? { isValid: f } : {},
        errors: a.errors,
        name: _
      };
      a = {
        ...a,
        ...D
      }, g.state.next(D);
    }
  }, U = async (_) => {
    $(_, !0);
    const f = await t.resolver(r, t.context, ri(_ || l.mount, o, t.criteriaMode, t.shouldUseNativeValidation));
    return $(_), f;
  }, ae = async (_) => {
    const { errors: f } = await U(_);
    if (_)
      for (const m of _) {
        const z = C(f, m);
        z ? G(a.errors, m, z) : re(a.errors, m);
      }
    else
      a.errors = f;
    return f;
  }, Q = async (_, f, m = {
    valid: !0
  }) => {
    for (const z in _) {
      const x = _[z];
      if (x) {
        const { _f: w, ...D } = x;
        if (w) {
          const V = l.array.has(w.name), W = x._f && ii(x._f);
          W && u.validatingFields && $([z], !0);
          const me = await ho(x, l.disabled, r, b, t.shouldUseNativeValidation && !f, V);
          if (W && u.validatingFields && $([z]), me[w.name] && (m.valid = !1, f))
            break;
          !f && (C(me, w.name) ? V ? _i(a.errors, me, w.name) : G(a.errors, w.name, me[w.name]) : re(a.errors, w.name));
        }
        !ge(D) && await Q(D, f, m);
      }
    }
    return m.valid;
  }, X = () => {
    for (const _ of l.unMount) {
      const f = C(o, _);
      f && (f._f.refs ? f._f.refs.every((m) => !_a(m)) : !_a(f._f.ref)) && la(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, ce = (_, f) => !t.disabled && (_ && f && G(r, _, f), !Oe(Ve(), n)), B = (_, f, m) => wn(_, l, {
    ...i.mount ? r : ee(f) ? n : Ce(_) ? { [_]: f } : f
  }, m, f), E = (_) => Oa(C(i.mount ? r : n, _, t.shouldUnregister ? C(n, _, []) : [])), T = (_, f, m = {}) => {
    const z = C(o, _);
    let x = f;
    if (z) {
      const w = z._f;
      w && (!w.disabled && G(r, _, An(f, w)), x = Tt(w.ref) && de(f) ? "" : f, xn(w.ref) ? [...w.ref.options].forEach((D) => D.selected = x.includes(D.value)) : w.refs ? $t(w.ref) ? w.refs.forEach((D) => {
        (!D.defaultChecked || !D.disabled) && (Array.isArray(x) ? D.checked = !!x.find((V) => V === D.value) : D.checked = x === D.value || !!x);
      }) : w.refs.forEach((D) => D.checked = D.value === x) : Ba(w.ref) ? w.ref.value = "" : (w.ref.value = x, w.ref.type || g.state.next({
        name: _,
        values: ie(r)
      })));
    }
    (m.shouldDirty || m.shouldTouch) && N(_, x, m.shouldTouch, m.shouldDirty, !0), m.shouldValidate && ke(_);
  }, Z = (_, f, m) => {
    for (const z in f) {
      if (!f.hasOwnProperty(z))
        return;
      const x = f[z], w = _ + "." + z, D = C(o, w);
      (l.array.has(_) || te(x) || D && !D._f) && !Ue(x) ? Z(w, x, m) : T(w, x, m);
    }
  }, q = (_, f, m = {}) => {
    const z = C(o, _), x = l.array.has(_), w = ie(f);
    G(r, _, w), x ? (g.array.next({
      name: _,
      values: ie(r)
    }), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && m.shouldDirty && g.state.next({
      name: _,
      dirtyFields: lt(n, r),
      isDirty: ce(_, w)
    })) : z && !z._f && !de(w) ? Z(_, w, m) : T(_, w, m), go(_, l) && g.state.next({ ...a, name: _ }), g.state.next({
      name: i.mount ? _ : void 0,
      values: ie(r)
    });
  }, oe = async (_) => {
    i.mount = !0;
    const f = _.target;
    let m = f.name, z = !0;
    const x = C(o, m), w = (W) => {
      z = Number.isNaN(W) || Ue(W) && isNaN(W.getTime()) || Oe(W, C(r, m, W));
    }, D = uo(t.mode), V = uo(t.reValidateMode);
    if (x) {
      let W, me;
      const St = f.type ? co(x._f) : yn(_), Ee = _.type === Bt.BLUR || _.type === Bt.FOCUS_OUT, Gr = !li(x._f) && !t.resolver && !C(a.errors, m) && !x._f.deps || ui(Ee, C(a.touchedFields, m), a.isSubmitted, V, D), ua = go(m, l, Ee);
      G(r, m, St), Ee ? (!f || !f.readOnly) && (x._f.onBlur && x._f.onBlur(_), c && c(0)) : x._f.onChange && x._f.onChange(_);
      const da = N(m, St, Ee), Ur = !ge(da) || ua;
      if (!Ee && g.state.next({
        name: m,
        type: _.type,
        values: ie(r)
      }), Gr)
        return (u.isValid || d.isValid) && (t.mode === "onBlur" ? Ee && p() : Ee || p()), Ur && g.state.next({ name: m, ...ua ? {} : da });
      if (!Ee && ua && g.state.next({ ...a }), t.resolver) {
        const { errors: to } = await U([m]);
        if (w(St), z) {
          const Zr = fo(a.errors, o, m), ao = fo(to, o, Zr.name || m);
          W = ao.error, m = ao.name, me = ge(to);
        }
      } else
        $([m], !0), W = (await ho(x, l.disabled, r, b, t.shouldUseNativeValidation))[m], $([m]), w(St), z && (W ? me = !1 : (u.isValid || d.isValid) && (me = await Q(o, !0)));
      z && (x._f.deps && ke(x._f.deps), F(m, me, W, da));
    }
  }, ve = (_, f) => {
    if (C(a.errors, f) && _.focus)
      return _.focus(), 1;
  }, ke = async (_, f = {}) => {
    let m, z;
    const x = dt(_);
    if (t.resolver) {
      const w = await ae(ee(_) ? _ : x);
      m = ge(w), z = _ ? !x.some((D) => C(w, D)) : m;
    } else _ ? (z = (await Promise.all(x.map(async (w) => {
      const D = C(o, w);
      return await Q(D && D._f ? { [w]: D } : D);
    }))).every(Boolean), !(!z && !a.isValid) && p()) : z = m = await Q(o);
    return g.state.next({
      ...!Ce(_) || (u.isValid || d.isValid) && m !== a.isValid ? {} : { name: _ },
      ...t.resolver || !_ ? { isValid: m } : {},
      errors: a.errors
    }), f.shouldFocus && !z && _t(o, ve, _ ? x : l.mount), z;
  }, Ve = (_) => {
    const f = {
      ...i.mount ? r : n
    };
    return ee(_) ? f : Ce(_) ? C(f, _) : _.map((m) => C(f, m));
  }, ue = (_, f) => ({
    invalid: !!C((f || a).errors, _),
    isDirty: !!C((f || a).dirtyFields, _),
    error: C((f || a).errors, _),
    isValidating: !!C(a.validatingFields, _),
    isTouched: !!C((f || a).touchedFields, _)
  }), Ae = (_) => {
    _ && dt(_).forEach((f) => re(a.errors, f)), g.state.next({
      errors: _ ? a.errors : {}
    });
  }, Le = (_, f, m) => {
    const z = (C(o, _, { _f: {} })._f || {}).ref, x = C(a.errors, _) || {}, { ref: w, message: D, type: V, ...W } = x;
    G(a.errors, _, {
      ...W,
      ...f,
      ref: z
    }), g.state.next({
      name: _,
      errors: a.errors,
      isValid: !1
    }), m && m.shouldFocus && z && z.focus && z.focus();
  }, Ct = (_, f) => we(_) ? g.state.subscribe({
    next: (m) => "values" in m && _(B(void 0, f), m)
  }) : B(_, f, !0), Ha = (_) => g.state.subscribe({
    next: (f) => {
      ci(_.name, f.name, _.exact) && si(f, _.formState || u, Vr, _.reRenderRoot) && _.callback({
        values: { ...r },
        ...a,
        ...f,
        defaultValues: n
      });
    }
  }).unsubscribe, Br = (_) => (i.mount = !0, d = {
    ...d,
    ..._.formState
  }, Ha({
    ..._,
    formState: d
  })), la = (_, f = {}) => {
    for (const m of _ ? dt(_) : l.mount)
      l.mount.delete(m), l.array.delete(m), f.keepValue || (re(o, m), re(r, m)), !f.keepError && re(a.errors, m), !f.keepDirty && re(a.dirtyFields, m), !f.keepTouched && re(a.touchedFields, m), !f.keepIsValidating && re(a.validatingFields, m), !t.shouldUnregister && !f.keepDefaultValue && re(n, m);
    g.state.next({
      values: ie(r)
    }), g.state.next({
      ...a,
      ...f.keepDirty ? { isDirty: ce() } : {}
    }), !f.keepIsValid && p();
  }, Ja = ({ disabled: _, name: f }) => {
    (he(_) && i.mount || _ || l.disabled.has(f)) && (_ ? l.disabled.add(f) : l.disabled.delete(f));
  }, sa = (_, f = {}) => {
    let m = C(o, _);
    const z = he(f.disabled) || he(t.disabled);
    return G(o, _, {
      ...m || {},
      _f: {
        ...m && m._f ? m._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...f
      }
    }), l.mount.add(_), m ? Ja({
      disabled: he(f.disabled) ? f.disabled : t.disabled,
      name: _
    }) : A(_, !0, f.value), {
      ...z ? { disabled: f.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!f.required,
        min: st(f.min),
        max: st(f.max),
        minLength: st(f.minLength),
        maxLength: st(f.maxLength),
        pattern: st(f.pattern)
      } : {},
      name: _,
      onChange: oe,
      onBlur: oe,
      ref: (x) => {
        if (x) {
          sa(_, f), m = C(o, _);
          const w = ee(x.value) && x.querySelectorAll && x.querySelectorAll("input,select,textarea")[0] || x, D = ai(w), V = m._f.refs || [];
          if (D ? V.find((W) => W === w) : w === m._f.ref)
            return;
          G(o, _, {
            _f: {
              ...m._f,
              ...D ? {
                refs: [
                  ...V.filter(_a),
                  w,
                  ...Array.isArray(C(n, _)) ? [{}] : []
                ],
                ref: { type: w.type, name: _ }
              } : { ref: w }
            }
          }), A(_, !1, void 0, w);
        } else
          m = C(o, _, {}), m._f && (m._f.mount = !1), (t.shouldUnregister || f.shouldUnregister) && !(vn(l.array, _) && i.action) && l.unMount.add(_);
      }
    };
  }, ca = () => t.shouldFocusError && _t(o, ve, l.mount), Tr = (_) => {
    he(_) && (g.state.next({ disabled: _ }), _t(o, (f, m) => {
      const z = C(o, m);
      z && (f.disabled = z._f.disabled || _, Array.isArray(z._f.refs) && z._f.refs.forEach((x) => {
        x.disabled = z._f.disabled || _;
      }));
    }, 0, !1));
  }, Ya = (_, f) => async (m) => {
    let z;
    m && (m.preventDefault && m.preventDefault(), m.persist && m.persist());
    let x = ie(r);
    if (g.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: w, values: D } = await U();
      a.errors = w, x = ie(D);
    } else
      await Q(o);
    if (l.disabled.size)
      for (const w of l.disabled)
        re(x, w);
    if (re(a.errors, "root"), ge(a.errors)) {
      g.state.next({
        errors: {}
      });
      try {
        await _(x, m);
      } catch (w) {
        z = w;
      }
    } else
      f && await f({ ...a.errors }, m), ca(), setTimeout(ca);
    if (g.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ge(a.errors) && !z,
      submitCount: a.submitCount + 1,
      errors: a.errors
    }), z)
      throw z;
  }, Rr = (_, f = {}) => {
    C(o, _) && (ee(f.defaultValue) ? q(_, ie(C(n, _))) : (q(_, f.defaultValue), G(n, _, ie(f.defaultValue))), f.keepTouched || re(a.touchedFields, _), f.keepDirty || (re(a.dirtyFields, _), a.isDirty = f.defaultValue ? ce(_, ie(C(n, _))) : ce()), f.keepError || (re(a.errors, _), u.isValid && p()), g.state.next({ ...a }));
  }, Qa = (_, f = {}) => {
    const m = _ ? ie(_) : n, z = ie(m), x = ge(_), w = x ? n : z;
    if (f.keepDefaultValues || (n = m), !f.keepValues) {
      if (f.keepDirtyValues) {
        const D = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(lt(n, r))
        ]);
        for (const V of Array.from(D))
          C(a.dirtyFields, V) ? G(w, V, C(r, V)) : q(V, C(w, V));
      } else {
        if (Na && ee(_))
          for (const D of l.mount) {
            const V = C(o, D);
            if (V && V._f) {
              const W = Array.isArray(V._f.refs) ? V._f.refs[0] : V._f.ref;
              if (Tt(W)) {
                const me = W.closest("form");
                if (me) {
                  me.reset();
                  break;
                }
              }
            }
          }
        if (f.keepFieldsRef)
          for (const D of l.mount)
            q(D, C(w, D));
        else
          o = {};
      }
      r = t.shouldUnregister ? f.keepDefaultValues ? ie(n) : {} : ie(w), g.array.next({
        values: { ...w }
      }), g.state.next({
        values: { ...w }
      });
    }
    l = {
      mount: f.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, i.mount = !u.isValid || !!f.keepIsValid || !!f.keepDirtyValues, i.watch = !!t.shouldUnregister, g.state.next({
      submitCount: f.keepSubmitCount ? a.submitCount : 0,
      isDirty: x ? !1 : f.keepDirty ? a.isDirty : !!(f.keepDefaultValues && !Oe(_, n)),
      isSubmitted: f.keepIsSubmitted ? a.isSubmitted : !1,
      dirtyFields: x ? {} : f.keepDirtyValues ? f.keepDefaultValues && r ? lt(n, r) : a.dirtyFields : f.keepDefaultValues && _ ? lt(n, _) : f.keepDirty ? a.dirtyFields : {},
      touchedFields: f.keepTouched ? a.touchedFields : {},
      errors: f.keepErrors ? a.errors : {},
      isSubmitSuccessful: f.keepIsSubmitSuccessful ? a.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: n
    });
  }, Xa = (_, f) => Qa(we(_) ? _(r) : _, f), Fr = (_, f = {}) => {
    const m = C(o, _), z = m && m._f;
    if (z) {
      const x = z.refs ? z.refs[0] : z.ref;
      x.focus && (x.focus(), f.shouldSelect && we(x.select) && x.select());
    }
  }, Vr = (_) => {
    a = {
      ...a,
      ..._
    };
  }, eo = {
    control: {
      register: sa,
      unregister: la,
      getFieldState: ue,
      handleSubmit: Ya,
      setError: Le,
      _subscribe: Ha,
      _runSchema: U,
      _focusError: ca,
      _getWatch: B,
      _getDirty: ce,
      _setValid: p,
      _setFieldArray: M,
      _setDisabledField: Ja,
      _setErrors: P,
      _getFieldArray: E,
      _reset: Qa,
      _resetDefaultValues: () => we(t.defaultValues) && t.defaultValues().then((_) => {
        Xa(_, t.resetOptions), g.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: X,
      _disableForm: Tr,
      _subjects: g,
      _proxyFormState: u,
      get _fields() {
        return o;
      },
      get _formValues() {
        return r;
      },
      get _state() {
        return i;
      },
      set _state(_) {
        i = _;
      },
      get _defaultValues() {
        return n;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return a;
      },
      get _options() {
        return t;
      },
      set _options(_) {
        t = {
          ...t,
          ..._
        };
      }
    },
    subscribe: Br,
    trigger: ke,
    register: sa,
    handleSubmit: Ya,
    watch: Ct,
    setValue: q,
    getValues: Ve,
    reset: Xa,
    resetField: Rr,
    clearErrors: Ae,
    unregister: la,
    setError: Le,
    setFocus: Fr,
    getFieldState: ue
  };
  return {
    ...eo,
    formControl: eo
  };
}
function bi(e = {}) {
  const t = L.useRef(void 0), a = L.useRef(void 0), [o, n] = L.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: we(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    isReady: !1,
    defaultValues: we(e.defaultValues) ? void 0 : e.defaultValues
  });
  if (!t.current)
    if (e.formControl)
      t.current = {
        ...e.formControl,
        formState: o
      }, e.defaultValues && !we(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: i, ...l } = fi(e);
      t.current = {
        ...l,
        formState: o
      };
    }
  const r = t.current.control;
  return r._options = e, La(() => {
    const i = r._subscribe({
      formState: r._proxyFormState,
      callback: () => n({ ...r._formState }),
      reRenderRoot: !0
    });
    return n((l) => ({
      ...l,
      isReady: !0
    })), r._formState.isReady = !0, i;
  }, [r]), L.useEffect(() => r._disableForm(e.disabled), [r, e.disabled]), L.useEffect(() => {
    e.mode && (r._options.mode = e.mode), e.reValidateMode && (r._options.reValidateMode = e.reValidateMode);
  }, [r, e.mode, e.reValidateMode]), L.useEffect(() => {
    e.errors && (r._setErrors(e.errors), r._focusError());
  }, [r, e.errors]), L.useEffect(() => {
    e.shouldUnregister && r._subjects.state.next({
      values: r._getWatch()
    });
  }, [r, e.shouldUnregister]), L.useEffect(() => {
    if (r._proxyFormState.isDirty) {
      const i = r._getDirty();
      i !== o.isDirty && r._subjects.state.next({
        isDirty: i
      });
    }
  }, [r, o.isDirty]), L.useEffect(() => {
    e.values && !Oe(e.values, a.current) ? (r._reset(e.values, {
      keepFieldsRef: !0,
      ...r._options.resetOptions
    }), a.current = e.values, n((i) => ({ ...i }))) : r._resetDefaultValues();
  }, [r, e.values]), L.useEffect(() => {
    r._state.mount || (r._setValid(), r._state.mount = !0), r._state.watch && (r._state.watch = !1, r._subjects.state.next({ ...r._formState })), r._removeUnmounted();
  }), t.current.formState = $n(o, r), t.current;
}
const hi = (e, t, a, o) => {
  const n = [a, {
    code: t,
    ...o || {}
  }];
  if (e?.services?.logger?.forward)
    return e.services.logger.forward(n, "warn", "react-i18next::", !0);
  Ze(n[0]) && (n[0] = `react-i18next:: ${n[0]}`), e?.services?.logger?.warn ? e.services.logger.warn(...n) : console?.warn && console.warn(...n);
}, mo = {}, ya = (e, t, a, o) => {
  Ze(a) && mo[a] || (Ze(a) && (mo[a] = /* @__PURE__ */ new Date()), hi(e, t, a, o));
}, Mn = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const a = () => {
      setTimeout(() => {
        e.off("initialized", a);
      }, 0), t();
    };
    e.on("initialized", a);
  }
}, va = (e, t, a) => {
  e.loadNamespaces(t, Mn(e, a));
}, po = (e, t, a, o) => {
  if (Ze(a) && (a = [a]), e.options.preload && e.options.preload.indexOf(t) > -1) return va(e, a, o);
  a.forEach((n) => {
    e.options.ns.indexOf(n) < 0 && e.options.ns.push(n);
  }), e.loadLanguages(t, Mn(e, o));
}, mi = (e, t, a = {}) => !t.languages || !t.languages.length ? (ya(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: a.lng,
  precheck: (o, n) => {
    if (a.bindI18n && a.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !n(o.isLanguageChangingTo, e)) return !1;
  }
}), Ze = (e) => typeof e == "string", pi = (e) => typeof e == "object" && e !== null, yi = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, vi = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, ki = (e) => vi[e], $i = (e) => e.replace(yi, ki);
let wi = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: $i
};
const xi = () => wi;
let Ci;
const Si = () => Ci, Dn = gn();
class zi {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((a) => {
      this.usedNamespaces[a] || (this.usedNamespaces[a] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Ai = (e, t) => {
  const a = Et();
  return Ie(() => {
    a.current = e;
  }, [e, t]), a.current;
}, Nn = (e, t, a, o) => e.getFixedT(t, a, o), Pi = (e, t, a, o) => bn(Nn(e, t, a, o), [e, t, a, o]), Ra = (e, t = {}) => {
  const {
    i18n: a
  } = t, {
    i18n: o,
    defaultNS: n
  } = fn(Dn) || {}, r = a || o || Si();
  if (r && !r.reportNamespaces && (r.reportNamespaces = new zi()), !r) {
    ya(r, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const A = (F, U) => Ze(U) ? U : pi(U) && Ze(U.defaultValue) ? U.defaultValue : Array.isArray(F) ? F[F.length - 1] : F, N = [A, {}, !1];
    return N.t = A, N.i18n = {}, N.ready = !1, N;
  }
  r.options.react?.wait && ya(r, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...xi(),
    ...r.options.react,
    ...t
  }, {
    useSuspense: l,
    keyPrefix: c
  } = i;
  let s = e || n || r.options?.defaultNS;
  s = Ze(s) ? [s] : s || ["translation"], r.reportNamespaces.addUsedNamespaces?.(s);
  const u = (r.isInitialized || r.initializedStoreOnce) && s.every((A) => mi(A, r, i)), d = Pi(r, t.lng || null, i.nsMode === "fallback" ? s : s[0], c), g = () => d, b = () => Nn(r, t.lng || null, i.nsMode === "fallback" ? s : s[0], c), [h, p] = xe(g);
  let $ = s.join();
  t.lng && ($ = `${t.lng}${$}`);
  const M = Ai($), k = Et(!0);
  Ie(() => {
    const {
      bindI18n: A,
      bindI18nStore: N
    } = i;
    k.current = !0, !u && !l && (t.lng ? po(r, t.lng, s, () => {
      k.current && p(b);
    }) : va(r, s, () => {
      k.current && p(b);
    })), u && M && M !== $ && k.current && p(b);
    const F = () => {
      k.current && p(b);
    };
    return A && r?.on(A, F), N && r?.store.on(N, F), () => {
      k.current = !1, r && A && A?.split(" ").forEach((U) => r.off(U, F)), N && r && N.split(" ").forEach((U) => r.store.off(U, F));
    };
  }, [r, $]), Ie(() => {
    k.current && u && p(g);
  }, [r, c, u]);
  const P = [h, r, u];
  if (P.t = h, P.i18n = r, P.ready = u, u || !u && !l) return P;
  throw new Promise((A) => {
    t.lng ? po(r, t.lng, s, () => A()) : va(r, s, () => A());
  });
};
function Mi({
  i18n: e,
  defaultNS: t,
  children: a
}) {
  const o = hn(() => ({
    i18n: e,
    defaultNS: t
  }), [e, t]);
  return Kr(Dn.Provider, {
    value: o
  }, a);
}
function On(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = On(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function H() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = On(e)) && (o && (o += " "), o += t);
  return o;
}
const Di = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Ni = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Oi = Di.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Ni[e]
})), Ii = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, ji = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Li(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ y("span", { className: a }, a));
}
const We = kt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = Oi.find((c) => c.name === e), l = H("icon", `ds-${i?.class}`, ji[t], Ii[a], o);
    return /* @__PURE__ */ y("i", { className: l, ...n, ref: r, children: Li(i?.paths) });
  }
);
We.displayName = "Icon";
const Ei = "_loader_1ksyv_29", Bi = "_circle_1ksyv_41", Ye = {
  loader: Ei,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: Bi,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, Ti = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, Ri = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function Fi({ onDark: e, size: t = "medium", color: a = "primary", className: o }) {
  return /* @__PURE__ */ R(
    "svg",
    {
      className: H(
        Ye.loader,
        Ye[Ti[t]],
        Ye[Ri[a]],
        e && Ye["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ y("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ y("circle", { className: Ye.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ R(
          "circle",
          {
            className: Ye["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ y("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ y(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const Vi = "_button_z1os6_29", Gi = "_disabled_z1os6_43", Ui = "_loader_z1os6_263", Me = {
  button: Vi,
  disabled: Gi,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: Ui,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, nt = kt(
  ({
    text: e,
    color: t = "primary",
    size: a = "medium",
    isFullWidth: o = !1,
    icon: n,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: l = "medium",
    isContrasted: c = !1,
    disabled: s = !1,
    className: u,
    children: d,
    ...g
  }, b) => {
    const h = H(
      Me.button,
      Me[Zi[t]],
      Me[Wi[a]],
      o && Me["is-full-width"],
      s && Me.disabled,
      r === "right" && Me["has-icon-right"],
      c && Me["is-contrasted"],
      i && Me["is-loading"],
      u
    ), p = /* @__PURE__ */ R(Wr, { children: [
      i && /* @__PURE__ */ y(Fi, { className: Me.loader, onDark: !0, size: "small" }),
      n && r === "left" && /* @__PURE__ */ y(We, { color: "inherit", size: l, name: n }),
      d ?? e,
      n && r === "right" && /* @__PURE__ */ y(We, { color: "inherit", size: l, name: n })
    ] });
    if (Ki(g))
      return /* @__PURE__ */ y(
        "a",
        {
          ...g,
          href: s ? void 0 : g.href,
          className: h,
          target: g.target,
          ref: b,
          children: p
        }
      );
    if (qi(g))
      return /* @__PURE__ */ y(
        "button",
        {
          disabled: i || s,
          ...g,
          className: h,
          ref: b,
          children: p
        }
      );
  }
);
nt.displayName = "Button";
const Zi = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, Wi = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function Ki(e) {
  return "href" in e && typeof e.href == "string";
}
function qi(e) {
  return !("href" in e);
}
const Hi = "_buttons_1obz3_29", yo = {
  buttons: Hi,
  "flex-grow-buttons": "_flex-grow-buttons_1obz3_44"
}, In = ({ children: e, flexGrowButtons: t }) => /* @__PURE__ */ y("div", { className: H(yo.buttons, t && yo["flex-grow-buttons"]), children: e }), vo = {
  MOBILE: 640,
  TABLET: 768
}, Ji = "_text_1tduc_29", Be = {
  text: Ji,
  "is-small": "_is-small_1tduc_34",
  "is-uppercase": "_is-uppercase_1tduc_38",
  "is-ellipsis": "_is-ellipsis_1tduc_41",
  "is-center": "_is-center_1tduc_47",
  "color-primary": "_color-primary_1tduc_50",
  "color-secondary": "_color-secondary_1tduc_53",
  "color-tertiary": "_color-tertiary_1tduc_56",
  "color-eco-green": "_color-eco-green_1tduc_59",
  "color-success": "_color-success_1tduc_62",
  "color-error": "_color-error_1tduc_65",
  "color-inverted": "_color-inverted_1tduc_68",
  "color-warning": "_color-warning_1tduc_71",
  "color-highlight": "_color-highlight_1tduc_74",
  "color-inherit": "_color-inherit_1tduc_77",
  "is-bold": "_is-bold_1tduc_80",
  "size-xs": "_size-xs_1tduc_83",
  "size-sm": "_size-sm_1tduc_86",
  "size-base": "_size-base_1tduc_89",
  "size-lg": "_size-lg_1tduc_92",
  "size-xl": "_size-xl_1tduc_95",
  "dialog-overlay-show": "_dialog-overlay-show_1tduc_1",
  "dialog-content-show": "_dialog-content-show_1tduc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1tduc_1"
};
function bt({
  children: e,
  dangerouslySetInnerHTML: t,
  isSmall: a,
  isUppercase: o,
  ellipsis: n,
  isSpan: r,
  className: i = "",
  color: l = "primary",
  isBold: c,
  size: s,
  title: u,
  center: d,
  ...g
}) {
  const b = H(
    Be.text,
    a && Be["is-small"],
    n && Be["is-ellipsis"],
    l && Be[`color-${l}`],
    c && Be["is-bold"],
    o && Be["is-uppercase"],
    s && Be[`size-${s}`],
    d && Be["is-center"],
    i
  ), h = r ? "span" : "div";
  return t ? /* @__PURE__ */ y(h, { className: b, dangerouslySetInnerHTML: t, ...g, title: u }) : /* @__PURE__ */ y(h, { className: b, ...g, children: e });
}
const Yi = "_title_1s6y9_29", Qi = "_subtitle_1s6y9_106", Ge = {
  "title-container": "_title-container_1s6y9_29",
  "color-inverted": "_color-inverted_1s6y9_32",
  "is-primary": "_is-primary_1s6y9_35",
  "is-secondary": "_is-secondary_1s6y9_38",
  "is-tertiary": "_is-tertiary_1s6y9_41",
  "is-success": "_is-success_1s6y9_44",
  "is-error": "_is-error_1s6y9_47",
  "is-eco-green": "_is-eco-green_1s6y9_50",
  title: Yi,
  "is-1": "_is-1_1s6y9_61",
  "is-impact": "_is-impact_1s6y9_70",
  "is-2": "_is-2_1s6y9_74",
  "is-3": "_is-3_1s6y9_84",
  "text-align-left": "_text-align-left_1s6y9_94",
  "text-align-right": "_text-align-right_1s6y9_97",
  "text-align-center": "_text-align-center_1s6y9_100",
  "text-align-justify": "_text-align-justify_1s6y9_103",
  subtitle: Qi,
  "dialog-overlay-show": "_dialog-overlay-show_1s6y9_1",
  "dialog-content-show": "_dialog-content-show_1s6y9_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1s6y9_1"
}, Xi = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function jn({
  color: e = "default",
  children: t,
  level: a = 3,
  hasHeaderTag: o = !1,
  isImpact: n,
  subtitle: r,
  className: i = "",
  title: l,
  textAlign: c,
  ...s
}) {
  const u = `h${a}`, d = `${o ? u : "p"}`, g = H(
    Ge.title,
    Ge[`is-${a}`],
    n && Ge["is-impact"],
    c && Ge[`text-align-${c}`],
    i
  );
  return /* @__PURE__ */ R("div", { className: H(Ge["title-container"], Ge[Xi[e]]), children: [
    /* @__PURE__ */ y(d, { className: g, ...s, title: l, children: t }),
    r && /* @__PURE__ */ y("p", { className: H(Ge.subtitle), children: r })
  ] });
}
const zt = {
  "flex-children": "_flex-children_7pjb4_29",
  "justify-self-start": "_justify-self-start_7pjb4_29",
  "justify-self-end": "_justify-self-end_7pjb4_32",
  "justify-self-center": "_justify-self-center_7pjb4_35",
  "align-self-start": "_align-self-start_7pjb4_38",
  "align-self-end": "_align-self-end_7pjb4_41",
  "align-self-center": "_align-self-center_7pjb4_44",
  "is-full-width": "_is-full-width_7pjb4_47",
  "dialog-overlay-show": "_dialog-overlay-show_7pjb4_1",
  "dialog-content-show": "_dialog-content-show_7pjb4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7pjb4_1"
}, el = ({ alignSelf: e, justifySelf: t, children: a, isFullWidth: o, ...n }) => {
  const r = H(
    zt["flex-children"],
    e && zt[`align-self-${e}`],
    t && zt[`justify-self-${t}`],
    o && zt["is-full-width"]
  );
  return /* @__PURE__ */ y("div", { className: r, ...n, children: a });
}, tl = "_flex_1taae_29", al = "_wrap_1taae_67", ol = "_nowrap_1taae_70", nl = "_shrink_1taae_88", pe = {
  flex: tl,
  "flex-row": "_flex-row_1taae_34",
  "flex-column": "_flex-column_1taae_37",
  "justify-start": "_justify-start_1taae_40",
  "justify-end": "_justify-end_1taae_43",
  "justify-center": "_justify-center_1taae_46",
  "justify-space-between": "_justify-space-between_1taae_49",
  "justify-space-around": "_justify-space-around_1taae_52",
  "align-start": "_align-start_1taae_55",
  "align-end": "_align-end_1taae_58",
  "align-center": "_align-center_1taae_61",
  "align-stretch": "_align-stretch_1taae_64",
  wrap: al,
  nowrap: ol,
  "wrap-reverse": "_wrap-reverse_1taae_73",
  "is-full-width": "_is-full-width_1taae_79",
  "is-full-height": "_is-full-height_1taae_82",
  "flex-grow": "_flex-grow_1taae_85",
  shrink: nl,
  "hide-on-mobile": "_hide-on-mobile_1taae_91",
  "gap-0": "_gap-0_1taae_99",
  "gap-1": "_gap-1_1taae_102",
  "gap-2": "_gap-2_1taae_105",
  "gap-3": "_gap-3_1taae_108",
  "gap-4": "_gap-4_1taae_111",
  "gap-5": "_gap-5_1taae_114",
  "gap-6": "_gap-6_1taae_117",
  "gap-7": "_gap-7_1taae_120",
  "gap-8": "_gap-8_1taae_123",
  "gap-9": "_gap-9_1taae_126",
  "gap-10": "_gap-10_1taae_129",
  "gap-11": "_gap-11_1taae_132",
  "gap-12": "_gap-12_1taae_135",
  "gap-14": "_gap-14_1taae_138",
  "gap-16": "_gap-16_1taae_141",
  "gap-18": "_gap-18_1taae_144",
  "gap-20": "_gap-20_1taae_147",
  "gap-24": "_gap-24_1taae_150",
  "gap-28": "_gap-28_1taae_153",
  "gap-32": "_gap-32_1taae_156",
  "gap-36": "_gap-36_1taae_159",
  "gap-40": "_gap-40_1taae_162",
  "gap-44": "_gap-44_1taae_165",
  "gap-48": "_gap-48_1taae_168",
  "gap-52": "_gap-52_1taae_171",
  "gap-56": "_gap-56_1taae_174",
  "gap-60": "_gap-60_1taae_177",
  "gap-64": "_gap-64_1taae_180",
  "gap-72": "_gap-72_1taae_183",
  "gap-80": "_gap-80_1taae_186",
  "gap-96": "_gap-96_1taae_189",
  "no-margin": "_no-margin_1taae_192",
  "dialog-overlay-show": "_dialog-overlay-show_1taae_1",
  "dialog-content-show": "_dialog-content-show_1taae_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1taae_1"
};
function tt({
  children: e,
  direction: t = "row",
  justifyContent: a = "start",
  alignItems: o = "start",
  flexWrap: n = "wrap",
  className: r = "",
  isFullWidth: i = !1,
  isFullHeight: l = !1,
  gap: c,
  style: s,
  noMargin: u = !1,
  flexGrow: d = !1,
  hideOnMobile: g = !1,
  shrink: b = !1,
  ...h
}) {
  const p = H(
    pe.flex,
    pe[`flex-${t}`],
    pe[`justify-${a}`],
    pe[`align-${o}`],
    pe[n],
    i && pe["is-full-width"],
    l && pe["is-full-height"],
    c && pe[`gap-${c}`],
    u && pe["no-margin"],
    d && pe["flex-grow"],
    g && pe["hide-on-mobile"],
    b && pe.shrink,
    r
  );
  return /* @__PURE__ */ y("div", { className: p, ...h, style: s, children: e });
}
tt.FlexChildren = el;
function je(e, t, { checkForDefaultPrevented: a = !0 } = {}) {
  return function(o) {
    if (e?.(o), a === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var ht = globalThis?.document ? S.useLayoutEffect : () => {
}, rl = S[" useInsertionEffect ".trim().toString()] || ht;
function Ln({
  prop: e,
  defaultProp: t,
  onChange: a = () => {
  },
  caller: o
}) {
  const [n, r, i] = il({
    defaultProp: t,
    onChange: a
  }), l = e !== void 0, c = l ? e : n;
  {
    const u = S.useRef(e !== void 0);
    S.useEffect(() => {
      const d = u.current;
      d !== l && console.warn(
        `${o} is changing from ${d ? "controlled" : "uncontrolled"} to ${l ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = l;
    }, [l, o]);
  }
  const s = S.useCallback(
    (u) => {
      if (l) {
        const d = ll(u) ? u(e) : u;
        d !== e && i.current?.(d);
      } else
        r(u);
    },
    [l, e, r, i]
  );
  return [c, s];
}
function il({
  defaultProp: e,
  onChange: t
}) {
  const [a, o] = S.useState(e), n = S.useRef(a), r = S.useRef(t);
  return rl(() => {
    r.current = t;
  }, [t]), S.useEffect(() => {
    n.current !== a && (r.current?.(a), n.current = a);
  }, [a, n]), [a, o, r];
}
function ll(e) {
  return typeof e == "function";
}
function ko(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function En(...e) {
  return (t) => {
    let a = !1;
    const o = e.map((n) => {
      const r = ko(n, t);
      return !a && typeof r == "function" && (a = !0), r;
    });
    if (a)
      return () => {
        for (let n = 0; n < o.length; n++) {
          const r = o[n];
          typeof r == "function" ? r() : ko(e[n], null);
        }
      };
  };
}
function Ke(...e) {
  return S.useCallback(En(...e), e);
}
function Yt(e, t = []) {
  let a = [];
  function o(r, i) {
    const l = S.createContext(i), c = a.length;
    a = [...a, i];
    const s = (d) => {
      const { scope: g, children: b, ...h } = d, p = g?.[e]?.[c] || l, $ = S.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ y(p.Provider, { value: $, children: b });
    };
    s.displayName = r + "Provider";
    function u(d, g) {
      const b = g?.[e]?.[c] || l, h = S.useContext(b);
      if (h) return h;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [s, u];
  }
  const n = () => {
    const r = a.map((i) => S.createContext(i));
    return function(i) {
      const l = i?.[e] || r;
      return S.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: l } }),
        [i, l]
      );
    };
  };
  return n.scopeName = e, [o, sl(n, ...t)];
}
function sl(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const a = () => {
    const o = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(n) {
      const r = o.reduce((i, { useScope: l, scopeName: c }) => {
        const s = l(n)[`__scope${c}`];
        return { ...i, ...s };
      }, {});
      return S.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return a.scopeName = t.scopeName, a;
}
// @__NO_SIDE_EFFECTS__
function ka(e) {
  const t = /* @__PURE__ */ cl(e), a = S.forwardRef((o, n) => {
    const { children: r, ...i } = o, l = S.Children.toArray(r), c = l.find(dl);
    if (c) {
      const s = c.props.children, u = l.map((d) => d === c ? S.Children.count(s) > 1 ? S.Children.only(null) : S.isValidElement(s) ? s.props.children : null : d);
      return /* @__PURE__ */ y(t, { ...i, ref: n, children: S.isValidElement(s) ? S.cloneElement(s, void 0, u) : null });
    }
    return /* @__PURE__ */ y(t, { ...i, ref: n, children: r });
  });
  return a.displayName = `${e}.Slot`, a;
}
// @__NO_SIDE_EFFECTS__
function cl(e) {
  const t = S.forwardRef((a, o) => {
    const { children: n, ...r } = a;
    if (S.isValidElement(n)) {
      const i = gl(n), l = _l(r, n.props);
      return n.type !== S.Fragment && (l.ref = o ? En(o, i) : i), S.cloneElement(n, l);
    }
    return S.Children.count(n) > 1 ? S.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var ul = Symbol("radix.slottable");
function dl(e) {
  return S.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === ul;
}
function _l(e, t) {
  const a = { ...t };
  for (const o in t) {
    const n = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? n && r ? a[o] = (...i) => {
      const l = r(...i);
      return n(...i), l;
    } : n && (a[o] = n) : o === "style" ? a[o] = { ...n, ...r } : o === "className" && (a[o] = [n, r].filter(Boolean).join(" "));
  }
  return { ...e, ...a };
}
function gl(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var fl = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], rt = fl.reduce((e, t) => {
  const a = /* @__PURE__ */ ka(`Primitive.${t}`), o = S.forwardRef((n, r) => {
    const { asChild: i, ...l } = n, c = i ? a : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ y(c, { ...l, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {}), bl = S.createContext(void 0);
function Bn(e) {
  const t = S.useContext(bl);
  return e || t || "ltr";
}
function hl(e) {
  const t = e + "CollectionProvider", [a, o] = Yt(t), [n, r] = a(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: $, children: M } = p, k = L.useRef(null), P = L.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ y(n, { scope: $, itemMap: P, collectionRef: k, children: M });
  };
  i.displayName = t;
  const l = e + "CollectionSlot", c = /* @__PURE__ */ ka(l), s = L.forwardRef(
    (p, $) => {
      const { scope: M, children: k } = p, P = r(l, M), A = Ke($, P.collectionRef);
      return /* @__PURE__ */ y(c, { ref: A, children: k });
    }
  );
  s.displayName = l;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", g = /* @__PURE__ */ ka(u), b = L.forwardRef(
    (p, $) => {
      const { scope: M, children: k, ...P } = p, A = L.useRef(null), N = Ke($, A), F = r(u, M);
      return L.useEffect(() => (F.itemMap.set(A, { ref: A, ...P }), () => void F.itemMap.delete(A))), /* @__PURE__ */ y(g, { [d]: "", ref: N, children: k });
    }
  );
  b.displayName = u;
  function h(p) {
    const $ = r(e + "CollectionConsumer", p);
    return L.useCallback(() => {
      const M = $.collectionRef.current;
      if (!M) return [];
      const k = Array.from(M.querySelectorAll(`[${d}]`));
      return Array.from($.itemMap.values()).sort(
        (P, A) => k.indexOf(P.ref.current) - k.indexOf(A.ref.current)
      );
    }, [$.collectionRef, $.itemMap]);
  }
  return [
    { Provider: i, Slot: s, ItemSlot: b },
    h,
    o
  ];
}
var ml = S[" useId ".trim().toString()] || (() => {
}), pl = 0;
function yl(e) {
  const [t, a] = S.useState(ml());
  return ht(() => {
    a((o) => o ?? String(pl++));
  }, [e]), t ? `radix-${t}` : "";
}
function vl(e, t) {
  return S.useReducer((a, o) => t[a][o] ?? a, e);
}
var Tn = (e) => {
  const { present: t, children: a } = e, o = kl(t), n = typeof a == "function" ? a({ present: o.isPresent }) : S.Children.only(a), r = Ke(o.ref, $l(n));
  return typeof a == "function" || o.isPresent ? S.cloneElement(n, { ref: r }) : null;
};
Tn.displayName = "Presence";
function kl(e) {
  const [t, a] = S.useState(), o = S.useRef(null), n = S.useRef(e), r = S.useRef("none"), i = e ? "mounted" : "unmounted", [l, c] = vl(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return S.useEffect(() => {
    const s = At(o.current);
    r.current = l === "mounted" ? s : "none";
  }, [l]), ht(() => {
    const s = o.current, u = n.current;
    if (u !== e) {
      const d = r.current, g = At(s);
      e ? c("MOUNT") : g === "none" || s?.display === "none" ? c("UNMOUNT") : c(u && d !== g ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, c]), ht(() => {
    if (t) {
      let s;
      const u = t.ownerDocument.defaultView ?? window, d = (b) => {
        const h = At(o.current).includes(CSS.escape(b.animationName));
        if (b.target === t && h && (c("ANIMATION_END"), !n.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", s = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, g = (b) => {
        b.target === t && (r.current = At(o.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(s), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: S.useCallback((s) => {
      o.current = s ? getComputedStyle(s) : null, a(s);
    }, [])
  };
}
function At(e) {
  return e?.animationName || "none";
}
function $l(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
function wl(e) {
  const t = S.useRef(e);
  return S.useEffect(() => {
    t.current = e;
  }), S.useMemo(() => (...a) => t.current?.(...a), []);
}
var ga = "rovingFocusGroup.onEntryFocus", xl = { bubbles: !1, cancelable: !0 }, wt = "RovingFocusGroup", [$a, Rn, Cl] = hl(wt), [Sl, Fn] = Yt(
  wt,
  [Cl]
), [zl, Al] = Sl(wt), Vn = S.forwardRef(
  (e, t) => /* @__PURE__ */ y($a.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ y($a.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ y(Pl, { ...e, ref: t }) }) })
);
Vn.displayName = wt;
var Pl = S.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: a,
    orientation: o,
    loop: n = !1,
    dir: r,
    currentTabStopId: i,
    defaultCurrentTabStopId: l,
    onCurrentTabStopIdChange: c,
    onEntryFocus: s,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, g = S.useRef(null), b = Ke(t, g), h = Bn(r), [p, $] = Ln({
    prop: i,
    defaultProp: l ?? null,
    onChange: c,
    caller: wt
  }), [M, k] = S.useState(!1), P = wl(s), A = Rn(a), N = S.useRef(!1), [F, U] = S.useState(0);
  return S.useEffect(() => {
    const ae = g.current;
    if (ae)
      return ae.addEventListener(ga, P), () => ae.removeEventListener(ga, P);
  }, [P]), /* @__PURE__ */ y(
    zl,
    {
      scope: a,
      orientation: o,
      dir: h,
      loop: n,
      currentTabStopId: p,
      onItemFocus: S.useCallback(
        (ae) => $(ae),
        [$]
      ),
      onItemShiftTab: S.useCallback(() => k(!0), []),
      onFocusableItemAdd: S.useCallback(
        () => U((ae) => ae + 1),
        []
      ),
      onFocusableItemRemove: S.useCallback(
        () => U((ae) => ae - 1),
        []
      ),
      children: /* @__PURE__ */ y(
        rt.div,
        {
          tabIndex: M || F === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: b,
          style: { outline: "none", ...e.style },
          onMouseDown: je(e.onMouseDown, () => {
            N.current = !0;
          }),
          onFocus: je(e.onFocus, (ae) => {
            const Q = !N.current;
            if (ae.target === ae.currentTarget && Q && !M) {
              const X = new CustomEvent(ga, xl);
              if (ae.currentTarget.dispatchEvent(X), !X.defaultPrevented) {
                const ce = A().filter((Z) => Z.focusable), B = ce.find((Z) => Z.active), E = ce.find((Z) => Z.id === p), T = [B, E, ...ce].filter(
                  Boolean
                ).map((Z) => Z.ref.current);
                Zn(T, u);
              }
            }
            N.current = !1;
          }),
          onBlur: je(e.onBlur, () => k(!1))
        }
      )
    }
  );
}), Gn = "RovingFocusGroupItem", Un = S.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: a,
      focusable: o = !0,
      active: n = !1,
      tabStopId: r,
      children: i,
      ...l
    } = e, c = yl(), s = r || c, u = Al(Gn, a), d = u.currentTabStopId === s, g = Rn(a), { onFocusableItemAdd: b, onFocusableItemRemove: h, currentTabStopId: p } = u;
    return S.useEffect(() => {
      if (o)
        return b(), () => h();
    }, [o, b, h]), /* @__PURE__ */ y(
      $a.ItemSlot,
      {
        scope: a,
        id: s,
        focusable: o,
        active: n,
        children: /* @__PURE__ */ y(
          rt.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...l,
            ref: t,
            onMouseDown: je(e.onMouseDown, ($) => {
              o ? u.onItemFocus(s) : $.preventDefault();
            }),
            onFocus: je(e.onFocus, () => u.onItemFocus(s)),
            onKeyDown: je(e.onKeyDown, ($) => {
              if ($.key === "Tab" && $.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if ($.target !== $.currentTarget) return;
              const M = Nl($, u.orientation, u.dir);
              if (M !== void 0) {
                if ($.metaKey || $.ctrlKey || $.altKey || $.shiftKey) return;
                $.preventDefault();
                let k = g().filter((P) => P.focusable).map((P) => P.ref.current);
                if (M === "last") k.reverse();
                else if (M === "prev" || M === "next") {
                  M === "prev" && k.reverse();
                  const P = k.indexOf($.currentTarget);
                  k = u.loop ? Ol(k, P + 1) : k.slice(P + 1);
                }
                setTimeout(() => Zn(k));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: p != null }) : i
          }
        )
      }
    );
  }
);
Un.displayName = Gn;
var Ml = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Dl(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Nl(e, t, a) {
  const o = Dl(e.key, a);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return Ml[o];
}
function Zn(e, t = !1) {
  const a = document.activeElement;
  for (const o of e)
    if (o === a || (o.focus({ preventScroll: t }), document.activeElement !== a)) return;
}
function Ol(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
var Il = Vn, jl = Un;
function Ll(e) {
  const [t, a] = S.useState(void 0);
  return ht(() => {
    if (e) {
      a({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const r = n[0];
        let i, l;
        if ("borderBoxSize" in r) {
          const c = r.borderBoxSize, s = Array.isArray(c) ? c[0] : c;
          i = s.inlineSize, l = s.blockSize;
        } else
          i = e.offsetWidth, l = e.offsetHeight;
        a({ width: i, height: l });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      a(void 0);
  }, [e]), t;
}
function El(e) {
  const t = S.useRef({ value: e, previous: e });
  return S.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Fa = "Radio", [Bl, Wn] = Yt(Fa), [Tl, Rl] = Bl(Fa), Kn = S.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: a,
      name: o,
      checked: n = !1,
      required: r,
      disabled: i,
      value: l = "on",
      onCheck: c,
      form: s,
      ...u
    } = e, [d, g] = S.useState(null), b = Ke(t, ($) => g($)), h = S.useRef(!1), p = d ? s || !!d.closest("form") : !0;
    return /* @__PURE__ */ R(Tl, { scope: a, checked: n, disabled: i, children: [
      /* @__PURE__ */ y(
        rt.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": n,
          "data-state": Yn(n),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: l,
          ...u,
          ref: b,
          onClick: je(e.onClick, ($) => {
            n || c?.(), p && (h.current = $.isPropagationStopped(), h.current || $.stopPropagation());
          })
        }
      ),
      p && /* @__PURE__ */ y(
        Jn,
        {
          control: d,
          bubbles: !h.current,
          name: o,
          value: l,
          checked: n,
          required: r,
          disabled: i,
          form: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Kn.displayName = Fa;
var qn = "RadioIndicator", Hn = S.forwardRef(
  (e, t) => {
    const { __scopeRadio: a, forceMount: o, ...n } = e, r = Rl(qn, a);
    return /* @__PURE__ */ y(Tn, { present: o || r.checked, children: /* @__PURE__ */ y(
      rt.span,
      {
        "data-state": Yn(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    ) });
  }
);
Hn.displayName = qn;
var Fl = "RadioBubbleInput", Jn = S.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: a,
    bubbles: o = !0,
    ...n
  }, r) => {
    const i = S.useRef(null), l = Ke(i, r), c = El(a), s = Ll(t);
    return S.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const d = window.HTMLInputElement.prototype, g = Object.getOwnPropertyDescriptor(
        d,
        "checked"
      ).set;
      if (c !== a && g) {
        const b = new Event("click", { bubbles: o });
        g.call(u, a), u.dispatchEvent(b);
      }
    }, [c, a, o]), /* @__PURE__ */ y(
      rt.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: a,
        ...n,
        tabIndex: -1,
        ref: l,
        style: {
          ...n.style,
          ...s,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Jn.displayName = Fl;
function Yn(e) {
  return e ? "checked" : "unchecked";
}
var Vl = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Qt = "RadioGroup", [Gl, jL] = Yt(Qt, [
  Fn,
  Wn
]), Qn = Fn(), Xn = Wn(), [Ul, Zl] = Gl(Qt), er = S.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: a,
      name: o,
      defaultValue: n,
      value: r,
      required: i = !1,
      disabled: l = !1,
      orientation: c,
      dir: s,
      loop: u = !0,
      onValueChange: d,
      ...g
    } = e, b = Qn(a), h = Bn(s), [p, $] = Ln({
      prop: r,
      defaultProp: n ?? null,
      onChange: d,
      caller: Qt
    });
    return /* @__PURE__ */ y(
      Ul,
      {
        scope: a,
        name: o,
        required: i,
        disabled: l,
        value: p,
        onValueChange: $,
        children: /* @__PURE__ */ y(
          Il,
          {
            asChild: !0,
            ...b,
            orientation: c,
            dir: h,
            loop: u,
            children: /* @__PURE__ */ y(
              rt.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": c,
                "data-disabled": l ? "" : void 0,
                dir: h,
                ...g,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
er.displayName = Qt;
var tr = "RadioGroupItem", ar = S.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: a, disabled: o, ...n } = e, r = Zl(tr, a), i = r.disabled || o, l = Qn(a), c = Xn(a), s = S.useRef(null), u = Ke(t, s), d = r.value === n.value, g = S.useRef(!1);
    return S.useEffect(() => {
      const b = (p) => {
        Vl.includes(p.key) && (g.current = !0);
      }, h = () => g.current = !1;
      return document.addEventListener("keydown", b), document.addEventListener("keyup", h), () => {
        document.removeEventListener("keydown", b), document.removeEventListener("keyup", h);
      };
    }, []), /* @__PURE__ */ y(
      jl,
      {
        asChild: !0,
        ...l,
        focusable: !i,
        active: d,
        children: /* @__PURE__ */ y(
          Kn,
          {
            disabled: i,
            required: r.required,
            checked: d,
            ...c,
            ...n,
            name: r.name,
            ref: u,
            onCheck: () => r.onValueChange(n.value),
            onKeyDown: je((b) => {
              b.key === "Enter" && b.preventDefault();
            }),
            onFocus: je(n.onFocus, () => {
              g.current && s.current?.click();
            })
          }
        )
      }
    );
  }
);
ar.displayName = tr;
var Wl = "RadioGroupIndicator", or = S.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: a, ...o } = e, n = Xn(a);
    return /* @__PURE__ */ y(Hn, { ...n, ...o, ref: t });
  }
);
or.displayName = Wl;
var Kl = er, ql = ar, Hl = or;
const Jl = "_indicator_o29me_51", Yl = "_label_o29me_66", Pt = {
  "radio-item": "_radio-item_o29me_29",
  "radio-button": "_radio-button_o29me_33",
  indicator: Jl,
  label: Yl
};
function Ql({ value: e, id: t, label: a, description: o }) {
  return /* @__PURE__ */ R("div", { className: Pt["radio-item"], children: [
    /* @__PURE__ */ y(ql, { value: e, id: t, className: Pt["radio-button"], "aria-label": a, children: /* @__PURE__ */ y(Hl, { className: Pt.indicator }) }),
    /* @__PURE__ */ R("label", { htmlFor: t, className: Pt.label, children: [
      a,
      o && /* @__PURE__ */ y("p", { children: o })
    ] })
  ] });
}
function Xl() {
  const [e, t] = xe({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Ie(() => {
    function a() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", a), a(), () => window.removeEventListener("resize", a);
  }, []), e;
}
function nr() {
  const { width: e } = Xl();
  let t = "desktop";
  return e && e <= vo.MOBILE ? t = "mobile" : e && e <= vo.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
const es = ({
  initialPhoneNumber: e = "",
  initialCountry: t = "",
  onChangePhoneNumber: a,
  onChangeCountry: o
}) => {
  const [n, r] = xe(e), [i, l] = xe(t);
  return {
    phoneNumber: n,
    country: i,
    handlePhoneNumberChange: (c) => {
      r(c), a?.(c);
    },
    handleCountryChange: (c) => {
      l(c), o?.(c);
    }
  };
}, ts = {
  ad: "Andorra",
  ae: "De Forenede Arabiske Emirater",
  af: "Afghanistan",
  ag: "Antigua og Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikansk Samoa",
  at: "Østrig",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Aserbajdsjan",
  ba: "Bosnien-Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "De tidligere Nederlandske Antiller",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Hviderusland",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocosøerne",
  cd: "Congo-Kinshasa",
  cf: "Den Centralafrikanske Republik",
  cg: "Congo-Brazzaville",
  ch: "Schweiz",
  ci: "Elfenbenskysten",
  ck: "Cookøerne",
  cl: "Chile",
  cm: "Cameroun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Juleøen",
  cy: "Cypern",
  cz: "Tjekkiet",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Den Dominikanske Republik",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Vestsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsøerne",
  fm: "Mikronesien",
  fo: "Færøerne",
  fr: "Frankrig",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Fransk Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grønland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ækvatorialguinea",
  gr: "Grækenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "SAR Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Det Britiske Territorium i Det Indiske Ocean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgisistan",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comorerne",
  kn: "Saint Kitts og Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanøerne",
  kz: "Kasakhstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxembourg",
  lv: "Letland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Marshalløerne",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "SAR Macao",
  mp: "Nordmarianerne",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverne",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Ny Kaledonien",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Holland",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Fransk Polynesien",
  pg: "Papua Ny Guinea",
  ph: "Filippinerne",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint Pierre og Miquelon",
  pr: "Puerto Rico",
  ps: "De palæstinensiske områder",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumænien",
  rs: "Serbien",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saudi-Arabien",
  sb: "Salomonøerne",
  sc: "Seychellerne",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenien",
  sj: "Svalbard og Jan Mayen",
  sk: "Slovakiet",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé og Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- og Caicosøerne",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadsjikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Tyrkiet",
  tt: "Trinidad og Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstaten",
  vc: "Saint Vincent og Grenadinerne",
  ve: "Venezuela",
  vg: "De Britiske Jomfruøer",
  vi: "De Amerikanske Jomfruøer",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis og Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, as = {
  selectedCountryAriaLabel: "Valgt land",
  noCountrySelected: "Intet land er valgt",
  countryListAriaLabel: "Liste over lande",
  searchPlaceholder: "Søg",
  zeroSearchResults: "Ingen resultater fundet",
  oneSearchResult: "1 resultat fundet",
  multipleSearchResults: "${count} resultater fundet",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, os = { ...ts, ...as }, ns = {
  ad: "Andorra",
  ae: "Vereinigte Arabische Emirate",
  af: "Afghanistan",
  ag: "Antigua und Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentinien",
  as: "Amerikanisch-Samoa",
  at: "Österreich",
  au: "Australien",
  aw: "Aruba",
  ax: "Ålandinseln",
  az: "Aserbaidschan",
  ba: "Bosnien und Herzegowina",
  bb: "Barbados",
  bd: "Bangladesch",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei Darussalam",
  bo: "Bolivien",
  bq: "Bonaire, Sint Eustatius und Saba",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botsuana",
  by: "Belarus",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosinseln",
  cd: "Kongo-Kinshasa",
  cf: "Zentralafrikanische Republik",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cookinseln",
  cl: "Chile",
  cm: "Kamerun",
  cn: "China",
  co: "Kolumbien",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Weihnachtsinsel",
  cy: "Zypern",
  cz: "Tschechien",
  de: "Deutschland",
  dj: "Dschibuti",
  dk: "Dänemark",
  dm: "Dominica",
  do: "Dominikanische Republik",
  dz: "Algerien",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Ägypten",
  eh: "Westsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Äthiopien",
  fi: "Finnland",
  fj: "Fidschi",
  fk: "Falklandinseln",
  fm: "Mikronesien",
  fo: "Färöer",
  fr: "Frankreich",
  ga: "Gabun",
  gb: "Vereinigtes Königreich",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Französisch-Guayana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Äquatorialguinea",
  gr: "Griechenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Sonderverwaltungsregion Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Britisches Territorium im Indischen Ozean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaika",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgisistan",
  kh: "Kambodscha",
  ki: "Kiribati",
  km: "Komoren",
  kn: "St. Kitts und Nevis",
  kp: "Nordkorea",
  kr: "Südkorea",
  kw: "Kuwait",
  ky: "Kaimaninseln",
  kz: "Kasachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Republik Moldau",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagaskar",
  mh: "Marshallinseln",
  mk: "Nordmazedonien",
  ml: "Mali",
  mm: "Myanmar",
  mn: "Mongolei",
  mo: "Sonderverwaltungsregion Macau",
  mp: "Nördliche Marianen",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Malediven",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Mosambik",
  na: "Namibia",
  nc: "Neukaledonien",
  ne: "Niger",
  nf: "Norfolkinsel",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Niederlande",
  no: "Norwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Neuseeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Französisch-Polynesien",
  pg: "Papua-Neuguinea",
  ph: "Philippinen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "St. Pierre und Miquelon",
  pr: "Puerto Rico",
  ps: "Palästinensische Autonomiegebiete",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Russland",
  rw: "Ruanda",
  sa: "Saudi-Arabien",
  sb: "Salomonen",
  sc: "Seychellen",
  sd: "Sudan",
  se: "Schweden",
  sg: "Singapur",
  sh: "St. Helena",
  si: "Slowenien",
  sj: "Spitzbergen und Jan Mayen",
  sk: "Slowakei",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Südsudan",
  st: "São Tomé und Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- und Caicosinseln",
  td: "Tschad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadschikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Türkei",
  tt: "Trinidad und Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tansania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "Vereinigte Staaten",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstadt",
  vc: "St. Vincent und die Grenadinen",
  ve: "Venezuela",
  vg: "Britische Jungferninseln",
  vi: "Amerikanische Jungferninseln",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis und Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Südafrika",
  zm: "Sambia",
  zw: "Simbabwe"
}, rs = {
  selectedCountryAriaLabel: "Ausgewähltes Land",
  noCountrySelected: "Kein Land ausgewählt",
  countryListAriaLabel: "Liste der Länder",
  searchPlaceholder: "Suchen",
  zeroSearchResults: "Keine Suchergebnisse",
  oneSearchResult: "1 Suchergebnis",
  multipleSearchResults: "${count} Suchergebnisse",
  // additional countries (not supported by country-list library)
  ac: "Ascension-Insel",
  xk: "Kosovo"
}, is = { ...ns, ...rs }, ls = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, ss = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, cs = { ...ls, ...ss }, us = {
  ad: "Andorra",
  ae: "Emiratos Árabes Unidos",
  af: "Afganistán",
  ag: "Antigua y Barbuda",
  ai: "Anguila",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Islas Åland",
  az: "Azerbaiyán",
  ba: "Bosnia y Herzegovina",
  bb: "Barbados",
  bd: "Bangladés",
  be: "Bélgica",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Baréin",
  bi: "Burundi",
  bj: "Benín",
  bl: "San Bartolomé",
  bm: "Bermudas",
  bn: "Brunéi",
  bo: "Bolivia",
  bq: "Caribe neerlandés",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Bután",
  bw: "Botsuana",
  by: "Bielorrusia",
  bz: "Belice",
  ca: "Canadá",
  cc: "Islas Cocos",
  cd: "República Democrática del Congo",
  cf: "República Centroafricana",
  cg: "Congo",
  ch: "Suiza",
  ci: "Côte d’Ivoire",
  ck: "Islas Cook",
  cl: "Chile",
  cm: "Camerún",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curazao",
  cx: "Isla de Navidad",
  cy: "Chipre",
  cz: "Chequia",
  de: "Alemania",
  dj: "Yibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argelia",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egipto",
  eh: "Sáhara Occidental",
  er: "Eritrea",
  es: "España",
  et: "Etiopía",
  fi: "Finlandia",
  fj: "Fiyi",
  fk: "Islas Malvinas",
  fm: "Micronesia",
  fo: "Islas Feroe",
  fr: "Francia",
  ga: "Gabón",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Georgia",
  gf: "Guayana Francesa",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupe",
  gq: "Guinea Ecuatorial",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bisáu",
  gy: "Guyana",
  hk: "RAE de Hong Kong (China)",
  hn: "Honduras",
  hr: "Croacia",
  ht: "Haití",
  hu: "Hungría",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israel",
  im: "Isla de Man",
  in: "India",
  io: "Territorio Británico del Océano Índico",
  iq: "Irak",
  ir: "Irán",
  is: "Islandia",
  it: "Italia",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordania",
  jp: "Japón",
  ke: "Kenia",
  kg: "Kirguistán",
  kh: "Camboya",
  ki: "Kiribati",
  km: "Comoras",
  kn: "San Cristóbal y Nieves",
  kp: "Corea del Norte",
  kr: "Corea del Sur",
  kw: "Kuwait",
  ky: "Islas Caimán",
  kz: "Kazajistán",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lucía",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesoto",
  lt: "Lituania",
  lu: "Luxemburgo",
  lv: "Letonia",
  ly: "Libia",
  ma: "Marruecos",
  mc: "Mónaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "San Martín",
  mg: "Madagascar",
  mh: "Islas Marshall",
  mk: "Macedonia del Norte",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAE de Macao (China)",
  mp: "Islas Marianas del Norte",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricio",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malasia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Nueva Caledonia",
  ne: "Níger",
  nf: "Isla Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Países Bajos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nueva Zelanda",
  om: "Omán",
  pa: "Panamá",
  pe: "Perú",
  pf: "Polinesia Francesa",
  pg: "Papúa Nueva Guinea",
  ph: "Filipinas",
  pk: "Pakistán",
  pl: "Polonia",
  pm: "San Pedro y Miquelón",
  pr: "Puerto Rico",
  ps: "Territorios Palestinos",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Catar",
  re: "Reunión",
  ro: "Rumanía",
  rs: "Serbia",
  ru: "Rusia",
  rw: "Ruanda",
  sa: "Arabia Saudí",
  sb: "Islas Salomón",
  sc: "Seychelles",
  sd: "Sudán",
  se: "Suecia",
  sg: "Singapur",
  sh: "Santa Elena",
  si: "Eslovenia",
  sj: "Svalbard y Jan Mayen",
  sk: "Eslovaquia",
  sl: "Sierra Leona",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sudán del Sur",
  st: "Santo Tomé y Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Esuatini",
  tc: "Islas Turcas y Caicos",
  td: "Chad",
  tg: "Togo",
  th: "Tailandia",
  tj: "Tayikistán",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistán",
  tn: "Túnez",
  to: "Tonga",
  tr: "Turquía",
  tt: "Trinidad y Tobago",
  tv: "Tuvalu",
  tw: "Taiwán",
  tz: "Tanzania",
  ua: "Ucrania",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguay",
  uz: "Uzbekistán",
  va: "Ciudad del Vaticano",
  vc: "San Vicente y las Granadinas",
  ve: "Venezuela",
  vg: "Islas Vírgenes Británicas",
  vi: "Islas Vírgenes de EE. UU.",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis y Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudáfrica",
  zm: "Zambia",
  zw: "Zimbabue"
}, ds = {
  selectedCountryAriaLabel: "País seleccionado",
  noCountrySelected: "Ningún país seleccionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Buscar",
  zeroSearchResults: "No se han encontrado resultados",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "isla Ascencion",
  xk: "Kosovo"
}, _s = { ...us, ...ds }, gs = {
  ad: "Andorre",
  ae: "Émirats arabes unis",
  af: "Afghanistan",
  ag: "Antigua-et-Barbuda",
  ai: "Anguilla",
  al: "Albanie",
  am: "Arménie",
  ao: "Angola",
  ar: "Argentine",
  as: "Samoa américaines",
  at: "Autriche",
  au: "Australie",
  aw: "Aruba",
  ax: "Îles Åland",
  az: "Azerbaïdjan",
  ba: "Bosnie-Herzégovine",
  bb: "Barbade",
  bd: "Bangladesh",
  be: "Belgique",
  bf: "Burkina Faso",
  bg: "Bulgarie",
  bh: "Bahreïn",
  bi: "Burundi",
  bj: "Bénin",
  bl: "Saint-Barthélemy",
  bm: "Bermudes",
  bn: "Brunéi Darussalam",
  bo: "Bolivie",
  bq: "Pays-Bas caribéens",
  br: "Brésil",
  bs: "Bahamas",
  bt: "Bhoutan",
  bw: "Botswana",
  by: "Biélorussie",
  bz: "Belize",
  ca: "Canada",
  cc: "Îles Cocos",
  cd: "Congo-Kinshasa",
  cf: "République centrafricaine",
  cg: "Congo-Brazzaville",
  ch: "Suisse",
  ci: "Côte d’Ivoire",
  ck: "Îles Cook",
  cl: "Chili",
  cm: "Cameroun",
  cn: "Chine",
  co: "Colombie",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cap-Vert",
  cw: "Curaçao",
  cx: "Île Christmas",
  cy: "Chypre",
  cz: "Tchéquie",
  de: "Allemagne",
  dj: "Djibouti",
  dk: "Danemark",
  dm: "Dominique",
  do: "République dominicaine",
  dz: "Algérie",
  ec: "Équateur",
  ee: "Estonie",
  eg: "Égypte",
  eh: "Sahara occidental",
  er: "Érythrée",
  es: "Espagne",
  et: "Éthiopie",
  fi: "Finlande",
  fj: "Fidji",
  fk: "Îles Malouines",
  fm: "États fédérés de Micronésie",
  fo: "Îles Féroé",
  fr: "France",
  ga: "Gabon",
  gb: "Royaume-Uni",
  gd: "Grenade",
  ge: "Géorgie",
  gf: "Guyane française",
  gg: "Guernesey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambie",
  gn: "Guinée",
  gp: "Guadeloupe",
  gq: "Guinée équatoriale",
  gr: "Grèce",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinée-Bissau",
  gy: "Guyana",
  hk: "R.A.S. chinoise de Hong Kong",
  hn: "Honduras",
  hr: "Croatie",
  ht: "Haïti",
  hu: "Hongrie",
  id: "Indonésie",
  ie: "Irlande",
  il: "Israël",
  im: "Île de Man",
  in: "Inde",
  io: "Territoire britannique de l’océan Indien",
  iq: "Irak",
  ir: "Iran",
  is: "Islande",
  it: "Italie",
  je: "Jersey",
  jm: "Jamaïque",
  jo: "Jordanie",
  jp: "Japon",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambodge",
  ki: "Kiribati",
  km: "Comores",
  kn: "Saint-Christophe-et-Niévès",
  kp: "Corée du Nord",
  kr: "Corée du Sud",
  kw: "Koweït",
  ky: "Îles Caïmans",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Liban",
  lc: "Sainte-Lucie",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesotho",
  lt: "Lituanie",
  lu: "Luxembourg",
  lv: "Lettonie",
  ly: "Libye",
  ma: "Maroc",
  mc: "Monaco",
  md: "Moldavie",
  me: "Monténégro",
  mf: "Saint-Martin",
  mg: "Madagascar",
  mh: "Îles Marshall",
  mk: "Macédoine du Nord",
  ml: "Mali",
  mm: "Myanmar (Birmanie)",
  mn: "Mongolie",
  mo: "R.A.S. chinoise de Macao",
  mp: "Îles Mariannes du Nord",
  mq: "Martinique",
  mr: "Mauritanie",
  ms: "Montserrat",
  mt: "Malte",
  mu: "Maurice",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexique",
  my: "Malaisie",
  mz: "Mozambique",
  na: "Namibie",
  nc: "Nouvelle-Calédonie",
  ne: "Niger",
  nf: "Île Norfolk",
  ng: "Nigéria",
  ni: "Nicaragua",
  nl: "Pays-Bas",
  no: "Norvège",
  np: "Népal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nouvelle-Zélande",
  om: "Oman",
  pa: "Panama",
  pe: "Pérou",
  pf: "Polynésie française",
  pg: "Papouasie-Nouvelle-Guinée",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Pologne",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Porto Rico",
  ps: "Territoires palestiniens",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Qatar",
  re: "La Réunion",
  ro: "Roumanie",
  rs: "Serbie",
  ru: "Russie",
  rw: "Rwanda",
  sa: "Arabie saoudite",
  sb: "Îles Salomon",
  sc: "Seychelles",
  sd: "Soudan",
  se: "Suède",
  sg: "Singapour",
  sh: "Sainte-Hélène",
  si: "Slovénie",
  sj: "Svalbard et Jan Mayen",
  sk: "Slovaquie",
  sl: "Sierra Leone",
  sm: "Saint-Marin",
  sn: "Sénégal",
  so: "Somalie",
  sr: "Suriname",
  ss: "Soudan du Sud",
  st: "Sao Tomé-et-Principe",
  sv: "Salvador",
  sx: "Saint-Martin (partie néerlandaise)",
  sy: "Syrie",
  sz: "Eswatini",
  tc: "Îles Turques-et-Caïques",
  td: "Tchad",
  tg: "Togo",
  th: "Thaïlande",
  tj: "Tadjikistan",
  tk: "Tokelau",
  tl: "Timor oriental",
  tm: "Turkménistan",
  tn: "Tunisie",
  to: "Tonga",
  tr: "Turquie",
  tt: "Trinité-et-Tobago",
  tv: "Tuvalu",
  tw: "Taïwan",
  tz: "Tanzanie",
  ua: "Ukraine",
  ug: "Ouganda",
  us: "États-Unis",
  uy: "Uruguay",
  uz: "Ouzbékistan",
  va: "État de la Cité du Vatican",
  vc: "Saint-Vincent-et-les-Grenadines",
  ve: "Venezuela",
  vg: "Îles Vierges britanniques",
  vi: "Îles Vierges des États-Unis",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis-et-Futuna",
  ws: "Samoa",
  ye: "Yémen",
  yt: "Mayotte",
  za: "Afrique du Sud",
  zm: "Zambie",
  zw: "Zimbabwe"
}, fs = {
  selectedCountryAriaLabel: "Pays sélectionné",
  noCountrySelected: "Aucun pays sélectionné",
  countryListAriaLabel: "Liste des pays",
  searchPlaceholder: "Recherche",
  zeroSearchResults: "Aucun résultat trouvé",
  oneSearchResult: "1 résultat trouvé",
  multipleSearchResults: "${count} résultats trouvés",
  // additional countries (not supported by country-list library)
  ac: "Île de l'Ascension",
  xk: "Kosovo"
}, bs = { ...gs, ...fs }, hs = {
  ad: "Andora",
  ae: "Ujedinjeni Arapski Emirati",
  af: "Afganistan",
  ag: "Antigva i Barbuda",
  ai: "Angvila",
  al: "Albanija",
  am: "Armenija",
  ao: "Angola",
  ar: "Argentina",
  as: "Američka Samoa",
  at: "Austrija",
  au: "Australija",
  aw: "Aruba",
  ax: "Ålandski otoci",
  az: "Azerbajdžan",
  ba: "Bosna i Hercegovina",
  bb: "Barbados",
  bd: "Bangladeš",
  be: "Belgija",
  bf: "Burkina Faso",
  bg: "Bugarska",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermudi",
  bn: "Brunej",
  bo: "Bolivija",
  bq: "Karipski otoci Nizozemske",
  br: "Brazil",
  bs: "Bahami",
  bt: "Butan",
  bw: "Bocvana",
  by: "Bjelorusija",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosovi (Keelingovi) otoci",
  cd: "Kongo - Kinshasa",
  cf: "Srednjoafrička Republika",
  cg: "Kongo - Brazzaville",
  ch: "Švicarska",
  ci: "Obala Bjelokosti",
  ck: "Cookovi Otoci",
  cl: "Čile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Kolumbija",
  cr: "Kostarika",
  cu: "Kuba",
  cv: "Zelenortska Republika",
  cw: "Curaçao",
  cx: "Božićni otok",
  cy: "Cipar",
  cz: "Češka",
  de: "Njemačka",
  dj: "Džibuti",
  dk: "Danska",
  dm: "Dominika",
  do: "Dominikanska Republika",
  dz: "Alžir",
  ec: "Ekvador",
  ee: "Estonija",
  eg: "Egipat",
  eh: "Zapadna Sahara",
  er: "Eritreja",
  es: "Španjolska",
  et: "Etiopija",
  fi: "Finska",
  fj: "Fidži",
  fk: "Falklandski otoci",
  fm: "Mikronezija",
  fo: "Farski otoci",
  fr: "Francuska",
  ga: "Gabon",
  gb: "Ujedinjeno Kraljevstvo",
  gd: "Grenada",
  ge: "Gruzija",
  gf: "Francuska Gijana",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Grenland",
  gm: "Gambija",
  gn: "Gvineja",
  gp: "Guadalupe",
  gq: "Ekvatorska Gvineja",
  gr: "Grčka",
  gt: "Gvatemala",
  gu: "Guam",
  gw: "Gvineja Bisau",
  gy: "Gvajana",
  hk: "PUP Hong Kong Kina",
  hn: "Honduras",
  hr: "Hrvatska",
  ht: "Haiti",
  hu: "Mađarska",
  id: "Indonezija",
  ie: "Irska",
  il: "Izrael",
  im: "Otok Man",
  in: "Indija",
  io: "Britanski Indijskooceanski teritorij",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italija",
  je: "Jersey",
  jm: "Jamajka",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenija",
  kg: "Kirgistan",
  kh: "Kambodža",
  ki: "Kiribati",
  km: "Komori",
  kn: "Sveti Kristofor i Nevis",
  kp: "Sjeverna Koreja",
  kr: "Južna Koreja",
  kw: "Kuvajt",
  ky: "Kajmanski otoci",
  kz: "Kazahstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Sveta Lucija",
  li: "Lihtenštajn",
  lk: "Šri Lanka",
  lr: "Liberija",
  ls: "Lesoto",
  lt: "Litva",
  lu: "Luksemburg",
  lv: "Latvija",
  ly: "Libija",
  ma: "Maroko",
  mc: "Monako",
  md: "Moldavija",
  me: "Crna Gora",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Maršalovi Otoci",
  mk: "Sjeverna Makedonija",
  ml: "Mali",
  mm: "Mjanmar (Burma)",
  mn: "Mongolija",
  mo: "PUP Makao Kina",
  mp: "Sjevernomarijanski otoci",
  mq: "Martinique",
  mr: "Mauretanija",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricijus",
  mv: "Maldivi",
  mw: "Malavi",
  mx: "Meksiko",
  my: "Malezija",
  mz: "Mozambik",
  na: "Namibija",
  nc: "Nova Kaledonija",
  ne: "Niger",
  nf: "Otok Norfolk",
  ng: "Nigerija",
  ni: "Nikaragva",
  nl: "Nizozemska",
  no: "Norveška",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Novi Zeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Francuska Polinezija",
  pg: "Papua Nova Gvineja",
  ph: "Filipini",
  pk: "Pakistan",
  pl: "Poljska",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Portoriko",
  ps: "Palestinsko područje",
  pt: "Portugal",
  pw: "Palau",
  py: "Paragvaj",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumunjska",
  rs: "Srbija",
  ru: "Rusija",
  rw: "Ruanda",
  sa: "Saudijska Arabija",
  sb: "Salomonski Otoci",
  sc: "Sejšeli",
  sd: "Sudan",
  se: "Švedska",
  sg: "Singapur",
  sh: "Sveta Helena",
  si: "Slovenija",
  sj: "Svalbard i Jan Mayen",
  sk: "Slovačka",
  sl: "Sijera Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalija",
  sr: "Surinam",
  ss: "Južni Sudan",
  st: "Sveti Toma i Princip",
  sv: "Salvador",
  sx: "Sint Maarten",
  sy: "Sirija",
  sz: "Esvatini",
  tc: "Otoci Turks i Caicos",
  td: "Čad",
  tg: "Togo",
  th: "Tajland",
  tj: "Tadžikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunis",
  to: "Tonga",
  tr: "Turska",
  tt: "Trinidad i Tobago",
  tv: "Tuvalu",
  tw: "Tajvan",
  tz: "Tanzanija",
  ua: "Ukrajina",
  ug: "Uganda",
  us: "Sjedinjene Američke Države",
  uy: "Urugvaj",
  uz: "Uzbekistan",
  va: "Vatikanski Grad",
  vc: "Sveti Vincent i Grenadini",
  ve: "Venezuela",
  vg: "Britanski Djevičanski otoci",
  vi: "Američki Djevičanski otoci",
  vn: "Vijetnam",
  vu: "Vanuatu",
  wf: "Wallis i Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Južnoafrička Republika",
  zm: "Zambija",
  zw: "Zimbabve"
}, ms = {
  selectedCountryAriaLabel: "Odabrana zemlja",
  noCountrySelected: "Zemlja nije odabrana",
  countryListAriaLabel: "Lista zemalja",
  searchPlaceholder: "Pretraži",
  zeroSearchResults: "Nema pronađenih rezultata",
  oneSearchResult: "Pronađen 1 rezultat",
  multipleSearchResults: "${count} rezultata pronađeno",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, ps = { ...hs, ...ms }, ys = {
  ad: "Andorra",
  ae: "Emirati Arabi Uniti",
  af: "Afghanistan",
  ag: "Antigua e Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa americane",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Isole Åland",
  az: "Azerbaigian",
  ba: "Bosnia ed Erzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgio",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caraibi olandesi",
  br: "Brasile",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Bielorussia",
  bz: "Belize",
  ca: "Canada",
  cc: "Isole Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "Repubblica Centrafricana",
  cg: "Congo-Brazzaville",
  ch: "Svizzera",
  ci: "Costa d’Avorio",
  ck: "Isole Cook",
  cl: "Cile",
  cm: "Camerun",
  cn: "Cina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Capo Verde",
  cw: "Curaçao",
  cx: "Isola Christmas",
  cy: "Cipro",
  cz: "Cechia",
  de: "Germania",
  dj: "Gibuti",
  dk: "Danimarca",
  dm: "Dominica",
  do: "Repubblica Dominicana",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egitto",
  eh: "Sahara occidentale",
  er: "Eritrea",
  es: "Spagna",
  et: "Etiopia",
  fi: "Finlandia",
  fj: "Figi",
  fk: "Isole Falkland",
  fm: "Micronesia",
  fo: "Isole Fær Øer",
  fr: "Francia",
  ga: "Gabon",
  gb: "Regno Unito",
  gd: "Grenada",
  ge: "Georgia",
  gf: "Guyana francese",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibilterra",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupa",
  gq: "Guinea Equatoriale",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "RAS di Hong Kong",
  hn: "Honduras",
  hr: "Croazia",
  ht: "Haiti",
  hu: "Ungheria",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israele",
  im: "Isola di Man",
  in: "India",
  io: "Territorio britannico dell’Oceano Indiano",
  iq: "Iraq",
  ir: "Iran",
  is: "Islanda",
  it: "Italia",
  je: "Jersey",
  jm: "Giamaica",
  jo: "Giordania",
  jp: "Giappone",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambogia",
  ki: "Kiribati",
  km: "Comore",
  kn: "Saint Kitts e Nevis",
  kp: "Corea del Nord",
  kr: "Corea del Sud",
  kw: "Kuwait",
  ky: "Isole Cayman",
  kz: "Kazakistan",
  la: "Laos",
  lb: "Libano",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lituania",
  lu: "Lussemburgo",
  lv: "Lettonia",
  ly: "Libia",
  ma: "Marocco",
  mc: "Monaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagascar",
  mh: "Isole Marshall",
  mk: "Macedonia del Nord",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAS di Macao",
  mp: "Isole Marianne settentrionali",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldive",
  mw: "Malawi",
  mx: "Messico",
  my: "Malaysia",
  mz: "Mozambico",
  na: "Namibia",
  nc: "Nuova Caledonia",
  ne: "Niger",
  nf: "Isola Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Paesi Bassi",
  no: "Norvegia",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nuova Zelanda",
  om: "Oman",
  pa: "Panamá",
  pe: "Perù",
  pf: "Polinesia francese",
  pg: "Papua Nuova Guinea",
  ph: "Filippine",
  pk: "Pakistan",
  pl: "Polonia",
  pm: "Saint-Pierre e Miquelon",
  pr: "Portorico",
  ps: "Territori palestinesi",
  pt: "Portogallo",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Riunione",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Ruanda",
  sa: "Arabia Saudita",
  sb: "Isole Salomone",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Svezia",
  sg: "Singapore",
  sh: "Sant’Elena",
  si: "Slovenia",
  sj: "Svalbard e Jan Mayen",
  sk: "Slovacchia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Sud Sudan",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Swaziland",
  tc: "Isole Turks e Caicos",
  td: "Ciad",
  tg: "Togo",
  th: "Thailandia",
  tj: "Tagikistan",
  tk: "Tokelau",
  tl: "Timor Est",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turchia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ucraina",
  ug: "Uganda",
  us: "Stati Uniti",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Città del Vaticano",
  vc: "Saint Vincent e Grenadine",
  ve: "Venezuela",
  vg: "Isole Vergini Britanniche",
  vi: "Isole Vergini Americane",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudafrica",
  zm: "Zambia",
  zw: "Zimbabwe"
}, vs = {
  selectedCountryAriaLabel: "Paese selezionato",
  noCountrySelected: "Nessun paese selezionato",
  countryListAriaLabel: "Elenco dei paesi",
  searchPlaceholder: "Ricerca",
  zeroSearchResults: "Nessun risultato trovato",
  oneSearchResult: "1 risultato trovato",
  multipleSearchResults: "${count} risultati trovati",
  // additional countries (not supported by country-list library)
  ac: "Isola di Ascensione",
  xk: "Kosovo"
}, ks = { ...ys, ...vs }, $s = {
  ad: "Andorra",
  ae: "Verenigde Arabische Emiraten",
  af: "Afghanistan",
  ag: "Antigua en Barbuda",
  ai: "Anguilla",
  al: "Albanië",
  am: "Armenië",
  ao: "Angola",
  ar: "Argentinië",
  as: "Amerikaans-Samoa",
  at: "Oostenrijk",
  au: "Australië",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbeidzjan",
  ba: "Bosnië en Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "België",
  bf: "Burkina Faso",
  bg: "Bulgarije",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribisch Nederland",
  br: "Brazilië",
  bs: "Bahama’s",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocoseilanden",
  cd: "Congo-Kinshasa",
  cf: "Centraal-Afrikaanse Republiek",
  cg: "Congo-Brazzaville",
  ch: "Zwitserland",
  ci: "Ivoorkust",
  ck: "Cookeilanden",
  cl: "Chili",
  cm: "Kameroen",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kaapverdië",
  cw: "Curaçao",
  cx: "Christmaseiland",
  cy: "Cyprus",
  cz: "Tsjechië",
  de: "Duitsland",
  dj: "Djibouti",
  dk: "Denemarken",
  dm: "Dominica",
  do: "Dominicaanse Republiek",
  dz: "Algerije",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypte",
  eh: "Westelijke Sahara",
  er: "Eritrea",
  es: "Spanje",
  et: "Ethiopië",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandeilanden",
  fm: "Micronesia",
  fo: "Faeröer",
  fr: "Frankrijk",
  ga: "Gabon",
  gb: "Verenigd Koninkrijk",
  gd: "Grenada",
  ge: "Georgië",
  gf: "Frans-Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambia",
  gn: "Guinee",
  gp: "Guadeloupe",
  gq: "Equatoriaal-Guinea",
  gr: "Griekenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinee-Bissau",
  gy: "Guyana",
  hk: "Hongkong SAR van China",
  hn: "Honduras",
  hr: "Kroatië",
  ht: "Haïti",
  hu: "Hongarije",
  id: "Indonesië",
  ie: "Ierland",
  il: "Israël",
  im: "Isle of Man",
  in: "India",
  io: "Brits Indische Oceaanterritorium",
  iq: "Irak",
  ir: "Iran",
  is: "IJsland",
  it: "Italië",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanië",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgizië",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comoren",
  kn: "Saint Kitts en Nevis",
  kp: "Noord-Korea",
  kr: "Zuid-Korea",
  kw: "Koeweit",
  ky: "Kaaimaneilanden",
  kz: "Kazachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litouwen",
  lu: "Luxemburg",
  lv: "Letland",
  ly: "Libië",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldavië",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshalleilanden",
  mk: "Noord-Macedonië",
  ml: "Mali",
  mm: "Myanmar (Birma)",
  mn: "Mongolië",
  mo: "Macau SAR van China",
  mp: "Noordelijke Marianen",
  mq: "Martinique",
  mr: "Mauritanië",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiven",
  mw: "Malawi",
  mx: "Mexico",
  my: "Maleisië",
  mz: "Mozambique",
  na: "Namibië",
  nc: "Nieuw-Caledonië",
  ne: "Niger",
  nf: "Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederland",
  no: "Noorwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nieuw-Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Frans-Polynesië",
  pg: "Papoea-Nieuw-Guinea",
  ph: "Filipijnen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint-Pierre en Miquelon",
  pr: "Puerto Rico",
  ps: "Palestijnse gebieden",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Roemenië",
  rs: "Servië",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saoedi-Arabië",
  sb: "Salomonseilanden",
  sc: "Seychellen",
  sd: "Soedan",
  se: "Zweden",
  sg: "Singapore",
  sh: "Sint-Helena",
  si: "Slovenië",
  sj: "Spitsbergen en Jan Mayen",
  sk: "Slowakije",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalië",
  sr: "Suriname",
  ss: "Zuid-Soedan",
  st: "Sao Tomé en Principe",
  sv: "El Salvador",
  sx: "Sint-Maarten",
  sy: "Syrië",
  sz: "eSwatini",
  tc: "Turks- en Caicoseilanden",
  td: "Tsjaad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Oost-Timor",
  tm: "Turkmenistan",
  tn: "Tunesië",
  to: "Tonga",
  tr: "Turkije",
  tt: "Trinidad en Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Oekraïne",
  ug: "Oeganda",
  us: "Verenigde Staten",
  uy: "Uruguay",
  uz: "Oezbekistan",
  va: "Vaticaanstad",
  vc: "Saint Vincent en de Grenadines",
  ve: "Venezuela",
  vg: "Britse Maagdeneilanden",
  vi: "Amerikaanse Maagdeneilanden",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis en Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Zuid-Afrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, ws = {
  selectedCountryAriaLabel: "Geselecteerd land",
  noCountrySelected: "Geen land geselecteerd",
  countryListAriaLabel: "Lijst met landen",
  searchPlaceholder: "Zoekopdracht",
  zeroSearchResults: "Geen resultaten gevonden",
  oneSearchResult: "1 resultaat gevonden",
  multipleSearchResults: "${count} resultaten gevonden",
  // additional countries (not supported by country-list library)
  ac: "Ascension-eiland",
  xk: "Kosovo"
}, $o = { ...$s, ...ws }, xs = {
  ad: "Andorra",
  ae: "Emirados Árabes Unidos",
  af: "Afeganistão",
  ag: "Antígua e Barbuda",
  ai: "Anguila",
  al: "Albânia",
  am: "Armênia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Áustria",
  au: "Austrália",
  aw: "Aruba",
  ax: "Ilhas Aland",
  az: "Azerbaijão",
  ba: "Bósnia e Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Bélgica",
  bf: "Burquina Faso",
  bg: "Bulgária",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "São Bartolomeu",
  bm: "Bermudas",
  bn: "Brunei",
  bo: "Bolívia",
  bq: "Países Baixos Caribenhos",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Butão",
  bw: "Botsuana",
  by: "Bielorrússia",
  bz: "Belize",
  ca: "Canadá",
  cc: "Ilhas Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "República Centro-Africana",
  cg: "República do Congo",
  ch: "Suíça",
  ci: "Costa do Marfim",
  ck: "Ilhas Cook",
  cl: "Chile",
  cm: "Camarões",
  cn: "China",
  co: "Colômbia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Ilha Christmas",
  cy: "Chipre",
  cz: "Tchéquia",
  de: "Alemanha",
  dj: "Djibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argélia",
  ec: "Equador",
  ee: "Estônia",
  eg: "Egito",
  eh: "Saara Ocidental",
  er: "Eritreia",
  es: "Espanha",
  et: "Etiópia",
  fi: "Finlândia",
  fj: "Fiji",
  fk: "Ilhas Malvinas",
  fm: "Micronésia",
  fo: "Ilhas Faroe",
  fr: "França",
  ga: "Gabão",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Geórgia",
  gf: "Guiana Francesa",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Groenlândia",
  gm: "Gâmbia",
  gn: "Guiné",
  gp: "Guadalupe",
  gq: "Guiné Equatorial",
  gr: "Grécia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guiné-Bissau",
  gy: "Guiana",
  hk: "Hong Kong, RAE da China",
  hn: "Honduras",
  hr: "Croácia",
  ht: "Haiti",
  hu: "Hungria",
  id: "Indonésia",
  ie: "Irlanda",
  il: "Israel",
  im: "Ilha de Man",
  in: "Índia",
  io: "Território Britânico do Oceano Índico",
  iq: "Iraque",
  ir: "Irã",
  is: "Islândia",
  it: "Itália",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordânia",
  jp: "Japão",
  ke: "Quênia",
  kg: "Quirguistão",
  kh: "Camboja",
  ki: "Quiribati",
  km: "Comores",
  kn: "São Cristóvão e Névis",
  kp: "Coreia do Norte",
  kr: "Coreia do Sul",
  kw: "Kuwait",
  ky: "Ilhas Cayman",
  kz: "Cazaquistão",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lúcia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesoto",
  lt: "Lituânia",
  lu: "Luxemburgo",
  lv: "Letônia",
  ly: "Líbia",
  ma: "Marrocos",
  mc: "Mônaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "São Martinho",
  mg: "Madagascar",
  mh: "Ilhas Marshall",
  mk: "Macedônia do Norte",
  ml: "Mali",
  mm: "Mianmar (Birmânia)",
  mn: "Mongólia",
  mo: "Macau, RAE da China",
  mp: "Ilhas Marianas do Norte",
  mq: "Martinica",
  mr: "Mauritânia",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Maurício",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malásia",
  mz: "Moçambique",
  na: "Namíbia",
  nc: "Nova Caledônia",
  ne: "Níger",
  nf: "Ilha Norfolk",
  ng: "Nigéria",
  ni: "Nicarágua",
  nl: "Países Baixos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nova Zelândia",
  om: "Omã",
  pa: "Panamá",
  pe: "Peru",
  pf: "Polinésia Francesa",
  pg: "Papua-Nova Guiné",
  ph: "Filipinas",
  pk: "Paquistão",
  pl: "Polônia",
  pm: "São Pedro e Miquelão",
  pr: "Porto Rico",
  ps: "Territórios palestinos",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguai",
  qa: "Catar",
  re: "Reunião",
  ro: "Romênia",
  rs: "Sérvia",
  ru: "Rússia",
  rw: "Ruanda",
  sa: "Arábia Saudita",
  sb: "Ilhas Salomão",
  sc: "Seicheles",
  sd: "Sudão",
  se: "Suécia",
  sg: "Singapura",
  sh: "Santa Helena",
  si: "Eslovênia",
  sj: "Svalbard e Jan Mayen",
  sk: "Eslováquia",
  sl: "Serra Leoa",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somália",
  sr: "Suriname",
  ss: "Sudão do Sul",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Síria",
  sz: "Essuatíni",
  tc: "Ilhas Turcas e Caicos",
  td: "Chade",
  tg: "Togo",
  th: "Tailândia",
  tj: "Tadjiquistão",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turcomenistão",
  tn: "Tunísia",
  to: "Tonga",
  tr: "Turquia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzânia",
  ua: "Ucrânia",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguai",
  uz: "Uzbequistão",
  va: "Cidade do Vaticano",
  vc: "São Vicente e Granadinas",
  ve: "Venezuela",
  vg: "Ilhas Virgens Britânicas",
  vi: "Ilhas Virgens Americanas",
  vn: "Vietnã",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Iêmen",
  yt: "Mayotte",
  za: "África do Sul",
  zm: "Zâmbia",
  zw: "Zimbábue"
}, Cs = {
  selectedCountryAriaLabel: "País selecionado",
  noCountrySelected: "Nenhum país selecionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Procurar",
  zeroSearchResults: "Nenhum resultado encontrado",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "Ilha de Ascensão",
  xk: "Kosovo"
}, Ss = { ...xs, ...Cs }, zs = {
  ad: "Andorra",
  ae: "Förenade Arabemiraten",
  af: "Afghanistan",
  ag: "Antigua och Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikanska Samoa",
  at: "Österrike",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbajdzjan",
  ba: "Bosnien och Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "S:t Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Karibiska Nederländerna",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Vitryssland",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosöarna",
  cd: "Kongo-Kinshasa",
  cf: "Centralafrikanska republiken",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cooköarna",
  cl: "Chile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Julön",
  cy: "Cypern",
  cz: "Tjeckien",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Dominikanska republiken",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Västsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsöarna",
  fm: "Mikronesien",
  fo: "Färöarna",
  fr: "Frankrike",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Franska Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ekvatorialguinea",
  gr: "Grekland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungern",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Brittiska territoriet i Indiska oceanen",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgizistan",
  kh: "Kambodja",
  ki: "Kiribati",
  km: "Komorerna",
  kn: "S:t Kitts och Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanöarna",
  kz: "Kazakstan",
  la: "Laos",
  lb: "Libanon",
  lc: "S:t Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marocko",
  mc: "Monaco",
  md: "Moldavien",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshallöarna",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "Macao",
  mp: "Nordmarianerna",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverna",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Moçambique",
  na: "Namibia",
  nc: "Nya Kaledonien",
  ne: "Niger",
  nf: "Norfolkön",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederländerna",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nya Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Franska Polynesien",
  pg: "Papua Nya Guinea",
  ph: "Filippinerna",
  pk: "Pakistan",
  pl: "Polen",
  pm: "S:t Pierre och Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinska territorierna",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Ryssland",
  rw: "Rwanda",
  sa: "Saudiarabien",
  sb: "Salomonöarna",
  sc: "Seychellerna",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "S:t Helena",
  si: "Slovenien",
  sj: "Svalbard och Jan Mayen",
  sk: "Slovakien",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé och Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Swaziland",
  tc: "Turks- och Caicosöarna",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Östtimor",
  tm: "Turkmenistan",
  tn: "Tunisien",
  to: "Tonga",
  tr: "Turkiet",
  tt: "Trinidad och Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraina",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatikanstaten",
  vc: "S:t Vincent och Grenadinerna",
  ve: "Venezuela",
  vg: "Brittiska Jungfruöarna",
  vi: "Amerikanska Jungfruöarna",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis- och Futunaöarna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, As = {
  selectedCountryAriaLabel: "Valt land",
  noCountrySelected: "Inget land valt",
  countryListAriaLabel: "Lista över länder",
  searchPlaceholder: "Sök",
  zeroSearchResults: "Inga resultat hittades",
  oneSearchResult: "1 resultat hittades",
  multipleSearchResults: "${count} resultat hittades",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, Ps = { ...zs, ...As }, Ms = {
  en: cs,
  fr: bs,
  it: ks,
  es: _s,
  de: is,
  da: os,
  hr: ps,
  nb: $o,
  nl: $o,
  pt: Ss,
  sv: Ps
}, wo = {
  error: "is-error"
}, xo = {
  error: {
    name: "error-warning-fill",
    color: "error"
  }
}, Ds = "_title_ej2xw_37", Ns = "_text_ej2xw_41", Qe = {
  "radio-group": "_radio-group_ej2xw_29",
  "group-label": "_group-label_ej2xw_34",
  title: Ds,
  text: Ns,
  "has-error": "_has-error_ej2xw_48",
  "error-message": "_error-message_ej2xw_51"
};
function wa({
  children: e,
  defaultValue: t,
  label: a,
  helperContent: o,
  errorMessage: n,
  disabled: r,
  onChange: i,
  onBlur: l,
  value: c,
  name: s
}) {
  const u = !!n, d = !!(a ?? o);
  return /* @__PURE__ */ R(
    Kl,
    {
      name: s,
      onValueChange: i,
      defaultValue: t,
      className: H(Qe["radio-group"], n && Qe["has-error"]),
      disabled: r,
      onBlur: l,
      value: c,
      children: [
        d && /* @__PURE__ */ R("div", { className: Qe["group-label"], children: [
          a && /* @__PURE__ */ y("label", { className: Qe.title, children: a }),
          o && /* @__PURE__ */ y("p", { className: Qe.text, children: o })
        ] }),
        e,
        u && /* @__PURE__ */ R("p", { className: Qe["error-message"], children: [
          /* @__PURE__ */ y(We, { name: "error-warning-fill", color: "error" }),
          n
        ] })
      ]
    }
  );
}
wa.Item = Ql;
var Os = [
  [
    "af",
    // Afghanistan
    "93"
  ],
  [
    "ax",
    // Åland Islands
    "358",
    1
  ],
  [
    "al",
    // Albania
    "355"
  ],
  [
    "dz",
    // Algeria
    "213"
  ],
  [
    "as",
    // American Samoa
    "1",
    5,
    ["684"]
  ],
  [
    "ad",
    // Andorra
    "376"
  ],
  [
    "ao",
    // Angola
    "244"
  ],
  [
    "ai",
    // Anguilla
    "1",
    6,
    ["264"]
  ],
  [
    "ag",
    // Antigua and Barbuda
    "1",
    7,
    ["268"]
  ],
  [
    "ar",
    // Argentina
    "54"
  ],
  [
    "am",
    // Armenia
    "374"
  ],
  [
    "aw",
    // Aruba
    "297"
  ],
  [
    "ac",
    // Ascension Island
    "247"
  ],
  [
    "au",
    // Australia
    "61",
    0,
    null,
    "0"
  ],
  [
    "at",
    // Austria
    "43"
  ],
  [
    "az",
    // Azerbaijan
    "994"
  ],
  [
    "bs",
    // Bahamas
    "1",
    8,
    ["242"]
  ],
  [
    "bh",
    // Bahrain
    "973"
  ],
  [
    "bd",
    // Bangladesh
    "880"
  ],
  [
    "bb",
    // Barbados
    "1",
    9,
    ["246"]
  ],
  [
    "by",
    // Belarus
    "375"
  ],
  [
    "be",
    // Belgium
    "32"
  ],
  [
    "bz",
    // Belize
    "501"
  ],
  [
    "bj",
    // Benin
    "229"
  ],
  [
    "bm",
    // Bermuda
    "1",
    10,
    ["441"]
  ],
  [
    "bt",
    // Bhutan
    "975"
  ],
  [
    "bo",
    // Bolivia
    "591"
  ],
  [
    "ba",
    // Bosnia and Herzegovina
    "387"
  ],
  [
    "bw",
    // Botswana
    "267"
  ],
  [
    "br",
    // Brazil
    "55"
  ],
  [
    "io",
    // British Indian Ocean Territory
    "246"
  ],
  [
    "vg",
    // British Virgin Islands
    "1",
    11,
    ["284"]
  ],
  [
    "bn",
    // Brunei
    "673"
  ],
  [
    "bg",
    // Bulgaria
    "359"
  ],
  [
    "bf",
    // Burkina Faso
    "226"
  ],
  [
    "bi",
    // Burundi
    "257"
  ],
  [
    "kh",
    // Cambodia
    "855"
  ],
  [
    "cm",
    // Cameroon
    "237"
  ],
  [
    "ca",
    // Canada
    "1",
    1,
    ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "879", "902", "905"]
  ],
  [
    "cv",
    // Cape Verde
    "238"
  ],
  [
    "bq",
    // Caribbean Netherlands
    "599",
    1,
    ["3", "4", "7"]
  ],
  [
    "ky",
    // Cayman Islands
    "1",
    12,
    ["345"]
  ],
  [
    "cf",
    // Central African Republic
    "236"
  ],
  [
    "td",
    // Chad
    "235"
  ],
  [
    "cl",
    // Chile
    "56"
  ],
  [
    "cn",
    // China
    "86"
  ],
  [
    "cx",
    // Christmas Island
    "61",
    2,
    ["89164"],
    "0"
  ],
  [
    "cc",
    // Cocos (Keeling) Islands
    "61",
    1,
    ["89162"],
    "0"
  ],
  [
    "co",
    // Colombia
    "57"
  ],
  [
    "km",
    // Comoros
    "269"
  ],
  [
    "cg",
    // Congo (Brazzaville)
    "242"
  ],
  [
    "cd",
    // Congo (Kinshasa)
    "243"
  ],
  [
    "ck",
    // Cook Islands
    "682"
  ],
  [
    "cr",
    // Costa Rica
    "506"
  ],
  [
    "ci",
    // Côte d'Ivoire
    "225"
  ],
  [
    "hr",
    // Croatia
    "385"
  ],
  [
    "cu",
    // Cuba
    "53"
  ],
  [
    "cw",
    // Curaçao
    "599",
    0
  ],
  [
    "cy",
    // Cyprus
    "357"
  ],
  [
    "cz",
    // Czech Republic
    "420"
  ],
  [
    "dk",
    // Denmark
    "45"
  ],
  [
    "dj",
    // Djibouti
    "253"
  ],
  [
    "dm",
    // Dominica
    "1",
    13,
    ["767"]
  ],
  [
    "do",
    // Dominican Republic
    "1",
    2,
    ["809", "829", "849"]
  ],
  [
    "ec",
    // Ecuador
    "593"
  ],
  [
    "eg",
    // Egypt
    "20"
  ],
  [
    "sv",
    // El Salvador
    "503"
  ],
  [
    "gq",
    // Equatorial Guinea
    "240"
  ],
  [
    "er",
    // Eritrea
    "291"
  ],
  [
    "ee",
    // Estonia
    "372"
  ],
  [
    "sz",
    // Eswatini
    "268"
  ],
  [
    "et",
    // Ethiopia
    "251"
  ],
  [
    "fk",
    // Falkland Islands (Malvinas)
    "500"
  ],
  [
    "fo",
    // Faroe Islands
    "298"
  ],
  [
    "fj",
    // Fiji
    "679"
  ],
  [
    "fi",
    // Finland
    "358",
    0
  ],
  [
    "fr",
    // France
    "33"
  ],
  [
    "gf",
    // French Guiana
    "594"
  ],
  [
    "pf",
    // French Polynesia
    "689"
  ],
  [
    "ga",
    // Gabon
    "241"
  ],
  [
    "gm",
    // Gambia
    "220"
  ],
  [
    "ge",
    // Georgia
    "995"
  ],
  [
    "de",
    // Germany
    "49"
  ],
  [
    "gh",
    // Ghana
    "233"
  ],
  [
    "gi",
    // Gibraltar
    "350"
  ],
  [
    "gr",
    // Greece
    "30"
  ],
  [
    "gl",
    // Greenland
    "299"
  ],
  [
    "gd",
    // Grenada
    "1",
    14,
    ["473"]
  ],
  [
    "gp",
    // Guadeloupe
    "590",
    0
  ],
  [
    "gu",
    // Guam
    "1",
    15,
    ["671"]
  ],
  [
    "gt",
    // Guatemala
    "502"
  ],
  [
    "gg",
    // Guernsey
    "44",
    1,
    ["1481", "7781", "7839", "7911"],
    "0"
  ],
  [
    "gn",
    // Guinea
    "224"
  ],
  [
    "gw",
    // Guinea-Bissau
    "245"
  ],
  [
    "gy",
    // Guyana
    "592"
  ],
  [
    "ht",
    // Haiti
    "509"
  ],
  [
    "hn",
    // Honduras
    "504"
  ],
  [
    "hk",
    // Hong Kong SAR China
    "852"
  ],
  [
    "hu",
    // Hungary
    "36"
  ],
  [
    "is",
    // Iceland
    "354"
  ],
  [
    "in",
    // India
    "91"
  ],
  [
    "id",
    // Indonesia
    "62"
  ],
  [
    "ir",
    // Iran
    "98"
  ],
  [
    "iq",
    // Iraq
    "964"
  ],
  [
    "ie",
    // Ireland
    "353"
  ],
  [
    "im",
    // Isle of Man
    "44",
    2,
    ["1624", "74576", "7524", "7924", "7624"],
    "0"
  ],
  [
    "il",
    // Israel
    "972"
  ],
  [
    "it",
    // Italy
    "39",
    0
  ],
  [
    "jm",
    // Jamaica
    "1",
    4,
    ["876", "658"]
  ],
  [
    "jp",
    // Japan
    "81"
  ],
  [
    "je",
    // Jersey
    "44",
    3,
    ["1534", "7509", "7700", "7797", "7829", "7937"],
    "0"
  ],
  [
    "jo",
    // Jordan
    "962"
  ],
  [
    "kz",
    // Kazakhstan
    "7",
    1,
    ["33", "7"],
    "8"
  ],
  [
    "ke",
    // Kenya
    "254"
  ],
  [
    "ki",
    // Kiribati
    "686"
  ],
  [
    "xk",
    // Kosovo
    "383"
  ],
  [
    "kw",
    // Kuwait
    "965"
  ],
  [
    "kg",
    // Kyrgyzstan
    "996"
  ],
  [
    "la",
    // Laos
    "856"
  ],
  [
    "lv",
    // Latvia
    "371"
  ],
  [
    "lb",
    // Lebanon
    "961"
  ],
  [
    "ls",
    // Lesotho
    "266"
  ],
  [
    "lr",
    // Liberia
    "231"
  ],
  [
    "ly",
    // Libya
    "218"
  ],
  [
    "li",
    // Liechtenstein
    "423"
  ],
  [
    "lt",
    // Lithuania
    "370"
  ],
  [
    "lu",
    // Luxembourg
    "352"
  ],
  [
    "mo",
    // Macao SAR China
    "853"
  ],
  [
    "mg",
    // Madagascar
    "261"
  ],
  [
    "mw",
    // Malawi
    "265"
  ],
  [
    "my",
    // Malaysia
    "60"
  ],
  [
    "mv",
    // Maldives
    "960"
  ],
  [
    "ml",
    // Mali
    "223"
  ],
  [
    "mt",
    // Malta
    "356"
  ],
  [
    "mh",
    // Marshall Islands
    "692"
  ],
  [
    "mq",
    // Martinique
    "596"
  ],
  [
    "mr",
    // Mauritania
    "222"
  ],
  [
    "mu",
    // Mauritius
    "230"
  ],
  [
    "yt",
    // Mayotte
    "262",
    1,
    ["269", "639"],
    "0"
  ],
  [
    "mx",
    // Mexico
    "52"
  ],
  [
    "fm",
    // Micronesia
    "691"
  ],
  [
    "md",
    // Moldova
    "373"
  ],
  [
    "mc",
    // Monaco
    "377"
  ],
  [
    "mn",
    // Mongolia
    "976"
  ],
  [
    "me",
    // Montenegro
    "382"
  ],
  [
    "ms",
    // Montserrat
    "1",
    16,
    ["664"]
  ],
  [
    "ma",
    // Morocco
    "212",
    0,
    null,
    "0"
  ],
  [
    "mz",
    // Mozambique
    "258"
  ],
  [
    "mm",
    // Myanmar (Burma)
    "95"
  ],
  [
    "na",
    // Namibia
    "264"
  ],
  [
    "nr",
    // Nauru
    "674"
  ],
  [
    "np",
    // Nepal
    "977"
  ],
  [
    "nl",
    // Netherlands
    "31"
  ],
  [
    "nc",
    // New Caledonia
    "687"
  ],
  [
    "nz",
    // New Zealand
    "64"
  ],
  [
    "ni",
    // Nicaragua
    "505"
  ],
  [
    "ne",
    // Niger
    "227"
  ],
  [
    "ng",
    // Nigeria
    "234"
  ],
  [
    "nu",
    // Niue
    "683"
  ],
  [
    "nf",
    // Norfolk Island
    "672"
  ],
  [
    "kp",
    // North Korea
    "850"
  ],
  [
    "mk",
    // North Macedonia
    "389"
  ],
  [
    "mp",
    // Northern Mariana Islands
    "1",
    17,
    ["670"]
  ],
  [
    "no",
    // Norway
    "47",
    0
  ],
  [
    "om",
    // Oman
    "968"
  ],
  [
    "pk",
    // Pakistan
    "92"
  ],
  [
    "pw",
    // Palau
    "680"
  ],
  [
    "ps",
    // Palestinian Territories
    "970"
  ],
  [
    "pa",
    // Panama
    "507"
  ],
  [
    "pg",
    // Papua New Guinea
    "675"
  ],
  [
    "py",
    // Paraguay
    "595"
  ],
  [
    "pe",
    // Peru
    "51"
  ],
  [
    "ph",
    // Philippines
    "63"
  ],
  [
    "pl",
    // Poland
    "48"
  ],
  [
    "pt",
    // Portugal
    "351"
  ],
  [
    "pr",
    // Puerto Rico
    "1",
    3,
    ["787", "939"]
  ],
  [
    "qa",
    // Qatar
    "974"
  ],
  [
    "re",
    // Réunion
    "262",
    0,
    null,
    "0"
  ],
  [
    "ro",
    // Romania
    "40"
  ],
  [
    "ru",
    // Russia
    "7",
    0,
    null,
    "8"
  ],
  [
    "rw",
    // Rwanda
    "250"
  ],
  [
    "ws",
    // Samoa
    "685"
  ],
  [
    "sm",
    // San Marino
    "378"
  ],
  [
    "st",
    // São Tomé & Príncipe
    "239"
  ],
  [
    "sa",
    // Saudi Arabia
    "966"
  ],
  [
    "sn",
    // Senegal
    "221"
  ],
  [
    "rs",
    // Serbia
    "381"
  ],
  [
    "sc",
    // Seychelles
    "248"
  ],
  [
    "sl",
    // Sierra Leone
    "232"
  ],
  [
    "sg",
    // Singapore
    "65"
  ],
  [
    "sx",
    // Sint Maarten
    "1",
    21,
    ["721"]
  ],
  [
    "sk",
    // Slovakia
    "421"
  ],
  [
    "si",
    // Slovenia
    "386"
  ],
  [
    "sb",
    // Solomon Islands
    "677"
  ],
  [
    "so",
    // Somalia
    "252"
  ],
  [
    "za",
    // South Africa
    "27"
  ],
  [
    "kr",
    // South Korea
    "82"
  ],
  [
    "ss",
    // South Sudan
    "211"
  ],
  [
    "es",
    // Spain
    "34"
  ],
  [
    "lk",
    // Sri Lanka
    "94"
  ],
  [
    "bl",
    // St. Barthélemy
    "590",
    1
  ],
  [
    "sh",
    // St. Helena
    "290"
  ],
  [
    "kn",
    // St. Kitts & Nevis
    "1",
    18,
    ["869"]
  ],
  [
    "lc",
    // St. Lucia
    "1",
    19,
    ["758"]
  ],
  [
    "mf",
    // St. Martin
    "590",
    2
  ],
  [
    "pm",
    // St. Pierre & Miquelon
    "508"
  ],
  [
    "vc",
    // St. Vincent & Grenadines
    "1",
    20,
    ["784"]
  ],
  [
    "sd",
    // Sudan
    "249"
  ],
  [
    "sr",
    // Suriname
    "597"
  ],
  [
    "sj",
    // Svalbard & Jan Mayen
    "47",
    1,
    ["79"]
  ],
  [
    "se",
    // Sweden
    "46"
  ],
  [
    "ch",
    // Switzerland
    "41"
  ],
  [
    "sy",
    // Syria
    "963"
  ],
  [
    "tw",
    // Taiwan
    "886"
  ],
  [
    "tj",
    // Tajikistan
    "992"
  ],
  [
    "tz",
    // Tanzania
    "255"
  ],
  [
    "th",
    // Thailand
    "66"
  ],
  [
    "tl",
    // Timor-Leste
    "670"
  ],
  [
    "tg",
    // Togo
    "228"
  ],
  [
    "tk",
    // Tokelau
    "690"
  ],
  [
    "to",
    // Tonga
    "676"
  ],
  [
    "tt",
    // Trinidad & Tobago
    "1",
    22,
    ["868"]
  ],
  [
    "tn",
    // Tunisia
    "216"
  ],
  [
    "tr",
    // Turkey
    "90"
  ],
  [
    "tm",
    // Turkmenistan
    "993"
  ],
  [
    "tc",
    // Turks & Caicos Islands
    "1",
    23,
    ["649"]
  ],
  [
    "tv",
    // Tuvalu
    "688"
  ],
  [
    "vi",
    // U.S. Virgin Islands
    "1",
    24,
    ["340"]
  ],
  [
    "ug",
    // Uganda
    "256"
  ],
  [
    "ua",
    // Ukraine
    "380"
  ],
  [
    "ae",
    // United Arab Emirates
    "971"
  ],
  [
    "gb",
    // United Kingdom
    "44",
    0,
    null,
    "0"
  ],
  [
    "us",
    // United States
    "1",
    0
  ],
  [
    "uy",
    // Uruguay
    "598"
  ],
  [
    "uz",
    // Uzbekistan
    "998"
  ],
  [
    "vu",
    // Vanuatu
    "678"
  ],
  [
    "va",
    // Vatican City
    "39",
    1,
    ["06698"]
  ],
  [
    "ve",
    // Venezuela
    "58"
  ],
  [
    "vn",
    // Vietnam
    "84"
  ],
  [
    "wf",
    // Wallis & Futuna
    "681"
  ],
  [
    "eh",
    // Western Sahara
    "212",
    1,
    ["5288", "5289"],
    "0"
  ],
  [
    "ye",
    // Yemen
    "967"
  ],
  [
    "zm",
    // Zambia
    "260"
  ],
  [
    "zw",
    // Zimbabwe
    "263"
  ]
], rr = [];
for (const e of Os)
  rr.push({
    name: "",
    // populated in the plugin
    iso2: e[0],
    dialCode: e[1],
    priority: e[2] || 0,
    areaCodes: e[3] || null,
    nodeById: {},
    // populated by the plugin
    nationalPrefix: e[4] || null
  });
var at = rr, Is = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, js = Is, Ls = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, Es = Ls, Bs = { ...js, ...Es }, ir = Bs, fa = (e) => typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia(e).matches, Ts = () => {
  if (typeof navigator < "u" && typeof window < "u") {
    const e = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), t = fa("(max-width: 500px)"), a = fa("(max-height: 600px)"), o = fa("(pointer: coarse)");
    return e || t || o && a;
  }
  return !1;
}, lr = {
  // Allow alphanumeric "phonewords" (e.g. +1 800 FLOWERS) as valid numbers
  allowPhonewords: !1,
  //* Whether or not to allow the dropdown.
  allowDropdown: !0,
  //* Add a placeholder in the input with an example number for the selected country.
  autoPlaceholder: "polite",
  //* Modify the parentClass.
  containerClass: "",
  //* The order of the countries in the dropdown. Defaults to alphabetical.
  countryOrder: null,
  //* Add a country search input at the top of the dropdown.
  countrySearch: !0,
  //* Modify the auto placeholder.
  customPlaceholder: null,
  //* Append menu to specified element.
  dropdownContainer: null,
  //* Don't display these countries.
  excludeCountries: [],
  //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
  fixDropdownWidth: !0,
  //* Format the number as the user types
  formatAsYouType: !0,
  //* Format the input value during initialisation and on setNumber.
  formatOnDisplay: !0,
  //* geoIp lookup function.
  geoIpLookup: null,
  //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
  hiddenInput: null,
  //* Internationalise the plugin text e.g. search input placeholder, country names.
  i18n: {},
  //* Initial country.
  initialCountry: "",
  //* A function to load the utils script.
  loadUtils: null,
  //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
  nationalMode: !0,
  //* Display only these countries.
  onlyCountries: [],
  //* Number type to use for placeholders.
  placeholderNumberType: "MOBILE",
  //* Show flags - for both the selected country, and in the country dropdown
  showFlags: !0,
  //* Display the international dial code next to the selected flag.
  separateDialCode: !1,
  //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
  strictMode: !1,
  //* Use full screen popup instead of dropdown for country list.
  useFullscreenPopup: Ts(),
  //* The number type to enforce during validation.
  validationNumberTypes: ["MOBILE"]
};
function Rs(e) {
  e.useFullscreenPopup && (e.fixDropdownWidth = !1), e.onlyCountries.length === 1 && (e.initialCountry = e.onlyCountries[0]), e.separateDialCode && (e.nationalMode = !1), e.allowDropdown && !e.showFlags && !e.separateDialCode && (e.nationalMode = !1), e.useFullscreenPopup && !e.dropdownContainer && (e.dropdownContainer = document.body), e.i18n = { ...ir, ...e.i18n };
}
var Lt = (e) => e.replace(/\D/g, ""), sr = (e = "") => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(), ne = (e, t, a) => {
  const o = document.createElement(e);
  return t && Object.entries(t).forEach(([n, r]) => o.setAttribute(n, r)), a && a.appendChild(o), o;
};
function Fs(e) {
  const { onlyCountries: t, excludeCountries: a } = e;
  if (t.length) {
    const o = t.map((n) => n.toLowerCase());
    return at.filter((n) => o.includes(n.iso2));
  } else if (a.length) {
    const o = a.map((n) => n.toLowerCase());
    return at.filter((n) => !o.includes(n.iso2));
  }
  return at;
}
function Vs(e, t) {
  for (const a of e) {
    const o = a.iso2.toLowerCase();
    t.i18n[o] && (a.name = t.i18n[o]);
  }
}
function Gs(e, t) {
  const a = /* @__PURE__ */ new Set();
  let o = 0;
  const n = {}, r = (i, l, c) => {
    if (!i || !l)
      return;
    l.length > o && (o = l.length), n.hasOwnProperty(l) || (n[l] = []);
    const s = n[l];
    if (s.includes(i))
      return;
    const u = c !== void 0 ? c : s.length;
    s[u] = i;
  };
  for (const i of e)
    a.has(i.dialCode) || a.add(i.dialCode), r(i.iso2, i.dialCode, i.priority);
  (t.onlyCountries.length || t.excludeCountries.length) && a.forEach((i) => {
    n[i] = n[i].filter(Boolean);
  });
  for (const i of e)
    if (i.areaCodes) {
      const l = n[i.dialCode][0];
      for (const c of i.areaCodes) {
        for (let s = 1; s < c.length; s++) {
          const u = c.substring(0, s), d = i.dialCode + u;
          r(l, d), r(i.iso2, d);
        }
        r(i.iso2, i.dialCode + c);
      }
    }
  return { dialCodes: a, dialCodeMaxLen: o, dialCodeToIso2Map: n };
}
function Us(e, t) {
  t.countryOrder && (t.countryOrder = t.countryOrder.map((a) => a.toLowerCase())), e.sort((a, o) => {
    const { countryOrder: n } = t;
    if (n) {
      const r = n.indexOf(a.iso2), i = n.indexOf(o.iso2), l = r > -1, c = i > -1;
      if (l || c)
        return l && c ? r - i : l ? -1 : 1;
    }
    return a.name.localeCompare(o.name);
  });
}
function Zs(e) {
  for (const t of e)
    t.normalisedName = sr(t.name), t.initials = t.name.split(/[^a-zA-ZÀ-ÿа-яА-Я]/).map((a) => a[0]).join("").toLowerCase(), t.dialCodePlus = `+${t.dialCode}`;
}
function Ws(e, t, a, o) {
  let n = e;
  if (a && t) {
    t = `+${o.dialCode}`;
    const r = n[t.length] === " " || n[t.length] === "-" ? t.length + 1 : t.length;
    n = n.substring(r);
  }
  return n;
}
function Ks(e, t, a, o, n) {
  const r = a ? a.formatNumberAsYouType(e, o.iso2) : e, { dialCode: i } = o;
  return n && t.charAt(0) !== "+" && r.includes(`+${i}`) ? (r.split(`+${i}`)[1] || "").trim() : r;
}
function qs(e, t, a, o) {
  if (a === 0 && !o)
    return 0;
  let n = 0;
  for (let r = 0; r < t.length; r++) {
    if (/[+0-9]/.test(t[r]) && n++, n === e && !o)
      return r + 1;
    if (o && n === e + 1)
      return r;
  }
  return t.length;
}
var Hs = [
  "800",
  "822",
  "833",
  "844",
  "855",
  "866",
  "877",
  "880",
  "881",
  "882",
  "883",
  "884",
  "885",
  "886",
  "887",
  "888",
  "889"
], Co = (e) => {
  const t = Lt(e);
  if (t.charAt(0) === "1") {
    const a = t.substring(1, 4);
    return Hs.includes(a);
  }
  return !1;
};
for (const e of at)
  e.name = ir[e.iso2];
var Js = 0, Ys = new Set(at.map((e) => e.iso2)), ba = (e) => Ys.has(e), gt = (e, ...t) => {
  const { instances: a } = O;
  Object.values(a).forEach((o) => o[e](...t));
}, Qs = class xa {
  /**
   * Build a space-delimited class string from an object map of className -> truthy/falsey.
   * Only keys with truthy values are included.
   */
  static _buildClassNames(t) {
    return Object.keys(t).filter((a) => !!t[a]).join(" ");
  }
  constructor(t, a = {}) {
    this.id = Js++, this.telInput = t, this.highlightedItem = null, this.options = Object.assign({}, lr, a), this.hadInitialPlaceholder = !!t.getAttribute("placeholder");
  }
  _detectEnvironmentAndLayout() {
    this.isAndroid = typeof navigator < "u" ? /Android/i.test(navigator.userAgent) : !1, this.isRTL = !!this.telInput.closest("[dir=rtl]"), this.telInput.dir = "ltr";
    const t = this.options.allowDropdown || this.options.separateDialCode;
    this.showSelectedCountryOnLeft = this.isRTL ? !t : t, this.options.separateDialCode && (this.isRTL ? this.originalPaddingRight = this.telInput.style.paddingRight : this.originalPaddingLeft = this.telInput.style.paddingLeft);
  }
  _createInitPromises() {
    const t = new Promise((o, n) => {
      this.resolveAutoCountryPromise = o, this.rejectAutoCountryPromise = n;
    }), a = new Promise((o, n) => {
      this.resolveUtilsScriptPromise = o, this.rejectUtilsScriptPromise = n;
    });
    this.promise = Promise.all([t, a]);
  }
  //* Can't be private as it's called from intlTelInput convenience wrapper.
  _init() {
    Rs(this.options), this._detectEnvironmentAndLayout(), this._createInitPromises(), this.selectedCountryData = {}, this._processCountryData(), this._generateMarkup(), this._setInitialState(), this._initListeners(), this._initRequests();
  }
  //********************
  //*  PRIVATE METHODS
  //********************
  //* Prepare all of the country data, including onlyCountries, excludeCountries, countryOrder options.
  _processCountryData() {
    this.countries = Fs(this.options);
    const t = Gs(this.countries, this.options);
    this.dialCodes = t.dialCodes, this.dialCodeMaxLen = t.dialCodeMaxLen, this.dialCodeToIso2Map = t.dialCodeToIso2Map, Vs(this.countries, this.options), Us(this.countries, this.options), this.countryByIso2 = new Map(this.countries.map((a) => [a.iso2, a])), Zs(this.countries);
  }
  //* Generate all of the markup for the plugin: the selected country overlay, and the dropdown.
  _generateMarkup() {
    this._prepareTelInput();
    const t = this._createWrapperAndInsert();
    this._maybeBuildCountryContainer(t), t.appendChild(this.telInput), this._maybeUpdateInputPaddingAndReveal(), this._maybeBuildHiddenInputs(t);
  }
  _prepareTelInput() {
    this.telInput.classList.add("iti__tel-input"), !this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete")) && this.telInput.setAttribute("autocomplete", "off");
  }
  _createWrapperAndInsert() {
    const {
      allowDropdown: t,
      showFlags: a,
      containerClass: o,
      useFullscreenPopup: n
    } = this.options, r = xa._buildClassNames({
      iti: !0,
      "iti--allow-dropdown": t,
      "iti--show-flags": a,
      "iti--inline-dropdown": !n,
      [o]: !!o
    }), i = ne("div", { class: r });
    return this.telInput.parentNode?.insertBefore(i, this.telInput), i;
  }
  _maybeBuildCountryContainer(t) {
    const {
      allowDropdown: a,
      separateDialCode: o,
      showFlags: n
    } = this.options;
    if (a || n || o) {
      this.countryContainer = ne(
        "div",
        // visibly hidden until we measure it's width to set the input padding correctly
        { class: "iti__country-container iti__v-hide" },
        t
      ), this.showSelectedCountryOnLeft ? this.countryContainer.style.left = "0px" : this.countryContainer.style.right = "0px", a ? (this.selectedCountry = ne(
        "button",
        {
          type: "button",
          class: "iti__selected-country",
          "aria-expanded": "false",
          "aria-label": this.options.i18n.noCountrySelected,
          "aria-haspopup": "dialog",
          "aria-controls": `iti-${this.id}__dropdown-content`
        },
        this.countryContainer
      ), this.telInput.disabled && this.selectedCountry.setAttribute("disabled", "true")) : this.selectedCountry = ne(
        "div",
        { class: "iti__selected-country" },
        this.countryContainer
      );
      const r = ne(
        "div",
        { class: "iti__selected-country-primary" },
        this.selectedCountry
      );
      this.selectedCountryInner = ne(
        "div",
        { class: "iti__flag" },
        r
      ), a && (this.dropdownArrow = ne(
        "div",
        { class: "iti__arrow", "aria-hidden": "true" },
        r
      )), o && (this.selectedDialCode = ne(
        "div",
        { class: "iti__selected-dial-code", dir: "ltr" },
        this.selectedCountry
      )), a && this._buildDropdownContent();
    }
  }
  _buildDropdownContent() {
    const {
      fixDropdownWidth: t,
      useFullscreenPopup: a,
      countrySearch: o,
      i18n: n,
      dropdownContainer: r,
      containerClass: i
    } = this.options, l = t ? "" : "iti--flexible-dropdown-width";
    if (this.dropdownContent = ne("div", {
      id: `iti-${this.id}__dropdown-content`,
      class: `iti__dropdown-content iti__hide ${l}`,
      role: "dialog",
      "aria-modal": "true"
    }), o && this._buildSearchUI(), this.countryList = ne(
      "ul",
      {
        class: "iti__country-list",
        id: `iti-${this.id}__country-listbox`,
        role: "listbox",
        "aria-label": n.countryListAriaLabel
      },
      this.dropdownContent
    ), this._appendListItems(), o && this._updateSearchResultsA11yText(), r) {
      const c = xa._buildClassNames({
        iti: !0,
        "iti--container": !0,
        "iti--fullscreen-popup": a,
        "iti--inline-dropdown": !a,
        [i]: !!i
      });
      this.dropdown = ne("div", { class: c }), this.dropdown.appendChild(this.dropdownContent);
    } else
      this.countryContainer.appendChild(this.dropdownContent);
  }
  _buildSearchUI() {
    const { i18n: t } = this.options, a = ne(
      "div",
      { class: "iti__search-input-wrapper" },
      this.dropdownContent
    );
    this.searchIcon = ne(
      "span",
      {
        class: "iti__search-icon",
        "aria-hidden": "true"
      },
      a
    ), this.searchIcon.innerHTML = `
      <svg class="iti__search-icon-svg" width="14" height="14" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>`, this.searchInput = ne(
      "input",
      {
        id: `iti-${this.id}__search-input`,
        // Chrome says inputs need either a name or an id
        type: "search",
        class: "iti__search-input",
        placeholder: t.searchPlaceholder,
        // role=combobox + aria-autocomplete=list + aria-activedescendant allows maintaining focus on the search input while allowing users to navigate search results with up/down keyboard keys
        role: "combobox",
        "aria-expanded": "true",
        "aria-label": t.searchPlaceholder,
        "aria-controls": `iti-${this.id}__country-listbox`,
        "aria-autocomplete": "list",
        autocomplete: "off"
      },
      a
    ), this.searchClearButton = ne(
      "button",
      {
        type: "button",
        class: "iti__search-clear iti__hide",
        "aria-label": t.clearSearchAriaLabel,
        tabindex: "-1"
      },
      a
    );
    const o = `iti-${this.id}-clear-mask`;
    this.searchClearButton.innerHTML = `
      <svg class="iti__search-clear-svg" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <mask id="${o}" maskUnits="userSpaceOnUse">
          <rect width="16" height="16" fill="white" />
          <path d="M5.2 5.2 L10.8 10.8 M10.8 5.2 L5.2 10.8" stroke="black" stroke-linecap="round" class="iti__search-clear-x" />
        </mask>
        <circle cx="8" cy="8" r="8" class="iti__search-clear-bg" mask="url(#${o})" />
      </svg>`, this.searchResultsA11yText = ne(
      "span",
      { class: "iti__a11y-text" },
      this.dropdownContent
    ), this.searchNoResults = ne(
      "div",
      {
        class: "iti__no-results iti__hide",
        "aria-hidden": "true"
        // all a11y messaging happens in this.searchResultsA11yText
      },
      this.dropdownContent
    ), this.searchNoResults.textContent = t.zeroSearchResults;
  }
  _maybeUpdateInputPaddingAndReveal() {
    this.countryContainer && (this._updateInputPadding(), this.countryContainer.classList.remove("iti__v-hide"));
  }
  _maybeBuildHiddenInputs(t) {
    const { hiddenInput: a } = this.options;
    if (a) {
      const o = this.telInput.getAttribute("name") || "", n = a(o);
      if (n.phone) {
        const r = this.telInput.form?.querySelector(`input[name="${n.phone}"]`);
        r ? this.hiddenInput = r : (this.hiddenInput = ne("input", {
          type: "hidden",
          name: n.phone
        }), t.appendChild(this.hiddenInput));
      }
      if (n.country) {
        const r = this.telInput.form?.querySelector(`input[name="${n.country}"]`);
        r ? this.hiddenInputCountry = r : (this.hiddenInputCountry = ne("input", {
          type: "hidden",
          name: n.country
        }), t.appendChild(this.hiddenInputCountry));
      }
    }
  }
  //* For each country: add a country list item <li> to the countryList <ul> container.
  _appendListItems() {
    for (let t = 0; t < this.countries.length; t++) {
      const a = this.countries[t], o = t === 0 ? "iti__highlight" : "", n = ne(
        "li",
        {
          id: `iti-${this.id}__item-${a.iso2}`,
          class: `iti__country ${o}`,
          tabindex: "-1",
          role: "option",
          "data-dial-code": a.dialCode,
          "data-country-code": a.iso2,
          "aria-selected": "false"
        },
        this.countryList
      );
      a.nodeById[this.id] = n;
      let r = "";
      this.options.showFlags && (r += `<div class='iti__flag iti__${a.iso2}'></div>`), r += `<span class='iti__country-name'>${a.name}</span>`, r += `<span class='iti__dial-code' dir='ltr'>+${a.dialCode}</span>`, n.insertAdjacentHTML("beforeend", r);
    }
  }
  //* Set the initial state of the input value and the selected country by:
  //* 1. Extracting a dial code from the given number
  //* 2. Using explicit initialCountry
  _setInitialState(t = !1) {
    const a = this.telInput.getAttribute("value"), o = this.telInput.value, n = a && a.charAt(0) === "+" && (!o || o.charAt(0) !== "+") ? a : o, r = this._getDialCode(n), i = Co(n), { initialCountry: l, geoIpLookup: c } = this.options, s = l === "auto" && c;
    if (r && !i)
      this._updateCountryFromNumber(n);
    else if (!s || t) {
      const u = l ? l.toLowerCase() : "";
      ba(u) ? this._setCountry(u) : r && i ? this._setCountry("us") : this._setCountry("");
    }
    n && this._updateValFromNumber(n);
  }
  //* Initialise the main event listeners: input keyup, and click selected country.
  _initListeners() {
    this._initTelInputListeners(), this.options.allowDropdown && this._initDropdownListeners(), (this.hiddenInput || this.hiddenInputCountry) && this.telInput.form && this._initHiddenInputListener();
  }
  //* Update hidden input on form submit.
  _initHiddenInputListener() {
    this._handleHiddenInputSubmit = () => {
      this.hiddenInput && (this.hiddenInput.value = this.getNumber()), this.hiddenInputCountry && (this.hiddenInputCountry.value = this.getSelectedCountryData().iso2 || "");
    }, this.telInput.form?.addEventListener(
      "submit",
      this._handleHiddenInputSubmit
    );
  }
  //* initialise the dropdown listeners.
  _initDropdownListeners() {
    this._handleLabelClick = (a) => {
      this.dropdownContent.classList.contains("iti__hide") ? this.telInput.focus() : a.preventDefault();
    };
    const t = this.telInput.closest("label");
    t && t.addEventListener("click", this._handleLabelClick), this._handleClickSelectedCountry = () => {
      this.dropdownContent.classList.contains("iti__hide") && !this.telInput.disabled && !this.telInput.readOnly && this._openDropdown();
    }, this.selectedCountry.addEventListener("click", this._handleClickSelectedCountry), this._handleCountryContainerKeydown = (a) => {
      this.dropdownContent.classList.contains("iti__hide") && ["ArrowUp", "ArrowDown", " ", "Enter"].includes(a.key) && (a.preventDefault(), a.stopPropagation(), this._openDropdown()), a.key === "Tab" && this._closeDropdown();
    }, this.countryContainer.addEventListener(
      "keydown",
      this._handleCountryContainerKeydown
    );
  }
  //* Init many requests: utils script / geo ip lookup.
  _initRequests() {
    let { loadUtils: t, initialCountry: a, geoIpLookup: o } = this.options;
    t && !O.utils ? (this._doAttachUtils = () => {
      O.attachUtils(t)?.catch(() => {
      });
    }, O.documentReady() ? this._doAttachUtils() : (this._handlePageLoad = () => {
      this._doAttachUtils();
    }, window.addEventListener("load", this._handlePageLoad))) : this.resolveUtilsScriptPromise(), a === "auto" && o && !this.selectedCountryData.iso2 ? this._loadAutoCountry() : this.resolveAutoCountryPromise();
  }
  //* Perform the geo ip lookup.
  _loadAutoCountry() {
    O.autoCountry ? this.handleAutoCountry() : O.startedLoadingAutoCountry || (O.startedLoadingAutoCountry = !0, typeof this.options.geoIpLookup == "function" && this.options.geoIpLookup(
      (t = "") => {
        const a = t.toLowerCase();
        ba(a) ? (O.autoCountry = a, setTimeout(() => gt("handleAutoCountry"))) : (this._setInitialState(!0), gt("rejectAutoCountryPromise"));
      },
      () => {
        this._setInitialState(!0), gt("rejectAutoCountryPromise");
      }
    ));
  }
  _openDropdownWithPlus() {
    this._openDropdown(), this.searchInput.value = "+", this._filterCountries("");
  }
  //* Initialize the tel input listeners.
  _initTelInputListeners() {
    this._bindInputListener(), this._maybeBindKeydownListener(), this._maybeBindPasteListener();
  }
  _bindInputListener() {
    const { strictMode: t, formatAsYouType: a, separateDialCode: o, allowDropdown: n, countrySearch: r } = this.options;
    let i = !1;
    new RegExp("\\p{L}", "u").test(this.telInput.value) && (i = !0), this._handleInputEvent = (l) => {
      if (this.isAndroid && l?.data === "+" && o && n && r) {
        const d = this.telInput.selectionStart || 0, g = this.telInput.value.substring(0, d - 1), b = this.telInput.value.substring(d);
        this.telInput.value = g + b, this._openDropdownWithPlus();
        return;
      }
      this._updateCountryFromNumber(this.telInput.value) && this._triggerCountryChange();
      const c = l?.data && /[^+0-9]/.test(l.data), s = l?.inputType === "insertFromPaste" && this.telInput.value;
      c || s && !t ? i = !0 : /[^+0-9]/.test(this.telInput.value) || (i = !1);
      const u = l?.detail && l.detail.isSetNumber;
      if (a && !i && !u) {
        const d = this.telInput.selectionStart || 0, g = this.telInput.value.substring(0, d).replace(/[^+0-9]/g, "").length, b = l?.inputType === "deleteContentForward", h = this._getFullNumber(), p = Ks(
          h,
          this.telInput.value,
          O.utils,
          this.selectedCountryData,
          this.options.separateDialCode
        ), $ = qs(g, p, d, b);
        this.telInput.value = p, this.telInput.setSelectionRange($, $);
      }
    }, this.telInput.addEventListener("input", this._handleInputEvent);
  }
  _maybeBindKeydownListener() {
    const { strictMode: t, separateDialCode: a, allowDropdown: o, countrySearch: n } = this.options;
    (t || a) && (this._handleKeydownEvent = (r) => {
      if (r.key && r.key.length === 1 && !r.altKey && !r.ctrlKey && !r.metaKey) {
        if (a && o && n && r.key === "+") {
          r.preventDefault(), this._openDropdownWithPlus();
          return;
        }
        if (t) {
          const i = this.telInput.value, l = i.charAt(0) !== "+" && this.telInput.selectionStart === 0 && r.key === "+", c = /^[0-9]$/.test(r.key), s = a ? c : l || c, u = i.slice(0, this.telInput.selectionStart) + r.key + i.slice(this.telInput.selectionEnd), d = this._getFullNumber(u), g = O.utils.getCoreNumber(d, this.selectedCountryData.iso2), b = this.maxCoreNumberLength && g.length > this.maxCoreNumberLength, h = this._getNewCountryFromNumber(d) !== null;
          (!s || b && !h && !l) && r.preventDefault();
        }
      }
    }, this.telInput.addEventListener("keydown", this._handleKeydownEvent));
  }
  _maybeBindPasteListener() {
    this.options.strictMode && (this._handlePasteEvent = (t) => {
      t.preventDefault();
      const a = this.telInput, o = a.selectionStart, n = a.selectionEnd, r = a.value.slice(0, o), i = a.value.slice(n), l = this.selectedCountryData.iso2, c = t.clipboardData.getData("text"), s = o === 0 && n > 0, u = !a.value.startsWith("+") || s, d = c.replace(/[^0-9+]/g, ""), g = d.startsWith("+"), b = d.replace(/\+/g, ""), h = g && u ? `+${b}` : b;
      let p = r + h + i, $ = O.utils.getCoreNumber(p, l);
      for (; $.length === 0 && p.length > 0; )
        p = p.slice(0, -1), $ = O.utils.getCoreNumber(p, l);
      if (!$)
        return;
      if (this.maxCoreNumberLength && $.length > this.maxCoreNumberLength)
        if (a.selectionEnd === a.value.length) {
          const k = $.length - this.maxCoreNumberLength;
          p = p.slice(0, p.length - k);
        } else
          return;
      a.value = p;
      const M = o + h.length;
      a.setSelectionRange(M, M), a.dispatchEvent(new InputEvent("input", { bubbles: !0 }));
    }, this.telInput.addEventListener("paste", this._handlePasteEvent));
  }
  //* Adhere to the input's maxlength attr.
  _cap(t) {
    const a = parseInt(this.telInput.getAttribute("maxlength") || "", 10);
    return a && t.length > a ? t.substring(0, a) : t;
  }
  //* Trigger a custom event on the input.
  _trigger(t, a = {}) {
    const o = new CustomEvent(t, {
      bubbles: !0,
      cancelable: !0,
      detail: a
    });
    this.telInput.dispatchEvent(o);
  }
  //* Open the dropdown.
  _openDropdown() {
    const { fixDropdownWidth: t, countrySearch: a } = this.options;
    if (t && (this.dropdownContent.style.width = `${this.telInput.offsetWidth}px`), this.dropdownContent.classList.remove("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "true"), this._setDropdownPosition(), a) {
      const o = this.countryList.firstElementChild;
      o && (this._highlightListItem(o, !1), this.countryList.scrollTop = 0), this.searchInput.focus();
    }
    this._bindDropdownListeners(), this.dropdownArrow.classList.add("iti__arrow--up"), this._trigger("open:countrydropdown");
  }
  //* Set the dropdown position
  _setDropdownPosition() {
    if (this.options.dropdownContainer && this.options.dropdownContainer.appendChild(this.dropdown), !this.options.useFullscreenPopup) {
      const t = this.telInput.getBoundingClientRect(), a = this.telInput.offsetHeight;
      this.options.dropdownContainer && (this.dropdown.style.top = `${t.top + a}px`, this.dropdown.style.left = `${t.left}px`, this._handleWindowScroll = () => this._closeDropdown(), window.addEventListener("scroll", this._handleWindowScroll));
    }
  }
  //* We only bind dropdown listeners when the dropdown is open.
  _bindDropdownListeners() {
    this._handleMouseoverCountryList = (o) => {
      const n = o.target?.closest(".iti__country");
      n && this._highlightListItem(n, !1);
    }, this.countryList.addEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this._handleClickCountryList = (o) => {
      const n = o.target?.closest(".iti__country");
      n && this._selectListItem(n);
    }, this.countryList.addEventListener("click", this._handleClickCountryList), this._handleClickOffToClose = (o) => {
      o.target.closest(`#iti-${this.id}__dropdown-content`) || this._closeDropdown();
    }, setTimeout(() => {
      document.documentElement.addEventListener(
        "click",
        this._handleClickOffToClose
      );
    }, 0);
    let t = "", a = null;
    if (this._handleKeydownOnDropdown = (o) => {
      ["ArrowUp", "ArrowDown", "Enter", "Escape"].includes(o.key) && (o.preventDefault(), o.stopPropagation(), o.key === "ArrowUp" || o.key === "ArrowDown" ? this._handleUpDownKey(o.key) : o.key === "Enter" ? this._handleEnterKey() : o.key === "Escape" && this._closeDropdown()), !this.options.countrySearch && /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(o.key) && (o.stopPropagation(), a && clearTimeout(a), t += o.key.toLowerCase(), this._searchForCountry(t), a = setTimeout(() => {
        t = "";
      }, 1e3));
    }, document.addEventListener("keydown", this._handleKeydownOnDropdown), this.options.countrySearch) {
      const o = () => {
        const r = this.searchInput.value.trim();
        this._filterCountries(r), this.searchInput.value ? this.searchClearButton.classList.remove("iti__hide") : this.searchClearButton.classList.add("iti__hide");
      };
      let n = null;
      this._handleSearchChange = () => {
        n && clearTimeout(n), n = setTimeout(() => {
          o(), n = null;
        }, 100);
      }, this.searchInput.addEventListener("input", this._handleSearchChange), this._handleSearchClear = () => {
        this.searchInput.value = "", this.searchInput.focus(), o();
      }, this.searchClearButton.addEventListener("click", this._handleSearchClear);
    }
  }
  //* Hidden search (countrySearch disabled): Find the first list item whose name starts with the query string.
  _searchForCountry(t) {
    for (const a of this.countries)
      if (a.name.substring(0, t.length).toLowerCase() === t) {
        const o = a.nodeById[this.id];
        this._highlightListItem(o, !1), this._scrollTo(o);
        break;
      }
  }
  //* Country search enabled: Filter the countries according to the search query.
  _filterCountries(t) {
    this.countryList.innerHTML = "";
    let a;
    t === "" ? a = this.countries : a = this._getMatchedCountries(t);
    let o = !0;
    for (const n of a) {
      const r = n.nodeById[this.id];
      r && (this.countryList.appendChild(r), o && (this._highlightListItem(r, !1), o = !1));
    }
    o ? (this._highlightListItem(null, !1), this.searchNoResults && this.searchNoResults.classList.remove("iti__hide")) : this.searchNoResults && this.searchNoResults.classList.add("iti__hide"), this.countryList.scrollTop = 0, this._updateSearchResultsA11yText();
  }
  _getMatchedCountries(t) {
    const a = sr(t), o = [], n = [], r = [], i = [], l = [], c = [];
    for (const s of this.countries)
      s.iso2 === a ? o.push(s) : s.normalisedName.startsWith(a) ? n.push(s) : s.normalisedName.includes(a) ? r.push(s) : a === s.dialCode || a === s.dialCodePlus ? i.push(s) : s.dialCodePlus.includes(a) ? l.push(s) : s.initials.includes(a) && c.push(s);
    return [
      ...o.sort((s, u) => s.priority - u.priority),
      ...n.sort((s, u) => s.priority - u.priority),
      ...r.sort((s, u) => s.priority - u.priority),
      ...i.sort((s, u) => s.priority - u.priority),
      ...l.sort((s, u) => s.priority - u.priority),
      ...c.sort((s, u) => s.priority - u.priority)
    ];
  }
  //* Update search results text (for a11y).
  _updateSearchResultsA11yText() {
    const { i18n: t } = this.options, a = this.countryList.childElementCount;
    let o;
    a === 0 ? o = t.zeroSearchResults : t.searchResultsText ? o = t.searchResultsText(a) : a === 1 ? o = t.oneSearchResult : o = t.multipleSearchResults.replace("${count}", a.toString()), this.searchResultsA11yText.textContent = o;
  }
  //* Highlight the next/prev item in the list (and ensure it is visible).
  _handleUpDownKey(t) {
    let a = t === "ArrowUp" ? this.highlightedItem?.previousElementSibling : this.highlightedItem?.nextElementSibling;
    !a && this.countryList.childElementCount > 1 && (a = t === "ArrowUp" ? this.countryList.lastElementChild : this.countryList.firstElementChild), a && (this._scrollTo(a), this._highlightListItem(a, !1));
  }
  //* Select the currently highlighted item.
  _handleEnterKey() {
    this.highlightedItem && this._selectListItem(this.highlightedItem);
  }
  //* Update the input's value to the given val (format first if possible)
  //* NOTE: this is called from _setInitialState, handleUtils and setNumber.
  _updateValFromNumber(t) {
    let a = t;
    if (this.options.formatOnDisplay && O.utils && this.selectedCountryData) {
      const o = this.options.nationalMode || a.charAt(0) !== "+" && !this.options.separateDialCode, { NATIONAL: n, INTERNATIONAL: r } = O.utils.numberFormat, i = o ? n : r;
      a = O.utils.formatNumber(
        a,
        this.selectedCountryData.iso2,
        i
      );
    }
    a = this._beforeSetNumber(a), this.telInput.value = a;
  }
  //* Check if need to select a new country based on the given number
  //* Note: called from _setInitialState, keyup handler, setNumber.
  _updateCountryFromNumber(t) {
    const a = this._getNewCountryFromNumber(t);
    return a !== null ? this._setCountry(a) : !1;
  }
  _ensureHasDialCode(t) {
    const { dialCode: a, nationalPrefix: o } = this.selectedCountryData;
    if (t.charAt(0) === "+" || !a)
      return t;
    const n = o && t.charAt(0) === o && !this.options.separateDialCode ? t.substring(1) : t;
    return `+${a}${n}`;
  }
  // Get the country ISO2 code from the given number
  // BUT ONLY IF ITS CHANGED FROM THE CURRENTLY SELECTED COUNTRY
  // NOTE: consider refactoring this to be more clear
  _getNewCountryFromNumber(t) {
    const a = t.indexOf("+");
    let o = a ? t.substring(a) : t;
    const n = this.selectedCountryData.iso2, r = this.selectedCountryData.dialCode;
    o = this._ensureHasDialCode(o);
    const i = this._getDialCode(o, !0), l = Lt(o);
    if (i) {
      const c = Lt(i), s = this.dialCodeToIso2Map[c];
      if (s.length === 1)
        return s[0] === n ? null : s[0];
      if (!n && this.defaultCountry && s.includes(this.defaultCountry))
        return this.defaultCountry;
      if (r === "1" && Co(l))
        return null;
      const u = this.selectedCountryData.areaCodes && l.length > c.length;
      if (!(n && s.includes(n) && !u))
        return s[0];
    } else {
      if (o.charAt(0) === "+" && l.length)
        return "";
      if ((!o || o === "+") && !n)
        return this.defaultCountry;
    }
    return null;
  }
  //* Remove highlighting from other list items and highlight the given item.
  _highlightListItem(t, a) {
    const o = this.highlightedItem;
    if (o && (o.classList.remove("iti__highlight"), o.setAttribute("aria-selected", "false")), this.highlightedItem = t, this.highlightedItem && (this.highlightedItem.classList.add("iti__highlight"), this.highlightedItem.setAttribute("aria-selected", "true"), this.options.countrySearch)) {
      const n = this.highlightedItem.getAttribute("id") || "";
      this.searchInput.setAttribute("aria-activedescendant", n);
    }
    a && this.highlightedItem.focus();
  }
  //* Update the selected country, dial code (if separateDialCode), placeholder, title, and active list item.
  //* Note: called from _setInitialState, _updateCountryFromNumber, _selectListItem, setCountry.
  _setCountry(t) {
    const { separateDialCode: a, showFlags: o, i18n: n } = this.options, r = this.selectedCountryData.iso2 || "";
    if (this.selectedCountryData = t ? this.countryByIso2.get(t) : {}, this.selectedCountryData.iso2 && (this.defaultCountry = this.selectedCountryData.iso2), this.selectedCountry) {
      const i = t && o ? `iti__flag iti__${t}` : "iti__flag iti__globe";
      let l, c;
      if (t) {
        const { name: s, dialCode: u } = this.selectedCountryData;
        c = s, l = n.selectedCountryAriaLabel.replace("${countryName}", s).replace("${dialCode}", `+${u}`);
      } else
        c = n.noCountrySelected, l = n.noCountrySelected;
      this.selectedCountryInner.className = i, this.selectedCountry.setAttribute("title", c), this.selectedCountry.setAttribute("aria-label", l);
    }
    if (a) {
      const i = this.selectedCountryData.dialCode ? `+${this.selectedCountryData.dialCode}` : "";
      this.selectedDialCode.innerHTML = i, this._updateInputPadding();
    }
    return this._updatePlaceholder(), this._updateMaxLength(), r !== t;
  }
  //* Update the input padding to make space for the selected country/dial code.
  _updateInputPadding() {
    if (this.selectedCountry) {
      const t = this.options.separateDialCode ? 78 : 42, a = (this.selectedCountry.offsetWidth || this._getHiddenSelectedCountryWidth() || t) + 6;
      this.showSelectedCountryOnLeft ? this.telInput.style.paddingLeft = `${a}px` : this.telInput.style.paddingRight = `${a}px`;
    }
  }
  //* Update the maximum valid number length for the currently selected country.
  _updateMaxLength() {
    const { strictMode: t, placeholderNumberType: a, validationNumberTypes: o } = this.options, { iso2: n } = this.selectedCountryData;
    if (t && O.utils)
      if (n) {
        const r = O.utils.numberType[a];
        let i = O.utils.getExampleNumber(
          n,
          !1,
          r,
          !0
        ), l = i;
        for (; O.utils.isPossibleNumber(i, n, o); )
          l = i, i += "0";
        const c = O.utils.getCoreNumber(l, n);
        this.maxCoreNumberLength = c.length, n === "by" && (this.maxCoreNumberLength = c.length + 1);
      } else
        this.maxCoreNumberLength = null;
  }
  //* When input is in a hidden container during init, we cannot calculate the selected country width.
  //* Fix: clone the markup, make it invisible, add it to the end of the DOM, and then measure it's width.
  //* To get the right styling to apply, all we need is a shallow clone of the container,
  //* and then to inject a deep clone of the selectedCountry element.
  _getHiddenSelectedCountryWidth() {
    if (this.telInput.parentNode) {
      let t;
      try {
        t = window.top.document.body;
      } catch {
        t = document.body;
      }
      const a = this.telInput.parentNode.cloneNode(!1);
      a.style.visibility = "hidden", t.appendChild(a);
      const o = this.countryContainer.cloneNode();
      a.appendChild(o);
      const n = this.selectedCountry.cloneNode(!0);
      o.appendChild(n);
      const r = n.offsetWidth;
      return t.removeChild(a), r;
    }
    return 0;
  }
  //* Update the input placeholder to an example number from the currently selected country.
  _updatePlaceholder() {
    const {
      autoPlaceholder: t,
      placeholderNumberType: a,
      nationalMode: o,
      customPlaceholder: n
    } = this.options, r = t === "aggressive" || !this.hadInitialPlaceholder && t === "polite";
    if (O.utils && r) {
      const i = O.utils.numberType[a];
      let l = this.selectedCountryData.iso2 ? O.utils.getExampleNumber(
        this.selectedCountryData.iso2,
        o,
        i
      ) : "";
      l = this._beforeSetNumber(l), typeof n == "function" && (l = n(l, this.selectedCountryData)), this.telInput.setAttribute("placeholder", l);
    }
  }
  //* Called when the user selects a list item from the dropdown.
  _selectListItem(t) {
    const a = t.getAttribute("data-country-code"), o = this._setCountry(a);
    this._closeDropdown();
    const n = t.getAttribute("data-dial-code");
    this._updateDialCode(n), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this.telInput.focus(), o && this._triggerCountryChange();
  }
  //* Close the dropdown and unbind any listeners.
  _closeDropdown() {
    this.dropdownContent.classList.add("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "false"), this.highlightedItem && this.highlightedItem.setAttribute("aria-selected", "false"), this.options.countrySearch && this.searchInput.removeAttribute("aria-activedescendant"), this.dropdownArrow.classList.remove("iti__arrow--up"), this.options.countrySearch && (this.searchInput.removeEventListener("input", this._handleSearchChange), this.searchClearButton.removeEventListener("click", this._handleSearchClear)), document.removeEventListener("keydown", this._handleKeydownOnDropdown), document.documentElement.removeEventListener(
      "click",
      this._handleClickOffToClose
    ), this.countryList.removeEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this.countryList.removeEventListener("click", this._handleClickCountryList), this.options.dropdownContainer && (this.options.useFullscreenPopup || window.removeEventListener("scroll", this._handleWindowScroll), this.dropdown.parentNode && this.dropdown.parentNode.removeChild(this.dropdown)), this._trigger("close:countrydropdown");
  }
  //* Check if an element is visible within it's container, else scroll until it is.
  _scrollTo(t) {
    const a = this.countryList, o = document.documentElement.scrollTop, n = a.offsetHeight, r = a.getBoundingClientRect().top + o, i = r + n, l = t.offsetHeight, c = t.getBoundingClientRect().top + o, s = c + l, u = c - r + a.scrollTop;
    if (c < r)
      a.scrollTop = u;
    else if (s > i) {
      const d = n - l;
      a.scrollTop = u - d;
    }
  }
  //* Replace any existing dial code with the new one
  //* Note: called from _selectListItem and setCountry
  _updateDialCode(t) {
    const a = this.telInput.value, o = `+${t}`;
    let n;
    if (a.charAt(0) === "+") {
      const r = this._getDialCode(a);
      r ? n = a.replace(r, o) : n = o, this.telInput.value = n;
    }
  }
  //* Try and extract a valid international dial code from a full telephone number.
  //* Note: returns the raw string inc plus character and any whitespace/dots etc.
  _getDialCode(t, a) {
    let o = "";
    if (t.charAt(0) === "+") {
      let n = "";
      for (let r = 0; r < t.length; r++) {
        const i = t.charAt(r);
        if (/[0-9]/.test(i)) {
          if (n += i, a)
            this.dialCodeToIso2Map[n] && (o = t.substring(0, r + 1));
          else if (this.dialCodes.has(n)) {
            o = t.substring(0, r + 1);
            break;
          }
          if (n.length === this.dialCodeMaxLen)
            break;
        }
      }
    }
    return o;
  }
  //* Get the input val, adding the dial code if separateDialCode is enabled.
  _getFullNumber(t) {
    const a = t || this.telInput.value.trim(), { dialCode: o } = this.selectedCountryData;
    let n;
    const r = Lt(a);
    return this.options.separateDialCode && a.charAt(0) !== "+" && o && r ? n = `+${o}` : n = "", n + a;
  }
  //* Remove the dial code if separateDialCode is enabled also cap the length if the input has a maxlength attribute
  _beforeSetNumber(t) {
    const a = this._getDialCode(t), o = Ws(
      t,
      a,
      this.options.separateDialCode,
      this.selectedCountryData
    );
    return this._cap(o);
  }
  //* Trigger the 'countrychange' event.
  _triggerCountryChange() {
    this._trigger("countrychange");
  }
  //**************************
  //*  SECRET PUBLIC METHODS
  //**************************
  //* This is called when the geoip call returns.
  handleAutoCountry() {
    this.options.initialCountry === "auto" && O.autoCountry && (this.defaultCountry = O.autoCountry, this.selectedCountryData.iso2 || this.selectedCountryInner.classList.contains("iti__globe") || this.setCountry(this.defaultCountry), this.resolveAutoCountryPromise());
  }
  //* This is called when the utils request completes.
  handleUtils() {
    O.utils && (this.telInput.value && this._updateValFromNumber(this.telInput.value), this.selectedCountryData.iso2 && (this._updatePlaceholder(), this._updateMaxLength())), this.resolveUtilsScriptPromise();
  }
  //********************
  //*  PUBLIC METHODS
  //********************
  //* Remove plugin.
  destroy() {
    this.telInput.iti = void 0;
    const { allowDropdown: t, separateDialCode: a } = this.options;
    if (t) {
      this._closeDropdown(), this.selectedCountry.removeEventListener(
        "click",
        this._handleClickSelectedCountry
      ), this.countryContainer.removeEventListener(
        "keydown",
        this._handleCountryContainerKeydown
      );
      const r = this.telInput.closest("label");
      r && r.removeEventListener("click", this._handleLabelClick);
    }
    const { form: o } = this.telInput;
    this._handleHiddenInputSubmit && o && o.removeEventListener("submit", this._handleHiddenInputSubmit), this.telInput.removeEventListener("input", this._handleInputEvent), this._handleKeydownEvent && this.telInput.removeEventListener("keydown", this._handleKeydownEvent), this._handlePasteEvent && this.telInput.removeEventListener("paste", this._handlePasteEvent), this._handlePageLoad && window.removeEventListener("load", this._handlePageLoad), this.telInput.removeAttribute("data-intl-tel-input-id"), a && (this.isRTL ? this.telInput.style.paddingRight = this.originalPaddingRight : this.telInput.style.paddingLeft = this.originalPaddingLeft);
    const n = this.telInput.parentNode;
    n?.parentNode?.insertBefore(this.telInput, n), n?.parentNode?.removeChild(n), delete O.instances[this.id];
  }
  //* Get the extension from the current number.
  getExtension() {
    return O.utils ? O.utils.getExtension(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : "";
  }
  //* Format the number to the given format.
  getNumber(t) {
    if (O.utils) {
      const { iso2: a } = this.selectedCountryData;
      return O.utils.formatNumber(
        this._getFullNumber(),
        a,
        t
      );
    }
    return "";
  }
  //* Get the type of the entered number e.g. landline/mobile.
  getNumberType() {
    return O.utils ? O.utils.getNumberType(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : -99;
  }
  //* Get the country data for the currently selected country.
  getSelectedCountryData() {
    return this.selectedCountryData;
  }
  //* Get the validation error.
  getValidationError() {
    if (O.utils) {
      const { iso2: t } = this.selectedCountryData;
      return O.utils.getValidationError(this._getFullNumber(), t);
    }
    return -99;
  }
  //* Validate the input val (with precise=false)
  isValidNumber() {
    return this._validateNumber(!1);
  }
  //* Validate the input val (with precise=true)
  isValidNumberPrecise() {
    return this._validateNumber(!0);
  }
  _utilsIsPossibleNumber(t) {
    return O.utils ? O.utils.isPossibleNumber(t, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Shared internal validation logic to handle alpha character extension rules.
  _validateNumber(t) {
    if (!this.selectedCountryData.iso2)
      return !1;
    const a = (r) => t ? this._utilsIsValidNumber(r) : this._utilsIsPossibleNumber(r), o = this._getFullNumber(), n = o.search(new RegExp("\\p{L}", "u"));
    if (n > -1 && !this.options.allowPhonewords) {
      const r = o.substring(0, n), i = a(r), l = a(o);
      return i && l;
    }
    return a(o);
  }
  _utilsIsValidNumber(t) {
    return O.utils ? O.utils.isValidNumber(t, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Update the selected country, and update the input val accordingly.
  setCountry(t) {
    const a = t?.toLowerCase();
    if (!ba(a))
      throw new Error(`Invalid country code: '${a}'`);
    const o = this.selectedCountryData.iso2;
    (t && a !== o || !t && o) && (this._setCountry(a), this._updateDialCode(this.selectedCountryData.dialCode), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this._triggerCountryChange());
  }
  //* Set the input value and update the country.
  setNumber(t) {
    const a = this._updateCountryFromNumber(t);
    this._updateValFromNumber(t), a && this._triggerCountryChange(), this._trigger("input", { isSetNumber: !0 });
  }
  //* Set the placeholder number typ
  setPlaceholderNumberType(t) {
    this.options.placeholderNumberType = t, this._updatePlaceholder();
  }
  setDisabled(t) {
    this.telInput.disabled = t, t ? this.selectedCountry.setAttribute("disabled", "true") : this.selectedCountry.removeAttribute("disabled");
  }
}, Xs = (e) => {
  if (!O.utils && !O.startedLoadingUtilsScript) {
    let t;
    if (typeof e == "function")
      try {
        t = Promise.resolve(e());
      } catch (a) {
        return Promise.reject(a);
      }
    else
      return Promise.reject(new TypeError(`The argument passed to attachUtils must be a function that returns a promise for the utilities module, not ${typeof e}`));
    return O.startedLoadingUtilsScript = !0, t.then((a) => {
      const o = a?.default;
      if (!o || typeof o != "object")
        throw new TypeError("The loader function passed to attachUtils did not resolve to a module object with utils as its default export.");
      return O.utils = o, gt("handleUtils"), !0;
    }).catch((a) => {
      throw gt("rejectUtilsScriptPromise", a), a;
    });
  }
  return null;
}, O = Object.assign(
  (e, t) => {
    const a = new Qs(e, t);
    return a._init(), e.setAttribute("data-intl-tel-input-id", a.id.toString()), O.instances[a.id] = a, e.iti = a, a;
  },
  {
    defaults: lr,
    //* Using a static var like this allows us to mock it in the tests.
    documentReady: () => document.readyState === "complete",
    //* Get the country data object.
    getCountryData: () => at,
    //* A getter for the plugin instance.
    getInstance: (e) => {
      const t = e.getAttribute("data-intl-tel-input-id");
      return t ? O.instances[t] : null;
    },
    //* A map from instance ID to instance object.
    instances: {},
    attachUtils: Xs,
    startedLoadingUtilsScript: !1,
    startedLoadingAutoCountry: !1,
    version: "25.10.10"
  }
), ec = O, tc = kt(function({
  initialValue: e = "",
  onChangeNumber: t = () => {
  },
  onChangeCountry: a = () => {
  },
  onChangeValidity: o = () => {
  },
  onChangeErrorCode: n = () => {
  },
  usePreciseValidation: r = !1,
  initOptions: i = {},
  inputProps: l = {},
  disabled: c = void 0
}, s) {
  const u = Et(null), d = Et(null);
  qr(s, () => ({
    getInstance: () => d.current,
    getInput: () => u.current
  }));
  const g = bn(() => {
    const b = d.current?.getNumber() || "", h = d.current?.getSelectedCountryData().iso2 || "";
    if (t(b), a(h), d.current)
      if (r ? d.current.isValidNumberPrecise() : d.current.isValidNumber())
        o(!0), n(null);
      else {
        const p = d.current.getValidationError();
        o(!1), n(p);
      }
  }, [a, n, t, o, r]);
  return Ie(() => (u.current && (d.current = ec(u.current, i)), () => {
    d.current?.destroy();
  }), []), Ie(() => {
    const b = u.current;
    return b && (b.addEventListener("countrychange", g), d.current.promise.then(g)), () => {
      b && b.removeEventListener("countrychange", g);
    };
  }, [g]), Ie(() => {
    d.current && c !== void 0 && d.current.setDisabled(c);
  }, [c]), /* @__PURE__ */ L.createElement(
    "input",
    {
      type: "tel",
      ref: u,
      onInput: g,
      defaultValue: e,
      ...l
    }
  );
}), ac = tc;
const Te = {
  "phone-number": "_phone-number_1ni27_30",
  "is-full-width": "_is-full-width_1ni27_41",
  "group-label": "_group-label_1ni27_44",
  "helper-text": "_helper-text_1ni27_53",
  "is-disabled": "_is-disabled_1ni27_58",
  "is-error": "_is-error_1ni27_73",
  "is-success": "_is-success_1ni27_144",
  "container-icon": "_container-icon_1ni27_166",
  "dialog-overlay-show": "_dialog-overlay-show_1ni27_1",
  "dialog-content-show": "_dialog-content-show_1ni27_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ni27_1"
};
kt(
  ({
    label: e,
    helperText: t,
    initialPhoneNumber: a,
    onChangePhoneNumber: o,
    initialCountry: n,
    onChangeCountry: r,
    locale: i = "en",
    message: l,
    status: c,
    disabled: s,
    isFullWidth: u,
    inputProps: d,
    setErrorCode: g,
    setIsValidPhoneNumber: b
  }, h) => {
    const { phoneNumber: p, country: $, handlePhoneNumberChange: M, handleCountryChange: k } = es({
      initialPhoneNumber: a,
      initialCountry: n,
      onChangePhoneNumber: o,
      onChangeCountry: r
    }), P = H(
      Te["phone-number"],
      s && Te["is-disabled"],
      c && Te[wo[c]],
      u && Te["is-full-width"]
    );
    return /* @__PURE__ */ R("div", { className: P, children: [
      /* @__PURE__ */ R("div", { className: Te["group-label"], children: [
        e && /* @__PURE__ */ y("label", { children: e }),
        t && /* @__PURE__ */ y("div", { className: Te["helper-text"], children: t })
      ] }),
      /* @__PURE__ */ y(
        ac,
        {
          initialValue: p,
          onChangeErrorCode: g,
          onChangeValidity: b,
          onChangeCountry: k,
          onChangeNumber: M,
          inputProps: {
            disabled: s,
            "aria-label": d?.["aria-label"] || e,
            ...d
          },
          ref: h,
          initOptions: {
            strictMode: !0,
            initialCountry: $,
            i18n: Ms[i],
            useFullscreenPopup: !1,
            // Manually load the utils to prevent issues on SSR pages
            loadUtils: () => import("./utils-CJDvlpOH-DLsHHipy.js")
          }
        }
      ),
      l && c && !s && /* @__PURE__ */ R("div", { className: Te["container-icon"], children: [
        /* @__PURE__ */ y(We, { name: xo[c].name, size: "medium", color: xo[c].color }),
        /* @__PURE__ */ y("span", { className: Te[wo[c]], children: l })
      ] })
    ] });
  }
);
const oc = 0;
function nc(e, t, a, o, n, r) {
  const [i, l] = xe(!1), c = i ? a : o, [s, u] = xe(c ? c.length : oc), [d, g] = xe(!1);
  return {
    valueCounter: s,
    isOnBlur: d,
    hasLabelOrHelperText: !!(e ?? t),
    handleBlur: () => {
      g(!0), r?.();
    },
    handleChange: (b) => {
      l(!0), u(b.target.value.length), n && n(b), g(!1);
    }
  };
}
const rc = "_container_1qc3k_29", ic = "_filled_1qc3k_46", lc = "_error_1qc3k_49", sc = "_success_1qc3k_52", cc = "_counter_1qc3k_131", fe = {
  container: rc,
  "full-width": "_full-width_1qc3k_34",
  "group-label": "_group-label_1qc3k_37",
  filled: ic,
  error: lc,
  success: sc,
  "helper-text": "_helper-text_1qc3k_55",
  "container-counter-icon": "_container-counter-icon_1qc3k_110",
  "container-icon": "_container-icon_1qc3k_117",
  "icon-error-warning-fill": "_icon-error-warning-fill_1qc3k_122",
  counter: cc,
  "dialog-overlay-show": "_dialog-overlay-show_1qc3k_1",
  "dialog-content-show": "_dialog-content-show_1qc3k_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1qc3k_1"
};
function uc({
  id: e,
  disabled: t = !1,
  status: a,
  title: o,
  helperText: n,
  placeholder: r,
  maxLength: i,
  onChange: l,
  onBlur: c,
  message: s,
  value: u,
  defaultValue: d,
  name: g,
  isFullWidth: b = !1
}) {
  const {
    valueCounter: h,
    isOnBlur: p,
    handleBlur: $,
    handleChange: M,
    hasLabelOrHelperText: k
  } = nc(o, n, u, d, l, c);
  return /* @__PURE__ */ R("div", { className: H(fe.container, b && fe["full-width"]), children: [
    k && /* @__PURE__ */ R("div", { className: fe["group-label"], children: [
      o && /* @__PURE__ */ y(
        "label",
        {
          htmlFor: e,
          className: H(a && fe[a], (h > 0 && p || t) && fe.filled),
          children: o
        }
      ),
      n && /* @__PURE__ */ y("div", { className: fe["helper-text"], children: n })
    ] }),
    /* @__PURE__ */ y(
      "textarea",
      {
        id: e,
        name: g,
        "aria-label": "textarea",
        placeholder: r,
        onChange: M,
        className: H(a && fe[a]),
        value: u,
        defaultValue: d,
        disabled: t,
        onBlur: $
      }
    ),
    /* @__PURE__ */ R("div", { className: fe["container-counter-icon"], children: [
      s && a && /* @__PURE__ */ R("div", { className: fe["container-icon"], children: [
        /* @__PURE__ */ y(
          We,
          {
            name: `${a === "error" ? "error-warning-fill" : "checkbox-fill"}`,
            size: "medium",
            className: H(fe[a])
          }
        ),
        /* @__PURE__ */ y("span", { className: fe[a], children: s })
      ] }),
      i && /* @__PURE__ */ R("div", { className: H(fe.counter, h > i && fe.error), children: [
        h,
        "/",
        i
      ] })
    ] })
  ] });
}
const So = 640, ha = {
  "is-extra-small": "_is-extra-small_17143_29",
  "is-small": "_is-small_17143_32",
  "is-medium": "_is-medium_17143_35",
  "is-large": "_is-large_17143_38",
  "is-extra-large": "_is-extra-large_17143_41",
  "is-auto": "_is-auto_17143_44",
  "is-full-width": "_is-full-width_17143_47",
  "no-border": "_no-border_17143_50",
  "has-sm-border": "_has-sm-border_17143_53",
  "has-full-border": "_has-full-border_17143_56",
  "dialog-overlay-show": "_dialog-overlay-show_17143_1",
  "dialog-content-show": "_dialog-content-show_17143_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17143_1"
};
function cr({
  srcMobile: e,
  width: t = "auto",
  borderRadius: a = "none",
  className: o = "",
  ...n
}) {
  const r = H(ha.img, o, ha[dc[t]], ha[_c[a]]);
  return /* @__PURE__ */ R("picture", { children: [
    e && /* @__PURE__ */ y("source", { media: `(max-width: ${So}px)`, srcSet: e }),
    /* @__PURE__ */ y("source", { media: `(min-width: ${So + 1}px)` }),
    /* @__PURE__ */ y("img", { ...n, className: r, alt: n.alt, style: { width: `${n.widthInPx}px` } })
  ] });
}
const dc = {
  xsmall: "is-extra-small",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  xlarge: "is-extra-large",
  auto: "is-auto",
  full: "is-full-width"
}, _c = {
  none: "no-border",
  small: "has-sm-border",
  full: "has-full-border"
}, gc = "_callout_7jl0x_29", fc = "_link_7jl0x_52", ct = {
  callout: gc,
  "is-full-width": "_is-full-width_7jl0x_37",
  "is-small": "_is-small_7jl0x_47",
  link: fc,
  "is-medium": "_is-medium_7jl0x_55",
  "is-info": "_is-info_7jl0x_58",
  "is-warning": "_is-warning_7jl0x_61",
  "is-success": "_is-success_7jl0x_64",
  "is-error": "_is-error_7jl0x_67",
  "is-neutral": "_is-neutral_7jl0x_70",
  "is-collection": "_is-collection_7jl0x_73",
  "content-container": "_content-container_7jl0x_79",
  "dialog-overlay-show": "_dialog-overlay-show_7jl0x_1",
  "dialog-content-show": "_dialog-content-show_7jl0x_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7jl0x_1"
}, zo = {
  info: {
    name: "information-circle",
    color: "secondary"
  },
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  },
  neutral: {
    name: "information-circle",
    color: "secondary"
  },
  collection: {
    name: "information-circle",
    color: "primary"
  }
}, bc = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, hc = {
  small: "is-small",
  medium: "is-medium"
};
function mc({
  status: e = "info",
  size: t = "medium",
  children: a,
  hasIcon: o = !1,
  backgroundImage: n,
  isFullWidth: r = !1
}) {
  const i = H(ct.callout, ct[bc[e]], ct[hc[t]], {
    [ct["is-full-width"]]: r
  });
  return /* @__PURE__ */ R("div", { className: i, children: [
    o && /* @__PURE__ */ y(We, { name: zo[e].name, color: zo[e].color, size: "2xl" }),
    /* @__PURE__ */ y("div", { className: ct["content-container"], children: a }),
    n && /* @__PURE__ */ y("img", { src: n, alt: "background" })
  ] });
}
const pc = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, yc = ({ imageSrc: e, imageSrcMobile: t, imageSrcTablet: a, alt: o, className: n }) => {
  const { isMobile: r, isTablet: i } = nr();
  let l = e;
  return r && t && (l = t), i && a && (l = a), /* @__PURE__ */ y("img", { className: n, src: l, alt: o });
}, vc = "_banner_17hqf_29", De = {
  "banner-container": "_banner-container_17hqf_29",
  banner: vc,
  "banner-image": "_banner-image_17hqf_39",
  "banner-content": "_banner-content_17hqf_42",
  "banner-text": "_banner-text_17hqf_48",
  "banner-cta": "_banner-cta_17hqf_51",
  "is-info": "_is-info_17hqf_92",
  "is-warning": "_is-warning_17hqf_95",
  "is-success": "_is-success_17hqf_98",
  "is-error": "_is-error_17hqf_101",
  "is-neutral": "_is-neutral_17hqf_104",
  "dialog-overlay-show": "_dialog-overlay-show_17hqf_1",
  "dialog-content-show": "_dialog-content-show_17hqf_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17hqf_1"
};
function kc({ color: e, image: t, className: a, cta: o, title: n, description: r }) {
  const i = H(De.banner, De[pc[e]], a);
  return /* @__PURE__ */ y("div", { className: De["banner-container"], children: /* @__PURE__ */ R("div", { className: i, children: [
    t && /* @__PURE__ */ y(yc, { className: De["banner-image"], ...t }),
    /* @__PURE__ */ R("div", { className: De["banner-content"], children: [
      /* @__PURE__ */ R("div", { className: De["banner-text"], children: [
        /* @__PURE__ */ y(bt, { isBold: !0, className: De.title, children: n }),
        /* @__PURE__ */ y(bt, { className: De.description, children: r })
      ] }),
      o && /* @__PURE__ */ y(nt, { className: De["banner-cta"], color: o.color, onClick: o.onClick, children: o.text })
    ] })
  ] }) });
}
const $c = "_columns_10k0l_29", wc = "_column_10k0l_29", Ne = {
  columns: $c,
  "align-items-center": "_align-items-center_10k0l_36",
  "align-items-flex-start": "_align-items-flex-start_10k0l_39",
  "align-items-flex-end": "_align-items-flex-end_10k0l_42",
  "reverse-on-mobile": "_reverse-on-mobile_10k0l_57",
  column: wc,
  "gap-0": "_gap-0_10k0l_68",
  "gap-1": "_gap-1_10k0l_71",
  "gap-2": "_gap-2_10k0l_74",
  "gap-3": "_gap-3_10k0l_77",
  "gap-4": "_gap-4_10k0l_80",
  "gap-5": "_gap-5_10k0l_83",
  "gap-6": "_gap-6_10k0l_86",
  "gap-7": "_gap-7_10k0l_89",
  "gap-8": "_gap-8_10k0l_92",
  "gap-9": "_gap-9_10k0l_95",
  "gap-10": "_gap-10_10k0l_98",
  "gap-11": "_gap-11_10k0l_101",
  "gap-12": "_gap-12_10k0l_104",
  "gap-14": "_gap-14_10k0l_107",
  "gap-16": "_gap-16_10k0l_110",
  "gap-18": "_gap-18_10k0l_113",
  "gap-20": "_gap-20_10k0l_116",
  "gap-24": "_gap-24_10k0l_119",
  "gap-28": "_gap-28_10k0l_122",
  "gap-32": "_gap-32_10k0l_125",
  "gap-36": "_gap-36_10k0l_128",
  "gap-40": "_gap-40_10k0l_131",
  "gap-44": "_gap-44_10k0l_134",
  "gap-48": "_gap-48_10k0l_137",
  "gap-52": "_gap-52_10k0l_140",
  "gap-56": "_gap-56_10k0l_143",
  "gap-60": "_gap-60_10k0l_146",
  "gap-64": "_gap-64_10k0l_149",
  "gap-72": "_gap-72_10k0l_152",
  "gap-80": "_gap-80_10k0l_155",
  "gap-96": "_gap-96_10k0l_158",
  "hidden-content-on-mobile": "_hidden-content-on-mobile_10k0l_161",
  "is-1": "_is-1_10k0l_180",
  "is-2": "_is-2_10k0l_184",
  "is-3": "_is-3_10k0l_188",
  "is-4": "_is-4_10k0l_192",
  "is-5": "_is-5_10k0l_196",
  "is-6": "_is-6_10k0l_200",
  "is-7": "_is-7_10k0l_204",
  "is-8": "_is-8_10k0l_208",
  "is-9": "_is-9_10k0l_212",
  "is-10": "_is-10_10k0l_216",
  "is-11": "_is-11_10k0l_220",
  "is-12": "_is-12_10k0l_224",
  "is-offset-1": "_is-offset-1_10k0l_228",
  "is-offset-2": "_is-offset-2_10k0l_231",
  "is-offset-3": "_is-offset-3_10k0l_234",
  "is-offset-4": "_is-offset-4_10k0l_237",
  "is-offset-5": "_is-offset-5_10k0l_240",
  "is-offset-6": "_is-offset-6_10k0l_243",
  "is-offset-7": "_is-offset-7_10k0l_246",
  "is-offset-8": "_is-offset-8_10k0l_249",
  "is-offset-9": "_is-offset-9_10k0l_252",
  "is-offset-10": "_is-offset-10_10k0l_255",
  "is-offset-11": "_is-offset-11_10k0l_258",
  "is-narrow": "_is-narrow_10k0l_261",
  "dialog-overlay-show": "_dialog-overlay-show_10k0l_1",
  "dialog-content-show": "_dialog-content-show_10k0l_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_10k0l_1"
};
function ur({ children: e, className: t = "", reverseOnMobile: a = !1, alignItems: o, ...n }) {
  const r = H(
    Ne.columns,
    a && Ne["reverse-on-mobile"],
    o && Ne[`align-items-${o}`],
    t
  );
  return /* @__PURE__ */ y("div", { className: r, ...n, children: e });
}
const xc = {
  auto: "",
  1: "is-1",
  2: "is-2",
  3: "is-3",
  4: "is-4",
  5: "is-5",
  6: "is-6",
  7: "is-7",
  8: "is-8",
  9: "is-9",
  10: "is-10",
  11: "is-11",
  12: "is-12"
}, Cc = {
  auto: "",
  1: "is-offset-1",
  2: "is-offset-2",
  3: "is-offset-3",
  4: "is-offset-4",
  5: "is-offset-5",
  6: "is-offset-6",
  7: "is-offset-7",
  8: "is-offset-8",
  9: "is-offset-9",
  10: "is-offset-10",
  11: "is-offset-11",
  12: "is-offset-12"
};
function Vt({
  size: e = "auto",
  offset: t = "auto",
  isNarrow: a = !1,
  className: o = "",
  children: n,
  gap: r,
  hiddenContentOnMobile: i = !1,
  ...l
}) {
  const c = H(
    Ne.column,
    Ne[xc[e]],
    Ne[Cc[t]],
    a && Ne["is-narrow"],
    r && Ne[`gap-${r}`],
    i && Ne["hidden-content-on-mobile"],
    o
  );
  return /* @__PURE__ */ y("div", { className: c, ...l, children: n });
}
const Sc = "_container_68o99_29", Ao = {
  container: Sc,
  "is-fluid": "_is-fluid_68o99_50"
};
function zc({ isFluid: e = !1, children: t, className: a = "", ...o }) {
  const n = H(Ao.container, e && Ao["is-fluid"], a);
  return /* @__PURE__ */ y("div", { className: n, ...o, children: t });
}
const Ac = "_section_g0e0c_29", Pc = "_content_g0e0c_32", be = {
  section: Ac,
  content: Pc,
  "is-top-bottom-padding": "_is-top-bottom-padding_g0e0c_35",
  "has-small-padding": "_has-small-padding_g0e0c_38",
  "has-medium-padding": "_has-medium-padding_g0e0c_41",
  "has-large-padding": "_has-large-padding_g0e0c_44",
  "bg-image": "_bg-image_g0e0c_48",
  "image-flex": "_image-flex_g0e0c_53",
  "image-container": "_image-container_g0e0c_63",
  "reverse-bg-color": "_reverse-bg-color_g0e0c_82",
  "image-reverse": "_image-reverse_g0e0c_88",
  "is-full-height": "_is-full-height_g0e0c_94",
  "center-content": "_center-content_g0e0c_97",
  "border-top": "_border-top_g0e0c_101",
  "border-bottom": "_border-bottom_g0e0c_104",
  "border-top-and-bottom": "_border-top-and-bottom_g0e0c_107",
  "is-primary": "_is-primary_g0e0c_111",
  "is-secondary": "_is-secondary_g0e0c_114",
  "is-tertiary": "_is-tertiary_g0e0c_117",
  "dialog-overlay-show": "_dialog-overlay-show_g0e0c_1",
  "dialog-content-show": "_dialog-content-show_g0e0c_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_g0e0c_1"
}, Mc = {
  small: "has-small-padding",
  medium: "has-medium-padding",
  large: "has-large-padding"
}, Dc = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary"
}, Nc = {
  none: "",
  top: "border-top",
  bottom: "border-bottom",
  topAndBottom: "border-top-and-bottom"
};
function Oc({
  children: e,
  className: t = "",
  color: a,
  border: o = "none",
  isFullHeight: n,
  centerContent: r,
  isTopBottomPadding: i,
  padding: l = "medium",
  imageSrc: c,
  imagePosition: s,
  imageAlt: u,
  reverseBGColor: d,
  bgImage: g,
  ...b
}) {
  const h = H(
    be.section,
    t,
    a && be[Dc[a]],
    be[Nc[o]],
    n && be["is-full-height"],
    r && be["center-content"],
    c && be["image-flex"],
    s === "right" && be["image-reverse"],
    d && be["reverse-bg-color"]
  ), { isMobile: p } = nr();
  return /* @__PURE__ */ R("section", { ...b, className: h, children: [
    c && /* @__PURE__ */ y("div", { className: be["image-container"], children: /* @__PURE__ */ y("img", { src: c, alt: u }) }),
    /* @__PURE__ */ y(
      "div",
      {
        className: H(
          be.content,
          i && be["is-top-bottom-padding"],
          l && be[Mc[l]],
          g && be["bg-image"]
        ),
        style: !p && g ? { backgroundImage: `url(${g})` } : {},
        children: e
      }
    )
  ] });
}
function dr(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = dr(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function Ic() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = dr(e)) && (o && (o += " "), o += t);
  return o;
}
const jc = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Lc = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Ec = jc.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Lc[e]
})), Bc = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Tc = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Rc(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ y("span", { className: a }, a));
}
const Fc = kt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = Ec.find((c) => c.name === e), l = Ic("icon", `ds-${i?.class}`, Tc[t], Bc[a], o);
    return /* @__PURE__ */ y("i", { className: l, ...n, ref: r, children: Rc(i?.paths) });
  }
);
Fc.displayName = "Icon";
const Vc = ["en", "fr", "it"], _r = gn({
  locale: "en"
});
function Gc({ children: e, ...t }) {
  return /* @__PURE__ */ y(_r.Provider, { value: t, children: e });
}
const Uc = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
function Zc(e) {
  return Vc.includes(e) && !0;
}
function Wc(e, t) {
  const a = Uc.test(t);
  let o;
  return Zc(e) || a ? o = `${t}` : o = `/${e}${t}`, { url: o };
}
function Va(e) {
  const { locale: t } = fn(_r);
  return Wc(t, e);
}
function Kc() {
  const [e, t] = xe({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Ie(() => {
    function a() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", a), a(), () => window.removeEventListener("resize", a);
  }, []), e;
}
function gr() {
  const { width: e } = Kc();
  let t = "desktop";
  return e && e <= oo.MOBILE ? t = "mobile" : e && e <= oo.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
const Po = (e, t, a) => {
  if (e && "reportValidity" in e) {
    const o = C(a, t);
    e.setCustomValidity(o && o.message || ""), e.reportValidity();
  }
}, Ca = (e, t) => {
  for (const a in t.fields) {
    const o = t.fields[a];
    o && o.ref && "reportValidity" in o.ref ? Po(o.ref, a, e) : o && o.refs && o.refs.forEach((n) => Po(n, a, e));
  }
}, Mo = (e, t) => {
  t.shouldUseNativeValidation && Ca(e, t);
  const a = {};
  for (const o in e) {
    const n = C(t.fields, o), r = Object.assign(e[o] || {}, { ref: n && n.ref });
    if (qc(t.names || Object.keys(e), o)) {
      const i = Object.assign({}, C(a, o));
      G(i, "root", r), G(a, o, i);
    } else G(a, o, r);
  }
  return a;
}, qc = (e, t) => {
  const a = Do(t);
  return e.some((o) => Do(o).match(`^${a}\\.\\d+`));
};
function Do(e) {
  return e.replace(/\]|\[/g, "");
}
function v(e, t, a) {
  function o(l, c) {
    var s;
    Object.defineProperty(l, "_zod", {
      value: l._zod ?? {},
      enumerable: !1
    }), (s = l._zod).traits ?? (s.traits = /* @__PURE__ */ new Set()), l._zod.traits.add(e), t(l, c);
    for (const u in i.prototype)
      u in l || Object.defineProperty(l, u, { value: i.prototype[u].bind(l) });
    l._zod.constr = i, l._zod.def = c;
  }
  const n = a?.Parent ?? Object;
  class r extends n {
  }
  Object.defineProperty(r, "name", { value: e });
  function i(l) {
    var c;
    const s = a?.Parent ? new r() : this;
    o(s, l), (c = s._zod).deferred ?? (c.deferred = []);
    for (const u of s._zod.deferred)
      u();
    return s;
  }
  return Object.defineProperty(i, "init", { value: o }), Object.defineProperty(i, Symbol.hasInstance, {
    value: (l) => a?.Parent && l instanceof a.Parent ? !0 : l?._zod?.traits?.has(e)
  }), Object.defineProperty(i, "name", { value: e }), i;
}
class ot extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class fr extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const br = {};
function qe(e) {
  return br;
}
function Hc(e) {
  const t = Object.values(e).filter((o) => typeof o == "number");
  return Object.entries(e).filter(([o, n]) => t.indexOf(+o) === -1).map(([o, n]) => n);
}
function Sa(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Ga(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Ua(e) {
  return e == null;
}
function Za(e) {
  const t = e.startsWith("^") ? 1 : 0, a = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, a);
}
const No = Symbol("evaluating");
function K(e, t, a) {
  let o;
  Object.defineProperty(e, t, {
    get() {
      if (o !== No)
        return o === void 0 && (o = No, o = a()), o;
    },
    set(n) {
      Object.defineProperty(e, t, {
        value: n
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Jc(e) {
  return Object.create(Object.getPrototypeOf(e), Object.getOwnPropertyDescriptors(e));
}
function Re(e, t, a) {
  Object.defineProperty(e, t, {
    value: a,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function it(...e) {
  const t = {};
  for (const a of e) {
    const o = Object.getOwnPropertyDescriptors(a);
    Object.assign(t, o);
  }
  return Object.defineProperties({}, t);
}
function Oo(e) {
  return JSON.stringify(e);
}
const hr = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Gt(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Yc = Ga(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function mt(e) {
  if (Gt(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const a = t.prototype;
  return !(Gt(a) === !1 || Object.prototype.hasOwnProperty.call(a, "isPrototypeOf") === !1);
}
function mr(e) {
  return mt(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Qc = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Xt(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Fe(e, t, a) {
  const o = new e._zod.constr(t ?? e._zod.def);
  return (!t || a?.parent) && (o._zod.parent = e), o;
}
function j(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Xc(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function eu(e, t) {
  const a = e._zod.def, o = it(e._zod.def, {
    get shape() {
      const n = {};
      for (const r in t) {
        if (!(r in a.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        t[r] && (n[r] = a.shape[r]);
      }
      return Re(this, "shape", n), n;
    },
    checks: []
  });
  return Fe(e, o);
}
function tu(e, t) {
  const a = e._zod.def, o = it(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape };
      for (const r in t) {
        if (!(r in a.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        t[r] && delete n[r];
      }
      return Re(this, "shape", n), n;
    },
    checks: []
  });
  return Fe(e, o);
}
function au(e, t) {
  if (!mt(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const a = e._zod.def.checks;
  if (a && a.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const n = it(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Re(this, "shape", r), r;
    },
    checks: []
  });
  return Fe(e, n);
}
function ou(e, t) {
  if (!mt(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const a = {
    ...e._zod.def,
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return Re(this, "shape", o), o;
    },
    checks: e._zod.def.checks
  };
  return Fe(e, a);
}
function nu(e, t) {
  const a = it(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Re(this, "shape", o), o;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Fe(e, a);
}
function ru(e, t, a) {
  const o = it(t._zod.def, {
    get shape() {
      const n = t._zod.def.shape, r = { ...n };
      if (a)
        for (const i in a) {
          if (!(i in n))
            throw new Error(`Unrecognized key: "${i}"`);
          a[i] && (r[i] = e ? new e({
            type: "optional",
            innerType: n[i]
          }) : n[i]);
        }
      else
        for (const i in n)
          r[i] = e ? new e({
            type: "optional",
            innerType: n[i]
          }) : n[i];
      return Re(this, "shape", r), r;
    },
    checks: []
  });
  return Fe(t, o);
}
function iu(e, t, a) {
  const o = it(t._zod.def, {
    get shape() {
      const n = t._zod.def.shape, r = { ...n };
      if (a)
        for (const i in a) {
          if (!(i in r))
            throw new Error(`Unrecognized key: "${i}"`);
          a[i] && (r[i] = new e({
            type: "nonoptional",
            innerType: n[i]
          }));
        }
      else
        for (const i in n)
          r[i] = new e({
            type: "nonoptional",
            innerType: n[i]
          });
      return Re(this, "shape", r), r;
    },
    checks: []
  });
  return Fe(t, o);
}
function et(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let a = t; a < e.issues.length; a++)
    if (e.issues[a]?.continue !== !0)
      return !0;
  return !1;
}
function pr(e, t) {
  return t.map((a) => {
    var o;
    return (o = a).path ?? (o.path = []), a.path.unshift(e), a;
  });
}
function Mt(e) {
  return typeof e == "string" ? e : e?.message;
}
function He(e, t, a) {
  const o = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const n = Mt(e.inst?._zod.def?.error?.(e)) ?? Mt(t?.error?.(e)) ?? Mt(a.customError?.(e)) ?? Mt(a.localeError?.(e)) ?? "Invalid input";
    o.message = n;
  }
  return delete o.inst, delete o.continue, t?.reportInput || delete o.input, o;
}
function Wa(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function pt(...e) {
  const [t, a, o] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: a,
    inst: o
  } : { ...t };
}
const yr = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Sa, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, Ka = v("$ZodError", yr), ea = v("$ZodError", yr, { Parent: Error });
function lu(e, t = (a) => a.message) {
  const a = {}, o = [];
  for (const n of e.issues)
    n.path.length > 0 ? (a[n.path[0]] = a[n.path[0]] || [], a[n.path[0]].push(t(n))) : o.push(t(n));
  return { formErrors: o, fieldErrors: a };
}
function su(e, t) {
  const a = t || function(r) {
    return r.message;
  }, o = { _errors: [] }, n = (r) => {
    for (const i of r.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((l) => n({ issues: l }));
      else if (i.code === "invalid_key")
        n({ issues: i.issues });
      else if (i.code === "invalid_element")
        n({ issues: i.issues });
      else if (i.path.length === 0)
        o._errors.push(a(i));
      else {
        let l = o, c = 0;
        for (; c < i.path.length; ) {
          const s = i.path[c];
          c === i.path.length - 1 ? (l[s] = l[s] || { _errors: [] }, l[s]._errors.push(a(i))) : l[s] = l[s] || { _errors: [] }, l = l[s], c++;
        }
      }
  };
  return n(e), o;
}
const ta = (e) => (t, a, o, n) => {
  const r = o ? Object.assign(o, { async: !1 }) : { async: !1 }, i = t._zod.run({ value: a, issues: [] }, r);
  if (i instanceof Promise)
    throw new ot();
  if (i.issues.length) {
    const l = new (n?.Err ?? e)(i.issues.map((c) => He(c, r, qe())));
    throw hr(l, n?.callee), l;
  }
  return i.value;
}, cu = /* @__PURE__ */ ta(ea), aa = (e) => async (t, a, o, n) => {
  const r = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: a, issues: [] }, r);
  if (i instanceof Promise && (i = await i), i.issues.length) {
    const l = new (n?.Err ?? e)(i.issues.map((c) => He(c, r, qe())));
    throw hr(l, n?.callee), l;
  }
  return i.value;
}, uu = /* @__PURE__ */ aa(ea), oa = (e) => (t, a, o) => {
  const n = o ? { ...o, async: !1 } : { async: !1 }, r = t._zod.run({ value: a, issues: [] }, n);
  if (r instanceof Promise)
    throw new ot();
  return r.issues.length ? {
    success: !1,
    error: new (e ?? Ka)(r.issues.map((i) => He(i, n, qe())))
  } : { success: !0, data: r.value };
}, du = /* @__PURE__ */ oa(ea), na = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let r = t._zod.run({ value: a, issues: [] }, n);
  return r instanceof Promise && (r = await r), r.issues.length ? {
    success: !1,
    error: new e(r.issues.map((i) => He(i, n, qe())))
  } : { success: !0, data: r.value };
}, _u = /* @__PURE__ */ na(ea), gu = (e) => (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return ta(e)(t, a, n);
}, fu = (e) => (t, a, o) => ta(e)(t, a, o), bu = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return aa(e)(t, a, n);
}, hu = (e) => async (t, a, o) => aa(e)(t, a, o), mu = (e) => (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return oa(e)(t, a, n);
}, pu = (e) => (t, a, o) => oa(e)(t, a, o), yu = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return na(e)(t, a, n);
}, vu = (e) => async (t, a, o) => na(e)(t, a, o), ku = /^[cC][^\s-]{8,}$/, $u = /^[0-9a-z]+$/, wu = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, xu = /^[0-9a-vA-V]{20}$/, Cu = /^[A-Za-z0-9]{27}$/, Su = /^[a-zA-Z0-9_-]{21}$/, zu = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Au = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Io = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Pu = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Mu = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Du() {
  return new RegExp(Mu, "u");
}
const Nu = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ou = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Iu = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, ju = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Lu = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, vr = /^[A-Za-z0-9_-]*$/, Eu = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, Bu = /^\+(?:[0-9]){6,14}[0-9]$/, kr = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Tu = /* @__PURE__ */ new RegExp(`^${kr}$`);
function $r(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Ru(e) {
  return new RegExp(`^${$r(e)}$`);
}
function Fu(e) {
  const t = $r({ precision: e.precision }), a = ["Z"];
  e.local && a.push(""), e.offset && a.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const o = `${t}(?:${a.join("|")})`;
  return new RegExp(`^${kr}T(?:${o})$`);
}
const Vu = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Gu = /^[^A-Z]*$/, Uu = /^[^a-z]*$/, ze = /* @__PURE__ */ v("$ZodCheck", (e, t) => {
  var a;
  e._zod ?? (e._zod = {}), e._zod.def = t, (a = e._zod).onattach ?? (a.onattach = []);
}), Zu = /* @__PURE__ */ v("$ZodCheckMaxLength", (e, t) => {
  var a;
  ze.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Ua(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < n && (o._zod.bag.maximum = t.maximum);
  }), e._zod.check = (o) => {
    const n = o.value;
    if (n.length <= t.maximum)
      return;
    const i = Wa(n);
    o.issues.push({
      origin: i,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), Wu = /* @__PURE__ */ v("$ZodCheckMinLength", (e, t) => {
  var a;
  ze.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Ua(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > n && (o._zod.bag.minimum = t.minimum);
  }), e._zod.check = (o) => {
    const n = o.value;
    if (n.length >= t.minimum)
      return;
    const i = Wa(n);
    o.issues.push({
      origin: i,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), Ku = /* @__PURE__ */ v("$ZodCheckLengthEquals", (e, t) => {
  var a;
  ze.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Ua(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.minimum = t.length, n.maximum = t.length, n.length = t.length;
  }), e._zod.check = (o) => {
    const n = o.value, r = n.length;
    if (r === t.length)
      return;
    const i = Wa(n), l = r > t.length;
    o.issues.push({
      origin: i,
      ...l ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), ra = /* @__PURE__ */ v("$ZodCheckStringFormat", (e, t) => {
  var a, o;
  ze.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = t.format, t.pattern && (r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(t.pattern));
  }), t.pattern ? (a = e._zod).check ?? (a.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: n.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (o = e._zod).check ?? (o.check = () => {
  });
}), qu = /* @__PURE__ */ v("$ZodCheckRegex", (e, t) => {
  ra.init(e, t), e._zod.check = (a) => {
    t.pattern.lastIndex = 0, !t.pattern.test(a.value) && a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: a.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Hu = /* @__PURE__ */ v("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Gu), ra.init(e, t);
}), Ju = /* @__PURE__ */ v("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Uu), ra.init(e, t);
}), Yu = /* @__PURE__ */ v("$ZodCheckIncludes", (e, t) => {
  ze.init(e, t);
  const a = Xt(t.includes), o = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${a}` : a);
  t.pattern = o, e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(o);
  }), e._zod.check = (n) => {
    n.value.includes(t.includes, t.position) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Qu = /* @__PURE__ */ v("$ZodCheckStartsWith", (e, t) => {
  ze.init(e, t);
  const a = new RegExp(`^${Xt(t.prefix)}.*`);
  t.pattern ?? (t.pattern = a), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.patterns ?? (n.patterns = /* @__PURE__ */ new Set()), n.patterns.add(a);
  }), e._zod.check = (o) => {
    o.value.startsWith(t.prefix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Xu = /* @__PURE__ */ v("$ZodCheckEndsWith", (e, t) => {
  ze.init(e, t);
  const a = new RegExp(`.*${Xt(t.suffix)}$`);
  t.pattern ?? (t.pattern = a), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.patterns ?? (n.patterns = /* @__PURE__ */ new Set()), n.patterns.add(a);
  }), e._zod.check = (o) => {
    o.value.endsWith(t.suffix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), ed = /* @__PURE__ */ v("$ZodCheckOverwrite", (e, t) => {
  ze.init(e, t), e._zod.check = (a) => {
    a.value = t.tx(a.value);
  };
});
class td {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const o = t.split(`
`).filter((i) => i), n = Math.min(...o.map((i) => i.length - i.trimStart().length)), r = o.map((i) => i.slice(n)).map((i) => " ".repeat(this.indent * 2) + i);
    for (const i of r)
      this.content.push(i);
  }
  compile() {
    const t = Function, a = this?.args, n = [...(this?.content ?? [""]).map((r) => `  ${r}`)];
    return new t(...a, n.join(`
`));
  }
}
const ad = {
  major: 4,
  minor: 1,
  patch: 9
}, le = /* @__PURE__ */ v("$ZodType", (e, t) => {
  var a;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = ad;
  const o = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && o.unshift(e);
  for (const n of o)
    for (const r of n._zod.onattach)
      r(e);
  if (o.length === 0)
    (a = e._zod).deferred ?? (a.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const n = (i, l, c) => {
      let s = et(i), u;
      for (const d of l) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(i))
            continue;
        } else if (s)
          continue;
        const g = i.issues.length, b = d._zod.check(i);
        if (b instanceof Promise && c?.async === !1)
          throw new ot();
        if (u || b instanceof Promise)
          u = (u ?? Promise.resolve()).then(async () => {
            await b, i.issues.length !== g && (s || (s = et(i, g)));
          });
        else {
          if (i.issues.length === g)
            continue;
          s || (s = et(i, g));
        }
      }
      return u ? u.then(() => i) : i;
    }, r = (i, l, c) => {
      if (et(i))
        return i.aborted = !0, i;
      const s = n(l, o, c);
      if (s instanceof Promise) {
        if (c.async === !1)
          throw new ot();
        return s.then((u) => e._zod.parse(u, c));
      }
      return e._zod.parse(s, c);
    };
    e._zod.run = (i, l) => {
      if (l.skipChecks)
        return e._zod.parse(i, l);
      if (l.direction === "backward") {
        const s = e._zod.parse({ value: i.value, issues: [] }, { ...l, skipChecks: !0 });
        return s instanceof Promise ? s.then((u) => r(u, i, l)) : r(s, i, l);
      }
      const c = e._zod.parse(i, l);
      if (c instanceof Promise) {
        if (l.async === !1)
          throw new ot();
        return c.then((s) => n(s, o, l));
      }
      return n(c, o, l);
    };
  }
  e["~standard"] = {
    validate: (n) => {
      try {
        const r = du(e, n);
        return r.success ? { value: r.data } : { issues: r.error?.issues };
      } catch {
        return _u(e, n).then((i) => i.success ? { value: i.data } : { issues: i.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), qa = /* @__PURE__ */ v("$ZodString", (e, t) => {
  le.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? Vu(e._zod.bag), e._zod.parse = (a, o) => {
    if (t.coerce)
      try {
        a.value = String(a.value);
      } catch {
      }
    return typeof a.value == "string" || a.issues.push({
      expected: "string",
      code: "invalid_type",
      input: a.value,
      inst: e
    }), a;
  };
}), J = /* @__PURE__ */ v("$ZodStringFormat", (e, t) => {
  ra.init(e, t), qa.init(e, t);
}), od = /* @__PURE__ */ v("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = Au), J.init(e, t);
}), nd = /* @__PURE__ */ v("$ZodUUID", (e, t) => {
  if (t.version) {
    const o = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (o === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Io(o));
  } else
    t.pattern ?? (t.pattern = Io());
  J.init(e, t);
}), rd = /* @__PURE__ */ v("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Pu), J.init(e, t);
}), id = /* @__PURE__ */ v("$ZodURL", (e, t) => {
  J.init(e, t), e._zod.check = (a) => {
    try {
      const o = a.value.trim(), n = new URL(o);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(n.hostname) || a.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: Eu.source,
        input: a.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(n.protocol.endsWith(":") ? n.protocol.slice(0, -1) : n.protocol) || a.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: a.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? a.value = n.href : a.value = o;
      return;
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "url",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), ld = /* @__PURE__ */ v("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Du()), J.init(e, t);
}), sd = /* @__PURE__ */ v("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Su), J.init(e, t);
}), cd = /* @__PURE__ */ v("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = ku), J.init(e, t);
}), ud = /* @__PURE__ */ v("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = $u), J.init(e, t);
}), dd = /* @__PURE__ */ v("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = wu), J.init(e, t);
}), _d = /* @__PURE__ */ v("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = xu), J.init(e, t);
}), gd = /* @__PURE__ */ v("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Cu), J.init(e, t);
}), fd = /* @__PURE__ */ v("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Fu(t)), J.init(e, t);
}), bd = /* @__PURE__ */ v("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Tu), J.init(e, t);
}), hd = /* @__PURE__ */ v("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Ru(t)), J.init(e, t);
}), md = /* @__PURE__ */ v("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = zu), J.init(e, t);
}), pd = /* @__PURE__ */ v("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Nu), J.init(e, t), e._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.format = "ipv4";
  });
}), yd = /* @__PURE__ */ v("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Ou), J.init(e, t), e._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.format = "ipv6";
  }), e._zod.check = (a) => {
    try {
      new URL(`http://[${a.value}]`);
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), vd = /* @__PURE__ */ v("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = Iu), J.init(e, t);
}), kd = /* @__PURE__ */ v("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = ju), J.init(e, t), e._zod.check = (a) => {
    const o = a.value.split("/");
    try {
      if (o.length !== 2)
        throw new Error();
      const [n, r] = o;
      if (!r)
        throw new Error();
      const i = Number(r);
      if (`${i}` !== r)
        throw new Error();
      if (i < 0 || i > 128)
        throw new Error();
      new URL(`http://[${n}]`);
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function wr(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const $d = /* @__PURE__ */ v("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Lu), J.init(e, t), e._zod.onattach.push((a) => {
    a._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (a) => {
    wr(a.value) || a.issues.push({
      code: "invalid_format",
      format: "base64",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function wd(e) {
  if (!vr.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (o) => o === "-" ? "+" : "/"), a = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return wr(a);
}
const xd = /* @__PURE__ */ v("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = vr), J.init(e, t), e._zod.onattach.push((a) => {
    a._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (a) => {
    wd(a.value) || a.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Cd = /* @__PURE__ */ v("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Bu), J.init(e, t);
});
function Sd(e, t = null) {
  try {
    const a = e.split(".");
    if (a.length !== 3)
      return !1;
    const [o] = a;
    if (!o)
      return !1;
    const n = JSON.parse(atob(o));
    return !("typ" in n && n?.typ !== "JWT" || !n.alg || t && (!("alg" in n) || n.alg !== t));
  } catch {
    return !1;
  }
}
const zd = /* @__PURE__ */ v("$ZodJWT", (e, t) => {
  J.init(e, t), e._zod.check = (a) => {
    Sd(a.value, t.alg) || a.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ad = /* @__PURE__ */ v("$ZodUnknown", (e, t) => {
  le.init(e, t), e._zod.parse = (a) => a;
}), Pd = /* @__PURE__ */ v("$ZodNever", (e, t) => {
  le.init(e, t), e._zod.parse = (a, o) => (a.issues.push({
    expected: "never",
    code: "invalid_type",
    input: a.value,
    inst: e
  }), a);
});
function jo(e, t, a) {
  e.issues.length && t.issues.push(...pr(a, e.issues)), t.value[a] = e.value;
}
const Md = /* @__PURE__ */ v("$ZodArray", (e, t) => {
  le.init(e, t), e._zod.parse = (a, o) => {
    const n = a.value;
    if (!Array.isArray(n))
      return a.issues.push({
        expected: "array",
        code: "invalid_type",
        input: n,
        inst: e
      }), a;
    a.value = Array(n.length);
    const r = [];
    for (let i = 0; i < n.length; i++) {
      const l = n[i], c = t.element._zod.run({
        value: l,
        issues: []
      }, o);
      c instanceof Promise ? r.push(c.then((s) => jo(s, a, i))) : jo(c, a, i);
    }
    return r.length ? Promise.all(r).then(() => a) : a;
  };
});
function Ut(e, t, a, o) {
  e.issues.length && t.issues.push(...pr(a, e.issues)), e.value === void 0 ? a in o && (t.value[a] = void 0) : t.value[a] = e.value;
}
function xr(e) {
  const t = Object.keys(e.shape);
  for (const o of t)
    if (!e.shape?.[o]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${o}": expected a Zod schema`);
  const a = Xc(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(a)
  };
}
function Cr(e, t, a, o, n, r) {
  const i = [], l = n.keySet, c = n.catchall._zod, s = c.def.type;
  for (const u of Object.keys(t)) {
    if (l.has(u))
      continue;
    if (s === "never") {
      i.push(u);
      continue;
    }
    const d = c.run({ value: t[u], issues: [] }, o);
    d instanceof Promise ? e.push(d.then((g) => Ut(g, a, u, t))) : Ut(d, a, u, t);
  }
  return i.length && a.issues.push({
    code: "unrecognized_keys",
    keys: i,
    input: t,
    inst: r
  }), e.length ? Promise.all(e).then(() => a) : a;
}
const Dd = /* @__PURE__ */ v("$ZodObject", (e, t) => {
  le.init(e, t);
  const a = Ga(() => xr(t));
  K(e._zod, "propValues", () => {
    const i = t.shape, l = {};
    for (const c in i) {
      const s = i[c]._zod;
      if (s.values) {
        l[c] ?? (l[c] = /* @__PURE__ */ new Set());
        for (const u of s.values)
          l[c].add(u);
      }
    }
    return l;
  });
  const o = Gt, n = t.catchall;
  let r;
  e._zod.parse = (i, l) => {
    r ?? (r = a.value);
    const c = i.value;
    if (!o(c))
      return i.issues.push({
        expected: "object",
        code: "invalid_type",
        input: c,
        inst: e
      }), i;
    i.value = {};
    const s = [], u = r.shape;
    for (const d of r.keys) {
      const b = u[d]._zod.run({ value: c[d], issues: [] }, l);
      b instanceof Promise ? s.push(b.then((h) => Ut(h, i, d, c))) : Ut(b, i, d, c);
    }
    return n ? Cr(s, c, i, l, a.value, e) : s.length ? Promise.all(s).then(() => i) : i;
  };
}), Nd = /* @__PURE__ */ v("$ZodObjectJIT", (e, t) => {
  Dd.init(e, t);
  const a = e._zod.parse, o = Ga(() => xr(t)), n = (g) => {
    const b = new td(["shape", "payload", "ctx"]), h = o.value, p = (P) => {
      const A = Oo(P);
      return `shape[${A}]._zod.run({ value: input[${A}], issues: [] }, ctx)`;
    };
    b.write("const input = payload.value;");
    const $ = /* @__PURE__ */ Object.create(null);
    let M = 0;
    for (const P of h.keys)
      $[P] = `key_${M++}`;
    b.write("const newResult = {};");
    for (const P of h.keys) {
      const A = $[P], N = Oo(P);
      b.write(`const ${A} = ${p(P)};`), b.write(`
        if (${A}.issues.length) {
          payload.issues = payload.issues.concat(${A}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${N}, ...iss.path] : [${N}]
          })));
        }
        
        
        if (${A}.value === undefined) {
          if (${N} in input) {
            newResult[${N}] = undefined;
          }
        } else {
          newResult[${N}] = ${A}.value;
        }
        
      `);
    }
    b.write("payload.value = newResult;"), b.write("return payload;");
    const k = b.compile();
    return (P, A) => k(g, P, A);
  };
  let r;
  const i = Gt, l = !br.jitless, s = l && Yc.value, u = t.catchall;
  let d;
  e._zod.parse = (g, b) => {
    d ?? (d = o.value);
    const h = g.value;
    return i(h) ? l && s && b?.async === !1 && b.jitless !== !0 ? (r || (r = n(t.shape)), g = r(g, b), u ? Cr([], h, g, b, d, e) : g) : a(g, b) : (g.issues.push({
      expected: "object",
      code: "invalid_type",
      input: h,
      inst: e
    }), g);
  };
});
function Lo(e, t, a, o) {
  for (const r of e)
    if (r.issues.length === 0)
      return t.value = r.value, t;
  const n = e.filter((r) => !et(r));
  return n.length === 1 ? (t.value = n[0].value, n[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: a,
    errors: e.map((r) => r.issues.map((i) => He(i, o, qe())))
  }), t);
}
const Od = /* @__PURE__ */ v("$ZodUnion", (e, t) => {
  le.init(e, t), K(e._zod, "optin", () => t.options.some((n) => n._zod.optin === "optional") ? "optional" : void 0), K(e._zod, "optout", () => t.options.some((n) => n._zod.optout === "optional") ? "optional" : void 0), K(e._zod, "values", () => {
    if (t.options.every((n) => n._zod.values))
      return new Set(t.options.flatMap((n) => Array.from(n._zod.values)));
  }), K(e._zod, "pattern", () => {
    if (t.options.every((n) => n._zod.pattern)) {
      const n = t.options.map((r) => r._zod.pattern);
      return new RegExp(`^(${n.map((r) => Za(r.source)).join("|")})$`);
    }
  });
  const a = t.options.length === 1, o = t.options[0]._zod.run;
  e._zod.parse = (n, r) => {
    if (a)
      return o(n, r);
    let i = !1;
    const l = [];
    for (const c of t.options) {
      const s = c._zod.run({
        value: n.value,
        issues: []
      }, r);
      if (s instanceof Promise)
        l.push(s), i = !0;
      else {
        if (s.issues.length === 0)
          return s;
        l.push(s);
      }
    }
    return i ? Promise.all(l).then((c) => Lo(c, n, e, r)) : Lo(l, n, e, r);
  };
}), Id = /* @__PURE__ */ v("$ZodIntersection", (e, t) => {
  le.init(e, t), e._zod.parse = (a, o) => {
    const n = a.value, r = t.left._zod.run({ value: n, issues: [] }, o), i = t.right._zod.run({ value: n, issues: [] }, o);
    return r instanceof Promise || i instanceof Promise ? Promise.all([r, i]).then(([c, s]) => Eo(a, c, s)) : Eo(a, r, i);
  };
});
function za(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (mt(e) && mt(t)) {
    const a = Object.keys(t), o = Object.keys(e).filter((r) => a.indexOf(r) !== -1), n = { ...e, ...t };
    for (const r of o) {
      const i = za(e[r], t[r]);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...i.mergeErrorPath]
        };
      n[r] = i.data;
    }
    return { valid: !0, data: n };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const a = [];
    for (let o = 0; o < e.length; o++) {
      const n = e[o], r = t[o], i = za(n, r);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...i.mergeErrorPath]
        };
      a.push(i.data);
    }
    return { valid: !0, data: a };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Eo(e, t, a) {
  if (t.issues.length && e.issues.push(...t.issues), a.issues.length && e.issues.push(...a.issues), et(e))
    return e;
  const o = za(t.value, a.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const jd = /* @__PURE__ */ v("$ZodEnum", (e, t) => {
  le.init(e, t);
  const a = Hc(t.entries), o = new Set(a);
  e._zod.values = o, e._zod.pattern = new RegExp(`^(${a.filter((n) => Qc.has(typeof n)).map((n) => typeof n == "string" ? Xt(n) : n.toString()).join("|")})$`), e._zod.parse = (n, r) => {
    const i = n.value;
    return o.has(i) || n.issues.push({
      code: "invalid_value",
      values: a,
      input: i,
      inst: e
    }), n;
  };
}), Ld = /* @__PURE__ */ v("$ZodTransform", (e, t) => {
  le.init(e, t), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      throw new fr(e.constructor.name);
    const n = t.transform(a.value, a);
    if (o.async)
      return (n instanceof Promise ? n : Promise.resolve(n)).then((i) => (a.value = i, a));
    if (n instanceof Promise)
      throw new ot();
    return a.value = n, a;
  };
});
function Bo(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Ed = /* @__PURE__ */ v("$ZodOptional", (e, t) => {
  le.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", K(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), K(e._zod, "pattern", () => {
    const a = t.innerType._zod.pattern;
    return a ? new RegExp(`^(${Za(a.source)})?$`) : void 0;
  }), e._zod.parse = (a, o) => {
    if (t.innerType._zod.optin === "optional") {
      const n = t.innerType._zod.run(a, o);
      return n instanceof Promise ? n.then((r) => Bo(r, a.value)) : Bo(n, a.value);
    }
    return a.value === void 0 ? a : t.innerType._zod.run(a, o);
  };
}), Bd = /* @__PURE__ */ v("$ZodNullable", (e, t) => {
  le.init(e, t), K(e._zod, "optin", () => t.innerType._zod.optin), K(e._zod, "optout", () => t.innerType._zod.optout), K(e._zod, "pattern", () => {
    const a = t.innerType._zod.pattern;
    return a ? new RegExp(`^(${Za(a.source)}|null)$`) : void 0;
  }), K(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (a, o) => a.value === null ? a : t.innerType._zod.run(a, o);
}), Td = /* @__PURE__ */ v("$ZodDefault", (e, t) => {
  le.init(e, t), e._zod.optin = "optional", K(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    if (a.value === void 0)
      return a.value = t.defaultValue, a;
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => To(r, t)) : To(n, t);
  };
});
function To(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Rd = /* @__PURE__ */ v("$ZodPrefault", (e, t) => {
  le.init(e, t), e._zod.optin = "optional", K(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => (o.direction === "backward" || a.value === void 0 && (a.value = t.defaultValue), t.innerType._zod.run(a, o));
}), Fd = /* @__PURE__ */ v("$ZodNonOptional", (e, t) => {
  le.init(e, t), K(e._zod, "values", () => {
    const a = t.innerType._zod.values;
    return a ? new Set([...a].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (a, o) => {
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Ro(r, e)) : Ro(n, e);
  };
});
function Ro(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Vd = /* @__PURE__ */ v("$ZodCatch", (e, t) => {
  le.init(e, t), K(e._zod, "optin", () => t.innerType._zod.optin), K(e._zod, "optout", () => t.innerType._zod.optout), K(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => (a.value = r.value, r.issues.length && (a.value = t.catchValue({
      ...a,
      error: {
        issues: r.issues.map((i) => He(i, o, qe()))
      },
      input: a.value
    }), a.issues = []), a)) : (a.value = n.value, n.issues.length && (a.value = t.catchValue({
      ...a,
      error: {
        issues: n.issues.map((r) => He(r, o, qe()))
      },
      input: a.value
    }), a.issues = []), a);
  };
}), Gd = /* @__PURE__ */ v("$ZodPipe", (e, t) => {
  le.init(e, t), K(e._zod, "values", () => t.in._zod.values), K(e._zod, "optin", () => t.in._zod.optin), K(e._zod, "optout", () => t.out._zod.optout), K(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (a, o) => {
    if (o.direction === "backward") {
      const r = t.out._zod.run(a, o);
      return r instanceof Promise ? r.then((i) => Dt(i, t.in, o)) : Dt(r, t.in, o);
    }
    const n = t.in._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Dt(r, t.out, o)) : Dt(n, t.out, o);
  };
});
function Dt(e, t, a) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, a);
}
const Ud = /* @__PURE__ */ v("$ZodReadonly", (e, t) => {
  le.init(e, t), K(e._zod, "propValues", () => t.innerType._zod.propValues), K(e._zod, "values", () => t.innerType._zod.values), K(e._zod, "optin", () => t.innerType._zod.optin), K(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then(Fo) : Fo(n);
  };
});
function Fo(e) {
  return e.value = Object.freeze(e.value), e;
}
const Zd = /* @__PURE__ */ v("$ZodCustom", (e, t) => {
  ze.init(e, t), le.init(e, t), e._zod.parse = (a, o) => a, e._zod.check = (a) => {
    const o = a.value, n = t.fn(o);
    if (n instanceof Promise)
      return n.then((r) => Vo(r, a, o, e));
    Vo(n, a, o, e);
  };
});
function Vo(e, t, a, o) {
  if (!e) {
    const n = {
      code: "custom",
      input: a,
      inst: o,
      // incorporates params.error into issue reporting
      path: [...o._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !o._zod.def.abort
      // params: inst._zod.def.params,
    };
    o._zod.def.params && (n.params = o._zod.def.params), t.issues.push(pt(n));
  }
}
class Wd {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...a) {
    const o = a[0];
    if (this._map.set(t, o), o && typeof o == "object" && "id" in o) {
      if (this._idmap.has(o.id))
        throw new Error(`ID ${o.id} already exists in the registry`);
      this._idmap.set(o.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const a = this._map.get(t);
    return a && typeof a == "object" && "id" in a && this._idmap.delete(a.id), this._map.delete(t), this;
  }
  get(t) {
    const a = t._zod.parent;
    if (a) {
      const o = { ...this.get(a) ?? {} };
      delete o.id;
      const n = { ...o, ...this._map.get(t) };
      return Object.keys(n).length ? n : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Kd() {
  return new Wd();
}
const Nt = /* @__PURE__ */ Kd();
function qd(e, t) {
  return new e({
    type: "string",
    ...j(t)
  });
}
function Hd(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function Go(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function Jd(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function Yd(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...j(t)
  });
}
function Qd(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...j(t)
  });
}
function Xd(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...j(t)
  });
}
function e_(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function t_(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function a_(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function o_(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function n_(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function r_(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function i_(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function l_(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function s_(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function c_(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function u_(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function d_(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function __(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function g_(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function f_(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function b_(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...j(t)
  });
}
function h_(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...j(t)
  });
}
function m_(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...j(t)
  });
}
function p_(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...j(t)
  });
}
function y_(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...j(t)
  });
}
function v_(e) {
  return new e({
    type: "unknown"
  });
}
function k_(e, t) {
  return new e({
    type: "never",
    ...j(t)
  });
}
function Sr(e, t) {
  return new Zu({
    check: "max_length",
    ...j(t),
    maximum: e
  });
}
function Zt(e, t) {
  return new Wu({
    check: "min_length",
    ...j(t),
    minimum: e
  });
}
function zr(e, t) {
  return new Ku({
    check: "length_equals",
    ...j(t),
    length: e
  });
}
function $_(e, t) {
  return new qu({
    check: "string_format",
    format: "regex",
    ...j(t),
    pattern: e
  });
}
function w_(e) {
  return new Hu({
    check: "string_format",
    format: "lowercase",
    ...j(e)
  });
}
function x_(e) {
  return new Ju({
    check: "string_format",
    format: "uppercase",
    ...j(e)
  });
}
function C_(e, t) {
  return new Yu({
    check: "string_format",
    format: "includes",
    ...j(t),
    includes: e
  });
}
function S_(e, t) {
  return new Qu({
    check: "string_format",
    format: "starts_with",
    ...j(t),
    prefix: e
  });
}
function z_(e, t) {
  return new Xu({
    check: "string_format",
    format: "ends_with",
    ...j(t),
    suffix: e
  });
}
function xt(e) {
  return new ed({
    check: "overwrite",
    tx: e
  });
}
function A_(e) {
  return xt((t) => t.normalize(e));
}
function P_() {
  return xt((e) => e.trim());
}
function M_() {
  return xt((e) => e.toLowerCase());
}
function D_() {
  return xt((e) => e.toUpperCase());
}
function N_(e, t, a) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...j(a)
  });
}
function O_(e, t, a) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...j(a)
  });
}
function I_(e) {
  const t = j_((a) => (a.addIssue = (o) => {
    if (typeof o == "string")
      a.issues.push(pt(o, a.value, t._zod.def));
    else {
      const n = o;
      n.fatal && (n.continue = !1), n.code ?? (n.code = "custom"), n.input ?? (n.input = a.value), n.inst ?? (n.inst = t), n.continue ?? (n.continue = !t._zod.def.abort), a.issues.push(pt(n));
    }
  }, e(a.value, a)));
  return t;
}
function j_(e, t) {
  const a = new ze({
    check: "custom",
    ...j(t)
  });
  return a._zod.check = e, a;
}
function Uo(e, t) {
  try {
    var a = e();
  } catch (o) {
    return t(o);
  }
  return a && a.then ? a.then(void 0, t) : a;
}
function L_(e, t) {
  for (var a = {}; e.length; ) {
    var o = e[0], n = o.code, r = o.message, i = o.path.join(".");
    if (!a[i]) if ("unionErrors" in o) {
      var l = o.unionErrors[0].errors[0];
      a[i] = { message: l.message, type: l.code };
    } else a[i] = { message: r, type: n };
    if ("unionErrors" in o && o.unionErrors.forEach(function(u) {
      return u.errors.forEach(function(d) {
        return e.push(d);
      });
    }), t) {
      var c = a[i].types, s = c && c[o.code];
      a[i] = Ea(i, t, a, n, s ? [].concat(s, o.message) : o.message);
    }
    e.shift();
  }
  return a;
}
function E_(e, t) {
  for (var a = {}; e.length; ) {
    var o = e[0], n = o.code, r = o.message, i = o.path.join(".");
    if (!a[i]) if (o.code === "invalid_union" && o.errors.length > 0) {
      var l = o.errors[0][0];
      a[i] = { message: l.message, type: l.code };
    } else a[i] = { message: r, type: n };
    if (o.code === "invalid_union" && o.errors.forEach(function(u) {
      return u.forEach(function(d) {
        return e.push(d);
      });
    }), t) {
      var c = a[i].types, s = c && c[o.code];
      a[i] = Ea(i, t, a, n, s ? [].concat(s, o.message) : o.message);
    }
    e.shift();
  }
  return a;
}
function B_(e, t, a) {
  if (a === void 0 && (a = {}), function(o) {
    return "_def" in o && typeof o._def == "object" && "typeName" in o._def;
  }(e)) return function(o, n, r) {
    try {
      return Promise.resolve(Uo(function() {
        return Promise.resolve(e[a.mode === "sync" ? "parse" : "parseAsync"](o, t)).then(function(i) {
          return r.shouldUseNativeValidation && Ca({}, r), { errors: {}, values: a.raw ? Object.assign({}, o) : i };
        });
      }, function(i) {
        if (function(l) {
          return Array.isArray(l?.issues);
        }(i)) return { values: {}, errors: Mo(L_(i.errors, !r.shouldUseNativeValidation && r.criteriaMode === "all"), r) };
        throw i;
      }));
    } catch (i) {
      return Promise.reject(i);
    }
  };
  if (function(o) {
    return "_zod" in o && typeof o._zod == "object";
  }(e)) return function(o, n, r) {
    try {
      return Promise.resolve(Uo(function() {
        return Promise.resolve((a.mode === "sync" ? cu : uu)(e, o, t)).then(function(i) {
          return r.shouldUseNativeValidation && Ca({}, r), { errors: {}, values: a.raw ? Object.assign({}, o) : i };
        });
      }, function(i) {
        if (function(l) {
          return l instanceof Ka;
        }(i)) return { values: {}, errors: Mo(E_(i.issues, !r.shouldUseNativeValidation && r.criteriaMode === "all"), r) };
        throw i;
      }));
    } catch (i) {
      return Promise.reject(i);
    }
  };
  throw new Error("Invalid input: not a Zod schema");
}
const T_ = /* @__PURE__ */ v("ZodISODateTime", (e, t) => {
  fd.init(e, t), Y.init(e, t);
});
function R_(e) {
  return h_(T_, e);
}
const F_ = /* @__PURE__ */ v("ZodISODate", (e, t) => {
  bd.init(e, t), Y.init(e, t);
});
function V_(e) {
  return m_(F_, e);
}
const G_ = /* @__PURE__ */ v("ZodISOTime", (e, t) => {
  hd.init(e, t), Y.init(e, t);
});
function U_(e) {
  return p_(G_, e);
}
const Z_ = /* @__PURE__ */ v("ZodISODuration", (e, t) => {
  md.init(e, t), Y.init(e, t);
});
function W_(e) {
  return y_(Z_, e);
}
const K_ = (e, t) => {
  Ka.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (a) => su(e, a)
      // enumerable: false,
    },
    flatten: {
      value: (a) => lu(e, a)
      // enumerable: false,
    },
    addIssue: {
      value: (a) => {
        e.issues.push(a), e.message = JSON.stringify(e.issues, Sa, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (a) => {
        e.issues.push(...a), e.message = JSON.stringify(e.issues, Sa, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, ye = v("ZodError", K_, {
  Parent: Error
}), q_ = /* @__PURE__ */ ta(ye), H_ = /* @__PURE__ */ aa(ye), J_ = /* @__PURE__ */ oa(ye), Y_ = /* @__PURE__ */ na(ye), Q_ = /* @__PURE__ */ gu(ye), X_ = /* @__PURE__ */ fu(ye), eg = /* @__PURE__ */ bu(ye), tg = /* @__PURE__ */ hu(ye), ag = /* @__PURE__ */ mu(ye), og = /* @__PURE__ */ pu(ye), ng = /* @__PURE__ */ yu(ye), rg = /* @__PURE__ */ vu(ye), se = /* @__PURE__ */ v("ZodType", (e, t) => (le.init(e, t), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...a) => e.clone(
  {
    ...t,
    checks: [
      ...t.checks ?? [],
      ...a.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
    ]
  }
  // { parent: true }
), e.clone = (a, o) => Fe(e, a, o), e.brand = () => e, e.register = (a, o) => (a.add(e, o), e), e.parse = (a, o) => q_(e, a, o, { callee: e.parse }), e.safeParse = (a, o) => J_(e, a, o), e.parseAsync = async (a, o) => H_(e, a, o, { callee: e.parseAsync }), e.safeParseAsync = async (a, o) => Y_(e, a, o), e.spa = e.safeParseAsync, e.encode = (a, o) => Q_(e, a, o), e.decode = (a, o) => X_(e, a, o), e.encodeAsync = async (a, o) => eg(e, a, o), e.decodeAsync = async (a, o) => tg(e, a, o), e.safeEncode = (a, o) => ag(e, a, o), e.safeDecode = (a, o) => og(e, a, o), e.safeEncodeAsync = async (a, o) => ng(e, a, o), e.safeDecodeAsync = async (a, o) => rg(e, a, o), e.refine = (a, o) => e.check(Jg(a, o)), e.superRefine = (a) => e.check(Yg(a)), e.overwrite = (a) => e.check(xt(a)), e.optional = () => qo(e), e.nullable = () => Ho(e), e.nullish = () => qo(Ho(e)), e.nonoptional = (a) => Gg(e, a), e.array = () => Ag(e), e.or = (a) => Ng([e, a]), e.and = (a) => Ig(e, a), e.transform = (a) => Jo(e, Eg(a)), e.default = (a) => Rg(e, a), e.prefault = (a) => Vg(e, a), e.catch = (a) => Zg(e, a), e.pipe = (a) => Jo(e, a), e.readonly = () => qg(e), e.describe = (a) => {
  const o = e.clone();
  return Nt.add(o, { description: a }), o;
}, Object.defineProperty(e, "description", {
  get() {
    return Nt.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...a) => {
  if (a.length === 0)
    return Nt.get(e);
  const o = e.clone();
  return Nt.add(o, a[0]), o;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), Ar = /* @__PURE__ */ v("_ZodString", (e, t) => {
  qa.init(e, t), se.init(e, t);
  const a = e._zod.bag;
  e.format = a.format ?? null, e.minLength = a.minimum ?? null, e.maxLength = a.maximum ?? null, e.regex = (...o) => e.check($_(...o)), e.includes = (...o) => e.check(C_(...o)), e.startsWith = (...o) => e.check(S_(...o)), e.endsWith = (...o) => e.check(z_(...o)), e.min = (...o) => e.check(Zt(...o)), e.max = (...o) => e.check(Sr(...o)), e.length = (...o) => e.check(zr(...o)), e.nonempty = (...o) => e.check(Zt(1, ...o)), e.lowercase = (o) => e.check(w_(o)), e.uppercase = (o) => e.check(x_(o)), e.trim = () => e.check(P_()), e.normalize = (...o) => e.check(A_(...o)), e.toLowerCase = () => e.check(M_()), e.toUpperCase = () => e.check(D_());
}), ig = /* @__PURE__ */ v("ZodString", (e, t) => {
  qa.init(e, t), Ar.init(e, t), e.email = (a) => e.check(Hd(lg, a)), e.url = (a) => e.check(e_(sg, a)), e.jwt = (a) => e.check(b_(wg, a)), e.emoji = (a) => e.check(t_(cg, a)), e.guid = (a) => e.check(Go(Wo, a)), e.uuid = (a) => e.check(Jd(Ot, a)), e.uuidv4 = (a) => e.check(Yd(Ot, a)), e.uuidv6 = (a) => e.check(Qd(Ot, a)), e.uuidv7 = (a) => e.check(Xd(Ot, a)), e.nanoid = (a) => e.check(a_(ug, a)), e.guid = (a) => e.check(Go(Wo, a)), e.cuid = (a) => e.check(o_(dg, a)), e.cuid2 = (a) => e.check(n_(_g, a)), e.ulid = (a) => e.check(r_(gg, a)), e.base64 = (a) => e.check(__(vg, a)), e.base64url = (a) => e.check(g_(kg, a)), e.xid = (a) => e.check(i_(fg, a)), e.ksuid = (a) => e.check(l_(bg, a)), e.ipv4 = (a) => e.check(s_(hg, a)), e.ipv6 = (a) => e.check(c_(mg, a)), e.cidrv4 = (a) => e.check(u_(pg, a)), e.cidrv6 = (a) => e.check(d_(yg, a)), e.e164 = (a) => e.check(f_($g, a)), e.datetime = (a) => e.check(R_(a)), e.date = (a) => e.check(V_(a)), e.time = (a) => e.check(U_(a)), e.duration = (a) => e.check(W_(a));
});
function Zo(e) {
  return qd(ig, e);
}
const Y = /* @__PURE__ */ v("ZodStringFormat", (e, t) => {
  J.init(e, t), Ar.init(e, t);
}), lg = /* @__PURE__ */ v("ZodEmail", (e, t) => {
  rd.init(e, t), Y.init(e, t);
}), Wo = /* @__PURE__ */ v("ZodGUID", (e, t) => {
  od.init(e, t), Y.init(e, t);
}), Ot = /* @__PURE__ */ v("ZodUUID", (e, t) => {
  nd.init(e, t), Y.init(e, t);
}), sg = /* @__PURE__ */ v("ZodURL", (e, t) => {
  id.init(e, t), Y.init(e, t);
}), cg = /* @__PURE__ */ v("ZodEmoji", (e, t) => {
  ld.init(e, t), Y.init(e, t);
}), ug = /* @__PURE__ */ v("ZodNanoID", (e, t) => {
  sd.init(e, t), Y.init(e, t);
}), dg = /* @__PURE__ */ v("ZodCUID", (e, t) => {
  cd.init(e, t), Y.init(e, t);
}), _g = /* @__PURE__ */ v("ZodCUID2", (e, t) => {
  ud.init(e, t), Y.init(e, t);
}), gg = /* @__PURE__ */ v("ZodULID", (e, t) => {
  dd.init(e, t), Y.init(e, t);
}), fg = /* @__PURE__ */ v("ZodXID", (e, t) => {
  _d.init(e, t), Y.init(e, t);
}), bg = /* @__PURE__ */ v("ZodKSUID", (e, t) => {
  gd.init(e, t), Y.init(e, t);
}), hg = /* @__PURE__ */ v("ZodIPv4", (e, t) => {
  pd.init(e, t), Y.init(e, t);
}), mg = /* @__PURE__ */ v("ZodIPv6", (e, t) => {
  yd.init(e, t), Y.init(e, t);
}), pg = /* @__PURE__ */ v("ZodCIDRv4", (e, t) => {
  vd.init(e, t), Y.init(e, t);
}), yg = /* @__PURE__ */ v("ZodCIDRv6", (e, t) => {
  kd.init(e, t), Y.init(e, t);
}), vg = /* @__PURE__ */ v("ZodBase64", (e, t) => {
  $d.init(e, t), Y.init(e, t);
}), kg = /* @__PURE__ */ v("ZodBase64URL", (e, t) => {
  xd.init(e, t), Y.init(e, t);
}), $g = /* @__PURE__ */ v("ZodE164", (e, t) => {
  Cd.init(e, t), Y.init(e, t);
}), wg = /* @__PURE__ */ v("ZodJWT", (e, t) => {
  zd.init(e, t), Y.init(e, t);
}), xg = /* @__PURE__ */ v("ZodUnknown", (e, t) => {
  Ad.init(e, t), se.init(e, t);
});
function Ko() {
  return v_(xg);
}
const Cg = /* @__PURE__ */ v("ZodNever", (e, t) => {
  Pd.init(e, t), se.init(e, t);
});
function Sg(e) {
  return k_(Cg, e);
}
const zg = /* @__PURE__ */ v("ZodArray", (e, t) => {
  Md.init(e, t), se.init(e, t), e.element = t.element, e.min = (a, o) => e.check(Zt(a, o)), e.nonempty = (a) => e.check(Zt(1, a)), e.max = (a, o) => e.check(Sr(a, o)), e.length = (a, o) => e.check(zr(a, o)), e.unwrap = () => e.element;
});
function Ag(e, t) {
  return N_(zg, e, t);
}
const Pg = /* @__PURE__ */ v("ZodObject", (e, t) => {
  Nd.init(e, t), se.init(e, t), K(e, "shape", () => t.shape), e.keyof = () => jg(Object.keys(e._zod.def.shape)), e.catchall = (a) => e.clone({ ...e._zod.def, catchall: a }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Ko() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Ko() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Sg() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (a) => au(e, a), e.safeExtend = (a) => ou(e, a), e.merge = (a) => nu(e, a), e.pick = (a) => eu(e, a), e.omit = (a) => tu(e, a), e.partial = (...a) => ru(Pr, e, a[0]), e.required = (...a) => iu(Mr, e, a[0]);
});
function Mg(e, t) {
  const a = {
    type: "object",
    get shape() {
      return Re(this, "shape", e ? Jc(e) : {}), this.shape;
    },
    ...j(t)
  };
  return new Pg(a);
}
const Dg = /* @__PURE__ */ v("ZodUnion", (e, t) => {
  Od.init(e, t), se.init(e, t), e.options = t.options;
});
function Ng(e, t) {
  return new Dg({
    type: "union",
    options: e,
    ...j(t)
  });
}
const Og = /* @__PURE__ */ v("ZodIntersection", (e, t) => {
  Id.init(e, t), se.init(e, t);
});
function Ig(e, t) {
  return new Og({
    type: "intersection",
    left: e,
    right: t
  });
}
const Aa = /* @__PURE__ */ v("ZodEnum", (e, t) => {
  jd.init(e, t), se.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const a = new Set(Object.keys(t.entries));
  e.extract = (o, n) => {
    const r = {};
    for (const i of o)
      if (a.has(i))
        r[i] = t.entries[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new Aa({
      ...t,
      checks: [],
      ...j(n),
      entries: r
    });
  }, e.exclude = (o, n) => {
    const r = { ...t.entries };
    for (const i of o)
      if (a.has(i))
        delete r[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new Aa({
      ...t,
      checks: [],
      ...j(n),
      entries: r
    });
  };
});
function jg(e, t) {
  const a = Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, o])) : e;
  return new Aa({
    type: "enum",
    entries: a,
    ...j(t)
  });
}
const Lg = /* @__PURE__ */ v("ZodTransform", (e, t) => {
  Ld.init(e, t), se.init(e, t), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      throw new fr(e.constructor.name);
    a.addIssue = (r) => {
      if (typeof r == "string")
        a.issues.push(pt(r, a.value, t));
      else {
        const i = r;
        i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = a.value), i.inst ?? (i.inst = e), a.issues.push(pt(i));
      }
    };
    const n = t.transform(a.value, a);
    return n instanceof Promise ? n.then((r) => (a.value = r, a)) : (a.value = n, a);
  };
});
function Eg(e) {
  return new Lg({
    type: "transform",
    transform: e
  });
}
const Pr = /* @__PURE__ */ v("ZodOptional", (e, t) => {
  Ed.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function qo(e) {
  return new Pr({
    type: "optional",
    innerType: e
  });
}
const Bg = /* @__PURE__ */ v("ZodNullable", (e, t) => {
  Bd.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Ho(e) {
  return new Bg({
    type: "nullable",
    innerType: e
  });
}
const Tg = /* @__PURE__ */ v("ZodDefault", (e, t) => {
  Td.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Rg(e, t) {
  return new Tg({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : mr(t);
    }
  });
}
const Fg = /* @__PURE__ */ v("ZodPrefault", (e, t) => {
  Rd.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Vg(e, t) {
  return new Fg({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : mr(t);
    }
  });
}
const Mr = /* @__PURE__ */ v("ZodNonOptional", (e, t) => {
  Fd.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Gg(e, t) {
  return new Mr({
    type: "nonoptional",
    innerType: e,
    ...j(t)
  });
}
const Ug = /* @__PURE__ */ v("ZodCatch", (e, t) => {
  Vd.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Zg(e, t) {
  return new Ug({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Wg = /* @__PURE__ */ v("ZodPipe", (e, t) => {
  Gd.init(e, t), se.init(e, t), e.in = t.in, e.out = t.out;
});
function Jo(e, t) {
  return new Wg({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Kg = /* @__PURE__ */ v("ZodReadonly", (e, t) => {
  Ud.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function qg(e) {
  return new Kg({
    type: "readonly",
    innerType: e
  });
}
const Hg = /* @__PURE__ */ v("ZodCustom", (e, t) => {
  Zd.init(e, t), se.init(e, t);
});
function Jg(e, t = {}) {
  return O_(Hg, e, t);
}
function Yg(e) {
  return I_(e);
}
const Wt = "9", Qg = Mg({
  reasonId: Zo({ error: "reasons_for_cancellation_needed" }),
  comment: Zo().optional()
}).refine((e) => !(e.reasonId === Wt && !e.comment), {
  error: "reasons_other_comment_needed",
  path: ["comment"]
}).refine((e) => !(e.reasonId === Wt && e.comment && e.comment.length > 255), {
  error: "common:error.characters_max_limit",
  path: ["comment"]
});
function Xg({ onClickContinue: e, cancellationReasons: t, conversation: a, user: o }) {
  const { t: n } = Ra(["conversations", "common"]), [r, i] = xe(!1), [l, c] = xe(!1), s = async (h) => {
    try {
      i(!0), await Hr(a.id, h.reasonId, h.comment);
      const p = t.find(($) => $.id.toString() === h.reasonId);
      zL(
        {
          exchange_status: "cancelled",
          cancellation_reason: p?.name,
          exchange_type: a.exchanges.length === 1 ? "guest_point_exchange" : "reciprocal_exchange",
          collection: o.is_he_collection
        },
        { eventCallback: () => e(), eventTimeout: 2e3 }
      );
    } catch (p) {
      throw c(!0), p;
    } finally {
      i(!1);
    }
  }, u = bi({
    resolver: B_(Qg)
  }), { watch: d } = u, g = hn(
    () => t.map((h) => ({
      id: h.id.toString(),
      name: n(`reasons_for_cancellation_${h.name}`)
    })),
    [t, n]
  ), b = d("reasonId") === Wt;
  return {
    isLoading: r,
    requestHasError: l,
    onSubmitCancellationForm: s,
    cancellationReasonsRadioItems: g,
    displayCommentTextarea: b,
    cancellationForm: u
  };
}
function ef({ onClickContinue: e, cancellationReasons: t, conversation: a, user: o }) {
  const { url: n } = Va(`/conversations/${a.id}`), { t: r } = Ra(["conversations", "common"]), { isDesktop: i } = gr(), {
    isLoading: l,
    requestHasError: c,
    onSubmitCancellationForm: s,
    cancellationReasonsRadioItems: u,
    displayCommentTextarea: d,
    cancellationForm: {
      control: g,
      handleSubmit: b,
      setValue: h,
      formState: { errors: p }
    }
  } = Xg({ onClickContinue: e, cancellationReasons: t, conversation: a, user: o });
  return /* @__PURE__ */ R(ur, { children: [
    /* @__PURE__ */ y(Vt, { size: 6, children: /* @__PURE__ */ R(tt, { isFullHeight: !0, justifyContent: "center", alignItems: "stretch", direction: "column", children: [
      /* @__PURE__ */ y(jn, { level: 2, children: r("cancellation-page.reason_step.title") }),
      /* @__PURE__ */ y("form", { onSubmit: b(s), children: /* @__PURE__ */ R(tt, { isFullWidth: !0, flexGrow: !0, alignItems: "stretch", direction: "column", children: [
        /* @__PURE__ */ y(
          no,
          {
            name: "reasonId",
            control: g,
            render: ({ field: $ }) => /* @__PURE__ */ y(
              wa,
              {
                ...$,
                errorMessage: p.reasonId?.message ? r(p.reasonId.message) : void 0,
                onChange: (M) => {
                  M !== Wt && d && h("comment", ""), $.onChange(M);
                },
                label: r("cancellation-page.reason_step.checboxes_label"),
                children: u.map((M) => /* @__PURE__ */ y(wa.Item, { value: M.id, id: M.id, label: M.name }, M.id))
              }
            )
          }
        ),
        d && /* @__PURE__ */ y(
          no,
          {
            name: "comment",
            control: g,
            render: ({ field: $ }) => /* @__PURE__ */ y(
              uc,
              {
                placeholder: r("cancellation-page.reason_step.comment_placeholder"),
                id: "reason-comment",
                status: p.comment?.message ? "error" : void 0,
                message: p.comment?.message ? r(p.comment?.message, { limit: 255 }) : void 0,
                maxLength: 255,
                ...$
              }
            )
          }
        ),
        c && !l && /* @__PURE__ */ R(mc, { status: "error", hasIcon: !0, children: [
          /* @__PURE__ */ y("span", { style: { fontWeight: "bold" }, children: r("common:errors.unable_to_submit.title") }),
          /* @__PURE__ */ y(bt, { children: r("common:errors.unable_to_submit.subtitle") })
        ] }),
        /* @__PURE__ */ R(In, { flexGrowButtons: !0, children: [
          /* @__PURE__ */ y(nt, { isLoading: l, disabled: l, color: "destructive", type: "submit", children: r("cancellation-page.cancel-exchange") }),
          /* @__PURE__ */ y(nt, { disabled: l, color: "tertiary", href: n, children: r("cancellation-page.keep-exchange") })
        ] })
      ] }) })
    ] }) }),
    i && /* @__PURE__ */ y(Vt, { size: 6, children: /* @__PURE__ */ y(tt, { isFullHeight: !0, justifyContent: "center", alignItems: "stretch", direction: "column", children: /* @__PURE__ */ y(
      cr,
      {
        width: "full",
        src: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/cancellation/cancellation-regular-desktop.svg",
        alt: "cancellation-warning"
      }
    ) }) })
  ] });
}
function tf({ onClickContinue: e, conversation: t }) {
  const { t: a } = Ra("conversations"), { isTablet: o, isMobile: n, isDesktop: r } = gr(), { url: i } = Va(`/conversations/${t.id}`), l = /* @__PURE__ */ R(In, { flexGrowButtons: !0, children: [
    /* @__PURE__ */ y(nt, { onClick: e, children: a("cancellation-page.continue-cancellation") }),
    /* @__PURE__ */ y(nt, { color: "tertiary", href: i, children: a("cancellation-page.keep-exchange") })
  ] });
  return /* @__PURE__ */ R(ur, { children: [
    /* @__PURE__ */ y(Vt, { size: 6, children: /* @__PURE__ */ R(tt, { isFullHeight: !0, justifyContent: "center", alignItems: "stretch", direction: "column", children: [
      /* @__PURE__ */ y(jn, { level: 2, children: a("cancellation-page.cancel-exchange") }),
      /* @__PURE__ */ y(bt, { children: a("cancellation-page.warning-step.first-warning") }),
      /* @__PURE__ */ y(bt, { isBold: !0, children: a("cancellation-page.warning-step.second-warning") }),
      r && l
    ] }) }),
    /* @__PURE__ */ y(Vt, { size: 6, children: /* @__PURE__ */ R(tt, { isFullHeight: !0, justifyContent: "center", alignItems: "stretch", direction: "column", children: [
      /* @__PURE__ */ y(
        cr,
        {
          width: "full",
          src: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/cancellation/cancellation-regular-desktop.svg",
          alt: "cancellation-warning"
        }
      ),
      (o || n) && l
    ] }) })
  ] });
}
const Dr = "https://www.homeexchange.com/blog/calculate-the-carbon-footprint-of-your-trip/", af = {
  fr: "https://www.homeexchange.fr/blog/calculez-lempreinte-carbone-de-votre-voyage/",
  es: "https://es.homeexchange.com/es/blog/calcula-la-huella-de-carbono-de-tus-viajes/",
  en: Dr
};
function LL({
  className: e,
  title: t,
  description: a,
  locale: o,
  ctaText: n,
  onClickCTA: r
}) {
  return /* @__PURE__ */ y(
    kc,
    {
      className: e,
      color: "info",
      title: t,
      description: a,
      image: {
        alt: "transportation-banner-logo",
        imageSrc: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/transportation/transportation-banner-logo.svg",
        imageSrcMobile: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/transportation/transportation-banner-logo-small.svg"
      },
      cta: {
        color: "eco-green",
        text: n,
        onClick: async () => {
          await r(), window.open(af[o] || Dr, "_blank");
        }
      }
    }
  );
}
const of = (e, t, a, o) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null, page_data: null, user_data: null });
  const { eventCallback: n, ...r } = {}, i = (l) => {
    n && typeof n == "function" && l.startsWith("GTM-") && n(l);
  };
  window.dataLayer.push({
    event: "data_layer_init",
    event_data: {
      collection: a,
      method: null,
      text: null
    },
    page_data: {
      location: window.location.href,
      referrer: document.referrer,
      title: document.title,
      language: navigator.language
    },
    user_data: {
      login_status: "logged",
      uid: e,
      profile: t
    },
    eventCallback: i,
    ...r
  });
}, Nr = (e, t, a) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null });
  const { eventCallback: o, ...n } = a || {}, r = (i) => {
    o && typeof o == "function" && i.startsWith("GTM-") && o(i);
  };
  window.dataLayer.push({
    event: e,
    event_data: t,
    ...n,
    eventCallback: r
  }), !window.google_tag_manager && a?.eventCallback && typeof a.eventCallback == "function" && a.eventCallback();
}, nf = (e, t, a) => {
  Nr("funnel_progress", {
    funnel_name: e,
    funnel_step: t,
    ...a
  });
}, rf = (e) => e.subscriptionEndOn ? e.isHeCollection ? "member_collection" : new Date(e.subscriptionEndOn) < /* @__PURE__ */ new Date() ? "expired" : "member_regular" : "lead", I = (e) => typeof e == "string", ut = () => {
  let e, t;
  const a = new Promise((o, n) => {
    e = o, t = n;
  });
  return a.resolve = e, a.reject = t, a;
}, Yo = (e) => e == null ? "" : "" + e, lf = (e, t, a) => {
  e.forEach((o) => {
    t[o] && (a[o] = t[o]);
  });
}, sf = /###/g, Qo = (e) => e && e.indexOf("###") > -1 ? e.replace(sf, ".") : e, Xo = (e) => !e || I(e), ft = (e, t, a) => {
  const o = I(t) ? t.split(".") : t;
  let n = 0;
  for (; n < o.length - 1; ) {
    if (Xo(e)) return {};
    const r = Qo(o[n]);
    !e[r] && a && (e[r] = new a()), Object.prototype.hasOwnProperty.call(e, r) ? e = e[r] : e = {}, ++n;
  }
  return Xo(e) ? {} : {
    obj: e,
    k: Qo(o[n])
  };
}, en = (e, t, a) => {
  const {
    obj: o,
    k: n
  } = ft(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[n] = a;
    return;
  }
  let r = t[t.length - 1], i = t.slice(0, t.length - 1), l = ft(e, i, Object);
  for (; l.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), l = ft(e, i, Object), l?.obj && typeof l.obj[`${l.k}.${r}`] < "u" && (l.obj = void 0);
  l.obj[`${l.k}.${r}`] = a;
}, cf = (e, t, a, o) => {
  const {
    obj: n,
    k: r
  } = ft(e, t, Object);
  n[r] = n[r] || [], n[r].push(a);
}, Kt = (e, t) => {
  const {
    obj: a,
    k: o
  } = ft(e, t);
  if (a && Object.prototype.hasOwnProperty.call(a, o))
    return a[o];
}, uf = (e, t, a) => {
  const o = Kt(e, a);
  return o !== void 0 ? o : Kt(t, a);
}, Or = (e, t, a) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? I(e[o]) || e[o] instanceof String || I(t[o]) || t[o] instanceof String ? a && (e[o] = t[o]) : Or(e[o], t[o], a) : e[o] = t[o]);
  return e;
}, Xe = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var df = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const _f = (e) => I(e) ? e.replace(/[&<>"'\/]/g, (t) => df[t]) : e;
class gf {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const a = this.regExpMap.get(t);
    if (a !== void 0)
      return a;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
}
const ff = [" ", ",", "?", "!", ";"], bf = new gf(20), hf = (e, t, a) => {
  t = t || "", a = a || "";
  const o = ff.filter((i) => t.indexOf(i) < 0 && a.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const n = bf.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !n.test(e);
  if (!r) {
    const i = e.indexOf(a);
    i > 0 && !n.test(e.substring(0, i)) && (r = !0);
  }
  return r;
}, Pa = (e, t, a = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(a);
  let n = e;
  for (let r = 0; r < o.length; ) {
    if (!n || typeof n != "object")
      return;
    let i, l = "";
    for (let c = r; c < o.length; ++c)
      if (c !== r && (l += a), l += o[c], i = n[l], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && c < o.length - 1)
          continue;
        r += c - r + 1;
        break;
      }
    n = i;
  }
  return n;
}, yt = (e) => e?.replace("_", "-"), mf = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class qt {
  constructor(t, a = {}) {
    this.init(t, a);
  }
  init(t, a = {}) {
    this.prefix = a.prefix || "i18next:", this.logger = t || mf, this.options = a, this.debug = a.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, a, o, n) {
    return n && !this.debug ? null : (I(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[a](t));
  }
  create(t) {
    return new qt(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new qt(this.logger, t);
  }
}
var Se = new qt();
class ia {
  constructor() {
    this.observers = {};
  }
  on(t, a) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const n = this.observers[o].get(a) || 0;
      this.observers[o].set(a, n + 1);
    }), this;
  }
  off(t, a) {
    if (this.observers[t]) {
      if (!a) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(a);
    }
  }
  emit(t, ...a) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([n, r]) => {
      for (let i = 0; i < r; i++)
        n(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([n, r]) => {
      for (let i = 0; i < r; i++)
        n.apply(n, [t, ...a]);
    });
  }
}
class tn extends ia {
  constructor(t, a = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const a = this.options.ns.indexOf(t);
    a > -1 && this.options.ns.splice(a, 1);
  }
  getResource(t, a, o, n = {}) {
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, i = n.ignoreJSONStructure !== void 0 ? n.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let l;
    t.indexOf(".") > -1 ? l = t.split(".") : (l = [t, a], o && (Array.isArray(o) ? l.push(...o) : I(o) && r ? l.push(...o.split(r)) : l.push(o)));
    const c = Kt(this.data, l);
    return !c && !a && !o && t.indexOf(".") > -1 && (t = l[0], a = l[1], o = l.slice(2).join(".")), c || !i || !I(o) ? c : Pa(this.data?.[t]?.[a], o, r);
  }
  addResource(t, a, o, n, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let l = [t, a];
    o && (l = l.concat(i ? o.split(i) : o)), t.indexOf(".") > -1 && (l = t.split("."), n = a, a = l[1]), this.addNamespaces(a), en(this.data, l, n), r.silent || this.emit("added", t, a, o, n);
  }
  addResources(t, a, o, n = {
    silent: !1
  }) {
    for (const r in o)
      (I(o[r]) || Array.isArray(o[r])) && this.addResource(t, a, r, o[r], {
        silent: !0
      });
    n.silent || this.emit("added", t, a, o);
  }
  addResourceBundle(t, a, o, n, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let l = [t, a];
    t.indexOf(".") > -1 && (l = t.split("."), n = o, o = a, a = l[1]), this.addNamespaces(a);
    let c = Kt(this.data, l) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), n ? Or(c, o, r) : c = {
      ...c,
      ...o
    }, en(this.data, l, c), i.silent || this.emit("added", t, a, o);
  }
  removeResourceBundle(t, a) {
    this.hasResourceBundle(t, a) && delete this.data[t][a], this.removeNamespaces(a), this.emit("removed", t, a);
  }
  hasResourceBundle(t, a) {
    return this.getResource(t, a) !== void 0;
  }
  getResourceBundle(t, a) {
    return a || (a = this.options.defaultNS), this.getResource(t, a);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const a = this.getDataByLanguage(t);
    return !!(a && Object.keys(a) || []).find((n) => a[n] && Object.keys(a[n]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Ir = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, a, o, n) {
    return e.forEach((r) => {
      t = this.processors[r]?.process(t, a, o, n) ?? t;
    }), t;
  }
};
const jr = Symbol("i18next/PATH_KEY");
function pf() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let a;
  return t.get = (o, n) => (a?.revoke?.(), n === jr ? e : (e.push(n), a = Proxy.revocable(o, t), a.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function Ma(e, t) {
  const {
    [jr]: a
  } = e(pf());
  return a.join(t?.keySeparator ?? ".");
}
const an = {}, on = (e) => !I(e) && typeof e != "boolean" && typeof e != "number";
class Ht extends ia {
  constructor(t, a = {}) {
    super(), lf(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Se.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, a = {
    interpolation: {}
  }) {
    const o = {
      ...a
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, a) {
    let o = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const n = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let r = a.ns || this.options.defaultNS || [];
    const i = o && t.indexOf(o) > -1, l = !this.options.userDefinedKeySeparator && !a.keySeparator && !this.options.userDefinedNsSeparator && !a.nsSeparator && !hf(t, o, n);
    if (i && !l) {
      const c = t.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: t,
          namespaces: I(r) ? [r] : r
        };
      const s = t.split(o);
      (o !== n || o === n && this.options.ns.indexOf(s[0]) > -1) && (r = s.shift()), t = s.join(n);
    }
    return {
      key: t,
      namespaces: I(r) ? [r] : r
    };
  }
  translate(t, a, o) {
    let n = typeof a == "object" ? {
      ...a
    } : a;
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    typeof t == "function" && (t = Ma(t, {
      ...this.options,
      ...n
    })), Array.isArray(t) || (t = [String(t)]);
    const r = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: l,
      namespaces: c
    } = this.extractFromKey(t[t.length - 1], n), s = c[c.length - 1];
    let u = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = n.lng || this.language, g = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return g ? r ? {
        res: `${s}${u}${l}`,
        usedKey: l,
        exactUsedKey: l,
        usedLng: d,
        usedNS: s,
        usedParams: this.getUsedParamsDetails(n)
      } : `${s}${u}${l}` : r ? {
        res: l,
        usedKey: l,
        exactUsedKey: l,
        usedLng: d,
        usedNS: s,
        usedParams: this.getUsedParamsDetails(n)
      } : l;
    const b = this.resolve(t, n);
    let h = b?.res;
    const p = b?.usedKey || l, $ = b?.exactUsedKey || l, M = ["[object Number]", "[object Function]", "[object RegExp]"], k = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, P = !this.i18nFormat || this.i18nFormat.handleAsObject, A = n.count !== void 0 && !I(n.count), N = Ht.hasDefaultValue(n), F = A ? this.pluralResolver.getSuffix(d, n.count, n) : "", U = n.ordinal && A ? this.pluralResolver.getSuffix(d, n.count, {
      ordinal: !1
    }) : "", ae = A && !n.ordinal && n.count === 0, Q = ae && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${F}`] || n[`defaultValue${U}`] || n.defaultValue;
    let X = h;
    P && !h && N && (X = Q);
    const ce = on(X), B = Object.prototype.toString.apply(X);
    if (P && X && ce && M.indexOf(B) < 0 && !(I(k) && Array.isArray(X))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const E = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, X, {
          ...n,
          ns: c
        }) : `key '${l} (${this.language})' returned an object instead of string.`;
        return r ? (b.res = E, b.usedParams = this.getUsedParamsDetails(n), b) : E;
      }
      if (i) {
        const E = Array.isArray(X), T = E ? [] : {}, Z = E ? $ : p;
        for (const q in X)
          if (Object.prototype.hasOwnProperty.call(X, q)) {
            const oe = `${Z}${i}${q}`;
            N && !h ? T[q] = this.translate(oe, {
              ...n,
              defaultValue: on(Q) ? Q[q] : void 0,
              joinArrays: !1,
              ns: c
            }) : T[q] = this.translate(oe, {
              ...n,
              joinArrays: !1,
              ns: c
            }), T[q] === oe && (T[q] = X[q]);
          }
        h = T;
      }
    } else if (P && I(k) && Array.isArray(h))
      h = h.join(k), h && (h = this.extendTranslation(h, t, n, o));
    else {
      let E = !1, T = !1;
      !this.isValidLookup(h) && N && (E = !0, h = Q), this.isValidLookup(h) || (T = !0, h = l);
      const q = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && T ? void 0 : h, oe = N && Q !== h && this.options.updateMissing;
      if (T || E || oe) {
        if (this.logger.log(oe ? "updateKey" : "missingKey", d, s, l, oe ? Q : h), i) {
          const ue = this.resolve(l, {
            ...n,
            keySeparator: !1
          });
          ue && ue.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let ve = [];
        const ke = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && ke && ke[0])
          for (let ue = 0; ue < ke.length; ue++)
            ve.push(ke[ue]);
        else this.options.saveMissingTo === "all" ? ve = this.languageUtils.toResolveHierarchy(n.lng || this.language) : ve.push(n.lng || this.language);
        const Ve = (ue, Ae, Le) => {
          const Ct = N && Le !== h ? Le : q;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(ue, s, Ae, Ct, oe, n) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(ue, s, Ae, Ct, oe, n), this.emit("missingKey", ue, s, Ae, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && A ? ve.forEach((ue) => {
          const Ae = this.pluralResolver.getSuffixes(ue, n);
          ae && n[`defaultValue${this.options.pluralSeparator}zero`] && Ae.indexOf(`${this.options.pluralSeparator}zero`) < 0 && Ae.push(`${this.options.pluralSeparator}zero`), Ae.forEach((Le) => {
            Ve([ue], l + Le, n[`defaultValue${Le}`] || Q);
          });
        }) : Ve(ve, l, Q));
      }
      h = this.extendTranslation(h, t, n, b, o), T && h === l && this.options.appendNamespaceToMissingKey && (h = `${s}${u}${l}`), (T || E) && this.options.parseMissingKeyHandler && (h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${s}${u}${l}` : l, E ? h : void 0, n));
    }
    return r ? (b.res = h, b.usedParams = this.getUsedParamsDetails(n), b) : h;
  }
  extendTranslation(t, a, o, n, r) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || n.usedLng, n.usedNS, n.usedKey, {
        resolved: n
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const c = I(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let s;
      if (c) {
        const d = t.match(this.interpolator.nestingRegexp);
        s = d && d.length;
      }
      let u = o.replace && !I(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || n.usedLng, o), c) {
        const d = t.match(this.interpolator.nestingRegexp), g = d && d.length;
        s < g && (o.nest = !1);
      }
      !o.lng && n && n.res && (o.lng = this.language || n.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => r?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${a[0]}`), null) : this.translate(...d, a), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, l = I(i) ? [i] : i;
    return t != null && l?.length && o.applyPostProcessor !== !1 && (t = Ir.handle(l, t, a, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...n,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, a = {}) {
    let o, n, r, i, l;
    return I(t) && (t = [t]), t.forEach((c) => {
      if (this.isValidLookup(o)) return;
      const s = this.extractFromKey(c, a), u = s.key;
      n = u;
      let d = s.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const g = a.count !== void 0 && !I(a.count), b = g && !a.ordinal && a.count === 0, h = a.context !== void 0 && (I(a.context) || typeof a.context == "number") && a.context !== "", p = a.lngs ? a.lngs : this.languageUtils.toResolveHierarchy(a.lng || this.language, a.fallbackLng);
      d.forEach(($) => {
        this.isValidLookup(o) || (l = $, !an[`${p[0]}-${$}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(l) && (an[`${p[0]}-${$}`] = !0, this.logger.warn(`key "${n}" for languages "${p.join(", ")}" won't get resolved as namespace "${l}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p.forEach((M) => {
          if (this.isValidLookup(o)) return;
          i = M;
          const k = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(k, u, M, $, a);
          else {
            let A;
            g && (A = this.pluralResolver.getSuffix(M, a.count, a));
            const N = `${this.options.pluralSeparator}zero`, F = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (g && (a.ordinal && A.indexOf(F) === 0 && k.push(u + A.replace(F, this.options.pluralSeparator)), k.push(u + A), b && k.push(u + N)), h) {
              const U = `${u}${this.options.contextSeparator || "_"}${a.context}`;
              k.push(U), g && (a.ordinal && A.indexOf(F) === 0 && k.push(U + A.replace(F, this.options.pluralSeparator)), k.push(U + A), b && k.push(U + N));
            }
          }
          let P;
          for (; P = k.pop(); )
            this.isValidLookup(o) || (r = P, o = this.getResource(M, $, P, a));
        }));
      });
    }), {
      res: o,
      usedKey: n,
      exactUsedKey: r,
      usedLng: i,
      usedNS: l
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, a, o, n = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, a, o, n) : this.resourceStore.getResource(t, a, o, n);
  }
  getUsedParamsDetails(t = {}) {
    const a = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !I(t.replace);
    let n = o ? t.replace : t;
    if (o && typeof t.count < "u" && (n.count = t.count), this.options.interpolation.defaultVariables && (n = {
      ...this.options.interpolation.defaultVariables,
      ...n
    }), !o) {
      n = {
        ...n
      };
      for (const r of a)
        delete n[r];
    }
    return n;
  }
  static hasDefaultValue(t) {
    const a = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && a === o.substring(0, a.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class nn {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Se.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = yt(t), !t || t.indexOf("-") < 0) return null;
    const a = t.split("-");
    return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = yt(t), !t || t.indexOf("-") < 0) return t;
    const a = t.split("-");
    return this.formatLanguageCode(a[0]);
  }
  formatLanguageCode(t) {
    if (I(t) && t.indexOf("-") > -1) {
      let a;
      try {
        a = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return a && this.options.lowerCaseLng && (a = a.toLowerCase()), a || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let a;
    return t.forEach((o) => {
      if (a) return;
      const n = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(n)) && (a = n);
    }), !a && this.options.supportedLngs && t.forEach((o) => {
      if (a) return;
      const n = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(n)) return a = n;
      const r = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(r)) return a = r;
      a = this.options.supportedLngs.find((i) => {
        if (i === r) return i;
        if (!(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
  }
  getFallbackCodes(t, a) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(a)), I(t) && (t = [t]), Array.isArray(t)) return t;
    if (!a) return t.default || [];
    let o = t[a];
    return o || (o = t[this.getScriptPartFromCode(a)]), o || (o = t[this.formatLanguageCode(a)]), o || (o = t[this.getLanguagePartFromCode(a)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, a) {
    const o = this.getFallbackCodes((a === !1 ? [] : a) || this.options.fallbackLng || [], t), n = [], r = (i) => {
      i && (this.isSupportedCode(i) ? n.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return I(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(t))) : I(t) && r(this.formatLanguageCode(t)), o.forEach((i) => {
      n.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), n;
  }
}
const rn = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, ln = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class yf {
  constructor(t, a = {}) {
    this.languageUtils = t, this.options = a, this.logger = Se.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, a) {
    this.rules[t] = a;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, a = {}) {
    const o = yt(t === "dev" ? "en" : t), n = a.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: o,
      type: n
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: n
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), ln;
      if (!t.match(/-|_/)) return ln;
      const c = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(c, a);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, a, o = {}) {
    return this.getSuffixes(t, o).map((n) => `${a}${n}`);
  }
  getSuffixes(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o ? o.resolvedOptions().pluralCategories.sort((n, r) => rn[n] - rn[r]).map((n) => `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${n}`) : [];
  }
  getSuffix(t, a, o = {}) {
    const n = this.getRule(t, o);
    return n ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${n.select(a)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", a, o));
  }
}
const sn = (e, t, a, o = ".", n = !0) => {
  let r = uf(e, t, a);
  return !r && n && I(a) && (r = Pa(e, a, o), r === void 0 && (r = Pa(t, a, o))), r;
}, ma = (e) => e.replace(/\$/g, "$$$$");
class vf {
  constructor(t = {}) {
    this.logger = Se.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((a) => a), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: a,
      escapeValue: o,
      useRawValueToEscape: n,
      prefix: r,
      prefixEscaped: i,
      suffix: l,
      suffixEscaped: c,
      formatSeparator: s,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: g,
      nestingPrefixEscaped: b,
      nestingSuffix: h,
      nestingSuffixEscaped: p,
      nestingOptionsSeparator: $,
      maxReplaces: M,
      alwaysFormat: k
    } = t.interpolation;
    this.escape = a !== void 0 ? a : _f, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = n !== void 0 ? n : !1, this.prefix = r ? Xe(r) : i || "{{", this.suffix = l ? Xe(l) : c || "}}", this.formatSeparator = s || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = g ? Xe(g) : b || Xe("$t("), this.nestingSuffix = h ? Xe(h) : p || Xe(")"), this.nestingOptionsSeparator = $ || ",", this.maxReplaces = M || 1e3, this.alwaysFormat = k !== void 0 ? k : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (a, o) => a?.source === o ? (a.lastIndex = 0, a) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, a, o, n) {
    let r, i, l;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, s = (b) => {
      if (b.indexOf(this.formatSeparator) < 0) {
        const M = sn(a, c, b, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(M, void 0, o, {
          ...n,
          ...a,
          interpolationkey: b
        }) : M;
      }
      const h = b.split(this.formatSeparator), p = h.shift().trim(), $ = h.join(this.formatSeparator).trim();
      return this.format(sn(a, c, p, this.options.keySeparator, this.options.ignoreJSONStructure), $, o, {
        ...n,
        ...a,
        interpolationkey: p
      });
    };
    this.resetRegExp();
    const u = n?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = n?.interpolation?.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (b) => ma(b)
    }, {
      regex: this.regexp,
      safeValue: (b) => this.escapeValue ? ma(this.escape(b)) : ma(b)
    }].forEach((b) => {
      for (l = 0; r = b.regex.exec(t); ) {
        const h = r[1].trim();
        if (i = s(h), i === void 0)
          if (typeof u == "function") {
            const $ = u(t, r, n);
            i = I($) ? $ : "";
          } else if (n && Object.prototype.hasOwnProperty.call(n, h))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${t}`), i = "";
        else !I(i) && !this.useRawValueToEscape && (i = Yo(i));
        const p = b.safeValue(i);
        if (t = t.replace(r[0], p), d ? (b.regex.lastIndex += i.length, b.regex.lastIndex -= r[0].length) : b.regex.lastIndex = 0, l++, l >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, a, o = {}) {
    let n, r, i;
    const l = (c, s) => {
      const u = this.nestingOptionsSeparator;
      if (c.indexOf(u) < 0) return c;
      const d = c.split(new RegExp(`${u}[ ]*{`));
      let g = `{${d[1]}`;
      c = d[0], g = this.interpolate(g, i);
      const b = g.match(/'/g), h = g.match(/"/g);
      ((b?.length ?? 0) % 2 === 0 && !h || h.length % 2 !== 0) && (g = g.replace(/'/g, '"'));
      try {
        i = JSON.parse(g), s && (i = {
          ...s,
          ...i
        });
      } catch (p) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, p), `${c}${u}${g}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, c;
    };
    for (; n = this.nestingRegexp.exec(t); ) {
      let c = [];
      i = {
        ...o
      }, i = i.replace && !I(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const s = /{.*}/.test(n[1]) ? n[1].lastIndexOf("}") + 1 : n[1].indexOf(this.formatSeparator);
      if (s !== -1 && (c = n[1].slice(s).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), n[1] = n[1].slice(0, s)), r = a(l.call(this, n[1].trim(), i), i), r && n[0] === t && !I(r)) return r;
      I(r) || (r = Yo(r)), r || (this.logger.warn(`missed to resolve ${n[1]} for nesting ${t}`), r = ""), c.length && (r = c.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: n[1].trim()
      }), r.trim())), t = t.replace(n[0], r), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const kf = (e) => {
  let t = e.toLowerCase().trim();
  const a = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const n = o[1].substring(0, o[1].length - 1);
    t === "currency" && n.indexOf(":") < 0 ? a.currency || (a.currency = n.trim()) : t === "relativetime" && n.indexOf(":") < 0 ? a.range || (a.range = n.trim()) : n.split(";").forEach((i) => {
      if (i) {
        const [l, ...c] = i.split(":"), s = c.join(":").trim().replace(/^'+|'+$/g, ""), u = l.trim();
        a[u] || (a[u] = s), s === "false" && (a[u] = !1), s === "true" && (a[u] = !0), isNaN(s) || (a[u] = parseInt(s, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: a
  };
}, cn = (e) => {
  const t = {};
  return (a, o, n) => {
    let r = n;
    n && n.interpolationkey && n.formatParams && n.formatParams[n.interpolationkey] && n[n.interpolationkey] && (r = {
      ...r,
      [n.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(r);
    let l = t[i];
    return l || (l = e(yt(o), n), t[i] = l), l(a);
  };
}, $f = (e) => (t, a, o) => e(yt(a), o)(t);
class wf {
  constructor(t = {}) {
    this.logger = Se.create("formatter"), this.options = t, this.init(t);
  }
  init(t, a = {
    interpolation: {}
  }) {
    this.formatSeparator = a.interpolation.formatSeparator || ",";
    const o = a.cacheInBuiltFormats ? cn : $f;
    this.formats = {
      number: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r
        });
        return (l) => i.format(l);
      }),
      currency: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (l) => i.format(l);
      }),
      datetime: o((n, r) => {
        const i = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (l) => i.format(l);
      }),
      relativetime: o((n, r) => {
        const i = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (l) => i.format(l, r.range || "day");
      }),
      list: o((n, r) => {
        const i = new Intl.ListFormat(n, {
          ...r
        });
        return (l) => i.format(l);
      })
    };
  }
  add(t, a) {
    this.formats[t.toLowerCase().trim()] = a;
  }
  addCached(t, a) {
    this.formats[t.toLowerCase().trim()] = cn(a);
  }
  format(t, a, o, n = {}) {
    const r = a.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((l) => l.indexOf(")") > -1)) {
      const l = r.findIndex((c) => c.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, l)].join(this.formatSeparator);
    }
    return r.reduce((l, c) => {
      const {
        formatName: s,
        formatOptions: u
      } = kf(c);
      if (this.formats[s]) {
        let d = l;
        try {
          const g = n?.formatParams?.[n.interpolationkey] || {}, b = g.locale || g.lng || n.locale || n.lng || o;
          d = this.formats[s](l, b, {
            ...u,
            ...n,
            ...g
          });
        } catch (g) {
          this.logger.warn(g);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${s}`);
      return l;
    }, t);
  }
}
const xf = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class Cf extends ia {
  constructor(t, a, o, n = {}) {
    super(), this.backend = t, this.store = a, this.services = o, this.languageUtils = o.languageUtils, this.options = n, this.logger = Se.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = n.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = n.maxRetries >= 0 ? n.maxRetries : 5, this.retryTimeout = n.retryTimeout >= 1 ? n.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, n.backend, n);
  }
  queueLoad(t, a, o, n) {
    const r = {}, i = {}, l = {}, c = {};
    return t.forEach((s) => {
      let u = !0;
      a.forEach((d) => {
        const g = `${s}|${d}`;
        !o.reload && this.store.hasResourceBundle(s, d) ? this.state[g] = 2 : this.state[g] < 0 || (this.state[g] === 1 ? i[g] === void 0 && (i[g] = !0) : (this.state[g] = 1, u = !1, i[g] === void 0 && (i[g] = !0), r[g] === void 0 && (r[g] = !0), c[d] === void 0 && (c[d] = !0)));
      }), u || (l[s] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: n
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(l),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(t, a, o) {
    const n = t.split("|"), r = n[0], i = n[1];
    a && this.emit("failedLoading", r, i, a), !a && o && this.store.addResourceBundle(r, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = a ? -1 : 2, a && o && (this.state[t] = 0);
    const l = {};
    this.queue.forEach((c) => {
      cf(c.loaded, [r], i), xf(c, t), a && c.errors.push(a), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((s) => {
        l[s] || (l[s] = {});
        const u = c.loaded[s];
        u.length && u.forEach((d) => {
          l[s][d] === void 0 && (l[s][d] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", l), this.queue = this.queue.filter((c) => !c.done);
  }
  read(t, a, o, n = 0, r = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: a,
        fcName: o,
        tried: n,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const l = (s, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (s && u && n < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, a, o, n + 1, r * 2, i);
        }, r);
        return;
      }
      i(s, u);
    }, c = this.backend[o].bind(this.backend);
    if (c.length === 2) {
      try {
        const s = c(t, a);
        s && typeof s.then == "function" ? s.then((u) => l(null, u)).catch(l) : l(null, s);
      } catch (s) {
        l(s);
      }
      return;
    }
    return c(t, a, l);
  }
  prepareLoading(t, a, o = {}, n) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), n && n();
    I(t) && (t = this.languageUtils.toResolveHierarchy(t)), I(a) && (a = [a]);
    const r = this.queueLoad(t, a, o, n);
    if (!r.toLoad.length)
      return r.pending.length || n(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, a, o) {
    this.prepareLoading(t, a, {}, o);
  }
  reload(t, a, o) {
    this.prepareLoading(t, a, {
      reload: !0
    }, o);
  }
  loadOne(t, a = "") {
    const o = t.split("|"), n = o[0], r = o[1];
    this.read(n, r, "read", void 0, void 0, (i, l) => {
      i && this.logger.warn(`${a}loading namespace ${r} for language ${n} failed`, i), !i && l && this.logger.log(`${a}loaded namespace ${r} for language ${n}`, l), this.loaded(t, i, l);
    });
  }
  saveMissing(t, a, o, n, r, i = {}, l = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(a)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const c = {
          ...i,
          isUpdate: r
        }, s = this.backend.create.bind(this.backend);
        if (s.length < 6)
          try {
            let u;
            s.length === 5 ? u = s(t, a, o, n, c) : u = s(t, a, o, n), u && typeof u.then == "function" ? u.then((d) => l(null, d)).catch(l) : l(null, u);
          } catch (u) {
            l(u);
          }
        else
          s(t, a, o, n, l, c);
      }
      !t || !t[0] || this.store.addResource(t[0], a, o, n);
    }
  }
}
const un = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), I(e[1]) && (t.defaultValue = e[1]), I(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const a = e[3] || e[2];
      Object.keys(a).forEach((o) => {
        t[o] = a[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), dn = (e) => (I(e.ns) && (e.ns = [e.ns]), I(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), I(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), It = () => {
}, Sf = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((a) => {
    typeof e[a] == "function" && (e[a] = e[a].bind(e));
  });
};
class vt extends ia {
  constructor(t = {}, a) {
    if (super(), this.options = dn(t), this.services = {}, this.logger = Se, this.modules = {
      external: []
    }, Sf(this), a && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, a), this;
      setTimeout(() => {
        this.init(t, a);
      }, 0);
    }
  }
  init(t = {}, a) {
    this.isInitializing = !0, typeof t == "function" && (a = t, t = {}), t.defaultNS == null && t.ns && (I(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = un();
    this.options = {
      ...o,
      ...this.options,
      ...dn(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (s) => s ? typeof s == "function" ? new s() : s : null;
    if (!this.options.isClone) {
      this.modules.logger ? Se.init(n(this.modules.logger), this.options) : Se.init(null, this.options);
      let s;
      this.modules.formatter ? s = this.modules.formatter : s = wf;
      const u = new nn(this.options);
      this.store = new tn(this.options.resources, this.options);
      const d = this.services;
      d.logger = Se, d.resourceStore = this.store, d.languageUtils = u, d.pluralResolver = new yf(u, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), s && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (d.formatter = n(s), d.formatter.init && d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new vf(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new Cf(n(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", (b, ...h) => {
        this.emit(b, ...h);
      }), this.modules.languageDetector && (d.languageDetector = n(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = n(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new Ht(this.services, this.options), this.translator.on("*", (b, ...h) => {
        this.emit(b, ...h);
      }), this.modules.external.forEach((b) => {
        b.init && b.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = It), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      s.length > 0 && s[0] !== "dev" && (this.options.lng = s[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((s) => {
      this[s] = (...u) => this.store[s](...u);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((s) => {
      this[s] = (...u) => (this.store[s](...u), this);
    });
    const l = ut(), c = () => {
      const s = (u, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(d), a(u, d);
      };
      if (this.languages && !this.isInitialized) return s(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, s);
    };
    return this.options.resources || !this.options.initAsync ? c() : setTimeout(c, 0), l;
  }
  loadResources(t, a = It) {
    let o = a;
    const n = I(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (n?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const r = [], i = (l) => {
        if (!l || l === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(l).forEach((s) => {
          s !== "cimode" && r.indexOf(s) < 0 && r.push(s);
        });
      };
      n ? i(n) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((c) => i(c)), this.options.preload?.forEach?.((l) => i(l)), this.services.backendConnector.load(r, this.options.ns, (l) => {
        !l && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(l);
      });
    } else
      o(null);
  }
  reloadResources(t, a, o) {
    const n = ut();
    return typeof t == "function" && (o = t, t = void 0), typeof a == "function" && (o = a, a = void 0), t || (t = this.languages), a || (a = this.options.ns), o || (o = It), this.services.backendConnector.reload(t, a, (r) => {
      n.resolve(), o(r);
    }), n;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Ir.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let a = 0; a < this.languages.length; a++) {
        const o = this.languages[a];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, a) {
    this.isLanguageChangingTo = t;
    const o = ut();
    this.emit("languageChanging", t);
    const n = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, r = (l, c) => {
      c ? this.isLanguageChangingTo === t && (n(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, o.resolve((...s) => this.t(...s)), a && a(l, (...s) => this.t(...s));
    }, i = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const c = I(l) ? l : l && l[0], s = this.store.hasLanguageSomeTranslations(c) ? c : this.services.languageUtils.getBestMatchFromCodes(I(l) ? [l] : l);
      s && (this.language || n(s), this.translator.language || this.translator.changeLanguage(s), this.services.languageDetector?.cacheUserLanguage?.(s)), this.loadResources(s, (u) => {
        r(u, s);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), o;
  }
  getFixedT(t, a, o) {
    const n = (r, i, ...l) => {
      let c;
      typeof i != "object" ? c = this.options.overloadTranslationOptionHandler([r, i].concat(l)) : c = {
        ...i
      }, c.lng = c.lng || n.lng, c.lngs = c.lngs || n.lngs, c.ns = c.ns || n.ns, c.keyPrefix !== "" && (c.keyPrefix = c.keyPrefix || o || n.keyPrefix);
      const s = this.options.keySeparator || ".";
      let u;
      return c.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = Ma(d, {
        ...this.options,
        ...i
      })), `${c.keyPrefix}${s}${d}`)) : (typeof r == "function" && (r = Ma(r, {
        ...this.options,
        ...i
      })), u = c.keyPrefix ? `${c.keyPrefix}${s}${r}` : r), this.t(u, c);
    };
    return I(t) ? n.lng = t : n.lngs = t, n.ns = a, n.keyPrefix = o, n;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, a = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = a.lng || this.resolvedLanguage || this.languages[0], n = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (l, c) => {
      const s = this.services.backendConnector.state[`${l}|${c}`];
      return s === -1 || s === 0 || s === 2;
    };
    if (a.precheck) {
      const l = a.precheck(this, i);
      if (l !== void 0) return l;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, t) && (!n || i(r, t)));
  }
  loadNamespaces(t, a) {
    const o = ut();
    return this.options.ns ? (I(t) && (t = [t]), t.forEach((n) => {
      this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
    }), this.loadResources((n) => {
      o.resolve(), a && a(n);
    }), o) : (a && a(), Promise.resolve());
  }
  loadLanguages(t, a) {
    const o = ut();
    I(t) && (t = [t]);
    const n = this.options.preload || [], r = t.filter((i) => n.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = n.concat(r), this.loadResources((i) => {
      o.resolve(), a && a(i);
    }), o) : (a && a(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const n = new Intl.Locale(t);
      if (n && n.getTextInfo) {
        const r = n.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new nn(un());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : a.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, a) {
    return new vt(t, a);
  }
  cloneInstance(t = {}, a = It) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const n = {
      ...this.options,
      ...t,
      isClone: !0
    }, r = new vt(n);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (r.logger = r.logger.clone(t)), ["store", "services", "language"].forEach((l) => {
      r[l] = this[l];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, o) {
      const l = Object.keys(this.store.data).reduce((c, s) => (c[s] = {
        ...this.store.data[s]
      }, c[s] = Object.keys(c[s]).reduce((u, d) => (u[d] = {
        ...c[s][d]
      }, u), c[s]), c), {});
      r.store = new tn(l, n), r.services.resourceStore = r.store;
    }
    return r.translator = new Ht(r.services, n), r.translator.on("*", (l, ...c) => {
      r.emit(l, ...c);
    }), r.init(n, a), r.translator.options = n, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const _e = vt.createInstance();
_e.createInstance = vt.createInstance;
const zf = _e.createInstance;
_e.dir;
_e.init;
_e.loadResources;
_e.reloadResources;
_e.use;
_e.changeLanguage;
_e.getFixedT;
_e.t;
_e.exists;
_e.setDefaultNamespace;
_e.hasLoadedNamespace;
_e.loadNamespaces;
_e.loadLanguages;
const Af = "Studio", Pf = "{{count}} soveværelse", Mf = "{{count}} soveværelser", Df = "", Nf = "{{count}} seng", Of = "{{count}} senge", If = "Voksne", jf = "Babyer", Lf = "Din kalender er blevet opdateret.", Ef = "En måned", Bf = "Præcise datoer", Tf = "Uge", Rf = "", Ff = "", Vf = "", Gf = "", Uf = "To uger", Zf = "Annuller", Wf = "Børn", Kf = "Datoer", qf = "Slet", Hf = "Beskrivelse", Jf = "Destination", Yf = "Sådan!", Qf = "Rediger", Xf = "Enhver form for udveksling", eb = "Badekar", tb = "Grill", ab = "Cykel", ob = "Bil", nb = "Kat", rb = "By", ib = "På landet", lb = "Opvaskemaskine", sb = "Hund", cb = "Tørretumbler", ub = "Elevator", db = "Favoritboliger", _b = "Pejs/brændeovn", gb = "Lejlighed", fb = "Privat have", bb = "under {{max}} GP", hb = "fra {{min}} GP", mb = "Mellem {{min}} og {{max}} GP", pb = "Privat fitnessrum", yb = "Hus", vb = "En Ø", kb = "Isoleret", $b = "Jacuzzi", wb = "Søer", xb = "Collection-hjem", Cb = "Bjerge", Sb = "{{count}} badeværelser", zb = "Andre dyr", Ab = "Klaver", Pb = "Legeplads", Mb = "Primære bolig", Db = "Gensifig udveksling", Nb = "Omvendt søgning", Ob = "Flod", Ib = "Kystnær", jb = "Feriebolig", Lb = "TV", Eb = "Landsby", Bb = "Wi-Fi", Tb = "Filtre", Rb = "Faste datoer", Fb = "En måned i {{date}}", Vb = "En weekend i {{date}}", Gb = "En uge i {{date}}", Ub = "To uger i {{date}}", Zb = "Fleksible datoer", Wb = "Gæster", Kb = "boliger", qb = "Sidste minut", Hb = "Lokation", Jb = "Rediger", Yb = "Navn", Qb = "Næste", Xb = "", eh = "", th = "{{count}} voksne", ah = "", oh = "", nh = "{{count}} babyer", rh = "", ih = "", lh = "{{count}} børn", sh = "", ch = "{{count}} gæst", uh = "{{count}} gæster", dh = "Telefonnummerets format er ikke gyldigt.", _h = "Modtag e-mailnotifikationer", gh = "Gem", fh = "Ingen lokationer fundet", bh = "Flere beskeder", hh = "Rejseliste", mh = "", ph = "valgfrit", yh = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: Af,
  bedroomsNumbers_one: Pf,
  bedroomsNumbers_other: Mf,
  beds_zero: Df,
  beds_one: Nf,
  beds_other: Of,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_adults: If,
  global_babies: jf,
  global_calendarUpdated_toast: Lf,
  global_calendar_aMonth: Ef,
  global_calendar_exactDates: Bf,
  global_calendar_oneWeek: Tf,
  global_calendar_oneWeekend: Rf,
  global_calendar_plusMinusDay_zero: Ff,
  global_calendar_plusMinusDay_one: Vf,
  global_calendar_plusMinusDay_other: Gf,
  global_calendar_twoWeeks: Uf,
  global_cancel: Zf,
  global_children: Wf,
  global_dates: Kf,
  global_delete: qf,
  global_description: Hf,
  global_destination: Jf,
  global_done: Yf,
  global_edit: Qf,
  "global_filter_a-c": "Klimaanlæg",
  global_filter_available: Xf,
  "global_filter_baby-bed": "Babysenge",
  "global_filter_baby-gear": "Babyudstyr",
  "global_filter_balcony-terrace": "Altan/terrasse",
  global_filter_bathtub: eb,
  global_filter_bbq: tb,
  global_filter_bicycle: ab,
  global_filter_car: ob,
  global_filter_cat: nb,
  "global_filter_children-welcome": "Børn velkomne",
  global_filter_cities: rb,
  "global_filter_cleaning-person": "Rengøringsperson",
  global_filter_countryside: ib,
  "global_filter_dedicated-workspace": "Arbejdsområde",
  "global_filter_disabled-access": "Handicapvenlig bolig",
  global_filter_dishwasher: lb,
  global_filter_dog: sb,
  global_filter_dryer: cb,
  "global_filter_eco-level": "Kun bæredygtige boliger",
  "global_filter_electric-car-plug": "Stik til elbil",
  global_filter_elevator: ub,
  global_filter_favorite: db,
  global_filter_fireplace: _b,
  global_filter_flat: gb,
  global_filter_garden: fb,
  "global_filter_guest-wanted": "GuestPoints bytte",
  global_filter_guestPointsMax: bb,
  global_filter_guestPointsMin: hb,
  global_filter_guestPointsMinMax: mb,
  global_filter_gym: pb,
  "global_filter_heating-system": "Varmeanlæg",
  "global_filter_high-speed-connexion": "Hurtigt internet",
  global_filter_home: yb,
  "global_filter_home-verified": "Godkendte boliger",
  global_filter_island: vb,
  global_filter_isolated: kb,
  global_filter_jacuzzi: $b,
  "global_filter_kids-toys": "Legetøj til børn",
  global_filter_lakes: wb,
  global_filter_luxury: xb,
  global_filter_mountains: Cb,
  "global_filter_no-bed-up": "Ingen midlertidige senge",
  global_filter_numOfBathrooms: Sb,
  global_filter_other: zb,
  "global_filter_parking-space": "Privat parkeringsplads",
  "global_filter_pets-welcome": "Kæledyr er velkomne",
  global_filter_piano: Ab,
  global_filter_playground: Pb,
  global_filter_primary: Mb,
  "global_filter_public-transit-access": "Adgang til offentlig transport",
  global_filter_reciprocal: Db,
  "global_filter_response-rate-above-threshold": "Svarprocent ≥ Gennemsnitlig",
  global_filter_reverse: Nb,
  global_filter_river: Ob,
  global_filter_seaside: Ib,
  global_filter_secondary: jb,
  "global_filter_secured-pool": "Sikret pool",
  "global_filter_smokers-welcome": "Rygere er velkomne",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: Lb,
  global_filter_villages: Eb,
  "global_filter_washing-machine": "Vaskemaskine",
  "global_filter_whole-unit": "Hele enheden",
  global_filter_wifi: Bb,
  global_filters: Tb,
  global_fixDates: Rb,
  global_flexDates_aMonth: Fb,
  global_flexDates_aWeekend: Vb,
  global_flexDates_oneWeek: Gb,
  global_flexDates_twoWeek: Ub,
  global_flexibleDates: Zb,
  global_guests: Wb,
  global_homes: Kb,
  global_lastMinute: qb,
  global_location: Hb,
  global_modify: Jb,
  global_name: Yb,
  global_next: Qb,
  global_numberOfAdults_zero: Xb,
  global_numberOfAdults_one: eh,
  global_numberOfAdults_other: th,
  global_numberOfBabies_zero: ah,
  global_numberOfBabies_one: oh,
  global_numberOfBabies_other: nh,
  global_numberOfChildren_zero: rh,
  global_numberOfChildren_one: ih,
  global_numberOfChildren_other: lh,
  global_numberOfGuests_zero: sh,
  global_numberOfGuests_one: ch,
  global_numberOfGuests_other: uh,
  global_phoneNumber_notValid: dh,
  global_receiveEmailAlerts: _h,
  global_save: gh,
  global_searchBar_noLocationFound: fh,
  global_seeMore_link: bh,
  global_travelWishlist: hh,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: mh,
  optional: ph,
  "privacy-policy": "Privatpolitik"
}, vh = "Din vært kan frit vælge, om de vil beholde eller returnere GuestPoints.", kh = "Ubegrundede eller gentagne aflysninger kan medføre, at din konto bliver suspenderet.", $h = "Ubegrundede eller gentagne aflysninger kan medføre, at din konto bliver suspenderet. Hvis der var GuestPoints involveret, kan din byttepartner vælge, om de vil beholde eller returnere dem.", wh = "Når du har forhåndsgodkendt  dette boligbytte, skal din byttepartner bekræfte det. Byttepartneren har {nbDays} dage til at bekræfte boligbyttet (indtil {date}). Ellers vil din forhåndsgodkendelse udløbe, og du bliver nødt til at forhåndsgodkende boligbyttet igen.", xh = "Min byttepartner bad mig om at aflyse boligbyttet.", Ch = "Dobbelt booking (via en anden platform)", Sh = "Familieproblemer", zh = "Helbredsproblemer", Ah = "Skader i hjemmet", Ph = "Flytning", Mh = "Du skal angive årsagerne til, at du vil annullere boligbyttet.", Dh = "Andre", Nh = "Transportproblemer", Oh = "Tillidsproblem", Ih = "Arbejdsrelateret", jh = "Du er nødt til at indtaste en årsag", Lh = {
  "cancellation-page.cancel-exchange": "Annuller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsæt annulleringen",
  "cancellation-page.keep-exchange": "Behold mit boligbytte",
  "cancellation-page.reason_step.checboxes_label": "Vælg hovedårsagen til din annullering:",
  "cancellation-page.reason_step.comment_placeholder": "Skriv årsagen til din annullering her",
  "cancellation-page.reason_step.error": "Du er nødt til at indtaste en årsag",
  "cancellation-page.reason_step.title": "Hvorfor er du nødt til at annullere?",
  "cancellation-page.warning-step.first-warning": "Husk, at annullering af dit boligbytte kan have en negativ indvirkning på din byttepartner, som måske allerede har lavet rejseplaner!",
  "cancellation-page.warning-step.second-warning": "Vigtigt: I tilfælde af for mange uberettigede aflysninger som vært, kan din konto blive taget offline. Og som gæst får du muligvis ikke alle dine GuestPoints tilbage.",
  page_cancellation_guest_calloutBody: vh,
  page_cancellation_host_calloutBody: kh,
  page_cancellation_reciprocal_calloutBody: $h,
  pre_approval_modal_expiration_description: wh,
  reasons_for_cancellation_asked_by_exchange_partner: xh,
  reasons_for_cancellation_double_booking_rental: Ch,
  reasons_for_cancellation_family_issues: Sh,
  reasons_for_cancellation_health_issues: zh,
  reasons_for_cancellation_home_damage: Ah,
  reasons_for_cancellation_moving: Ph,
  reasons_for_cancellation_needed: Mh,
  reasons_for_cancellation_other: Dh,
  reasons_for_cancellation_transportation_issues: Nh,
  reasons_for_cancellation_trust_issues: Oh,
  reasons_for_cancellation_work_related: Ih,
  reasons_other_comment_needed: jh
}, Eh = "Studio", Bh = "{{count}} schlafzimmer", Th = "{{count}} schlafzimmer", Rh = "", Fh = "{{count}} Bett", Vh = "{{count}} Betten", Gh = "Erwachsene", Uh = "Babys", Zh = "Ihr Kalender wurde aktualisiert.", Wh = "Ein Monat", Kh = "Genaue Daten", qh = "Eine Woche", Hh = "Ein Wochenende", Jh = "", Yh = "{{count}} Tag", Qh = "{{count}} Tage", Xh = "Zwei Wochen", em = "Abbrechen", tm = "Kinder", am = "Daten", om = "Löschen", nm = "Beschreibung", rm = "Reiseziel", im = "Fertig!", lm = "Bearbeiten", sm = "Jede Tauschanfrage", cm = "Badewanne", um = "Grill", dm = "Fahrrad", _m = "Auto", gm = "Katze", fm = "Stadt", bm = "Auf dem Land", hm = "Geschirrspüler", mm = "Hund", pm = "Trockner", ym = "Aufzug", vm = "Lieblingshäuser", km = "Kamin", $m = "Apartment", wm = "Privater Garten", xm = "weniger als {{max}} GP", Cm = "von {{min}} GP", Sm = "Zwischen {{min}} und {{max}} GP", zm = "Privater Fitnessraum", Am = "Haus", Pm = "Insel", Mm = "Abgelegen", Dm = "Whirlpool", Nm = "See", Om = "Häuser der Collection", Im = "Berge", jm = "{{count}} Badezimmer", Lm = "Andere Tiere", Em = "Klavier", Bm = "Spielplatz", Tm = "Hauptwohnung", Rm = "Gegenseitiger Austausch", Fm = "Umgekehrte Suche", Vm = "Fluss", Gm = "An der Küste", Um = "Zweitwohnung", Zm = "Fernseher", Wm = "Dorf", Km = "WLAN", qm = "Filter", Hm = "Feste Daten", Jm = "Eine Woche im {{date}}", Ym = "Ein Wochenende im {{date}}", Qm = "Eine Woche im {{date}}", Xm = "Zwei Wochen im {{date}}", ep = "Flexible Daten", tp = "Gäste", ap = "Unterkünfte", op = "Last Minute", np = "Ort", rp = "Ändern", ip = "Name", lp = "Weiter", sp = "", cp = "{{count}} Erwachsener", up = "{{count}} Erwachsene", dp = "", _p = "{{count}} Baby", gp = "{{count}} Babys", fp = "", bp = "{{count}} Kind", hp = "{{count}} Kinder", mp = "", pp = "{{count}} Gast", yp = "{{count}} Gäste", vp = "Das Format der Telefonnummer ist ungültig.", kp = "Benachrichtigungen per E-Mail erhalten", $p = "Speichern", wp = "Kein Reiseziel gefunden", xp = "Mehr anzeigen", Cp = "Reiseprojekte", Sp = "", zp = "optional", Ap = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: Eh,
  bedroomsNumbers_one: Bh,
  bedroomsNumbers_other: Th,
  beds_zero: Rh,
  beds_one: Fh,
  beds_other: Vh,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_adults: Gh,
  global_babies: Uh,
  global_calendarUpdated_toast: Zh,
  global_calendar_aMonth: Wh,
  global_calendar_exactDates: Kh,
  global_calendar_oneWeek: qh,
  global_calendar_oneWeekend: Hh,
  global_calendar_plusMinusDay_zero: Jh,
  global_calendar_plusMinusDay_one: Yh,
  global_calendar_plusMinusDay_other: Qh,
  global_calendar_twoWeeks: Xh,
  global_cancel: em,
  global_children: tm,
  global_dates: am,
  global_delete: om,
  global_description: nm,
  global_destination: rm,
  global_done: im,
  global_edit: lm,
  "global_filter_a-c": "Klimaanlage",
  global_filter_available: sm,
  "global_filter_baby-bed": "Babybetten",
  "global_filter_baby-gear": "Babyausstattung",
  "global_filter_balcony-terrace": "Balkon / Terrasse",
  global_filter_bathtub: cm,
  global_filter_bbq: um,
  global_filter_bicycle: dm,
  global_filter_car: _m,
  global_filter_cat: gm,
  "global_filter_children-welcome": "Kinder willkommen",
  global_filter_cities: fm,
  "global_filter_cleaning-person": "Reinigungskraft",
  global_filter_countryside: bm,
  "global_filter_dedicated-workspace": "Spezieller Arbeitsbereich",
  "global_filter_disabled-access": "Barrierefreie Unterkunft",
  global_filter_dishwasher: hm,
  global_filter_dog: mm,
  global_filter_dryer: pm,
  "global_filter_eco-level": "Nur nachhaltige Häuser",
  "global_filter_electric-car-plug": "Steckdose für Elektroautos",
  global_filter_elevator: ym,
  global_filter_favorite: vm,
  global_filter_fireplace: km,
  global_filter_flat: $m,
  global_filter_garden: wm,
  "global_filter_guest-wanted": "Austausch gegen GuestPoints",
  global_filter_guestPointsMax: xm,
  global_filter_guestPointsMin: Cm,
  global_filter_guestPointsMinMax: Sm,
  global_filter_gym: zm,
  "global_filter_heating-system": "Heizung",
  "global_filter_high-speed-connexion": "Hochgeschwindigkeitsverbindung",
  global_filter_home: Am,
  "global_filter_home-verified": "Verifizierte Unterkünfte",
  global_filter_island: Pm,
  global_filter_isolated: Mm,
  global_filter_jacuzzi: Dm,
  "global_filter_kids-toys": "Kinderspielzeug",
  global_filter_lakes: Nm,
  global_filter_luxury: Om,
  global_filter_mountains: Im,
  "global_filter_no-bed-up": "Keine Zustellbetten",
  global_filter_numOfBathrooms: jm,
  global_filter_other: Lm,
  "global_filter_parking-space": "Privater Parkplatz",
  "global_filter_pets-welcome": "Haustiere willkommen",
  global_filter_piano: Em,
  global_filter_playground: Bm,
  global_filter_primary: Tm,
  "global_filter_public-transit-access": "Zugang zu öffentlichen Verkehrsmitteln",
  global_filter_reciprocal: Rm,
  "global_filter_response-rate-above-threshold": "Antwortrate ≥ Mittel",
  global_filter_reverse: Fm,
  global_filter_river: Vm,
  global_filter_seaside: Gm,
  global_filter_secondary: Um,
  "global_filter_secured-pool": "Gesicherter Pool",
  "global_filter_smokers-welcome": "Rauchen erlaubt",
  "global_filter_swimming-pool": "Swimmingpool",
  global_filter_tv: Zm,
  global_filter_villages: Wm,
  "global_filter_washing-machine": "Waschmaschine",
  "global_filter_whole-unit": "Die ganze Wohnung",
  global_filter_wifi: Km,
  global_filters: qm,
  global_fixDates: Hm,
  global_flexDates_aMonth: Jm,
  global_flexDates_aWeekend: Ym,
  global_flexDates_oneWeek: Qm,
  global_flexDates_twoWeek: Xm,
  global_flexibleDates: ep,
  global_guests: tp,
  global_homes: ap,
  global_lastMinute: op,
  global_location: np,
  global_modify: rp,
  global_name: ip,
  global_next: lp,
  global_numberOfAdults_zero: sp,
  global_numberOfAdults_one: cp,
  global_numberOfAdults_other: up,
  global_numberOfBabies_zero: dp,
  global_numberOfBabies_one: _p,
  global_numberOfBabies_other: gp,
  global_numberOfChildren_zero: fp,
  global_numberOfChildren_one: bp,
  global_numberOfChildren_other: hp,
  global_numberOfGuests_zero: mp,
  global_numberOfGuests_one: pp,
  global_numberOfGuests_other: yp,
  global_phoneNumber_notValid: vp,
  global_receiveEmailAlerts: kp,
  global_save: $p,
  global_searchBar_noLocationFound: wp,
  global_seeMore_link: xp,
  global_travelWishlist: Cp,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: Sp,
  optional: zp,
  "privacy-policy": "Datenschutz"
}, Pp = "Ihr Gastgeber hat die Wahl, die GuestPoints zu behalten oder zurückzugeben.", Mp = "Unbegründete oder wiederholte Stornierungen können zur Sperrung Ihres Kontos führen.", Dp = "Unbegründete oder wiederholte Stornierungen können zur Sperrung Ihres Kontos führen. Wenn GuestPoints im Spiel waren, kann Ihr Tauschpartner entscheiden, ob er sie behalten oder zurückgeben möchte.", Np = "Nachdem Sie diesen Haustausch vorläufig bestätigt haben, muss Ihr Tauschpartner ihn finalisieren. Dazu hat Ihr Partner {nbDays} Tage Zeit (bis {date}). Nach Ablauf dieser Frist erlischt Ihre Vorabbestätigung und Sie müssen den Haustausch erneut vorläufig bestätigen.", Op = "Mein Tauschpartner hat mich gebeten, den Tausch zu stornieren", Ip = "Doppelbuchung (über eine andere Plattform)", jp = "Familiäre Gründe", Lp = "Gesundheitliche Probleme", Ep = "Schäden an der Unterkunft", Bp = "Umzug", Tp = "Sie müssten bitte die Gründe für Ihre Stornierung angeben.", Rp = "Andere", Fp = "Probleme bei der An-/Abreise", Vp = "Vertrauensprobleme", Gp = "Arbeitsbedingte Gründe", Up = "Sie müssen einen Grund angeben", Zp = {
  "cancellation-page.cancel-exchange": "Den Tausch stornieren",
  "cancellation-page.continue-cancellation": "Stornierung fortsetzen",
  "cancellation-page.keep-exchange": "Meinen Haustausch beibehalten",
  "cancellation-page.reason_step.checboxes_label": "Wählen Sie den Hauptgrund für Ihre Stornierung aus:",
  "cancellation-page.reason_step.comment_placeholder": "Bitte geben Sie hier den Grund für Ihre Stornierung an",
  "cancellation-page.reason_step.error": "Sie müssen einen Grund angeben",
  "cancellation-page.reason_step.title": "Warum müssen Sie stornieren?",
  "cancellation-page.warning-step.first-warning": "HomeExchange basiert auf Vertrauen und Verlässlichkeit. Denken Sie daran, dass eine Stornierung Auswirkungen auf Ihren Tauschpartner hat.",
  "cancellation-page.warning-step.second-warning": "Wichtig: Bei mehreren unbegründeten Stornierungen als Gastgeber kann Ihr Konto deaktiviert werden. Als Gast erhalten Sie außerdem möglicherweise nicht alle Ihre GuestPoints zurück.",
  page_cancellation_guest_calloutBody: Pp,
  page_cancellation_host_calloutBody: Mp,
  page_cancellation_reciprocal_calloutBody: Dp,
  pre_approval_modal_expiration_description: Np,
  reasons_for_cancellation_asked_by_exchange_partner: Op,
  reasons_for_cancellation_double_booking_rental: Ip,
  reasons_for_cancellation_family_issues: jp,
  reasons_for_cancellation_health_issues: Lp,
  reasons_for_cancellation_home_damage: Ep,
  reasons_for_cancellation_moving: Bp,
  reasons_for_cancellation_needed: Tp,
  reasons_for_cancellation_other: Rp,
  reasons_for_cancellation_transportation_issues: Fp,
  reasons_for_cancellation_trust_issues: Vp,
  reasons_for_cancellation_work_related: Gp,
  reasons_other_comment_needed: Up
}, Wp = "Studio", Kp = "{{count}} bedroom", qp = "{{count}} bedrooms", Hp = "", Jp = "{{count}} bed", Yp = "{{count}} beds", Qp = "Adults", Xp = "Babies", ey = "Your calendar has been updated.", ty = "A month", ay = "Exact dates", oy = "One week", ny = "One weekend", ry = "", iy = "± {{count}} day", ly = "± {{count}} days", sy = "Two weeks", cy = "Cancel", uy = "Children", dy = "Dates", _y = "Delete", gy = "Description", fy = "Destination", by = "Done!", hy = "Edit", my = "Any type of exchange", py = "Bathtub", yy = "BBQ", vy = "Bicycle", ky = "Car", $y = "Cat", wy = "City", xy = "Countryside", Cy = "Dishwasher", Sy = "Dog", zy = "Dryer", Ay = "Elevator", Py = "Favorite homes", My = "Fireplace", Dy = "Apartment", Ny = "Private backyard", Oy = "less than {{max}} GP", Iy = "from {{min}} GP", jy = "Between {{min}} and {{max}} GP", Ly = "Private gym", Ey = "House", By = "Island", Ty = "Isolated", Ry = "Jacuzzi", Fy = "Lake", Vy = "Collection homes", Gy = "Mountain", Uy = "{{count}} bathrooms", Zy = "Other animals", Wy = "Piano", Ky = "Kid's playground", qy = "Primary", Hy = "Reciprocal exchange", Jy = "Reverse search", Yy = "River", Qy = "Coastal", Xy = "Secondary", ev = "TV", tv = "Village", av = "WiFi", ov = "Filters", nv = "Fixed dates", rv = "A month in {{date}}", iv = "A Week-end in {{date}}", lv = "One week in {{date}}", sv = "Two weeks in {{date}}", cv = "Flexible dates", uv = "Guests", dv = "homes", _v = "Last minute", gv = "Location", fv = "Modify", bv = "Name", hv = "Next", mv = "", pv = "{{count}} adult", yv = "{{count}} adults", vv = "", kv = "{{count}} baby", $v = "{{count}} babies", wv = "", xv = "{{count}} child", Cv = "{{count}} children", Sv = "{{count}} guest", zv = "{{count}} guest", Av = "{{count}} guests", Pv = "The phone number format is not valid", Mv = "Receive email alerts", Dv = "Save", Nv = "No locations found", Ov = "See more", Iv = "Travel wishlist", jv = "No result", Lv = "optional", Ev = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: Wp,
  bedroomsNumbers_one: Kp,
  bedroomsNumbers_other: qp,
  beds_zero: Hp,
  beds_one: Jp,
  beds_other: Yp,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_adults: Qp,
  global_babies: Xp,
  global_calendarUpdated_toast: ey,
  global_calendar_aMonth: ty,
  global_calendar_exactDates: ay,
  global_calendar_oneWeek: oy,
  global_calendar_oneWeekend: ny,
  global_calendar_plusMinusDay_zero: ry,
  global_calendar_plusMinusDay_one: iy,
  global_calendar_plusMinusDay_other: ly,
  global_calendar_twoWeeks: sy,
  global_cancel: cy,
  global_children: uy,
  global_dates: dy,
  global_delete: _y,
  global_description: gy,
  global_destination: fy,
  global_done: by,
  global_edit: hy,
  "global_filter_a-c": "A/C",
  global_filter_available: my,
  "global_filter_baby-bed": "Baby cribs",
  "global_filter_baby-gear": "Baby gear",
  "global_filter_balcony-terrace": "Balcony/Terrace",
  global_filter_bathtub: py,
  global_filter_bbq: yy,
  global_filter_bicycle: vy,
  global_filter_car: ky,
  global_filter_cat: $y,
  "global_filter_children-welcome": "Children welcome",
  global_filter_cities: wy,
  "global_filter_cleaning-person": "Cleaning person",
  global_filter_countryside: xy,
  "global_filter_dedicated-workspace": "Dedicated workspace",
  "global_filter_disabled-access": "Accessible home",
  global_filter_dishwasher: Cy,
  global_filter_dog: Sy,
  global_filter_dryer: zy,
  "global_filter_eco-level": "Only sustainable homes",
  "global_filter_electric-car-plug": "Electric car plug",
  global_filter_elevator: Ay,
  global_filter_favorite: Py,
  global_filter_fireplace: My,
  global_filter_flat: Dy,
  global_filter_garden: Ny,
  "global_filter_guest-wanted": "GuestPoints exchange",
  global_filter_guestPointsMax: Oy,
  global_filter_guestPointsMin: Iy,
  global_filter_guestPointsMinMax: jy,
  global_filter_gym: Ly,
  "global_filter_heating-system": "Heating system",
  "global_filter_high-speed-connexion": "High speed connection",
  global_filter_home: Ey,
  "global_filter_home-verified": "Verified homes",
  global_filter_island: By,
  global_filter_isolated: Ty,
  global_filter_jacuzzi: Ry,
  "global_filter_kids-toys": "Kids toys",
  global_filter_lakes: Fy,
  global_filter_luxury: Vy,
  global_filter_mountains: Gy,
  "global_filter_no-bed-up": "No temporary beds",
  global_filter_numOfBathrooms: Uy,
  global_filter_other: Zy,
  "global_filter_parking-space": "Private parking space",
  "global_filter_pets-welcome": "Pets welcome",
  global_filter_piano: Wy,
  global_filter_playground: Ky,
  global_filter_primary: qy,
  "global_filter_public-transit-access": "Public transport access",
  global_filter_reciprocal: Hy,
  "global_filter_response-rate-above-threshold": "Response rate ≥ Average",
  global_filter_reverse: Jy,
  global_filter_river: Yy,
  global_filter_seaside: Qy,
  global_filter_secondary: Xy,
  "global_filter_secured-pool": "Secured pool",
  "global_filter_smokers-welcome": "Smokers welcome",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: ev,
  global_filter_villages: tv,
  "global_filter_washing-machine": "Washing machine",
  "global_filter_whole-unit": "Entire home",
  global_filter_wifi: av,
  global_filters: ov,
  global_fixDates: nv,
  global_flexDates_aMonth: rv,
  global_flexDates_aWeekend: iv,
  global_flexDates_oneWeek: lv,
  global_flexDates_twoWeek: sv,
  global_flexibleDates: cv,
  global_guests: uv,
  global_homes: dv,
  global_lastMinute: _v,
  global_location: gv,
  global_modify: fv,
  global_name: bv,
  global_next: hv,
  global_numberOfAdults_zero: mv,
  global_numberOfAdults_one: pv,
  global_numberOfAdults_other: yv,
  global_numberOfBabies_zero: vv,
  global_numberOfBabies_one: kv,
  global_numberOfBabies_other: $v,
  global_numberOfChildren_zero: wv,
  global_numberOfChildren_one: xv,
  global_numberOfChildren_other: Cv,
  global_numberOfGuests_zero: Sv,
  global_numberOfGuests_one: zv,
  global_numberOfGuests_other: Av,
  global_phoneNumber_notValid: Pv,
  global_receiveEmailAlerts: Mv,
  global_save: Dv,
  global_searchBar_noLocationFound: Nv,
  global_seeMore_link: Ov,
  global_travelWishlist: Iv,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: jv,
  optional: Lv,
  "privacy-policy": "Privacy Policy"
}, Bv = "Your host will have the choice to keep or return the GuestPoints as they wish.", Tv = "Unjustified or repeated cancellations may result in your account being suspended.", Rv = "Unjustified or repeated cancellations may result in your account being suspended. If GuestPoints were involved, your exchange partner will have the choice to keep or return them.", Fv = "After you pre-approve this exchange, your exchange partner will need to finalize it. They have {nbDays} days to finalize the exchange (until {date}). Otherwise, your pre-approval will expire and you will have to preapprove the exchange again.", Vv = "My exchange partner asked me to cancel the exchange", Gv = "Double booking (via another platform)", Uv = "Family issue", Zv = "Health issue", Wv = "Damage to home", Kv = "Moving home", qv = "You need to indicate the reasons for your cancellation.", Hv = "Other", Jv = "Transport issue", Yv = "Trust issue", Qv = "Work related", Xv = "You need to enter a reason", ek = {
  "cancellation-page.cancel-exchange": "Cancel this exchange",
  "cancellation-page.continue-cancellation": "Continue with cancellation",
  "cancellation-page.keep-exchange": "Keep this exchange",
  "cancellation-page.reason_step.checboxes_label": "Select the main reason for your cancellation:",
  "cancellation-page.reason_step.comment_placeholder": "Write the reason for your cancellation here",
  "cancellation-page.reason_step.error": "You need to enter a reason",
  "cancellation-page.reason_step.title": "Why do you need to cancel?",
  "cancellation-page.warning-step.first-warning": "HomeExchange relies on trust and reliability. Remember that cancelling might have an impact on your exchange partner.",
  "cancellation-page.warning-step.second-warning": "Important: In case of excessive unjustified cancellations as a host, your account may be taken offline. And as a guest, you may not have all your GuestPoints returned to you.",
  page_cancellation_guest_calloutBody: Bv,
  page_cancellation_host_calloutBody: Tv,
  page_cancellation_reciprocal_calloutBody: Rv,
  pre_approval_modal_expiration_description: Fv,
  reasons_for_cancellation_asked_by_exchange_partner: Vv,
  reasons_for_cancellation_double_booking_rental: Gv,
  reasons_for_cancellation_family_issues: Uv,
  reasons_for_cancellation_health_issues: Zv,
  reasons_for_cancellation_home_damage: Wv,
  reasons_for_cancellation_moving: Kv,
  reasons_for_cancellation_needed: qv,
  reasons_for_cancellation_other: Hv,
  reasons_for_cancellation_transportation_issues: Jv,
  reasons_for_cancellation_trust_issues: Yv,
  reasons_for_cancellation_work_related: Qv,
  reasons_other_comment_needed: Xv
}, tk = "Estudio", ak = "{{count}} dormitorio", ok = "{{count}} dormitorios", nk = "", rk = "{{count}} cama", ik = "{{count}} camas", lk = "", sk = "", ck = "Tu calendario ha sido actualizado.", uk = "Un mes", dk = "Fechas exactas", _k = "Una semana", gk = "Un fin de semana", fk = "", bk = "± 1:{{count}} día", hk = "± 1:{{count}} días", mk = "Dos semanas", pk = "Cancelar", yk = "", vk = "Fechas", kk = "Eliminar", $k = "Descripción", wk = "Destino", xk = "¡Listo!", Ck = "Editar", Sk = "Cualquier tipo de intercambio", zk = "Bañera", Ak = "Barbacoa", Pk = "Bicicleta", Mk = "Coche", Dk = "Gato", Nk = "Ciudad", Ok = "Campo", Ik = "Lavavajillas", jk = "Perro", Lk = "Secadora", Ek = "Ascensor", Bk = "Casas favoritas", Tk = "Chimenea", Rk = "Piso", Fk = "Patio privado", Vk = "", Gk = "", Uk = "", Zk = "", Wk = "Casa", Kk = "Isla", qk = "Aislado", Hk = "Jacuzzi", Jk = "Lagos", Yk = "Casas Collection", Qk = "", Xk = "{{count}} baños", e$ = "Otros animales", t$ = "Piano", a$ = "Columpios", o$ = "Principal", n$ = "Intercambio recíproco", r$ = "Búsqueda inversa", i$ = "Río", l$ = "En la costa", s$ = "Secundaria", c$ = "TV", u$ = "Pueblo", d$ = "WiFi", _$ = "Filtros", g$ = "Fechas fijas", f$ = "Un mes en {{date}}", b$ = "Un fin de semana en {{date}}", h$ = "Una semana en {{date}}", m$ = "Dos semanas en {{date}}", p$ = "Fechas flexibles", y$ = "Invitados", v$ = "casas", k$ = "Último minuto", $$ = "Ubicación", w$ = "Modificar", x$ = "Nombre", C$ = "Siguiente", S$ = "", z$ = "{{count}} adulto", A$ = "{{count}} adultos", P$ = "", M$ = "{{count}} bebé", D$ = "bebé", N$ = "", O$ = "{{count}} niño/a", I$ = "{{count}} niños", j$ = "", L$ = "{{count}} invitado/a", E$ = "{{count}} invitados", B$ = "El formato del número de teléfono no es válido.", T$ = "Recibir notificaciones por correo electrónico", R$ = "Guardar", F$ = "No encontramos este lugar", V$ = "Ver más", G$ = "Proyectos de viaje", U$ = "", Z$ = "opcional", W$ = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: tk,
  bedroomsNumbers_one: ak,
  bedroomsNumbers_other: ok,
  beds_zero: nk,
  beds_one: rk,
  beds_other: ik,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_adults: lk,
  global_babies: sk,
  global_calendarUpdated_toast: ck,
  global_calendar_aMonth: uk,
  global_calendar_exactDates: dk,
  global_calendar_oneWeek: _k,
  global_calendar_oneWeekend: gk,
  global_calendar_plusMinusDay_zero: fk,
  global_calendar_plusMinusDay_one: bk,
  global_calendar_plusMinusDay_other: hk,
  global_calendar_twoWeeks: mk,
  global_cancel: pk,
  global_children: yk,
  global_dates: vk,
  global_delete: kk,
  global_description: $k,
  global_destination: wk,
  global_done: xk,
  global_edit: Ck,
  "global_filter_a-c": "Aire acondicionado",
  global_filter_available: Sk,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamiento para bebés",
  "global_filter_balcony-terrace": "Balcón/Terraza",
  global_filter_bathtub: zk,
  global_filter_bbq: Ak,
  global_filter_bicycle: Pk,
  global_filter_car: Mk,
  global_filter_cat: Dk,
  "global_filter_children-welcome": "Niños bienvenidos",
  global_filter_cities: Nk,
  "global_filter_cleaning-person": "Señor/a de la limpieza",
  global_filter_countryside: Ok,
  "global_filter_dedicated-workspace": "Escritorio para trabajar",
  "global_filter_disabled-access": "Casas accesibles",
  global_filter_dishwasher: Ik,
  global_filter_dog: jk,
  global_filter_dryer: Lk,
  "global_filter_eco-level": "Solo viviendas sostenibles",
  "global_filter_electric-car-plug": "Enchufe para coches eléctricos",
  global_filter_elevator: Ek,
  global_filter_favorite: Bk,
  global_filter_fireplace: Tk,
  global_filter_flat: Rk,
  global_filter_garden: Fk,
  "global_filter_guest-wanted": "Intercambio con GuestPoints",
  global_filter_guestPointsMax: Vk,
  global_filter_guestPointsMin: Gk,
  global_filter_guestPointsMinMax: Uk,
  global_filter_gym: Zk,
  "global_filter_heating-system": "Calefacción",
  "global_filter_high-speed-connexion": "Conexión de alta velocidad",
  global_filter_home: Wk,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: Kk,
  global_filter_isolated: qk,
  global_filter_jacuzzi: Hk,
  "global_filter_kids-toys": "",
  global_filter_lakes: Jk,
  global_filter_luxury: Yk,
  global_filter_mountains: Qk,
  "global_filter_no-bed-up": "Sin camas provisionales",
  global_filter_numOfBathrooms: Xk,
  global_filter_other: e$,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Mascotas bienvenidas",
  global_filter_piano: t$,
  global_filter_playground: a$,
  global_filter_primary: o$,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: n$,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: r$,
  global_filter_river: i$,
  global_filter_seaside: l$,
  global_filter_secondary: s$,
  "global_filter_secured-pool": "Piscina segura",
  "global_filter_smokers-welcome": "Fumadores bienvenidos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: c$,
  global_filter_villages: u$,
  "global_filter_washing-machine": "Lavadora",
  "global_filter_whole-unit": "",
  global_filter_wifi: d$,
  global_filters: _$,
  global_fixDates: g$,
  global_flexDates_aMonth: f$,
  global_flexDates_aWeekend: b$,
  global_flexDates_oneWeek: h$,
  global_flexDates_twoWeek: m$,
  global_flexibleDates: p$,
  global_guests: y$,
  global_homes: v$,
  global_lastMinute: k$,
  global_location: $$,
  global_modify: w$,
  global_name: x$,
  global_next: C$,
  global_numberOfAdults_zero: S$,
  global_numberOfAdults_one: z$,
  global_numberOfAdults_other: A$,
  global_numberOfBabies_zero: P$,
  global_numberOfBabies_one: M$,
  global_numberOfBabies_other: D$,
  global_numberOfChildren_zero: N$,
  global_numberOfChildren_one: O$,
  global_numberOfChildren_other: I$,
  global_numberOfGuests_zero: j$,
  global_numberOfGuests_one: L$,
  global_numberOfGuests_other: E$,
  global_phoneNumber_notValid: B$,
  global_receiveEmailAlerts: T$,
  global_save: R$,
  global_searchBar_noLocationFound: F$,
  global_seeMore_link: V$,
  global_travelWishlist: G$,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: U$,
  optional: Z$,
  "privacy-policy": "Política de Privacidad"
}, K$ = "Tus anfitriones podrán elegir si desean quedarse los GuestPoints o devolverlos.", q$ = "Las cancelaciones sin causa justificada o reiteradas pueden dar lugar a la suspensión de tu cuenta.", H$ = "Las cancelaciones sin causa justificada o reiteradas pueden dar lugar a la suspensión de una cuenta. Si hubiera GuestPoints de por medio, tus compañeros de intercambio tendrán la opción de conservarlos o devolverlos.", J$ = "Después de preaprobar este intercambio, tus compañeros de intercambio tendrán que registrarlo. Tienes {nbDays} días para registrar el intercambio (hasta el {date}). De lo contrario, la preaprobación caducará y tendrás que volver a preaprobar el intercambio.", Y$ = "Mis compañeros de intercambio me han pedido que cancele el intercambio", Q$ = "Reserva doble (por otra plataforma)", X$ = "Motivos familiares", ew = "Problemas de salud", tw = "Daños en la casa", aw = "Mudanza", ow = "Por favor, indica el motivo de la cancelación", nw = "Otros", rw = "Problemas con el transporte", iw = "Temas de confianza", lw = "Motivos laborales", sw = "Debes introducir un motivo", cw = {
  "cancellation-page.cancel-exchange": "Cancelar el intercambio",
  "cancellation-page.continue-cancellation": "Continuar con la cancelación",
  "cancellation-page.keep-exchange": "Mantener el intercambio",
  "cancellation-page.reason_step.checboxes_label": "Selecciona el motivo principal de la cancelación:",
  "cancellation-page.reason_step.comment_placeholder": "Escribe aquí el motivo de tu cancelación",
  "cancellation-page.reason_step.error": "Tienes que elegir un motivo",
  "cancellation-page.reason_step.title": "¿Por qué quieres cancelar el intercambio?",
  "cancellation-page.warning-step.first-warning": "HomeExchange se basa en la confianza. Recuerda que la cancelación puede afectar a tus compañeros de intercambio.",
  "cancellation-page.warning-step.second-warning": "Importante: un exceso de cancelaciones sin causa justificada por parte de los anfitriones puede resultar en la desactivación de su cuenta y, por parte de los invitados, puede implicar que no se recuperen todos los GuestPoints.",
  page_cancellation_guest_calloutBody: K$,
  page_cancellation_host_calloutBody: q$,
  page_cancellation_reciprocal_calloutBody: H$,
  pre_approval_modal_expiration_description: J$,
  reasons_for_cancellation_asked_by_exchange_partner: Y$,
  reasons_for_cancellation_double_booking_rental: Q$,
  reasons_for_cancellation_family_issues: X$,
  reasons_for_cancellation_health_issues: ew,
  reasons_for_cancellation_home_damage: tw,
  reasons_for_cancellation_moving: aw,
  reasons_for_cancellation_needed: ow,
  reasons_for_cancellation_other: nw,
  reasons_for_cancellation_transportation_issues: rw,
  reasons_for_cancellation_trust_issues: iw,
  reasons_for_cancellation_work_related: lw,
  reasons_other_comment_needed: sw
}, uw = "Studio", dw = "{{count}} chambre", _w = "{{count}} chambres", gw = "", fw = "{{count}} lit", bw = "{{count}} lits", hw = "Adultes", mw = "Bébés", pw = "Votre calendrier a été mis à jour.", yw = "Un mois", vw = "Dates exactes", kw = "Une semaine", $w = "Un week-end", ww = "Vide", xw = "± {{count}} jour", Cw = "± {{count}} jours", Sw = "Deux semaines", zw = "Annuler", Aw = "Enfants", Pw = "Dates", Mw = "Supprimer", Dw = "Description", Nw = "Destination", Ow = "C'est prêt !", Iw = "Modifier", jw = "Tout type d'échange", Lw = "Baignoire", Ew = "Barbecue", Bw = "Vélo", Tw = "Voiture", Rw = "Chat", Fw = "Ville", Vw = "Campagne", Gw = "Lave-vaisselle", Uw = "Chien", Zw = "Sèche linge", Ww = "Ascenseur", Kw = "Maisons favorites", qw = "Cheminée", Hw = "Appartement", Jw = "Jardin privé", Yw = "moins de {{max}} GP", Qw = "à partir de {{min}} GP", Xw = "Entre {{min}} et {{max}} GP", ex = "Salle de sport privée", tx = "Maison", ax = "Île", ox = "Isolé", nx = "Jacuzzi", rx = "Lac", ix = "Maisons Collection", lx = "Montagne", sx = "{{count}} salles de bain", cx = "Autre", ux = "Piano", dx = "Aire de jeux", _x = "Principale", gx = "Échange réciproque", fx = "Recherche inversée", bx = "Rivière", hx = "Bord de mer", mx = "Secondaire", px = "TV", yx = "Village", vx = "WiFi", kx = "Filtres", $x = "Dates fixes", wx = "Un mois en {{date}}", xx = "Un week-end en {{date}}", Cx = "Une semaine en {{date}}", Sx = "Deux semaines en {{date}}", zx = "Dates flexibles", Ax = "Personnes", Px = "maisons", Mx = "Dernière minute", Dx = "Lieu", Nx = "Modifier", Ox = "Titre", Ix = "Suivant", jx = "Vide", Lx = "{{count}} adulte", Ex = "{{count}} adultes", Bx = "Vide", Tx = "{{count}} bébé", Rx = "{{count}} bébés", Fx = "Vide", Vx = "{{count}} enfant", Gx = "{{count}} enfants", Ux = "{{count}} personne", Zx = "{{count}} personne", Wx = "{{count}} personnes", Kx = "Le format du numéro de téléphone est invalide.", qx = "Recevoir des alertes par email", Hx = "Enregistrer", Jx = "Aucun lieu trouvé", Yx = "Voir plus", Qx = "Projets de voyage", Xx = "", eC = "facultatif", tC = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: uw,
  bedroomsNumbers_one: dw,
  bedroomsNumbers_other: _w,
  beds_zero: gw,
  beds_one: fw,
  beds_other: bw,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_adults: hw,
  global_babies: mw,
  global_calendarUpdated_toast: pw,
  global_calendar_aMonth: yw,
  global_calendar_exactDates: vw,
  global_calendar_oneWeek: kw,
  global_calendar_oneWeekend: $w,
  global_calendar_plusMinusDay_zero: ww,
  global_calendar_plusMinusDay_one: xw,
  global_calendar_plusMinusDay_other: Cw,
  global_calendar_twoWeeks: Sw,
  global_cancel: zw,
  global_children: Aw,
  global_dates: Pw,
  global_delete: Mw,
  global_description: Dw,
  global_destination: Nw,
  global_done: Ow,
  global_edit: Iw,
  "global_filter_a-c": "Air conditionné",
  global_filter_available: jw,
  "global_filter_baby-bed": "Lits bébé",
  "global_filter_baby-gear": "Équipements bébé",
  "global_filter_balcony-terrace": "Balcon / Terrasse",
  global_filter_bathtub: Lw,
  global_filter_bbq: Ew,
  global_filter_bicycle: Bw,
  global_filter_car: Tw,
  global_filter_cat: Rw,
  "global_filter_children-welcome": "Les enfants sont les bienvenus",
  global_filter_cities: Fw,
  "global_filter_cleaning-person": "Service de ménage",
  global_filter_countryside: Vw,
  "global_filter_dedicated-workspace": "Espace de travail dédié",
  "global_filter_disabled-access": "Logement adapté",
  global_filter_dishwasher: Gw,
  global_filter_dog: Uw,
  global_filter_dryer: Zw,
  "global_filter_eco-level": "Uniquement des maisons durables",
  "global_filter_electric-car-plug": "Prise pour voiture électrique",
  global_filter_elevator: Ww,
  global_filter_favorite: Kw,
  global_filter_fireplace: qw,
  global_filter_flat: Hw,
  global_filter_garden: Jw,
  "global_filter_guest-wanted": "Échange contre GuestPoints",
  global_filter_guestPointsMax: Yw,
  global_filter_guestPointsMin: Qw,
  global_filter_guestPointsMinMax: Xw,
  global_filter_gym: ex,
  "global_filter_heating-system": "Chauffage",
  "global_filter_high-speed-connexion": "Connexion haut débit",
  global_filter_home: tx,
  "global_filter_home-verified": "Logements vérifiés",
  global_filter_island: ax,
  global_filter_isolated: ox,
  global_filter_jacuzzi: nx,
  "global_filter_kids-toys": "Jouets pour enfants",
  global_filter_lakes: rx,
  global_filter_luxury: ix,
  global_filter_mountains: lx,
  "global_filter_no-bed-up": "Pas de lit d'appoint",
  global_filter_numOfBathrooms: sx,
  global_filter_other: cx,
  "global_filter_parking-space": "Place de parking privé",
  "global_filter_pets-welcome": "Les animaux sont les bienvenus",
  global_filter_piano: ux,
  global_filter_playground: dx,
  global_filter_primary: _x,
  "global_filter_public-transit-access": "Accès aux transports publics",
  global_filter_reciprocal: gx,
  "global_filter_response-rate-above-threshold": "Réactivité ≥ Moyenne",
  global_filter_reverse: fx,
  global_filter_river: bx,
  global_filter_seaside: hx,
  global_filter_secondary: mx,
  "global_filter_secured-pool": "Piscine sécurisée",
  "global_filter_smokers-welcome": "Fumeurs bienvenus",
  "global_filter_swimming-pool": "Piscine",
  global_filter_tv: px,
  global_filter_villages: yx,
  "global_filter_washing-machine": "Lave linge",
  "global_filter_whole-unit": "L'intégralité du logement",
  global_filter_wifi: vx,
  global_filters: kx,
  global_fixDates: $x,
  global_flexDates_aMonth: wx,
  global_flexDates_aWeekend: xx,
  global_flexDates_oneWeek: Cx,
  global_flexDates_twoWeek: Sx,
  global_flexibleDates: zx,
  global_guests: Ax,
  global_homes: Px,
  global_lastMinute: Mx,
  global_location: Dx,
  global_modify: Nx,
  global_name: Ox,
  global_next: Ix,
  global_numberOfAdults_zero: jx,
  global_numberOfAdults_one: Lx,
  global_numberOfAdults_other: Ex,
  global_numberOfBabies_zero: Bx,
  global_numberOfBabies_one: Tx,
  global_numberOfBabies_other: Rx,
  global_numberOfChildren_zero: Fx,
  global_numberOfChildren_one: Vx,
  global_numberOfChildren_other: Gx,
  global_numberOfGuests_zero: Ux,
  global_numberOfGuests_one: Zx,
  global_numberOfGuests_other: Wx,
  global_phoneNumber_notValid: Kx,
  global_receiveEmailAlerts: qx,
  global_save: Hx,
  global_searchBar_noLocationFound: Jx,
  global_seeMore_link: Yx,
  global_travelWishlist: Qx,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: Xx,
  optional: eC,
  "privacy-policy": "Charte de vie privée"
}, aC = "Votre hôte pourra choisir de conserver ou de vous restituer les GuestPoints.", oC = "Des annulations injustifiées ou répétées peuvent entraîner la suspension de votre compte.", nC = "Des annulations injustifiées ou répétées peuvent entraîner la suspension de votre compte. Si des GuestPoints ont été utilisés, votre partenaire d'échange aura le choix de les conserver ou de vous les restituer.", rC = "Après cette pré-approbation, votre partenaire d'échange disposera de {nbDays} jour(s) pour finaliser (jusqu'au {date}). Sinon, votre pré-approbation expirera et vous devrez pré-approuver l'échange de nouveau.", iC = "C'est mon partenaire d'échange qui m'a demandé d'annuler", lC = "Double réservation (via une autre plateforme)", sC = "Imprévu familial", cC = "Problème de santé", uC = "Dégâts à mon domicile", dC = "Déménagement", _C = "Vous devez indiquer la raison de votre annulation.", gC = "Autre", fC = "Problème de transport", bC = "Problème de confiance", hC = "Imprévu professionnel", mC = "Vous devez saisir un motif", pC = {
  "cancellation-page.cancel-exchange": "Annuler l'échange",
  "cancellation-page.continue-cancellation": "Poursuivre l'annulation",
  "cancellation-page.keep-exchange": "Conserver mon échange",
  "cancellation-page.reason_step.checboxes_label": "Sélectionnez la raison principale de votre annulation :",
  "cancellation-page.reason_step.comment_placeholder": "Indiquez la raison de votre annulation juste ici",
  "cancellation-page.reason_step.error": "Vous devez saisir un motif",
  "cancellation-page.reason_step.title": "Pourquoi devez-vous annuler ?",
  "cancellation-page.warning-step.first-warning": "HomeExchange repose sur la confiance. N'oubliez pas que l'annulation de votre échange peut avoir un impact négatif sur votre partenaire d'échange.",
  "cancellation-page.warning-step.second-warning": "Important : Face à un nombre excessif d'annulations injustifiées en tant qu'hôte, votre compte pourrait être mis hors ligne et, en tant qu'invité-e, vous pourriez ne pas récupérer l'intégralité de vos GuestPoints.",
  page_cancellation_guest_calloutBody: aC,
  page_cancellation_host_calloutBody: oC,
  page_cancellation_reciprocal_calloutBody: nC,
  pre_approval_modal_expiration_description: rC,
  reasons_for_cancellation_asked_by_exchange_partner: iC,
  reasons_for_cancellation_double_booking_rental: lC,
  reasons_for_cancellation_family_issues: sC,
  reasons_for_cancellation_health_issues: cC,
  reasons_for_cancellation_home_damage: uC,
  reasons_for_cancellation_moving: dC,
  reasons_for_cancellation_needed: _C,
  reasons_for_cancellation_other: gC,
  reasons_for_cancellation_transportation_issues: fC,
  reasons_for_cancellation_trust_issues: bC,
  reasons_for_cancellation_work_related: hC,
  reasons_other_comment_needed: mC
}, yC = "Studio", vC = "{{count}} soba", kC = "{{count}} sobe", $C = "{{count}} sobe", wC = "", xC = "{{count}} krevet", CC = "{{count}} kreveti", SC = "{{count}} kreveti", zC = "Odrasle osobe", AC = "Bebe", PC = "Vaš je kalendar ažuriran.", MC = "Mjesec", DC = "Točni datumi", NC = "Jedan tjedan", OC = "Jedan vikend", IC = "dana", jC = "dan", LC = "dana", EC = "± {{count}} dan", BC = "Dva tjedna", TC = "Odustani", RC = "Djeca", FC = "Datumi", VC = "Izbrišite", GC = "Opis", UC = "Odredište", ZC = "Gotovo!", WC = "Uredite", KC = "Sve vrste zamjene", qC = "Kada", HC = "Roštilj", JC = "Bicikl", YC = "Automobil", QC = "Mačka", XC = "Grad", eS = "Ruralno", tS = "Perilica suđa", aS = "Pas", oS = "Sušilica", nS = "Dizalo", rS = "Favoriti", iS = "Kamin", lS = "Stan", sS = "Privatno dvorište", cS = "manje od {{max}} GP", uS = "od {{min}} GP", dS = "Između {{min}} i {{max}} GP", _S = "Privatna teretana", gS = "Kuća", fS = "Otok", bS = "Izoliran", hS = "Jacuzzi", mS = "Jezera", pS = "Domove iz Collectiona", yS = "Planine", vS = "broj kupanica: %{count}", kS = "Ostale životinje", $S = "Glasovir", wS = "Dječje igralište", xS = "Moj dom", CS = "Recipročna zamjena", SS = "Obrnuta pretraga", zS = "Rijeka", AS = "Na obali", PS = "Drugi", MS = "TV", DS = "Selo", NS = "WiFi", OS = "Filtri", IS = "Fiksni datumi", jS = "{{date}}: jedan mjesec", LS = "{{date}}: jedan vikend", ES = "{{date}}: jedan tjedan", BS = "{{date}}: dva tjedna", TS = "Fleksibilni datumi", RS = "Gosti", FS = "domova", VS = "U zadnji tren", GS = "Lokacija", US = "Uredi", ZS = "", WS = "Dalje", KS = "odraslih osoba", qS = "odrasla osoba", HS = "odrasle osobe", JS = "odraslih osoba", YS = "beba", QS = "beba", XS = "bebe", e1 = "beba", t1 = "djece", a1 = "dijete", o1 = "djeteta", n1 = "djece", r1 = "gostiju", i1 = "gost", l1 = "gosta", s1 = "gostiju", c1 = "Format telefonskog broja nije valjan.", u1 = "Primajte obavijesti e-poštom", d1 = "Spremi", _1 = "Nema pronađenih lokacija", g1 = "Saznajte više", f1 = "Planovi putovanja", b1 = "", h1 = "nije obavezno", m1 = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: yC,
  bedroomsNumbers_one: vC,
  bedroomsNumbers_few: kC,
  bedroomsNumbers_other: $C,
  beds_zero: wC,
  beds_one: xC,
  beds_few: CC,
  beds_other: SC,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_adults: zC,
  global_babies: AC,
  global_calendarUpdated_toast: PC,
  global_calendar_aMonth: MC,
  global_calendar_exactDates: DC,
  global_calendar_oneWeek: NC,
  global_calendar_oneWeekend: OC,
  global_calendar_plusMinusDay_zero: IC,
  global_calendar_plusMinusDay_one: jC,
  global_calendar_plusMinusDay_few: LC,
  global_calendar_plusMinusDay_other: EC,
  global_calendar_twoWeeks: BC,
  global_cancel: TC,
  global_children: RC,
  global_dates: FC,
  global_delete: VC,
  global_description: GC,
  global_destination: UC,
  global_done: ZC,
  global_edit: WC,
  "global_filter_a-c": "Klima uređaj",
  global_filter_available: KC,
  "global_filter_baby-bed": "Kreveti za bebe",
  "global_filter_baby-gear": "Oprema za bebe",
  "global_filter_balcony-terrace": "Balkon/terasa",
  global_filter_bathtub: qC,
  global_filter_bbq: HC,
  global_filter_bicycle: JC,
  global_filter_car: YC,
  global_filter_cat: QC,
  "global_filter_children-welcome": "Djeca su dobrodošla",
  global_filter_cities: XC,
  "global_filter_cleaning-person": "Čistačica",
  global_filter_countryside: eS,
  "global_filter_dedicated-workspace": "Zaseban radni prostor",
  "global_filter_disabled-access": "Pristupačan dom",
  global_filter_dishwasher: tS,
  global_filter_dog: aS,
  global_filter_dryer: oS,
  "global_filter_eco-level": "Samo održivi domovi",
  "global_filter_electric-car-plug": "Utikač za električni automobil",
  global_filter_elevator: nS,
  global_filter_favorite: rS,
  global_filter_fireplace: iS,
  global_filter_flat: lS,
  global_filter_garden: sS,
  "global_filter_guest-wanted": "Zamjena sa GuestPoints bodovima",
  global_filter_guestPointsMax: cS,
  global_filter_guestPointsMin: uS,
  global_filter_guestPointsMinMax: dS,
  global_filter_gym: _S,
  "global_filter_heating-system": "Sustav grijanja",
  "global_filter_high-speed-connexion": "Velika brzina veze",
  global_filter_home: gS,
  "global_filter_home-verified": "Provjereni domovi ",
  global_filter_island: fS,
  global_filter_isolated: bS,
  global_filter_jacuzzi: hS,
  "global_filter_kids-toys": "Dječje igračke",
  global_filter_lakes: mS,
  global_filter_luxury: pS,
  global_filter_mountains: yS,
  "global_filter_no-bed-up": "Nema privremenih kreveta",
  global_filter_numOfBathrooms: vS,
  global_filter_other: kS,
  "global_filter_parking-space": "Privatno parkirno mjesto",
  "global_filter_pets-welcome": "Kućni ljubimci su dobrodošli",
  global_filter_piano: $S,
  global_filter_playground: wS,
  global_filter_primary: xS,
  "global_filter_public-transit-access": "Pristup javnim prijevozom",
  global_filter_reciprocal: CS,
  "global_filter_response-rate-above-threshold": "Stopa odgovora ≥ Prosječno",
  global_filter_reverse: SS,
  global_filter_river: zS,
  global_filter_seaside: AS,
  global_filter_secondary: PS,
  "global_filter_secured-pool": "Osiguran bazen",
  "global_filter_smokers-welcome": "Dozvoljeno pušenje",
  "global_filter_swimming-pool": "Bazen",
  global_filter_tv: MS,
  global_filter_villages: DS,
  "global_filter_washing-machine": "Perilica rublja",
  "global_filter_whole-unit": "Cijela jedinica",
  global_filter_wifi: NS,
  global_filters: OS,
  global_fixDates: IS,
  global_flexDates_aMonth: jS,
  global_flexDates_aWeekend: LS,
  global_flexDates_oneWeek: ES,
  global_flexDates_twoWeek: BS,
  global_flexibleDates: TS,
  global_guests: RS,
  global_homes: FS,
  global_lastMinute: VS,
  global_location: GS,
  global_modify: US,
  global_name: ZS,
  global_next: WS,
  global_numberOfAdults_zero: KS,
  global_numberOfAdults_one: qS,
  global_numberOfAdults_few: HS,
  global_numberOfAdults_other: JS,
  global_numberOfBabies_zero: YS,
  global_numberOfBabies_one: QS,
  global_numberOfBabies_few: XS,
  global_numberOfBabies_other: e1,
  global_numberOfChildren_zero: t1,
  global_numberOfChildren_one: a1,
  global_numberOfChildren_few: o1,
  global_numberOfChildren_other: n1,
  global_numberOfGuests_zero: r1,
  global_numberOfGuests_one: i1,
  global_numberOfGuests_few: l1,
  global_numberOfGuests_other: s1,
  global_phoneNumber_notValid: c1,
  global_receiveEmailAlerts: u1,
  global_save: d1,
  global_searchBar_noLocationFound: _1,
  global_seeMore_link: g1,
  global_travelWishlist: f1,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: b1,
  optional: h1,
  "privacy-policy": "Pravila o privatnosti"
}, p1 = "Vaš će domaćin moći odabrati hoće li zadržati ili vratiti GuestPoints.", y1 = "Neopravdana ili ponavljana otkazivanja mogu dovesti do suspenzije Vašeg računa.", v1 = "Neopravdana ili ponavljana otkazivanja mogu dovesti do suspenzije Vašeg računa. Ako je zamjena bila temeljena na GuestPoints, Vaš partner za zamjenu će moći birati hoće li ih zadržati ili vratiti.", k1 = "Nakon što unaprijed odobrite ovu zamjenu, Vaš partner za zamjenu ju mora finalizirati. Za to ima {nbDays} dana (do {date}). Ako ne, Vaše će prethodno odobrenje isteći i trebat ćete ponovno prethodno odobriti zamjenu.", $1 = "Moj partner za zamjenu me zamolio da otkažem zamjenu", w1 = "Dvostruka rezervacija (druga platforma)", x1 = "Obiteljski problemi", C1 = "Zdravstveni problemi", S1 = "Oštećenje doma", z1 = "Preseljenje", A1 = "Morate navesti razloge otkazivanja.", P1 = "Ostalo", M1 = "Problemi s prijevozom", D1 = "Nepovjerenje", N1 = "Poslovni problemi", O1 = "Trebate unijeti razlog", I1 = {
  "cancellation-page.cancel-exchange": "Otkažite ovu zamjenu",
  "cancellation-page.continue-cancellation": "Nastavite s otkazivanjem",
  "cancellation-page.keep-exchange": "Zadržite ovu zamjenu",
  "cancellation-page.reason_step.checboxes_label": "Odaberite glavni razlog zašto otkazujete:",
  "cancellation-page.reason_step.comment_placeholder": "Ovdje unesite razlog otkazivanja zamjene",
  "cancellation-page.reason_step.error": "Trebate unijeti razlog",
  "cancellation-page.reason_step.title": "Zašto trebate otkazati?",
  "cancellation-page.warning-step.first-warning": "HomeExchange se oslanja na povjerenje i pouzdanost. Vodite računa o tome da otkazivanje može utjecati na Vašeg partnera za zamjenu.",
  "cancellation-page.warning-step.second-warning": "Važno: U slučaju pretjeranih neopradanih otkazivanja u svojstvu domaćina, Vaš račun može biti ugašen.. A kao gost, možda Vam neće biti vraćeni Vaši GuestPoints.",
  page_cancellation_guest_calloutBody: p1,
  page_cancellation_host_calloutBody: y1,
  page_cancellation_reciprocal_calloutBody: v1,
  pre_approval_modal_expiration_description: k1,
  reasons_for_cancellation_asked_by_exchange_partner: $1,
  reasons_for_cancellation_double_booking_rental: w1,
  reasons_for_cancellation_family_issues: x1,
  reasons_for_cancellation_health_issues: C1,
  reasons_for_cancellation_home_damage: S1,
  reasons_for_cancellation_moving: z1,
  reasons_for_cancellation_needed: A1,
  reasons_for_cancellation_other: P1,
  reasons_for_cancellation_transportation_issues: M1,
  reasons_for_cancellation_trust_issues: D1,
  reasons_for_cancellation_work_related: N1,
  reasons_other_comment_needed: O1
}, j1 = "Monolocale", L1 = "{{count}} camera da letto", E1 = "{{count}} camere da letto", B1 = "", T1 = "{{count}} letto", R1 = "{{count}} letti", F1 = "Adulti", V1 = "Neonati", G1 = "Il tuo calendario è stato aggiornato.", U1 = "Un mese", Z1 = "Date esatte", W1 = "Una settimana", K1 = "", q1 = "", H1 = "", J1 = "", Y1 = "Due settimane", Q1 = "Annulla", X1 = "Bambini", ez = "Date", tz = "Elimina", az = "Descrizione", oz = "Destinazione", nz = "Fatto!", rz = "Modifica", iz = "Qualsiasi tipo di scambio", lz = "Vasca da bagno", sz = "Barbecue", cz = "Bicicletta", uz = "Automobile", dz = "Gatto", _z = "Città", gz = "Campagna", fz = "Lavastoviglie", bz = "Cane", hz = "Asciugatrice", mz = "Ascensore", pz = "Case preferite", yz = "Camino", vz = "Appartamento", kz = "Cortile privato", $z = "Meno di {{max}} GP", wz = "da {{min}} GP", xz = "Tra {{min}} e {{max}} GP", Cz = "Palestra privata", Sz = "Casa", zz = "Isola o penisola", Az = "Isolata", Pz = "Idromassaggio", Mz = "Lago", Dz = "Case Collection", Nz = "Montagna", Oz = "{{count}} bagni", Iz = "Altri animali", jz = "Pianoforte", Lz = "Zona giochi per bambini", Ez = "Prima", Bz = "Scambio reciproco", Tz = "Ricerca inversa", Rz = "Fiume", Fz = "Sulla costa", Vz = "Seconda", Gz = "TV", Uz = "Paese", Zz = "WiFi", Wz = "Filtri", Kz = "Date esatte", qz = "Un mese in {{date}}", Hz = "Un fine settimana in {{date}}", Jz = "Una settimana in {{date}}", Yz = "Due settimane in {{date}}", Qz = "Date flessibili", Xz = "Ospiti", eA = "case", tA = "Ultimo minuto", aA = "Posizione", oA = "Modifica", nA = "Nome", rA = "Avanti", iA = "Zero", lA = "Uno", sA = "Altro", cA = "Zero", uA = "Uno", dA = "Altro", _A = "Zero", gA = "Uno", fA = "Altro", bA = "Zero", hA = "Uno", mA = "Altro", pA = "Il formato del numero di telefono non è valido.", yA = "Ricevi avvisi via email", vA = "Salva", kA = "Nessuna posizione trovata", $A = "Vedere di più", wA = "Lista dei progetti di viaggio", xA = "", CA = "facoltativo", SA = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: j1,
  bedroomsNumbers_one: L1,
  bedroomsNumbers_other: E1,
  beds_zero: B1,
  beds_one: T1,
  beds_other: R1,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_adults: F1,
  global_babies: V1,
  global_calendarUpdated_toast: G1,
  global_calendar_aMonth: U1,
  global_calendar_exactDates: Z1,
  global_calendar_oneWeek: W1,
  global_calendar_oneWeekend: K1,
  global_calendar_plusMinusDay_zero: q1,
  global_calendar_plusMinusDay_one: H1,
  global_calendar_plusMinusDay_other: J1,
  global_calendar_twoWeeks: Y1,
  global_cancel: Q1,
  global_children: X1,
  global_dates: ez,
  global_delete: tz,
  global_description: az,
  global_destination: oz,
  global_done: nz,
  global_edit: rz,
  "global_filter_a-c": "Aria condizionata",
  global_filter_available: iz,
  "global_filter_baby-bed": "Lettini per bambini",
  "global_filter_baby-gear": "Attrezzature per neonato",
  "global_filter_balcony-terrace": "Balcone/Terrazza",
  global_filter_bathtub: lz,
  global_filter_bbq: sz,
  global_filter_bicycle: cz,
  global_filter_car: uz,
  global_filter_cat: dz,
  "global_filter_children-welcome": "Bambini benvenuti",
  global_filter_cities: _z,
  "global_filter_cleaning-person": "Donna delle pulizie",
  global_filter_countryside: gz,
  "global_filter_dedicated-workspace": "Spazio di lavoro dedicato",
  "global_filter_disabled-access": "Casa accessibile alle sedie a rotelle",
  global_filter_dishwasher: fz,
  global_filter_dog: bz,
  global_filter_dryer: hz,
  "global_filter_eco-level": "Solo case sostenibili",
  "global_filter_electric-car-plug": "Presa per auto elettrica",
  global_filter_elevator: mz,
  global_filter_favorite: pz,
  global_filter_fireplace: yz,
  global_filter_flat: vz,
  global_filter_garden: kz,
  "global_filter_guest-wanted": "Scambio con GuestPoints",
  global_filter_guestPointsMax: $z,
  global_filter_guestPointsMin: wz,
  global_filter_guestPointsMinMax: xz,
  global_filter_gym: Cz,
  "global_filter_heating-system": "Sistema di riscaldamento",
  "global_filter_high-speed-connexion": "Connessione ad alta velocità",
  global_filter_home: Sz,
  "global_filter_home-verified": "Case verificate",
  global_filter_island: zz,
  global_filter_isolated: Az,
  global_filter_jacuzzi: Pz,
  "global_filter_kids-toys": "Giocattoli per bambini",
  global_filter_lakes: Mz,
  global_filter_luxury: Dz,
  global_filter_mountains: Nz,
  "global_filter_no-bed-up": "Nessun letto temporaneo",
  global_filter_numOfBathrooms: Oz,
  global_filter_other: Iz,
  "global_filter_parking-space": "Posto auto privato",
  "global_filter_pets-welcome": "Animali domestici ammessi",
  global_filter_piano: jz,
  global_filter_playground: Lz,
  global_filter_primary: Ez,
  "global_filter_public-transit-access": "Accesso ai trasporti pubblici",
  global_filter_reciprocal: Bz,
  "global_filter_response-rate-above-threshold": "Tasso di risposta ≥ Nella media",
  global_filter_reverse: Tz,
  global_filter_river: Rz,
  global_filter_seaside: Fz,
  global_filter_secondary: Vz,
  "global_filter_secured-pool": "Piscina protetta",
  "global_filter_smokers-welcome": "I fumatori sono i benvenuti",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: Gz,
  global_filter_villages: Uz,
  "global_filter_washing-machine": "Lavatrice",
  "global_filter_whole-unit": "L'intera unità",
  global_filter_wifi: Zz,
  global_filters: Wz,
  global_fixDates: Kz,
  global_flexDates_aMonth: qz,
  global_flexDates_aWeekend: Hz,
  global_flexDates_oneWeek: Jz,
  global_flexDates_twoWeek: Yz,
  global_flexibleDates: Qz,
  global_guests: Xz,
  global_homes: eA,
  global_lastMinute: tA,
  global_location: aA,
  global_modify: oA,
  global_name: nA,
  global_next: rA,
  global_numberOfAdults_zero: iA,
  global_numberOfAdults_one: lA,
  global_numberOfAdults_other: sA,
  global_numberOfBabies_zero: cA,
  global_numberOfBabies_one: uA,
  global_numberOfBabies_other: dA,
  global_numberOfChildren_zero: _A,
  global_numberOfChildren_one: gA,
  global_numberOfChildren_other: fA,
  global_numberOfGuests_zero: bA,
  global_numberOfGuests_one: hA,
  global_numberOfGuests_other: mA,
  global_phoneNumber_notValid: pA,
  global_receiveEmailAlerts: yA,
  global_save: vA,
  global_searchBar_noLocationFound: kA,
  global_seeMore_link: $A,
  global_travelWishlist: wA,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: xA,
  optional: CA,
  "privacy-policy": "Informativa sulla privacy"
}, zA = "Il tuo host potrà scegliere se conservare o restituire i GuestPoints a suo piacimento.", AA = "Cancellazioni ingiustificate o ripetute potrebbero comportare la sospensione del tuo account.", PA = "Cancellazioni ingiustificate o ripetute potrebbero comportare la sospensione del tuo account. Se sono coinvolti GuestPoints, il tuo partner di scambio avrà la possibilità di conservarli o restituirli.", MA = "Dopo aver pre-approvato questo scambio, il tuo partner di scambio dovrà finalizzarlo. Avrà tempo {nbDays} giorni per finalizzare lo scambio (fino al giorno {date}). In caso contrario, la tua pre-approvazione scadrà e dovrai pre-approvare lo scambio nuovamente.", DA = "Il mio partner di scambio mi ha chiesto di annullare lo scambio", NA = "Doppia prenotazione (con un'altra piattaforma)", OA = "Ragioni familiari", IA = "Motivi di salute", jA = "Danni alla proprietà", LA = "Trasferimento", EA = "È necessario indicare i motivi per la cancellazione.", BA = "Altro", TA = "Problemi di trasporto", RA = "Problemi di fiducia", FA = "Motivi legati al lavoro", VA = "È necessario inserire un motivo", GA = {
  "cancellation-page.cancel-exchange": "Annulla questo scambio",
  "cancellation-page.continue-cancellation": "Continua con la cancellazione",
  "cancellation-page.keep-exchange": "Mantieni questo scambio",
  "cancellation-page.reason_step.checboxes_label": "Seleziona il motivo principale della tua cancellazione:",
  "cancellation-page.reason_step.comment_placeholder": "Inserisci qui la ragione della cancellazione",
  "cancellation-page.reason_step.error": "È necessario inserire un motivo",
  "cancellation-page.reason_step.title": "Perché devi annullare?",
  "cancellation-page.warning-step.first-warning": "HomeExchange si basa sulla fiducia e sull'affidabilità. Ricorda che la cancellazione potrebbe avere ripercussioni sul tuo partner di scambio.",
  "cancellation-page.warning-step.second-warning": "Importante: In caso di eccessive cancellazioni ingiustificate in qualità di host, il tuo account potrebbe essere disattivato. Come ospite, invece, potresti non recuperare tutti i tuoi GuestPoints.",
  page_cancellation_guest_calloutBody: zA,
  page_cancellation_host_calloutBody: AA,
  page_cancellation_reciprocal_calloutBody: PA,
  pre_approval_modal_expiration_description: MA,
  reasons_for_cancellation_asked_by_exchange_partner: DA,
  reasons_for_cancellation_double_booking_rental: NA,
  reasons_for_cancellation_family_issues: OA,
  reasons_for_cancellation_health_issues: IA,
  reasons_for_cancellation_home_damage: jA,
  reasons_for_cancellation_moving: LA,
  reasons_for_cancellation_needed: EA,
  reasons_for_cancellation_other: BA,
  reasons_for_cancellation_transportation_issues: TA,
  reasons_for_cancellation_trust_issues: RA,
  reasons_for_cancellation_work_related: FA,
  reasons_other_comment_needed: VA
}, UA = "Studio", ZA = "{{count}} soverom", WA = "{{count}} soverom", KA = "", qA = "{{count}} seng", HA = "{{count}} senger", JA = "Voksne", YA = "Babyer", QA = "", XA = "En måned", e0 = "Nøyaktige datoer", t0 = "Uke", a0 = "", o0 = "", n0 = "", r0 = "", i0 = "To uker", l0 = "", s0 = "Barn", c0 = "Datoer", u0 = "", d0 = "Beskrivelse", _0 = "Reisemål", g0 = "", f0 = "", b0 = "alle typer boligbytter", h0 = "Badekar", m0 = "Grill", p0 = "Sykkel", y0 = "Bil", v0 = "Katt", k0 = "By", $0 = "Landlig", w0 = "Oppvaskmaskin", x0 = "Hund", C0 = "Tørketrommel", S0 = "Heis", z0 = "Favoritthjem", A0 = "Peis", P0 = "Leilighet", M0 = "", D0 = "mindre enn {{max}} GP", N0 = "fra {{min}} GP", O0 = "Mellom {{min}} og {{max}} GP", I0 = "Privat treningsrom", j0 = "Hus", L0 = "Øy", E0 = "Isolert", B0 = "Jacuzzi", T0 = "Innsjøer", R0 = "Collection-hjem", F0 = "Fjell", V0 = "", G0 = "Andre dyr", U0 = "Piano", Z0 = "", W0 = "Primær", K0 = "Gjensidig boligbytte", q0 = "Omvendt søk", H0 = "Elv", J0 = "", Y0 = "Sekundær", Q0 = "TV", X0 = "Landsbygd", eP = "WiFi", tP = "Filtrer", aP = "Nøyaktige datoer", oP = "", nP = "", rP = "", iP = "", lP = "Fleksible datoer", sP = "Gjester", cP = "", uP = "Siste øyeblikk", dP = "Beliggenhet", _P = "", gP = "", fP = "", bP = "", hP = "", mP = "", pP = "", yP = "", vP = "", kP = "", $P = "", wP = "", xP = "", CP = "", SP = "", zP = "", AP = "", PP = "Lagre", MP = "", DP = "Se mer", NP = "", OP = "", IP = "", jP = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: UA,
  bedroomsNumbers_one: ZA,
  bedroomsNumbers_other: WA,
  beds_zero: KA,
  beds_one: qA,
  beds_other: HA,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: JA,
  global_babies: YA,
  global_calendarUpdated_toast: QA,
  global_calendar_aMonth: XA,
  global_calendar_exactDates: e0,
  global_calendar_oneWeek: t0,
  global_calendar_oneWeekend: a0,
  global_calendar_plusMinusDay_zero: o0,
  global_calendar_plusMinusDay_one: n0,
  global_calendar_plusMinusDay_other: r0,
  global_calendar_twoWeeks: i0,
  global_cancel: l0,
  global_children: s0,
  global_dates: c0,
  global_delete: u0,
  global_description: d0,
  global_destination: _0,
  global_done: g0,
  global_edit: f0,
  "global_filter_a-c": "Klimaanlegg",
  global_filter_available: b0,
  "global_filter_baby-bed": "Sprinkelsenger",
  "global_filter_baby-gear": "Babyutstyr",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: h0,
  global_filter_bbq: m0,
  global_filter_bicycle: p0,
  global_filter_car: y0,
  global_filter_cat: v0,
  "global_filter_children-welcome": "Barn velkommen",
  global_filter_cities: k0,
  "global_filter_cleaning-person": "Rengjøringsperson",
  global_filter_countryside: $0,
  "global_filter_dedicated-workspace": "",
  "global_filter_disabled-access": "Tilgjengelig for funksjonshemmede",
  global_filter_dishwasher: w0,
  global_filter_dog: x0,
  global_filter_dryer: C0,
  "global_filter_eco-level": "Bare bærekraftige hjem",
  "global_filter_electric-car-plug": "Elektrisk bilplugg",
  global_filter_elevator: S0,
  global_filter_favorite: z0,
  global_filter_fireplace: A0,
  global_filter_flat: P0,
  global_filter_garden: M0,
  "global_filter_guest-wanted": "Boligbytte med GuestPoints",
  global_filter_guestPointsMax: D0,
  global_filter_guestPointsMin: N0,
  global_filter_guestPointsMinMax: O0,
  global_filter_gym: I0,
  "global_filter_heating-system": "Oppvarming",
  "global_filter_high-speed-connexion": "Høyhastighets tilkobling",
  global_filter_home: j0,
  "global_filter_home-verified": "Verifiserte hjem",
  global_filter_island: L0,
  global_filter_isolated: E0,
  global_filter_jacuzzi: B0,
  "global_filter_kids-toys": "Barneleker",
  global_filter_lakes: T0,
  global_filter_luxury: R0,
  global_filter_mountains: F0,
  "global_filter_no-bed-up": "",
  global_filter_numOfBathrooms: V0,
  global_filter_other: G0,
  "global_filter_parking-space": "Privat parkering",
  "global_filter_pets-welcome": "Kjæledyr velkommen",
  global_filter_piano: U0,
  global_filter_playground: Z0,
  global_filter_primary: W0,
  "global_filter_public-transit-access": "Tilgang til offentlig transport",
  global_filter_reciprocal: K0,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: q0,
  global_filter_river: H0,
  global_filter_seaside: J0,
  global_filter_secondary: Y0,
  "global_filter_secured-pool": "Sikret badebasseng",
  "global_filter_smokers-welcome": "Røykere velkommen",
  "global_filter_swimming-pool": "Svømmebasseng",
  global_filter_tv: Q0,
  global_filter_villages: X0,
  "global_filter_washing-machine": "Vaskemaskin",
  "global_filter_whole-unit": "Hele boligen",
  global_filter_wifi: eP,
  global_filters: tP,
  global_fixDates: aP,
  global_flexDates_aMonth: oP,
  global_flexDates_aWeekend: nP,
  global_flexDates_oneWeek: rP,
  global_flexDates_twoWeek: iP,
  global_flexibleDates: lP,
  global_guests: sP,
  global_homes: cP,
  global_lastMinute: uP,
  global_location: dP,
  global_modify: _P,
  global_name: gP,
  global_next: fP,
  global_numberOfAdults_zero: bP,
  global_numberOfAdults_one: hP,
  global_numberOfAdults_other: mP,
  global_numberOfBabies_zero: pP,
  global_numberOfBabies_one: yP,
  global_numberOfBabies_other: vP,
  global_numberOfChildren_zero: kP,
  global_numberOfChildren_one: $P,
  global_numberOfChildren_other: wP,
  global_numberOfGuests_zero: xP,
  global_numberOfGuests_one: CP,
  global_numberOfGuests_other: SP,
  global_phoneNumber_notValid: zP,
  global_receiveEmailAlerts: AP,
  global_save: PP,
  global_searchBar_noLocationFound: MP,
  global_seeMore_link: DP,
  global_travelWishlist: NP,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: OP,
  optional: IP,
  "privacy-policy": "Personvernpolicy"
}, LP = "", EP = "", BP = "", TP = "Etter at du har forhåndsgodkjent dette boligbyttet må din boligbyttepartner ferdigstille det. De har {nbDays} dager på seg til å ferdigstille boligbyttet (frem til {date}). Om ikke vil forhåndsgodkjenningen din utløpe, og du må forhåndsgodkjenne boligbyttet på nytt.", RP = "", FP = "Dobbelbooking (via en annen plattform)", VP = "Famileproblemer", GP = "Helseproblemer", UP = "Skade på boligen", ZP = "Flytting", WP = "Du må angi årsakene til avbestillingen.", KP = "Annet", qP = "Transportproblemer", HP = "Tillitsbrudd", JP = "Arbeidsrelatert", YP = "Du må oppgi en grunn", QP = {
  "cancellation-page.cancel-exchange": "Kanseller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsett kansellering",
  "cancellation-page.keep-exchange": "Behold boligbyttet",
  "cancellation-page.reason_step.checboxes_label": "Velg hovedårsaken for din kansellering:",
  "cancellation-page.reason_step.comment_placeholder": "Oppgi årsaken for din kansellering her",
  "cancellation-page.reason_step.error": "Du må oppgi en grunn",
  "cancellation-page.reason_step.title": "Hvorfor ønsker du å kansellere?",
  "cancellation-page.warning-step.first-warning": "Husk at det å kansellere boligbyttet kan ha en negativ innvirkning på din boligbyttepartner, som kanskje allerede har lagt reiseplaner!",
  "cancellation-page.warning-step.second-warning": "Viktig: Dersom du kansellerer et boligbytte som vert uten gyldig grunn kan din konto bli sperret. Som gjest kan konsekvensen være at du ikke får refundert alle dine GuestPoints.",
  page_cancellation_guest_calloutBody: LP,
  page_cancellation_host_calloutBody: EP,
  page_cancellation_reciprocal_calloutBody: BP,
  pre_approval_modal_expiration_description: TP,
  reasons_for_cancellation_asked_by_exchange_partner: RP,
  reasons_for_cancellation_double_booking_rental: FP,
  reasons_for_cancellation_family_issues: VP,
  reasons_for_cancellation_health_issues: GP,
  reasons_for_cancellation_home_damage: UP,
  reasons_for_cancellation_moving: ZP,
  reasons_for_cancellation_needed: WP,
  reasons_for_cancellation_other: KP,
  reasons_for_cancellation_transportation_issues: qP,
  reasons_for_cancellation_trust_issues: HP,
  reasons_for_cancellation_work_related: JP,
  reasons_other_comment_needed: YP
}, XP = "Studio", eM = "{{count}} slaapkamer", tM = "{{count}} slaapkamers", aM = "", oM = "{{count}} bed", nM = "{{count}} bedden", rM = "Volwassenen", iM = "Baby's", lM = "Je kalender is bijgewerkt.", sM = "Een maand", cM = "Exacte data", uM = "Een week", dM = "Een weekend", _M = "", gM = "", fM = "± {{count}} dagen", bM = "Twee weken", hM = "Annuleren", mM = "Kinderen", pM = "Data", yM = "Verwijderen", vM = "Beschrijving", kM = "Bestemming", $M = "Klaar!", wM = "Bewerken", xM = "Elk type ruil", CM = "Bad", SM = "BBQ", zM = "Fiets", AM = "Auto", PM = "Kat", MM = "De stad", DM = "Het platteland", NM = "Vaatwasmachine", OM = "Hond", IM = "Droger", jM = "Lift", LM = "Favoriete huizen", EM = "Open haard", BM = "Appartement", TM = "Privétuin", RM = "Minder dan {{max}} GP", FM = "vanaf {{min}} GP", VM = "Tussen {{min}} en {{max}} GP", GM = "Privésportzaal", UM = "Huis", ZM = "Een eiland", WM = "Geïsoleerd", KM = "Jacuzzi", qM = "Een meer", HM = "Collection-huizen", JM = "De bergen", YM = "{{count}} badkamers", QM = "Andere dieren", XM = "", eD = "Speeltuin", tD = "Eerste", aD = "Wederzijdse huizenruil", oD = "Omgekeerd zoeken", nD = "Rivier", rD = "Kust", iD = "Vakantiehuis", lD = "TV", sD = "Dorp", cD = "WiFi", uD = "Filters", dD = "Vaste data", _D = "Een maand in {{date}}", gD = "Een weekend in {{date}}", fD = "Een week in {{date}}", bD = "Twee weken in {{date}}", hD = "Flexibele data", mD = "Gasten", pD = "huizen", yD = "Last minute", vD = "Locatie", kD = "Wijzigen", $D = "Naam", wD = "Volgende", xD = "", CD = "{{count}} volwassene", SD = "{{count}} volwassenen", zD = "", AD = "{{count}} baby", PD = "{{count}} baby's", MD = "", DD = "{{count}} kind", ND = "{{count}} kinderen", OD = "", ID = "{{count}} gast", jD = "{{count}} gasten", LD = "De indeling van het telefoonnummer is niet geldig.", ED = "E-mailmeldingen ontvangen", BD = "Opslaan", TD = "Geen locaties gevonden", RD = "Bekijk meer", FD = "Reisplannen", VD = "Geen resultaat", GD = "optioneel", UD = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: XP,
  bedroomsNumbers_one: eM,
  bedroomsNumbers_other: tM,
  beds_zero: aM,
  beds_one: oM,
  beds_other: nM,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_adults: rM,
  global_babies: iM,
  global_calendarUpdated_toast: lM,
  global_calendar_aMonth: sM,
  global_calendar_exactDates: cM,
  global_calendar_oneWeek: uM,
  global_calendar_oneWeekend: dM,
  global_calendar_plusMinusDay_zero: _M,
  global_calendar_plusMinusDay_one: gM,
  global_calendar_plusMinusDay_other: fM,
  global_calendar_twoWeeks: bM,
  global_cancel: hM,
  global_children: mM,
  global_dates: pM,
  global_delete: yM,
  global_description: vM,
  global_destination: kM,
  global_done: $M,
  global_edit: wM,
  "global_filter_a-c": "Airco",
  global_filter_available: xM,
  "global_filter_baby-bed": "Babybedden",
  "global_filter_baby-gear": "Baby spullen",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: CM,
  global_filter_bbq: SM,
  global_filter_bicycle: zM,
  global_filter_car: AM,
  global_filter_cat: PM,
  "global_filter_children-welcome": "Kinderen welkom",
  global_filter_cities: MM,
  "global_filter_cleaning-person": "Schoonmaakster",
  global_filter_countryside: DM,
  "global_filter_dedicated-workspace": "Toegewijde werkruimte",
  "global_filter_disabled-access": "Toegankelijk voor invaliden",
  global_filter_dishwasher: NM,
  global_filter_dog: OM,
  global_filter_dryer: IM,
  "global_filter_eco-level": "Alleen duurzame woningen",
  "global_filter_electric-car-plug": "Elektrische auto stekker",
  global_filter_elevator: jM,
  global_filter_favorite: LM,
  global_filter_fireplace: EM,
  global_filter_flat: BM,
  global_filter_garden: TM,
  "global_filter_guest-wanted": "Ruil tegen GuestPoints",
  global_filter_guestPointsMax: RM,
  global_filter_guestPointsMin: FM,
  global_filter_guestPointsMinMax: VM,
  global_filter_gym: GM,
  "global_filter_heating-system": "Verwarming",
  "global_filter_high-speed-connexion": "Snelle verbinding",
  global_filter_home: UM,
  "global_filter_home-verified": "Geverifieerde huizen",
  global_filter_island: ZM,
  global_filter_isolated: WM,
  global_filter_jacuzzi: KM,
  "global_filter_kids-toys": "Kinderen speelgoed",
  global_filter_lakes: qM,
  global_filter_luxury: HM,
  global_filter_mountains: JM,
  "global_filter_no-bed-up": "Geen tijdelijke bedden",
  global_filter_numOfBathrooms: YM,
  global_filter_other: QM,
  "global_filter_parking-space": "Privé parkeerplaats",
  "global_filter_pets-welcome": "Huisdieren toegestaan ",
  global_filter_piano: XM,
  global_filter_playground: eD,
  global_filter_primary: tD,
  "global_filter_public-transit-access": "Toegang tot het openbaar vervoer",
  global_filter_reciprocal: aD,
  "global_filter_response-rate-above-threshold": "Responspercentage ≥ Gemiddeld",
  global_filter_reverse: oD,
  global_filter_river: nD,
  global_filter_seaside: rD,
  global_filter_secondary: iD,
  "global_filter_secured-pool": "Beveiligd zwembad",
  "global_filter_smokers-welcome": "Roken toegestaan ",
  "global_filter_swimming-pool": "Zwembad",
  global_filter_tv: lD,
  global_filter_villages: sD,
  "global_filter_washing-machine": "Wasmachine",
  "global_filter_whole-unit": "De hele woning",
  global_filter_wifi: cD,
  global_filters: uD,
  global_fixDates: dD,
  global_flexDates_aMonth: _D,
  global_flexDates_aWeekend: gD,
  global_flexDates_oneWeek: fD,
  global_flexDates_twoWeek: bD,
  global_flexibleDates: hD,
  global_guests: mD,
  global_homes: pD,
  global_lastMinute: yD,
  global_location: vD,
  global_modify: kD,
  global_name: $D,
  global_next: wD,
  global_numberOfAdults_zero: xD,
  global_numberOfAdults_one: CD,
  global_numberOfAdults_other: SD,
  global_numberOfBabies_zero: zD,
  global_numberOfBabies_one: AD,
  global_numberOfBabies_other: PD,
  global_numberOfChildren_zero: MD,
  global_numberOfChildren_one: DD,
  global_numberOfChildren_other: ND,
  global_numberOfGuests_zero: OD,
  global_numberOfGuests_one: ID,
  global_numberOfGuests_other: jD,
  global_phoneNumber_notValid: LD,
  global_receiveEmailAlerts: ED,
  global_save: BD,
  global_searchBar_noLocationFound: TD,
  global_seeMore_link: RD,
  global_travelWishlist: FD,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: VD,
  optional: GD,
  "privacy-policy": "Privacy"
}, ZD = "Je gastheer/-vrouw heeft de keuze om de GuestPoints te houden of terug te geven.", WD = "Ongerechtvaardigde of herhaalde annuleringen kunnen ertoe leiden dat je account wordt opgeschort.", KD = "Ongerechtvaardigde of herhaalde annuleringen kunnen ertoe leiden dat je account wordt opgeschort. Als er GuestPoints bij betrokken waren, heeft je uitwisselingspartner de keuze om deze te houden of terug te geven.", qD = "Nadat je de uitwisseling hebt goedgekeurd, moet je uitwisselingspartner deze bevestigen. Hij of zij heeft {nbDays} dagen de tijd om dit te doen (tot {date}). Anders vervalt je voorlopige goedkeuring en moet je de uitwisseling opnieuw goedkeuren.", HD = "Mijn uitwisselingspartner heeft me gevraagd de uitwisseling te annuleren", JD = "Dubbele boeking (via een ander platform)", YD = "Familiale redenen", QD = "Gezondheidsproblemen", XD = "Schade aan het huis", eN = "Verhuis", tN = "Je moet de redenen voor je annulering aangeven.", aN = "Andere", oN = "Problemen met het transport", nN = "Vertrouwenskwestie", rN = "Werkgerelateerde redenen", iN = "Je moet een reden opgeven", lN = {
  "cancellation-page.cancel-exchange": "Annuleer de uitwisseling",
  "cancellation-page.continue-cancellation": "Doorgaan met annuleren",
  "cancellation-page.keep-exchange": "Mijn uitwisseling behouden",
  "cancellation-page.reason_step.checboxes_label": "Selecteer de hoofdreden voor je annulering:",
  "cancellation-page.reason_step.comment_placeholder": "Schrijf hier de reden van de annulering.",
  "cancellation-page.reason_step.error": "Je moet een reden opgeven",
  "cancellation-page.reason_step.title": "Waarom moet je annuleren?",
  "cancellation-page.warning-step.first-warning": "HomeExchange is gebaseerd op vertrouwen en betrouwbaarheid. Vergeet niet dat annuleren gevolgen kan hebben voor je uitwisselingspartner.",
  "cancellation-page.warning-step.second-warning": "Belangrijk: Als je als gastheer/-vrouw te vaak onterecht annuleert, kan je account offline worden gehaald. En als gast kan het zijn dat je niet al je GuestPoints terugkrijgt.",
  page_cancellation_guest_calloutBody: ZD,
  page_cancellation_host_calloutBody: WD,
  page_cancellation_reciprocal_calloutBody: KD,
  pre_approval_modal_expiration_description: qD,
  reasons_for_cancellation_asked_by_exchange_partner: HD,
  reasons_for_cancellation_double_booking_rental: JD,
  reasons_for_cancellation_family_issues: YD,
  reasons_for_cancellation_health_issues: QD,
  reasons_for_cancellation_home_damage: XD,
  reasons_for_cancellation_moving: eN,
  reasons_for_cancellation_needed: tN,
  reasons_for_cancellation_other: aN,
  reasons_for_cancellation_transportation_issues: oN,
  reasons_for_cancellation_trust_issues: nN,
  reasons_for_cancellation_work_related: rN,
  reasons_other_comment_needed: iN
}, sN = "Studio", cN = "{{count}} quarto", uN = "{{count}} quartos", dN = "", _N = "{{count}} cama", gN = "{{count}} camas", fN = "", bN = "", hN = "O seu calendário foi atualizado.", mN = "Um mês", pN = "Datas exatas", yN = "Uma semana", vN = "Um fim de semana", kN = "", $N = "± 1:{{count}} dia", wN = "± {{count]] dias", xN = "Duas semanas", CN = "Cancelar", SN = "", zN = "Datas", AN = "Eliminar", PN = "Descrição", MN = "Destino", DN = "Feito!", NN = "Editar", ON = "Qualquer tipo de pedido de Troca", IN = "Banheiro", jN = "BBQ", LN = "Bicicleta", EN = "Carro", BN = "Gato", TN = "Cidade", RN = "Campo", FN = "Lavadora de louças", VN = "Cão", GN = "Secadora", UN = "Elevador", ZN = "Casas favoritas", WN = "Lareira", KN = "Apartamento", qN = "Quintal privado", HN = "", JN = "", YN = "", QN = "", XN = "Casa", eO = "Ilha", tO = "Isolada", aO = "Jacuzzi", oO = "Lagos", nO = "Casas Collection", rO = "", iO = "{{count}} casas de banho", lO = "Outros animais", sO = "Piano", cO = "Parque infantil", uO = "Principal", dO = "Troca Reciproca", _O = "Busca invertida", gO = "Rio", fO = "Litoral", bO = "Secundária", hO = "TV", mO = "Aldeia", pO = "WiFi", yO = "Filtros", vO = "Datas fixas", kO = "Um mês em {{date}}", $O = "Um fim de semana em {{date}}", wO = "Uma semana em {{date}}", xO = "Duas semanas em {{date}}", CO = "Datas flexíveis", SO = "Convidados", zO = "casas", AO = "Última hora", PO = "Localização", MO = "Modificar", DO = "Nome", NO = "Seguinte", OO = "", IO = "{{count}} adulto", jO = "{{count}} adultos", LO = "", EO = "{{count}} bebé", BO = "{{count}} bebés", TO = "", RO = "{{count}} criança", FO = "{{count}} crianças", VO = "", GO = "{{count}} convidado", UO = "{{count}} convidados", ZO = "O formato do número de telefone não é válido.", WO = "Receber alertas por e-mail", KO = "Guardar", qO = "Não foram encontradas localizações", HO = "Ver mais", JO = "Ideias de viagens", YO = "", QO = "", XO = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: sN,
  bedroomsNumbers_one: cN,
  bedroomsNumbers_other: uN,
  beds_zero: dN,
  beds_one: _N,
  beds_other: gN,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: fN,
  global_babies: bN,
  global_calendarUpdated_toast: hN,
  global_calendar_aMonth: mN,
  global_calendar_exactDates: pN,
  global_calendar_oneWeek: yN,
  global_calendar_oneWeekend: vN,
  global_calendar_plusMinusDay_zero: kN,
  global_calendar_plusMinusDay_one: $N,
  global_calendar_plusMinusDay_other: wN,
  global_calendar_twoWeeks: xN,
  global_cancel: CN,
  global_children: SN,
  global_dates: zN,
  global_delete: AN,
  global_description: PN,
  global_destination: MN,
  global_done: DN,
  global_edit: NN,
  "global_filter_a-c": "A/C",
  global_filter_available: ON,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamento para bebês",
  "global_filter_balcony-terrace": "Varanda/Terraço",
  global_filter_bathtub: IN,
  global_filter_bbq: jN,
  global_filter_bicycle: LN,
  global_filter_car: EN,
  global_filter_cat: BN,
  "global_filter_children-welcome": "Crianças bem vindas",
  global_filter_cities: TN,
  "global_filter_cleaning-person": "Faxineiro",
  global_filter_countryside: RN,
  "global_filter_dedicated-workspace": "Espaço de trabalho dedicado",
  "global_filter_disabled-access": "Casa acessível",
  global_filter_dishwasher: FN,
  global_filter_dog: VN,
  global_filter_dryer: GN,
  "global_filter_eco-level": "Só casas sustentáveis",
  "global_filter_electric-car-plug": "Tomada para carro elétrico",
  global_filter_elevator: UN,
  global_filter_favorite: ZN,
  global_filter_fireplace: WN,
  global_filter_flat: KN,
  global_filter_garden: qN,
  "global_filter_guest-wanted": "Troca por GuestPoints",
  global_filter_guestPointsMax: HN,
  global_filter_guestPointsMin: JN,
  global_filter_guestPointsMinMax: YN,
  global_filter_gym: QN,
  "global_filter_heating-system": "Sistema de aquecimento",
  "global_filter_high-speed-connexion": "Wi-fi de alta velocidade",
  global_filter_home: XN,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: eO,
  global_filter_isolated: tO,
  global_filter_jacuzzi: aO,
  "global_filter_kids-toys": "",
  global_filter_lakes: oO,
  global_filter_luxury: nO,
  global_filter_mountains: rO,
  "global_filter_no-bed-up": "Sem camas temporárias",
  global_filter_numOfBathrooms: iO,
  global_filter_other: lO,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Animais de estimação bem-vindos",
  global_filter_piano: sO,
  global_filter_playground: cO,
  global_filter_primary: uO,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: dO,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: _O,
  global_filter_river: gO,
  global_filter_seaside: fO,
  global_filter_secondary: bO,
  "global_filter_secured-pool": "Piscina protegida",
  "global_filter_smokers-welcome": "Fumantes bem-vindos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: hO,
  global_filter_villages: mO,
  "global_filter_washing-machine": "Máquina de lavar",
  "global_filter_whole-unit": "",
  global_filter_wifi: pO,
  global_filters: yO,
  global_fixDates: vO,
  global_flexDates_aMonth: kO,
  global_flexDates_aWeekend: $O,
  global_flexDates_oneWeek: wO,
  global_flexDates_twoWeek: xO,
  global_flexibleDates: CO,
  global_guests: SO,
  global_homes: zO,
  global_lastMinute: AO,
  global_location: PO,
  global_modify: MO,
  global_name: DO,
  global_next: NO,
  global_numberOfAdults_zero: OO,
  global_numberOfAdults_one: IO,
  global_numberOfAdults_other: jO,
  global_numberOfBabies_zero: LO,
  global_numberOfBabies_one: EO,
  global_numberOfBabies_other: BO,
  global_numberOfChildren_zero: TO,
  global_numberOfChildren_one: RO,
  global_numberOfChildren_other: FO,
  global_numberOfGuests_zero: VO,
  global_numberOfGuests_one: GO,
  global_numberOfGuests_other: UO,
  global_phoneNumber_notValid: ZO,
  global_receiveEmailAlerts: WO,
  global_save: KO,
  global_searchBar_noLocationFound: qO,
  global_seeMore_link: HO,
  global_travelWishlist: JO,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: YO,
  optional: QO,
  "privacy-policy": "Privacidade"
}, eI = "", tI = "", aI = "", oI = "Após pré-aprovar esta troca, o seu parceiro de troca terá de a finalizar e terá {nbDays} dias para o fazer (até {date}). Caso contrário, a sua pré-aprovação irá expirar e terá de voltar a pré-aprovar a troca.", nI = "", rI = "Reserva dupla (outra plataforma)", iI = "Motivos familiares", lI = "Motivos de saúde", sI = "Danos na propriedade", cI = "Mudanças", uI = "Você precisa indicar os motivos do cancelamento.", dI = "Outro", _I = "Problemas de transporte", gI = "Problemas de confiança", fI = "Motivos laborais", bI = "É obrigatório introduzir um motivo", hI = {
  "cancellation-page.cancel-exchange": "Cancelar a troca",
  "cancellation-page.continue-cancellation": "Continuar com o cancelamento",
  "cancellation-page.keep-exchange": "Manter a minha troca",
  "cancellation-page.reason_step.checboxes_label": "Selecione o motivo principal para o cancelamento:",
  "cancellation-page.reason_step.comment_placeholder": "Escreva aqui o motivo do cancelamento",
  "cancellation-page.reason_step.error": "É obrigatório introduzir um motivo",
  "cancellation-page.reason_step.title": "Por que motivo precisa de cancelar?",
  "cancellation-page.warning-step.first-warning": "Lembre-se que cancelar a sua troca pode ter um impacto negativo para o seu parceiro de troca, que pode já ter feito planos de viagem!",
  "cancellation-page.warning-step.second-warning": "Importante: Caso tenha demasiados cancelamentos injustificados como anfitrião, a sua conta poderá ser colocada offline. Caso isto aconteça enquanto convidado, poderá não receber todos os seus GuestPoints de volta.",
  page_cancellation_guest_calloutBody: eI,
  page_cancellation_host_calloutBody: tI,
  page_cancellation_reciprocal_calloutBody: aI,
  pre_approval_modal_expiration_description: oI,
  reasons_for_cancellation_asked_by_exchange_partner: nI,
  reasons_for_cancellation_double_booking_rental: rI,
  reasons_for_cancellation_family_issues: iI,
  reasons_for_cancellation_health_issues: lI,
  reasons_for_cancellation_home_damage: sI,
  reasons_for_cancellation_moving: cI,
  reasons_for_cancellation_needed: uI,
  reasons_for_cancellation_other: dI,
  reasons_for_cancellation_transportation_issues: _I,
  reasons_for_cancellation_trust_issues: gI,
  reasons_for_cancellation_work_related: fI,
  reasons_other_comment_needed: bI
}, mI = "Studio", pI = "{{count}} sovrum", yI = "{{count}} sovrum", vI = "", kI = "{{count}} säng", $I = "{{count}} sängar", wI = "Vuxna", xI = "Småbarn", CI = "Din kalender har uppdaterats.", SI = "En månad", zI = "Exakta datum", AI = "En vecka", PI = "En helg", MI = "", DI = "± {{count}} dag", NI = "± {{count}} dagar", OI = "Två veckor", II = "Avbryt", jI = "Barn", LI = "Datum", EI = "Ta bort", BI = "Beskrivning", TI = "Resmål", RI = "Klart!", FI = "Ändra", VI = "Alla typer av hembyten", GI = "Badkar", UI = "Grill", ZI = "Cykel", WI = "Bil", KI = "Katt", qI = "Stad", HI = "Landsbygd", JI = "Diskmaskin", YI = "Hund", QI = "Torktumlare", XI = "Hiss", ej = "Favorithem", tj = "Eldstad", aj = "Lägenhet", oj = "Privat trädgård", nj = "Mindre än {{max}} GP", rj = "från {{min}} GP", ij = "Mellan {{min}} och {{max}} GuestPoints", lj = "Hemmagym", sj = "Hus", cj = "Ö", uj = "Isolerat", dj = "Jacuzzi", _j = "Sjö", gj = "Collection-hem", fj = "Berg", bj = "{{count}} badrum", hj = "Andra djur", mj = "Piano", pj = "Lekplats för barn", yj = "Primärt", vj = "Ömsesidigt hembyte", kj = "Omvänd sökning", $j = "Älv", wj = "Kustnära", xj = "Sekundärt", Cj = "TV", Sj = "By", zj = "WiFi", Aj = "Filter", Pj = "Fasta datum", Mj = "En månad i {{date}}", Dj = "En helg i {{date}}", Nj = "En vecka i {{date}}", Oj = "Två veckor i {{date}}", Ij = "Flexibla datum", jj = "Gäster", Lj = "hem", Ej = "Sista minuten", Bj = "Plats", Tj = "Ändra", Rj = "Namn", Fj = "Nästa", Vj = "", Gj = "{{count}} vuxen", Uj = "{{count}} vuxna", Zj = "", Wj = "{{count}} bebis", Kj = "{{count}} bebisar", qj = "", Hj = "{{count}} barn", Jj = "{{count}} barn", Yj = "", Qj = "{{count}} gäst", Xj = "{{count}} gäster", eL = "Telefonnumrets format är inte giltigt.", tL = "Få e-postaviseringar", aL = "Spara", oL = "Inga resmål hittades", nL = "Se mer", rL = "Reselista", iL = "", lL = "valfritt", sL = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: mI,
  bedroomsNumbers_one: pI,
  bedroomsNumbers_other: yI,
  beds_zero: vI,
  beds_one: kI,
  beds_other: $I,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_adults: wI,
  global_babies: xI,
  global_calendarUpdated_toast: CI,
  global_calendar_aMonth: SI,
  global_calendar_exactDates: zI,
  global_calendar_oneWeek: AI,
  global_calendar_oneWeekend: PI,
  global_calendar_plusMinusDay_zero: MI,
  global_calendar_plusMinusDay_one: DI,
  global_calendar_plusMinusDay_other: NI,
  global_calendar_twoWeeks: OI,
  global_cancel: II,
  global_children: jI,
  global_dates: LI,
  global_delete: EI,
  global_description: BI,
  global_destination: TI,
  global_done: RI,
  global_edit: FI,
  "global_filter_a-c": "Luftkonditionering",
  global_filter_available: VI,
  "global_filter_baby-bed": "Bebissäng",
  "global_filter_baby-gear": "Barnutrustning",
  "global_filter_balcony-terrace": "Balkong/terrass",
  global_filter_bathtub: GI,
  global_filter_bbq: UI,
  global_filter_bicycle: ZI,
  global_filter_car: WI,
  global_filter_cat: KI,
  "global_filter_children-welcome": "Barn är välkomna",
  global_filter_cities: qI,
  "global_filter_cleaning-person": "Städare",
  global_filter_countryside: HI,
  "global_filter_dedicated-workspace": "Kontor",
  "global_filter_disabled-access": "Tillgängligt hem",
  global_filter_dishwasher: JI,
  global_filter_dog: YI,
  global_filter_dryer: QI,
  "global_filter_eco-level": "Endast hållbara hem",
  "global_filter_electric-car-plug": "Elbilsladdare",
  global_filter_elevator: XI,
  global_filter_favorite: ej,
  global_filter_fireplace: tj,
  global_filter_flat: aj,
  global_filter_garden: oj,
  "global_filter_guest-wanted": "Hembyte för GuestPoints",
  global_filter_guestPointsMax: nj,
  global_filter_guestPointsMin: rj,
  global_filter_guestPointsMinMax: ij,
  global_filter_gym: lj,
  "global_filter_heating-system": "Värmesystem",
  "global_filter_high-speed-connexion": "Bredband med hög hastighet",
  global_filter_home: sj,
  "global_filter_home-verified": "Verifierade hem",
  global_filter_island: cj,
  global_filter_isolated: uj,
  global_filter_jacuzzi: dj,
  "global_filter_kids-toys": "Barnleksaker",
  global_filter_lakes: _j,
  global_filter_luxury: gj,
  global_filter_mountains: fj,
  "global_filter_no-bed-up": "Inga tillfälliga sängar",
  global_filter_numOfBathrooms: bj,
  global_filter_other: hj,
  "global_filter_parking-space": "Privat parkeringsplats",
  "global_filter_pets-welcome": "Husdjur är välkomna",
  global_filter_piano: mj,
  global_filter_playground: pj,
  global_filter_primary: yj,
  "global_filter_public-transit-access": "Tillgång till kollektivtrafik",
  global_filter_reciprocal: vj,
  "global_filter_response-rate-above-threshold": "Svarsprocent ≥ Genomsnittlig",
  global_filter_reverse: kj,
  global_filter_river: $j,
  global_filter_seaside: wj,
  global_filter_secondary: xj,
  "global_filter_secured-pool": "Säker pool",
  "global_filter_smokers-welcome": "Rökning tillåtet",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: Cj,
  global_filter_villages: Sj,
  "global_filter_washing-machine": "Tvättmaskin",
  "global_filter_whole-unit": "Hela hemmet",
  global_filter_wifi: zj,
  global_filters: Aj,
  global_fixDates: Pj,
  global_flexDates_aMonth: Mj,
  global_flexDates_aWeekend: Dj,
  global_flexDates_oneWeek: Nj,
  global_flexDates_twoWeek: Oj,
  global_flexibleDates: Ij,
  global_guests: jj,
  global_homes: Lj,
  global_lastMinute: Ej,
  global_location: Bj,
  global_modify: Tj,
  global_name: Rj,
  global_next: Fj,
  global_numberOfAdults_zero: Vj,
  global_numberOfAdults_one: Gj,
  global_numberOfAdults_other: Uj,
  global_numberOfBabies_zero: Zj,
  global_numberOfBabies_one: Wj,
  global_numberOfBabies_other: Kj,
  global_numberOfChildren_zero: qj,
  global_numberOfChildren_one: Hj,
  global_numberOfChildren_other: Jj,
  global_numberOfGuests_zero: Yj,
  global_numberOfGuests_one: Qj,
  global_numberOfGuests_other: Xj,
  global_phoneNumber_notValid: eL,
  global_receiveEmailAlerts: tL,
  global_save: aL,
  global_searchBar_noLocationFound: oL,
  global_seeMore_link: nL,
  global_travelWishlist: rL,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: iL,
  optional: lL,
  "privacy-policy": "Sekretesspolicy"
}, cL = "Din värd kan själv välja att behålla eller återlämna GuestPoints om hen vill.", uL = "Obefogade eller upprepade avbokningar kan leda till att ditt konto stängs av.", dL = "Obefogade eller upprepade avbokningar kan leda till att ditt konto stängs av. Om GuestPoints har använts kommer din hembytespartner att ha valet att behålla eller återlämna dem.", _L = "Efter att du har förgodkänt det här hembytet behöver din hembytespartner bekräfta det. Hen har {nbDays} dagar på sig att bekräfta det (till {date}). Annars kommer ditt förgodkännande att löpa ut och du behöver förgodkänna hembytet igen.", gL = "Min hembytespartner bad mig att avbryta hembytet", fL = "Dubbelbokning (via en annan plattform)", bL = "Familjeproblem", hL = "Hälsoproblem", mL = "Skada i hemmet", pL = "Flytt", yL = "Du måste ange orsaken till din avbokning.", vL = "Annat", kL = "Transportproblem", $L = "Bristande förtroende", wL = "Arbetsrelaterat", xL = "Du behöver ange en anledning", CL = {
  "cancellation-page.cancel-exchange": "Avboka hembytet",
  "cancellation-page.continue-cancellation": "Fortsätt avbokning",
  "cancellation-page.keep-exchange": "Behåll mitt hembyte",
  "cancellation-page.reason_step.checboxes_label": "Välj huvudorsaken till din avbokning:",
  "cancellation-page.reason_step.comment_placeholder": "Skriv skälet till din avbokning här",
  "cancellation-page.reason_step.error": "Du behöver ange en orsak",
  "cancellation-page.reason_step.title": "Varför behöver du avboka?",
  "cancellation-page.warning-step.first-warning": "HomeExchange bygger på förtroende och pålitlighet. Tänk på att en avbokning kan påverka din hembytespartner.",
  "cancellation-page.warning-step.second-warning": "Viktigt: Vid överdrivna och omotiverade avbokningar som värd kan ditt konto tas offline. Och som gäst kanske inte alla dina GuestPoints återlämnas till dig.",
  page_cancellation_guest_calloutBody: cL,
  page_cancellation_host_calloutBody: uL,
  page_cancellation_reciprocal_calloutBody: dL,
  pre_approval_modal_expiration_description: _L,
  reasons_for_cancellation_asked_by_exchange_partner: gL,
  reasons_for_cancellation_double_booking_rental: fL,
  reasons_for_cancellation_family_issues: bL,
  reasons_for_cancellation_health_issues: hL,
  reasons_for_cancellation_home_damage: mL,
  reasons_for_cancellation_moving: pL,
  reasons_for_cancellation_needed: yL,
  reasons_for_cancellation_other: vL,
  reasons_for_cancellation_transportation_issues: kL,
  reasons_for_cancellation_trust_issues: $L,
  reasons_for_cancellation_work_related: wL,
  reasons_other_comment_needed: xL
}, SL = "en", Lr = zf({
  fallbackLng: SL,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      common: yh,
      conversations: Lh
    },
    de: {
      common: Ap,
      conversations: Zp
    },
    en: {
      conversations: ek,
      common: Ev
    },
    es: {
      conversations: cw,
      common: W$
    },
    fr: {
      conversations: pC,
      common: tC
    },
    hr: {
      conversations: I1,
      common: m1
    },
    it: {
      conversations: GA,
      common: SA
    },
    nb: {
      conversations: QP,
      common: jP
    },
    nl: {
      conversations: lN,
      common: UD
    },
    pt: {
      conversations: hI,
      common: XO
    },
    sv: {
      conversations: CL,
      common: sL
    }
  }
});
Lr.init();
const _n = Lr, zL = (e, t) => {
  Nr("exchange_status", e, t);
}, EL = (e, t) => {
  const a = {
    weekday: "long",
    month: "long",
    day: "numeric"
  };
  return mn(new Date(e), t).toLocaleDateString(document.body.dataset.locale, a);
}, BL = (e, t, a) => {
  const o = mn(new Date(t), a);
  return new Date(e) > o;
}, Da = "warning_step", Er = "reason_step", AL = {
  [Da]: tf,
  [Er]: ef
};
function PL({
  cancellationReasons: e,
  conversation: t,
  user: a
}) {
  const [o, n] = xe(Da), r = AL[o], { url: i } = Va(`/conversations/${t.id}`);
  return Ie(() => {
    const l = rf({
      isHeCollection: a.is_he_collection,
      subscriptionEndOn: a?.subscription?.end_on
    });
    of(a.id, l, a.is_he_collection);
  }, [a]), /* @__PURE__ */ y(Oc, { color: "primary", isFullHeight: !0, centerContent: !0, children: /* @__PURE__ */ y(zc, { children: /* @__PURE__ */ y(
    r,
    {
      cancellationReasons: e,
      conversation: t,
      user: a,
      onClickContinue: () => {
        o === Da ? (nf("exchange_cancellation", "exchange_cancellation_reason_selection", {
          collection: a.is_he_collection
        }), window.scrollTo(0, 0), n(Er)) : window.location.assign(i);
      }
    }
  ) }) });
}
function TL({ cancellationReasons: e, conversation: t, locale: a, user: o, apiUrl: n }) {
  return _n.changeLanguage(a), Jr(n), /* @__PURE__ */ y(Gc, { locale: a, children: /* @__PURE__ */ y(Mi, { i18n: _n, children: /* @__PURE__ */ y(PL, { cancellationReasons: e, conversation: t, user: o }) }) });
}
const RL = "WITH-GP", FL = "RECIPROCAL", VL = "RECIPROCAL-WITH-GP", GL = "NEW", UL = "ACCEPTED", ZL = "EXPIRED", WL = "MANUALLY_DECLINED", KL = "AUTOMATICALLY_DECLINED", qL = "PAST_DATES_DECLINE";
export {
  TL as CancellationPage,
  ef as ReasonStep,
  UL as STAY_REQUEST_STATUS_ACCEPTED,
  KL as STAY_REQUEST_STATUS_AUTOMATICALLY_DECLINED,
  ZL as STAY_REQUEST_STATUS_EXPIRED,
  WL as STAY_REQUEST_STATUS_MANUALLY_DECLINED,
  GL as STAY_REQUEST_STATUS_NEW,
  qL as STAY_REQUEST_STATUS_PAST_DATES_DECLINE,
  FL as STAY_TYPE_RECIPROCAL,
  VL as STAY_TYPE_RECIPROCAL_WITH_GP,
  RL as STAY_TYPE_WITH_GP,
  LL as TransportationBanner,
  tf as WarningStep,
  Hr as cancel,
  YL as cancelPreApprobation,
  QL as changeStayRequestToNonReciprocal,
  XL as changeStayRequestToReciprocal,
  eE as createStayRequest,
  tE as getCancellationInformations,
  aE as getExchangeConfig,
  EL as getExpirationDate,
  oE as getLastSentStayRequestMessage,
  nE as getStayRequest,
  rE as getV1StayRequest,
  iE as heFetch,
  _n as i18nConfig,
  lE as isCancellationPossible,
  BL as isStartDateAfterExpirationDate,
  sE as manualDecline,
  cE as preapproveExchange,
  Jr as setConversationsFetchConfig,
  zL as trackExchangeStatus,
  uE as updateStayRequestDates
};
